/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 38);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

if (typeof window !== 'undefined') {
    module.exports = window.React;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removePublicJSONData */
/* harmony export (immutable) */ __webpack_exports__["g"] = triggerSettingsUpdatedEvent;
/* unused harmony export resizeComponent */
/* harmony export (immutable) */ __webpack_exports__["d"] = openBillingPage;
/* unused harmony export getSitePages */
/* harmony export (immutable) */ __webpack_exports__["b"] = getStyleParams;
/* harmony export (immutable) */ __webpack_exports__["e"] = openModal;
/* harmony export (immutable) */ __webpack_exports__["f"] = openSettingsModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = isPremium;
var PREMIUM_PACKAGE_ID='opening_hours';var Wix=window.Wix;function removePublicJSONData(key,options){return new Promise(function(resolve,reject){Wix.Data.Public.remove(key,options,resolve,reject);});}function triggerSettingsUpdatedEvent(data){return Wix.Settings.triggerSettingsUpdatedEvent(data,Wix.Utils.getOrigCompId());}function resizeComponent(options){return new Promise(function(resolve,reject){Wix.Settings.resizeComponent(options,resolve,reject);});}function openBillingPage(){Wix.Settings.openBillingPage();}function getSitePages(){return new Promise(function(resolve){Wix.getSitePages(function(sitePages){resolve(sitePages);});});}function getStyleParams(){return new Promise(function(resolve){Wix.Styles.getStyleParams(function(styleParams){resolve(styleParams);});});}function openModal(){return new Promise(function(resolve){Wix.openModal(window.location.protocol+'//'+window.location.hostname+window.location.pathname+'?app=Modal',1000,350,resolve,Wix.Theme.DEFAULT);});}function openSettingsModal(title){return new Promise(function(resolve){Wix.Settings.openModal(window.location.protocol+'//'+window.location.hostname+window.location.pathname+'?app=Modal',1000,350,title,resolve);});}function isPremium(){if(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://backend.opensign.app"}).REACT_APP_PLAN){return Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://backend.opensign.app"}).REACT_APP_PLAN==='premium';}return Wix.Utils.getInstanceValue('vendorProductId')===PREMIUM_PACKAGE_ID;}/* harmony default export */ __webpack_exports__["a"] = (Wix);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (window.UI);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (window.React);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(27);
var isBuffer = __webpack_require__(54);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(75)(module)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNITS */
/* unused harmony export formatDate */
/* unused harmony export formatTime */
/* unused harmony export calcTimezoneOffsetDiff */
/* harmony export (immutable) */ __webpack_exports__["b"] = leftPad;
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DAYS=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];var UNITS={DAYS:24*60*60*1000,HOURS:60*60*1000,MINUTES:60*1000,SECONDS:1000};// formats a date object like 'YYYY-MM-DD'
function formatDate(dateObj){var year=dateObj.getFullYear();var month=leftPad(dateObj.getMonth()+1,2);var day=leftPad(dateObj.getDate(),2);return year+'-'+month+'-'+day;}// formats a time object like 'HH:mm'
function formatTime(dateObj){var hours=leftPad(dateObj.getHours(),2);var minutes=leftPad(dateObj.getMinutes(),2);return hours+':'+minutes;}function calcTimezoneOffsetDiff(timezoneOffset1,timezoneOffset2){var diff=Math.abs(timezoneOffset1-timezoneOffset2);return diff-timezoneOffset1;}function leftPad(n,len){return new Array(len-String(n).length+1).join('0').concat(n);}// parse a date with the format 'YYYY-MM-DD'
// and return an array like
// [year, month, day]
function parseDate(dateStr){return dateStr.split('-').map(function(piece){return parseInt(piece,10);});}// parse a time with the format 'HH:MM'
// and return an array like
// [hour, minutes]
function parseTime(timeStr){return timeStr.split(':').map(function(piece){return parseInt(piece,10);});}// This code was taken from https://github.com/moment/moment-timezone/blob/develop/moment-timezone.js#L164-L188
function parseZone(timestamp,zoneInfo){var subtractOffset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var target=+timestamp,offsets=zoneInfo.offsets,untils=zoneInfo.untils,max=untils.length-1,offset=void 0,offsetPrev=void 0,i=void 0;for(i=0;i<max;i++){offset=offsets[i];offsetPrev=offsets[i?i-1:i];if(offset>offsetPrev){offset=offsetPrev;}var delta=subtractOffset?offset*60000:0;if(target<untils[i]-delta){return offsets[i];}}return offsets[max];}var TZDate=function(){function TZDate(){var timestamp=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Date.now();var zoneInfo=arguments[1];_classCallCheck(this,TZDate);this._timestamp=timestamp;this._zoneInfo=zoneInfo;}_createClass(TZDate,[{key:'getTimezoneOffset',value:function getTimezoneOffset(){if(this._zoneInfo){return parseZone(this._timestamp,this._zoneInfo,false);}else{return new Date(this._timestamp).getTimezoneOffset();}}},{key:'getDateWithOffset',value:function getDateWithOffset(){var date=new Date(this._timestamp);var timestamp=this._timestamp+date.getTimezoneOffset()*60000-this.getTimezoneOffset()*60000;return new Date(timestamp);}// returns a date string like 'YYYY-MM-DD'
},{key:'getLocalDateString',value:function getLocalDateString(){return formatDate(this.getDateWithOffset());}// returns a time string like 'HH:mm'
},{key:'getLocalTimeString',value:function getLocalTimeString(){return formatTime(this.getDateWithOffset());}},{key:'getLocalDateTimeString',value:function getLocalDateTimeString(){return this.getLocalDateString()+' '+this.getLocalTimeString();}},{key:'getFullYear',value:function getFullYear(){return this.getDateWithOffset().getFullYear();}},{key:'getMonth',value:function getMonth(){return this.getDateWithOffset().getMonth();}},{key:'getDate',value:function getDate(){return this.getDateWithOffset().getDate();}},{key:'getDay',value:function getDay(){return this.getDateWithOffset().getDay();}},{key:'getHours',value:function getHours(){return this.getDateWithOffset().getHours();}},{key:'getMinutes',value:function getMinutes(){return this.getDateWithOffset().getMinutes();}},{key:'getDayString',value:function getDayString(){return DAYS[this.getDay()];}},{key:'getTimestamp',value:function getTimestamp(){return this._timestamp;}},{key:'toString',value:function toString(){return this.getLocalDateTimeString();}},{key:'add',value:function add(val,unitType){return new TZDate(this._timestamp+val*UNITS[unitType.toUpperCase()],this._zoneInfo);}// returns a new TZDate object which has a certain number of days added to it
},{key:'addDays',value:function addDays(days){return this.add(days,'days');}// check if two tzDates are equal
},{key:'equals',value:function equals(otherTZDate){return this.getTimestamp()===otherTZDate.getTimestamp();}},{key:'isSameDay',value:function isSameDay(otherTZDate){return this.getLocalDateString()===otherTZDate.getLocalDateString();}},{key:'isBefore',value:function isBefore(otherTZDate){return this.getTimestamp()<otherTZDate.getTimestamp();}},{key:'isSameOrBefore',value:function isSameOrBefore(otherTZDate){return this.getTimestamp()<=otherTZDate.getTimestamp();}},{key:'isAfter',value:function isAfter(otherTZDate){return this.getTimestamp()>otherTZDate.getTimestamp();}},{key:'isSameOrAfter',value:function isSameOrAfter(otherTZDate){return this.getTimestamp()>=otherTZDate.getTimestamp();}},{key:'isBetween',value:function isBetween(startTZDate,endTZDate){return this._timestamp>startTZDate.getTimestamp()&&this._timestamp<endTZDate.getTimestamp();}},{key:'diff',value:function diff(otherTZDate){return this._timestamp-otherTZDate.getTimestamp();}},{key:'setTime',value:function setTime(timeStr){return TZDate.createFromDateAndTimeString(this.getLocalDateString(),timeStr,this._zoneInfo);}// convert the current date to another zone
},{key:'toZone',value:function toZone(zoneInfo){return new TZDate(this._timestamp,zoneInfo);}},{key:'clone',value:function clone(){return new TZDate(this._timestamp,this._zoneInfo);}}],[{key:'createFromDateAndTimeString',value:function createFromDateAndTimeString(dateStr){var timeStr=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'00:00';var zoneInfo=arguments[2];var _parseDate=parseDate(dateStr),_parseDate2=_slicedToArray(_parseDate,3),year=_parseDate2[0],month=_parseDate2[1],day=_parseDate2[2];var _parseTime=parseTime(timeStr),_parseTime2=_slicedToArray(_parseTime,2),hour=_parseTime2[0],minute=_parseTime2[1];var timestamp=void 0;var timezoneOffset=void 0;if(!zoneInfo){var date=new Date(year,month-1,day,hour,minute,0);timestamp=date.getTime();timezoneOffset=date.getTimezoneOffset();}else{var tempTimestamp=Date.UTC(year,month-1,day,hour,minute,0);timezoneOffset=parseZone(tempTimestamp,zoneInfo);timestamp=tempTimestamp+timezoneOffset*60000;}return new TZDate(timestamp,zoneInfo);}}]);return TZDate;}();/* harmony default export */ __webpack_exports__["a"] = (TZDate);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

if (typeof window !== 'undefined') {
    module.exports = window.moment;
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return badgesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return badgesById; });
/* unused harmony export getDefaultBadgeId */
/* harmony export (immutable) */ __webpack_exports__["c"] = getNormalizedBadgeId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared___ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createBadgeContainer__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__badges_css__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__badges_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__badges_css__);
var badgesList=__WEBPACK_IMPORTED_MODULE_2__shared___["a" /* default */].badgesList.map(function(badge){return Object.assign({},badge,{BadgeComponent:Object(__WEBPACK_IMPORTED_MODULE_3__createBadgeContainer__["a" /* default */])(badge.BadgeComponentStateless)});});var badgesById=badgesList.reduce(function(memo,badge){memo[badge.id]=badge;return memo;},{});function getDefaultBadgeId(){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(badgesList,function(_ref){var isDefault=_ref.isDefault;return isDefault;}).id;}// get the selected badgeId or the default badgeId
function getNormalizedBadgeId(badgeId){if(!Object(__WEBPACK_IMPORTED_MODULE_0__services_Wix__["c" /* isPremium */])()&&badgesById[badgeId].premium){return getDefaultBadgeId();}return badgeId;}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return weekdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATE_FORMATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_TIME_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return languages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return timeFormats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateFormats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return wixWeekdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return wixLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return wixTimeFormats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return wixDateFormats; });
var weekdays=[{value:'monday',label:'Monday'},{value:'tuesday',label:'Tuesday'},{value:'wednesday',label:'Wednesday'},{value:'thursday',label:'Thursday'},{value:'friday',label:'Friday'},{value:'saturday',label:'Saturday'},{value:'sunday',label:'Sunday'}];var DATE_FORMATS={TIME_FORMAT_1:'time-format-1',TIME_FORMAT_2:'time-format-2',DATE_FORMAT_1:'date-format-1',DATE_FORMAT_2:'date-format-2',DATE_FORMAT_3:'date-format-3',DATE_FORMAT_4:'date-format-4',DATE_FORMAT_5:'date-format-5',DATE_FORMAT_6:'date-format-6'};var DEFAULT_TIME_FORMAT=DATE_FORMATS.TIME_FORMAT_1;var DEFAULT_DATE_FORMAT=DATE_FORMATS.DATE_FORMAT_1;var languages=[{value:'en',label:'English'},{value:'de',label:'German'},{value:'nl',label:'Dutch'},{value:'fr',label:'French'},{value:'es',label:'Spanish'},{value:'fin',label:'Finnish'},{value:'pt',label:'Portuguese'},{value:'swe',label:'Swedish'}];var timeFormats=[// 'hh:mm A'
{value:DATE_FORMATS.TIME_FORMAT_1,label:'12h (e.g. 9am)'},// 'HH:mm'
{value:DATE_FORMATS.TIME_FORMAT_2,label:'24h (e.g. 17:00)'}];var dateFormats=[{value:DATE_FORMATS.DATE_FORMAT_1,label:'2019-10-29'},{value:DATE_FORMATS.DATE_FORMAT_2,label:'2019/10/29'},{value:DATE_FORMATS.DATE_FORMAT_3,label:'10-29-2019'},{value:DATE_FORMATS.DATE_FORMAT_4,label:'29.10.2019'},{value:DATE_FORMATS.DATE_FORMAT_5,label:'29-10-2019'},{value:DATE_FORMATS.DATE_FORMAT_6,label:'29/10/2019'}];// Convert a list to an list with index values as expected by the Wix UI lib
function toWix(list){return list.map(function(x,i){return{value:''+i,label:x.label};});}var wixWeekdays=toWix(weekdays);var wixLanguages=toWix(languages);var wixTimeFormats=toWix(timeFormats);var wixDateFormats=toWix(dateFormats);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(155)();
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(15);
var request=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();request.interceptors.request.use(function(config){var context=Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* getContext */])();var extraParams={'wix-comp-id':__WEBPACK_IMPORTED_MODULE_1__Wix__["a" /* default */].Utils.getCompId(),'wix-instance':context.instance,'wix-app':context.app};if(__WEBPACK_IMPORTED_MODULE_1__Wix__["a" /* default */].Utils.getOrigCompId()){extraParams['wix-orig-comp-id']=__WEBPACK_IMPORTED_MODULE_1__Wix__["a" /* default */].Utils.getOrigCompId();}if(context.originCompId){extraParams['wix-origin-comp-id']=context.originCompId;}if(config.method==='post'||config.method==='put'){config.headers=Object.assign({},config.headers||{},extraParams);}else{config.params=Object.assign({},config.params||{},extraParams);}if(true){config.url=''+"https://backend.opensign.app"+config.url;}return config;});/* harmony default export */ __webpack_exports__["a"] = (request);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OPENED; });
/* unused harmony export CLOSED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INVALID_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INVALID_TIME_STRING; });
/* unused harmony export INVALID_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OVERLAPPING_RANGE; });
/* unused harmony export createRanges */
/* harmony export (immutable) */ __webpack_exports__["f"] = getOpeningState;
/* harmony export (immutable) */ __webpack_exports__["h"] = validateOpeningHours;
/* unused harmony export validateOpeningHoursByDay */
/* harmony export (immutable) */ __webpack_exports__["e"] = extractHoursAndMinutes;
/* unused harmony export formatTimeLong */
/* unused harmony export formatTime */
/* unused harmony export getOpeningHoursOfDate */
/* unused harmony export getNormalizedOpeningHours */
/* harmony export (immutable) */ __webpack_exports__["g"] = normalizeTableOpeningHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TZDate__ = __webpack_require__(7);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var OPENED='OPENED';var CLOSED='CLOSED';var INVALID_RANGE='INVALID_RANGE';var INVALID_TIME_STRING='INVALID_TIME_STRING';var INVALID_ORDER='INVALID_ORDER';var OVERLAPPING_RANGE='OVERLAPPING_RANGE';function partitionArray(arr,size){var partition=[];return arr.reduce(function(acc,v){partition.push(v);if(partition.length===size){acc.push(partition);partition=[];}return acc;},[]);}function createRange(date,_ref){var from=_ref.from,to=_ref.to;return{from:date.setTime(from),to:date.setTime(to)};}function createRanges(date,openingHours){return(openingHours||[]).map(function(fromTo){return createRange(date,fromTo);});}function getSpecialOpeningHoursByDay(specialOpeningHours,zoneInfo){var startDate=__WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */].createFromDateAndTimeString(specialOpeningHours.start,'00:00',zoneInfo);var endDate=__WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */].createFromDateAndTimeString(specialOpeningHours.end,'00:00',zoneInfo);var currentDate=startDate.clone();var openingHoursByDay={};if(endDate.isBefore(startDate)){return openingHoursByDay;}do{var dayStr=currentDate.getLocalDateString();openingHoursByDay[dayStr]=createRanges(currentDate,specialOpeningHours.openingHours);currentDate=currentDate.addDays(1);}while(currentDate.isSameOrBefore(endDate));return openingHoursByDay;}function getSpecialRangesByDate(allSpecialOpeningHours,zoneInfo){return allSpecialOpeningHours.map(function(specialOpeningHours){return getSpecialOpeningHoursByDay(specialOpeningHours,zoneInfo);}).reduce(function(memo,rangesByDate){return Object.assign({},memo,rangesByDate);},{});}function getLastDate(specialRangesByDayObj,zoneInfo,nowDate){var specialDates=Object.keys(specialRangesByDayObj);var lastSpecialDate=void 0;if(specialDates.length){specialDates.sort();lastSpecialDate=__WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */].createFromDateAndTimeString(specialDates[specialDates.length-1],'00:00',zoneInfo);}else{lastSpecialDate=nowDate.clone();}return lastSpecialDate.addDays(8,'days');}function flattenRanges(ranges){return ranges.reduce(function(memo,range){memo.push(range.from,range.to);return memo;},[]);}// transforms ranges like this:
// [{ from: '08:00', to: '12:00' }, { from: '12:00', to: '18:00' }]
// to:
// [{ from: '08:00', to: '18:00' }]
function normalizeRanges(ranges){var timeSpots=flattenRanges(ranges);var timeSpotsCount=timeSpots.reduce(function(memo,timeSpot){var dateStr=timeSpot.getLocalDateTimeString();if(!(dateStr in memo)){memo[dateStr]=0;}else{memo[dateStr]++;}return memo;},{});var timeSpotsWithoutDuplicates=timeSpots.filter(function(timeSpot){var dateStr=timeSpot.getLocalDateTimeString();return timeSpotsCount[dateStr]===0;});return partitionArray(timeSpotsWithoutDuplicates,2).map(function(_ref2){var _ref3=_slicedToArray(_ref2,2),from=_ref3[0],to=_ref3[1];return{from:from,to:to};});}function getOpeningStateFromRanges(ranges,zoneInfo,nowDate){var timeSpots=flattenRanges(ranges);if(timeSpots.length===2){// handle the case when a store is opened 24/7
var oneWeekLater=timeSpots[0].addDays(7);if(timeSpots[1].isSameOrAfter(oneWeekLater)){return{status:OPENED};}}for(var i=1;i<timeSpots.length;i++){var currentTimeSpot=timeSpots[i];var prevTimeSpot=timeSpots[i-1];if(!nowDate.isBetween(prevTimeSpot,currentTimeSpot)){continue;}if(i%2){// the store is currently opened
return{status:OPENED,closingDate:currentTimeSpot};}else{// the store is currently closed
var _state={status:CLOSED,openingDate:currentTimeSpot};return _state;}}var state={status:CLOSED};if(timeSpots.length&&nowDate.isBefore(timeSpots[0])){state.openingDate=timeSpots[0];}return state;}function getOpeningState(zoneInfo,openingHoursByDay){var allSpecialOpeningHours=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var nowDate=arguments.length>3&&arguments[3]!==undefined?arguments[3]:new __WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */](Date.now(),zoneInfo);var specialRangesByDate=getSpecialRangesByDate(allSpecialOpeningHours,zoneInfo);var lastDate=getLastDate(specialRangesByDate,zoneInfo,nowDate);var currentDate=nowDate.clone();var ranges=[];do{var dateStr=currentDate.getLocalDateString();if(dateStr in specialRangesByDate){ranges.push.apply(ranges,_toConsumableArray(specialRangesByDate[dateStr]));}else{var day=currentDate.getDayString().toLowerCase();ranges.push.apply(ranges,_toConsumableArray(createRanges(currentDate,openingHoursByDay[day].openingHours||[])));}currentDate=currentDate.addDays(1);}while(currentDate.isSameOrBefore(lastDate));return getOpeningStateFromRanges(normalizeRanges(ranges),zoneInfo,nowDate);}function getOverlappingRangesErrors(openingHours){var overlapping=[];var nowDate=new __WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */]();for(var i=0;i<openingHours.length;i++){if(getErrorsForFromTo(openingHours[i],i).length){continue;}for(var y=0;y<openingHours.length;y++){if(i===y||getErrorsForFromTo(openingHours[y],y).length){continue;}var range=createRange(nowDate,openingHours[i]);var comparedRange=createRange(nowDate,openingHours[y]);if(range.from.isBetween(comparedRange.from,comparedRange.to)||range.to.isBetween(comparedRange.from,comparedRange.to)){overlapping.push(i);break;}}}return overlapping.map(function(idx){return{path:''+idx,type:OVERLAPPING_RANGE};});}function isValidRange(_ref4){var from=_ref4.from,to=_ref4.to;return to.isAfter(from);}function isValidTimeString(timeStr){var pieces=timeStr.split(':');if(pieces.length!==2||pieces[0].length!==2||pieces[1].length!==2){return false;}var hours=parseInt(pieces[0],10);var minutes=parseInt(pieces[1],10);return!(hours===24&&minutes!==0||hours<0||hours>24||minutes<0||minutes>59);}function getErrorsForFromTo(fromTo,idx){var nowDate=new __WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */]();var errors=[];var fromIsValid=isValidTimeString(fromTo.from);var toIsValid=isValidTimeString(fromTo.to);if(!fromIsValid){errors.push({path:idx+'.from',type:INVALID_TIME_STRING});}if(!toIsValid){errors.push({path:idx+'.to',type:INVALID_TIME_STRING});}if(fromIsValid&&toIsValid){var range=createRange(nowDate,fromTo);if(!isValidRange(range)){errors.push({path:''+idx,type:INVALID_RANGE});}}return errors;}function validateOpeningHours(openingHours){var errors=openingHours.reduce(function(errors,fromTo,idx){return[].concat(_toConsumableArray(errors),_toConsumableArray(getErrorsForFromTo(fromTo,idx)));},[]);var overlappingRangesErrors=getOverlappingRangesErrors(openingHours);return errors.concat(overlappingRangesErrors);}function validateOpeningHoursByDay(openingHoursByDay){var days=Object.keys(openingHoursByDay);return days.reduce(function(memo,day){var openingHours=openingHoursByDay[day];var errors=validateOpeningHours(openingHours).map(function(error){return Object.assign({},error,{path:day+'.'+error.path});});return memo.concat(errors);},[]);}function extractHoursAndMinutes(str){var pieces=str.split(':');return{hours:parseInt(pieces[0],10),minutes:parseInt(pieces[1],10)};}function leftPad(n,len){return new Array(len-String(n).length+1).join('0').concat(n);}function formatTimeLong(timeStr){if(timeStr==='24:00'){return'midnight';}var _timeStr$split=timeStr.split(':'),_timeStr$split2=_slicedToArray(_timeStr$split,2),hourStr=_timeStr$split2[0],minuteStr=_timeStr$split2[1];var hour=parseInt(hourStr,10);var postFix=hour<12?'am':'pm';var hourFormated=''+leftPad(hour%12||12,2);var minuteFormated=':'+minuteStr;return''+hourFormated+minuteFormated+' '+postFix;}function formatTime(timeStr){if(timeStr==='24:00'){return'midnight';}var _timeStr$split3=timeStr.split(':'),_timeStr$split4=_slicedToArray(_timeStr$split3,2),hourStr=_timeStr$split4[0],minuteStr=_timeStr$split4[1];var hour=parseInt(hourStr,10);var postFix=hour<12?'am':'pm';var hourFormated=''+(hour%12||12);var minuteFormated=minuteStr==='00'?'':':'+minuteStr;return''+hourFormated+minuteFormated+postFix;}// Table related functions
function getOpeningHoursOfDate(date,openingHoursByDay){var specialOpeningHours=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var day=date.getDayString().toLowerCase();var special=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(specialOpeningHours,function(_ref5){var start=_ref5.start,end=_ref5.end;var startDate=__WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */].createFromDateAndTimeString(start,'00:00');var endDate=__WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */].createFromDateAndTimeString(end,'23:59');return startDate.isSameDay(date)||endDate.isSameDay(date)||date.isBetween(startDate,endDate);});return special?special:openingHoursByDay[day];}function isSpecialEndCase(openingHours){if(!openingHours.length){return false;}var _openingHours=openingHours[openingHours.length-1],from=_openingHours.from,to=_openingHours.to;return from!=='00:00'&&to==='24:00';}function isSpecialStartCase(openingHours){if(!openingHours.length){return false;}var _openingHours$=openingHours[0],from=_openingHours$.from,to=_openingHours$.to;return from==='00:00'&&to!=='24:00';}function getNormalizedOpeningHours(date,openingHoursByDay){var specialOpeningHours=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var prevDay=date.addDays(-1);var nextDay=date.addDays(1);var openingHours=getOpeningHoursOfDate(date,openingHoursByDay,specialOpeningHours).openingHours||[];var prevOpeningHours=getOpeningHoursOfDate(prevDay,openingHoursByDay,specialOpeningHours).openingHours||[];var nextOpeningHours=getOpeningHoursOfDate(nextDay,openingHoursByDay,specialOpeningHours).openingHours||[];var removeFirst=isSpecialEndCase(prevOpeningHours)&&isSpecialStartCase(openingHours);var addNext=isSpecialEndCase(openingHours)&&isSpecialStartCase(nextOpeningHours);var openingHoursNormalized=[].concat(_toConsumableArray(openingHours));if(removeFirst){openingHoursNormalized.shift();}if(addNext){openingHoursNormalized[openingHoursNormalized.length-1]=Object.assign({},openingHoursNormalized[openingHoursNormalized.length-1],{to:nextOpeningHours[0].to});}return openingHoursNormalized;}function normalizeTableOpeningHours(firstDayOfWeek,openingHoursByDay){var specialOpeningHours=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var today=arguments.length>3&&arguments[3]!==undefined?arguments[3]:new __WEBPACK_IMPORTED_MODULE_1__TZDate__["a" /* default */]();var startingDayIdx=['sunday','monday','tuesday','wednesday','thursday','friday','saturday'].indexOf(firstDayOfWeek);if(startingDayIdx===-1){startingDayIdx=1;}return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.times(7).map(function(val,idx){var normalizedIdx=idx+startingDayIdx;var date=today.addDays(normalizedIdx-today.getDay());var _getOpeningHoursOfDat=getOpeningHoursOfDate(date,openingHoursByDay,specialOpeningHours),note=_getOpeningHoursOfDat.note;var normalizedOpeningHours=getNormalizedOpeningHours(date,openingHoursByDay,specialOpeningHours);var day=date.getDayString().toLowerCase();return{openingHours:normalizedOpeningHours,note:note,day:day};});}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* unused harmony export normailzeQuery */
/* harmony export (immutable) */ __webpack_exports__["b"] = getContext;
/* unused harmony export setCookie */
/* unused harmony export getCookie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
function debounce(fn,ms){var to=void 0;function abort(){clearTimeout(to);}function func(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var that=this;abort();to=setTimeout(function(){fn.apply(that,args);},ms);}func.abort=abort;return func;}function normailzeQuery(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';// Sometimes the query contains the app parameter two times (happened at least to one customer)
// normalize the query-parameter.
//return (query || '').replace('?app=Widget?app=Widget', '?app=Widget');
if(query.match(/\?app=.*?\?/)){return query.replace(/^\?app=.*?(\?.*)/,'$1');}else{return query;}}function getContext(){return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(normailzeQuery(window.location.search));}// taken from https://www.w3schools.com/Js/js_cookies.asp
function setCookie(cname,cvalue,exdays){var d=new Date();d.setTime(d.getTime()+exdays*24*60*60*1000);var expires='expires='+d.toUTCString();document.cookie=cname+'='+cvalue+';'+expires+';path=/';}function getCookie(cname){var name=cname+'=';var ca=document.cookie.split(';');for(var i=0;i<ca.length;i++){var c=ca[i];while(c.charAt(0)===' '){c=c.substring(1);}if(c.indexOf(name)===0){return c.substring(name.length,c.length);}}return'';}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(4);
var normalizeHeaderName = __webpack_require__(57);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(28);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(28);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNEXPECTED_ERROR; });
var AUTH_ERROR='AUTH_ERROR';var UNEXPECTED_ERROR='UNEXPECTED_ERROR';

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_styles__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Wrap a component passing a styles property which is fetched from Wix and updated on changes.
function createStylesContainer(WrappedComponent){return function(_React$Component){_inherits(_class,_React$Component);function _class(props){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props));_this.onStylesChange=_this.onStylesChange.bind(_this);_this.state={styles:null};return _this;}_createClass(_class,[{key:'onStylesChange',value:function onStylesChange(styles){this.setState(function(){return{styles:Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_styles__["c" /* parseStyles */])(styles)};});}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1__commons_services_Wix__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_1__commons_services_Wix__["a" /* default */].Events.STYLE_PARAMS_CHANGE,this.onStylesChange);Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_styles__["a" /* getStyles */])().then(function(styles){_this2.setState(function(){return{styles:styles};});});}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_1__commons_services_Wix__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_1__commons_services_Wix__["a" /* default */].Events.STYLE_PARAMS_CHANGE,this.onStylesChange);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({},this.state,this.props));}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);}/* harmony default export */ __webpack_exports__["a"] = (createStylesContainer);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return params; });
/* harmony export (immutable) */ __webpack_exports__["c"] = parseStyles;
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lodash__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_badges__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_services_static__ = __webpack_require__(10);
// Map params name in case we like to switch to storing a field in a different Wix style param
var params={language:'language',firstDayOfWeek:'firstDayOfWeek',timeFormat:'timeFormat',dateFormat:'dateFormat',timezone:'timezone',selectedBadge:'selectedBadge',linkToPageEnabled:'linkToPageEnabled',modalEnabled:'modalEnabled',animateEnabled:'animateEnabled',noSublineEnabled:'noSublineEnabled',badgeFirstColor:'badgeFirstColor',badgeSecondColor:'badgeSecondColor',badgeThirdColor:'badgeThirdColor',modalBackgroundColor:'modalBackgroundColor',modalNoteBackgroundColor:'modalNoteBackgroundColor',modalNotesFont:'modalNotesFont',modalNotesColor:'modalNotesColor',modalHeadlineFont:'modalHeadlineFont',modalHeadlineColor:'modalHeadlineColor',modalWeekdaysFont:'modalWeekdaysFont',modalWeekdaysColor:'modalWeekdaysColor',modalTimeSlotsFont:'modalTimeSlotsFont',modalTimeSlotsColor:'modalTimeSlotsColor'};// Returns our internal data representation build from Wix style params,
// also sets defaults.
function parseStyles(styles){var timezone=void 0;var timezoneIdx=styles.numbers[params.timezone];if(!__WEBPACK_IMPORTED_MODULE_1__lodash__["a" /* default */].isUndefined(timezoneIdx)){timezone=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.tz.names()[timezoneIdx];}else{timezone=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.tz.guess();}return{language:__WEBPACK_IMPORTED_MODULE_4__commons_services_static__["e" /* languages */][styles.numbers[params.language]||0],firstDayOfWeek:__WEBPACK_IMPORTED_MODULE_4__commons_services_static__["g" /* weekdays */][styles.numbers[params.firstDayOfWeek]||0],// If modal and link are enabled, modal has priority
linkToPageEnabled:styles.booleans[params.linkToPageEnabled]||false,modalEnabled:params.modalEnabled in styles.booleans?styles.booleans[params.modalEnabled]:true,animateEnabled:params.animateEnabled in styles.booleans?styles.booleans[params.animateEnabled]:true,noSublineEnabled:params.noSublineEnabled in styles.booleans?styles.booleans[params.noSublineEnabled]:false,timeFormat:__WEBPACK_IMPORTED_MODULE_4__commons_services_static__["f" /* timeFormats */][styles.numbers[params.timeFormat]||0],dateFormat:__WEBPACK_IMPORTED_MODULE_4__commons_services_static__["d" /* dateFormats */][styles.numbers[params.dateFormat]||0],timezone:timezone,selectedBadge:__WEBPACK_IMPORTED_MODULE_3__commons_badges__["b" /* badgesList */][styles.numbers[params.selectedBadge]||0].id,badgeFirstColor:getColor(styles,params.badgeFirstColor),badgeSecondColor:getColor(styles,params.badgeSecondColor),badgeThirdColor:getColor(styles,params.badgeThirdColor),modalBackgroundColor:getColor(styles,params.modalBackgroundColor),modalNoteBackgroundColor:getColor(styles,params.modalNoteBackgroundColor),modalNotesFont:getFont(styles,params.modalNotesFont),modalNotesColor:getColor(styles,params.modalNotesColor),modalHeadlineFont:getFont(styles,params.modalHeadlineFont),modalHeadlineColor:getColor(styles,params.modalHeadlineColor),modalWeekdaysFont:getFont(styles,params.modalWeekdaysFont),modalWeekdaysColor:getColor(styles,params.modalWeekdaysColor),modalTimeSlotsFont:getFont(styles,params.modalTimeSlotsFont),modalTimeSlotsColor:getColor(styles,params.modalTimeSlotsColor),googleFontsCssUrl:styles.googleFontsCssUrl};}function getColor(styles,param){return __WEBPACK_IMPORTED_MODULE_1__lodash__["a" /* default */].get(styles,['colors',param,'value'],'');}function getFont(styles,param){return __WEBPACK_IMPORTED_MODULE_1__lodash__["a" /* default */].get(styles,['fonts',param,'value'],'');}// Async get styles in a parsed format from Wix
function getStyles(){return Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["b" /* getStyleParams */])().then(parseStyles);}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createNavigationContainer(TopLevelComponent){return function(_React$Component){_inherits(_class,_React$Component);function _class(props){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props));_this.isTopLevel=_this.isTopLevel.bind(_this);_this.getCurrent=_this.getCurrent.bind(_this);_this.gotoPrevComponent=_this.gotoPrevComponent.bind(_this);_this.addComponentToPath=_this.addComponentToPath.bind(_this);_this.reset=_this.reset.bind(_this);_this.state={path:[]};return _this;}_createClass(_class,[{key:'isTopLevel',value:function isTopLevel(){return this.state.path.length===0;}},{key:'getCurrent',value:function getCurrent(){var path=this.state.path;if(path.length===0){return{Component:TopLevelComponent};}return path[path.length-1];}},{key:'gotoPrevComponent',value:function gotoPrevComponent(){this.setState(function(_ref){var path=_ref.path;if(!path.length){return{};}return{path:path.slice(0,-1)};});}},{key:'addComponentToPath',value:function addComponentToPath(Component){var props=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};this.setState(function(_ref2){var path=_ref2.path;return{path:path.concat([{Component:Component,props:props}])};});}},{key:'reset',value:function reset(){this.setState(function(_ref3){var path=_ref3.path;return{path:[]};});}},{key:'render',value:function render(){var current=this.getCurrent();var CurrentComponent=current.Component;var currentProps=current.props||{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentComponent,Object.assign({hasPrevComponent:!this.isTopLevel(),addComponentToPath:this.addComponentToPath,gotoPrevComponent:this.gotoPrevComponent},this.state,this.props,currentProps));}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);}/* harmony default export */ __webpack_exports__["a"] = (createNavigationContainer);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_UI__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextInput=function(_React$Component){_inherits(TextInput,_React$Component);function TextInput(props){_classCallCheck(this,TextInput);var _this=_possibleConstructorReturn(this,(TextInput.__proto__||Object.getPrototypeOf(TextInput)).call(this,props));_this.updateValue=_this.updateValue.bind(_this);return _this;}_createClass(TextInput,[{key:'updateValue',value:function updateValue(){var value=this.props.value;this.textInput.setValue(value);}},{key:'componentDidMount',value:function componentDidMount(){this.updateValue();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.updateValue();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,value=_props.value,otherProps=_objectWithoutProperties(_props,['value']);return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].textInput,Object.assign({ref:function ref(textInput){return _this2.textInput=textInput;}},otherProps));}}]);return TextInput;}(__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].Component);/* harmony default export */ __webpack_exports__["a"] = (TextInput);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(41);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

if (typeof window !== 'undefined') {
    module.exports = window.ReactDOM;
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(45);
var objectAssign = __webpack_require__(23);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(50);

var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;

var toString = Object.prototype.toString
var type = function(obj) {
  return toString.call(obj).slice(8, -1);
}

var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
  getAllKeys(source).forEach(function(key) {
    if (hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  });
  return target;
};

var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };

/* istanbul ignore next */
function copy(object) {
  if (Array.isArray(object)) {
    return assign(object.constructor(object.length), object)
  } else if (type(object) === 'Map') {
    return new Map(object)
  } else if (type(object) === 'Set') {
    return new Set(object)
  } else if (object && typeof object === 'object') {
    var prototype = object.constructor && object.constructor.prototype
    return assign(Object.create(prototype || null), object);
  } else {
    return object;
  }
}

function newContext() {
  var commands = assign({}, defaultCommands);
  update.extend = function(directive, fn) {
    commands[directive] = fn;
  };
  update.isEquals = function(a, b) { return a === b; };

  return update;

  function update(object, spec) {
    if (typeof spec === 'function') {
      return spec(object);
    }

    if (!(Array.isArray(object) && Array.isArray(spec))) {
      invariant(
        !Array.isArray(spec),
        'update(): You provided an invalid spec to update(). The spec may ' +
        'not contain an array except as the value of $set, $push, $unshift, ' +
        '$splice or any custom command allowing an array value.'
      );
    }

    invariant(
      typeof spec === 'object' && spec !== null,
      'update(): You provided an invalid spec to update(). The spec and ' +
      'every included key path must be plain objects containing one of the ' +
      'following commands: %s.',
      Object.keys(commands).join(', ')
    );

    var nextObject = object;
    var index, key;
    getAllKeys(spec).forEach(function(key) {
      if (hasOwnProperty.call(commands, key)) {
        var objectWasNextObject = object === nextObject;
        nextObject = commands[key](spec[key], nextObject, spec, object);
        if (objectWasNextObject && update.isEquals(nextObject, object)) {
          nextObject = object;
        }
      } else {
        var nextValueForKey =
          type(object) === 'Map'
            ? update(object.get(key), spec[key])
            : update(object[key], spec[key]);
        if (!update.isEquals(nextValueForKey, nextObject[key]) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
          if (nextObject === object) {
            nextObject = copy(object);
          }
          if (type(nextObject) === 'Map') {
            nextObject.set(key, nextValueForKey);
          } else {
            nextObject[key] = nextValueForKey;
          }
        }
      }
    })
    return nextObject;
  }

}

var defaultCommands = {
  $push: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$push');
    return value.length ? nextObject.concat(value) : nextObject;
  },
  $unshift: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$unshift');
    return value.length ? value.concat(nextObject) : nextObject;
  },
  $splice: function(value, nextObject, spec, originalObject) {
    invariantSplices(nextObject, spec);
    value.forEach(function(args) {
      invariantSplice(args);
      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
      splice.apply(nextObject, args);
    });
    return nextObject;
  },
  $set: function(value, nextObject, spec) {
    invariantSet(spec);
    return value;
  },
  $toggle: function(targets, nextObject) {
    invariantSpecArray(targets, '$toggle');
    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;

    targets.forEach(function(target) {
      nextObjectCopy[target] = !nextObject[target];
    });

    return nextObjectCopy;
  },
  $unset: function(value, nextObject, spec, originalObject) {
    invariantSpecArray(value, '$unset');
    value.forEach(function(key) {
      if (Object.hasOwnProperty.call(nextObject, key)) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        delete nextObject[key];
      }
    });
    return nextObject;
  },
  $add: function(value, nextObject, spec, originalObject) {
    invariantMapOrSet(nextObject, '$add');
    invariantSpecArray(value, '$add');
    if (type(nextObject) === 'Map') {
      value.forEach(function(pair) {
        var key = pair[0];
        var value = pair[1];
        if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
        nextObject.set(key, value);
      });
    } else {
      value.forEach(function(value) {
        if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
        nextObject.add(value);
      });
    }
    return nextObject;
  },
  $remove: function(value, nextObject, spec, originalObject) {
    invariantMapOrSet(nextObject, '$remove');
    invariantSpecArray(value, '$remove');
    value.forEach(function(key) {
      if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
      nextObject.delete(key);
    });
    return nextObject;
  },
  $merge: function(value, nextObject, spec, originalObject) {
    invariantMerge(nextObject, value);
    getAllKeys(value).forEach(function(key) {
      if (value[key] !== nextObject[key]) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        nextObject[key] = value[key];
      }
    });
    return nextObject;
  },
  $apply: function(value, original) {
    invariantApply(value);
    return value(original);
  }
};

var contextForExport = newContext();

module.exports = contextForExport;
module.exports.default = contextForExport;
module.exports.newContext = newContext;

// invariants

function invariantPushAndUnshift(value, spec, command) {
  invariant(
    Array.isArray(value),
    'update(): expected target of %s to be an array; got %s.',
    command,
    value
  );
  invariantSpecArray(spec[command], command)
}

function invariantSpecArray(spec, command) {
  invariant(
    Array.isArray(spec),
    'update(): expected spec of %s to be an array; got %s. ' +
    'Did you forget to wrap your parameter in an array?',
    command,
    spec
  );
}

function invariantSplices(value, spec) {
  invariant(
    Array.isArray(value),
    'Expected $splice target to be an array; got %s',
    value
  );
  invariantSplice(spec['$splice']);
}

function invariantSplice(value) {
  invariant(
    Array.isArray(value),
    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
    'Did you forget to wrap your parameters in an array?',
    value
  );
}

function invariantApply(fn) {
  invariant(
    typeof fn === 'function',
    'update(): expected spec of $apply to be a function; got %s.',
    fn
  );
}

function invariantSet(spec) {
  invariant(
    Object.keys(spec).length === 1,
    'Cannot have more than one key in an object with $set'
  );
}

function invariantMerge(target, specValue) {
  invariant(
    specValue && typeof specValue === 'object',
    'update(): $merge expects a spec of type \'object\'; got %s',
    specValue
  );
  invariant(
    target && typeof target === 'object',
    'update(): $merge expects a target of type \'object\'; got %s',
    target
  );
}

function invariantMapOrSet(target, command) {
  var typeOfTarget = type(target);
  invariant(
    typeOfTarget === 'Map' || typeOfTarget === 'Set',
    'update(): %s expects a target of type Set or Map; got %s',
    command,
    typeOfTarget
  );
}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var settle = __webpack_require__(58);
var buildURL = __webpack_require__(60);
var parseHeaders = __webpack_require__(61);
var isURLSameOrigin = __webpack_require__(62);
var createError = __webpack_require__(29);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(63);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(64);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(59);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_errorCodes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthErrorMessage__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UnexpectedErrorMessage__ = __webpack_require__(74);
function SelectErrorMessage(_ref){var code=_ref.code;var errorHTML=void 0;switch(code){case __WEBPACK_IMPORTED_MODULE_1__services_errorCodes__["a" /* AUTH_ERROR */]:errorHTML=__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_2__AuthErrorMessage__["a" /* default */],null);break;default:errorHTML=__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_3__UnexpectedErrorMessage__["a" /* default */],null);}return errorHTML;}/* harmony default export */ __webpack_exports__["a"] = (SelectErrorMessage);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorMessage_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorMessage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ErrorMessage_css__);
function AlertIcon(){return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('svg',{style:{marginBottom:'-3px'},width:'14',height:'18',viewBox:'-503.5 377 18 14'},__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('path',{fill:'#1D2D3C',d:'M-486.1 389.4l-6.8-10.7c-.4-.6-1-.9-1.7-.9s-1.3.3-1.7.9l-6.8 10.7c-.4.7 0 1.6.8 1.6h15.2c1 0 1.5-.9 1-1.6zm-16 .6l6.8-10.8c.3-.4.7-.5.8-.5.2 0 .6 0 .8.5l6.8 10.8h-15.2z'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('path',{fill:'#1D2D3C',d:'M-495 389h1v-1h-1zM-495 384.1v2.9h.4l.6-2.9V382h-1z'}));}function ErrorMessage(_ref){var title=_ref.title,message=_ref.message;return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',{className:'ErrorMessage'},__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('header',{className:'ErrorMessage__Header'},__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(AlertIcon,null),' ',title),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',{className:'ErrorMessage__Text'},message));}/* harmony default export */ __webpack_exports__["a"] = (ErrorMessage);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (window._);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatTZDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TZDate__ = __webpack_require__(7);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function formatTZDate(dateObj,formatType,fallbackType){var isValidFormat=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.values(__WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */]).some(function(format){return format===formatType;});var year=dateObj.getFullYear();var month=Object(__WEBPACK_IMPORTED_MODULE_2__TZDate__["b" /* leftPad */])(dateObj.getMonth()+1,2);var day=Object(__WEBPACK_IMPORTED_MODULE_2__TZDate__["b" /* leftPad */])(dateObj.getDate(),2);var hours=Object(__WEBPACK_IMPORTED_MODULE_2__TZDate__["b" /* leftPad */])(dateObj.getHours(),2);// 24h
var minutes=Object(__WEBPACK_IMPORTED_MODULE_2__TZDate__["b" /* leftPad */])(dateObj.getMinutes(),2);// minutes
var normalizedFormat=isValidFormat?formatType:fallbackType;switch(normalizedFormat){// time formats
case __WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].TIME_FORMAT_1:return formatTime(hours+':'+minutes,normalizedFormat);case __WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].TIME_FORMAT_2:return formatTime(hours+':'+minutes,normalizedFormat);// date formats
case __WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].DATE_FORMAT_1:return year+'-'+month+'-'+day;case __WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].DATE_FORMAT_2:return year+'/'+month+'/'+day;case __WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].DATE_FORMAT_3:return month+'-'+day+'-'+year;case __WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].DATE_FORMAT_4:return day+'.'+month+'.'+year;case __WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].DATE_FORMAT_5:return day+'-'+month+'-'+year;case __WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].DATE_FORMAT_6:return day+'/'+month+'/'+year;default:return year+'-'+month+'-'+day;}}function formatTime(timeStr,formatType){if(formatType===__WEBPACK_IMPORTED_MODULE_1__static__["a" /* DATE_FORMATS */].TIME_FORMAT_2){return timeStr;}if(timeStr==='24:00'){return'midnight';}var _timeStr$split=timeStr.split(':'),_timeStr$split2=_slicedToArray(_timeStr$split,2),hourStr=_timeStr$split2[0],minuteStr=_timeStr$split2[1];var hour=parseInt(hourStr,10);var postFix=hour<12?'am':'pm';var hourFormated=''+(hour%12||12);var minuteFormated=minuteStr==='00'?'':':'+minuteStr;return''+hourFormated+minuteFormated+postFix;}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = translate;
/* harmony export (immutable) */ __webpack_exports__["a"] = getTranslation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__de__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nl__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fr__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fin__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pt__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__swe__ = __webpack_require__(141);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var translations={de:__WEBPACK_IMPORTED_MODULE_1__de__["a" /* default */],en:__WEBPACK_IMPORTED_MODULE_2__en__["a" /* default */],nl:__WEBPACK_IMPORTED_MODULE_3__nl__["a" /* default */],fr:__WEBPACK_IMPORTED_MODULE_4__fr__["a" /* default */],es:__WEBPACK_IMPORTED_MODULE_5__es__["a" /* default */],fin:__WEBPACK_IMPORTED_MODULE_6__fin__["a" /* default */],pt:__WEBPACK_IMPORTED_MODULE_7__pt__["a" /* default */],swe:__WEBPACK_IMPORTED_MODULE_8__swe__["a" /* default */]};function translate(langStringKey,langKey){var args=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var translation=getTranslation(langKey);var str='';if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isFunction(translation[langStringKey])){str=translation[langStringKey](args);}else if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(translation[langStringKey])){str=translation[langStringKey];}return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.entries(args).reduce(function(memo,_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],val=_ref2[1];return memo.replace('%'+key+'%',val);},str);}function getTranslation(langKey){return translations[langKey];}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutability_helper__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_lodash__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TimeDropdown__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_openingHours__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimeRanges_css__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimeRanges_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TimeRanges_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _validationMessages;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var validationMessages=(_validationMessages={},_defineProperty(_validationMessages,__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["a" /* INVALID_RANGE */],'Time range is invalid'),_defineProperty(_validationMessages,__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["b" /* INVALID_TIME_STRING */],'Time is invalid'),_defineProperty(_validationMessages,__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["d" /* OVERLAPPING_RANGE */],'Time ranges are overlapping'),_validationMessages);var defaultFrom='00:00';var defaultTo='00:00';var MAX_TIMERANGES=3;var TimeRanges=function(_React$Component){_inherits(TimeRanges,_React$Component);function TimeRanges(props){_classCallCheck(this,TimeRanges);var _this=_possibleConstructorReturn(this,(TimeRanges.__proto__||Object.getPrototypeOf(TimeRanges)).call(this,props));_this.removeTimerange=_this.removeTimerange.bind(_this);_this.addTimerange=_this.addTimerange.bind(_this);_this.isAddTimerangeDisabled=_this.isAddTimerangeDisabled.bind(_this);_this.updateTimeranges=_this.updateTimeranges.bind(_this);_this.updateRangeValue=_this.updateRangeValue.bind(_this);var errors=Object(__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["h" /* validateOpeningHours */])(props.timeranges||[]);_this.state={timeranges:props.timeranges,errors:errors};return _this;}_createClass(TimeRanges,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var timeranges=nextProps.timeranges;if(timeranges!==this.props.timeranges){var errors=Object(__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["h" /* validateOpeningHours */])(timeranges);this.setState({timeranges:timeranges,errors:errors});}}},{key:'addTimerange',value:function addTimerange(){var timeranges=this.state.timeranges;var from=void 0;var to=void 0;if(!timeranges.length){from='08:00';to='12:00';}else{var lastRange=__WEBPACK_IMPORTED_MODULE_1__services_lodash__["a" /* default */].last(timeranges);var extractedTo=Object(__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["e" /* extractHoursAndMinutes */])(lastRange.to);if(extractedTo.hours<=22&&lastRange.from!=='00:00'&&lastRange.to!=='00:00'){from=__WEBPACK_IMPORTED_MODULE_1__services_lodash__["a" /* default */].padStart(extractedTo.hours+1,2,'0')+':00';to=__WEBPACK_IMPORTED_MODULE_1__services_lodash__["a" /* default */].padStart(extractedTo.hours+2,2,'0')+':00';}else{// TODO: not sure if this makes sense here..
from=defaultFrom;to=defaultTo;}}var newTimeranges=timeranges.concat([{from:from,to:to}]);this.updateTimeranges(newTimeranges);}},{key:'removeTimerange',value:function removeTimerange(idxToRemove){var timeranges=this.state.timeranges;var newTimeranges=timeranges.filter(function(range,i){return i!==idxToRemove;});this.updateTimeranges(newTimeranges);}},{key:'updateRangeValue',value:function updateRangeValue(i,key,val){// No change
if(val===this.state.timeranges[i][key]){return;}// Update timeranges, validate and save errors
var newTimeranges=__WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(this.state.timeranges,_defineProperty({},i,_defineProperty({},key,{$set:val})));this.updateTimeranges(newTimeranges);}},{key:'updateTimeranges',value:function updateTimeranges(newTimeranges){var errors=Object(__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["h" /* validateOpeningHours */])(newTimeranges);this.setState(function(){return{timeranges:newTimeranges,errors:errors};});if(!errors.length){this.props.onChange(newTimeranges);}}},{key:'isAddTimerangeDisabled',value:function isAddTimerangeDisabled(){var timeranges=this.state.timeranges;if(timeranges.length>=MAX_TIMERANGES){return true;}if(timeranges.length){var lastRange=__WEBPACK_IMPORTED_MODULE_1__services_lodash__["a" /* default */].last(timeranges);return lastRange.to==='24:00';}return false;}},{key:'render',value:function render(){var _this2=this;// List errors
var errorTypes=__WEBPACK_IMPORTED_MODULE_1__services_lodash__["a" /* default */].uniq(this.state.errors.map(function(_ref){var type=_ref.type;return type;}));var errorMsg=void 0;if(errorTypes.length){errorMsg=__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('div',{className:'errors'},__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('div',{className:'control-section-divider labeled'},errorTypes.map(function(err){return validationMessages[err];}).join(', ')));}// For marking invalid fields
// let invalidFields = this.state.errors.reduce(
//   (fields, err) => fields.add(err.path),
//   new Set()
// );
// let isValid = (i, key) =>
//  !(invalidFields.has(`${i}.${key}`) || invalidFields.has(`${i}`));
// List time ranges
var timeranges=void 0;// Omit table when empty
if(this.state.timeranges.length){timeranges=this.state.timeranges.map(function(timerange,i){return __WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('div',{key:i},__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_3__services_UI__["a" /* default */].sectionDividerLabeled,{label:'Time Slot '+(i+1)}),__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('hr',{className:'divider-long'}),errorMsg,__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_4__TimeDropdown__["a" /* default */],{value:timerange.from,title:'From',onChange:function onChange(newVal){return _this2.updateRangeValue(i,'from',newVal);}}),__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_4__TimeDropdown__["a" /* default */],{value:timerange.to,title:'To',onChange:function onChange(newVal){return _this2.updateRangeValue(i,'to',newVal);}}),__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('div',{className:'DeleteButton__Wrapper'},__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_3__services_UI__["a" /* default */].button,{label:'Delete Time Slot '+(i+1),className:'btn-text',onClick:function onClick(){return _this2.removeTimerange(i);}})));});}var tooltipHTML=void 0;if(this.isAddTimerangeDisabled()){tooltipHTML=__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('div',{className:'TimeRanges__TooltipWrapper'},__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_3__services_UI__["a" /* default */].tooltip,{value:'You\u2019ve reached the maximum number of time slots.'},__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_3__services_UI__["a" /* default */].symbol,{name:'info'})));}return __WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('div',{className:'TimeRanges'},timeranges,__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement('div',{className:'TimeRanges__ButtonWrapper'},__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_3__services_UI__["a" /* default */].button,{className:'btn-confirm-primary add',onClick:this.addTimerange,disabled:this.isAddTimerangeDisabled(),label:'Add Time Slot'}),tooltipHTML));}}]);return TimeRanges;}(__WEBPACK_IMPORTED_MODULE_2__services_React__["a" /* default */].Component);/* harmony default export */ __webpack_exports__["a"] = (TimeRanges);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39);
module.exports = __webpack_require__(44);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(40).enable();
  window.Promise = __webpack_require__(42);
}

// fetch() polyfill for making API calls.
__webpack_require__(43);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(23);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(22);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(22);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_services_utils__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apps__ = __webpack_require__(46);
// set CUSTOM_INSTANCE if you want to test premium features
var CUSTOM_INSTANCE=null;var context=Object(__WEBPACK_IMPORTED_MODULE_3__commons_services_utils__["b" /* getContext */])(window.location.search);if(CUSTOM_INSTANCE&&window.history.pushState&&context.instance!==CUSTOM_INSTANCE){context=Object.assign({},context,{instance:CUSTOM_INSTANCE});var newurl=window.location.protocol+'//'+window.location.host+window.location.pathname+'?'+__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(context);window.history.pushState({path:newurl},'',newurl);window.location.reload();}if(context.app in __WEBPACK_IMPORTED_MODULE_4__apps__["a" /* default */]){var App=__WEBPACK_IMPORTED_MODULE_4__apps__["a" /* default */][context.app];__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(App,{context:context}),document.getElementById('root'));}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings_Settings__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_Modal__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widget_Widget__ = __webpack_require__(182);
/* harmony default export */ __webpack_exports__["a"] = ({Settings:__WEBPACK_IMPORTED_MODULE_0__settings_Settings__["a" /* default */],Modal:__WEBPACK_IMPORTED_MODULE_1__modal_Modal__["a" /* default */],Widget:__WEBPACK_IMPORTED_MODULE_2__widget_Widget__["a" /* default */]});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_components_PanelTabs__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_components_createSettingsStateContainer__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_components_createStylesContainer__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MainTab__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SettingsTab__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HoursTab__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BadgesTab__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DesignTab__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SupportTab__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Settings_css__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Settings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Settings_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// tabs
function createSettingsContainer(WrappedComponent){return function(_React$Component){_inherits(_class,_React$Component);function _class(props){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props));_this.setActiveTabIndex=_this.setActiveTabIndex.bind(_this);_this.state={activeTabIndex:0};return _this;}_createClass(_class,[{key:'setActiveTabIndex',value:function setActiveTabIndex(activeTabIndex){this.setState(function(){return{activeTabIndex:activeTabIndex};});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({},this.state,this.props,{setActiveTabIndex:this.setActiveTabIndex}));}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);}var Settings=function(_React$Component2){_inherits(Settings,_React$Component2);function Settings(){_classCallCheck(this,Settings);return _possibleConstructorReturn(this,(Settings.__proto__||Object.getPrototypeOf(Settings)).apply(this,arguments));}_createClass(Settings,[{key:'render',value:function render(){var _this3=this;var _props=this.props,data=_props.data,updateData=_props.updateData,activeTabIndex=_props.activeTabIndex,setActiveTabIndex=_props.setActiveTabIndex,styles=_props.styles,fetchStyles=_props.fetchStyles;if(!data){return null;}var upgradeSection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);if(!Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["c" /* isPremium */])()){upgradeSection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].button,{label:'Upgrade',className:'btn-upgrade-nav',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["d" /* openBillingPage */])();}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].appSettings,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commons_components_PanelTabs__["a" /* default */],{activeTabIndex:activeTabIndex,onChange:setActiveTabIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MainTab__["a" /* default */],{tab:'Main',data:data,styles:styles,onUpdate:updateData,onPrimaryButtonClick:function onPrimaryButtonClick(){return setActiveTabIndex(1);},onSecondaryButtonClick:function onSecondaryButtonClick(){return setActiveTabIndex(3);},onUpgradeClick:function onUpgradeClick(){Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["d" /* openBillingPage */])();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__HoursTab__["a" /* default */],{tab:'Hours',data:data,styles:styles,ref:function ref(cmp){return _this3.hoursTabCmp=cmp;},onActive:function onActive(){return _this3.hoursTabCmp&&_this3.hoursTabCmp.reset();},onUpdate:updateData,onUpgradeClick:function onUpgradeClick(){Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["d" /* openBillingPage */])();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SettingsTab__["a" /* default */],{tab:'Settings',data:data,styles:styles,onUpdate:updateData,onUpgradeClick:function onUpgradeClick(){Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["d" /* openBillingPage */])();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BadgesTab__["a" /* default */],{tab:'Signs',data:data,styles:styles,fetchStyles:fetchStyles,onUpdate:updateData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__DesignTab__["a" /* default */],{tab:'Design',data:data,styles:styles,onUpdate:updateData,onUpgradeClick:function onUpgradeClick(){Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["d" /* openBillingPage */])();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SupportTab__["a" /* default */],{tab:'Support',data:data,styles:styles,onUpdate:updateData}),upgradeSection));}}]);return Settings;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__commons_components_createStylesContainer__["a" /* default */])(createSettingsContainer(Object(__WEBPACK_IMPORTED_MODULE_4__commons_components_createSettingsStateContainer__["a" /* default */])(Settings))));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_UI__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PanelTabs=function(_React$Component){_inherits(PanelTabs,_React$Component);function PanelTabs(){_classCallCheck(this,PanelTabs);return _possibleConstructorReturn(this,(PanelTabs.__proto__||Object.getPrototypeOf(PanelTabs)).apply(this,arguments));}_createClass(PanelTabs,[{key:'setActiveTab',value:function setActiveTab(idx){this.panelTabsCmp.setActiveTab(idx);}},{key:'componentDidMount',value:function componentDidMount(){this.setActiveTab(this.props.activeTabIndex);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.activeTabIndex!==this.props.activeTabIndex){this.setActiveTab(nextProps.activeTabIndex);}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].panelTabs,Object.assign({},this.props,{ref:function ref(input){_this2.panelTabsCmp=input;}}));}}]);return PanelTabs;}(__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].Component);/* harmony default export */ __webpack_exports__["a"] = (PanelTabs);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutability_helper__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce_promise__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_services_request__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_components_SelectErrorMessage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_services_errorCodes__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// here we are gonna handle the state of the settings area.
// if stuff gets too complex, we will switch to redux or mobx.
// component specfic ui-state can also be handled in the sub-component
// but the main state should ne handled in here.
function createSettingsStateContainer(WrappedComponent){return function(_React$Component){_inherits(_class,_React$Component);function _class(props){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props));_this.setData=_this.setData.bind(_this);_this.updateData=_this.updateData.bind(_this);_this.fetchData=_this.fetchData.bind(_this);// debounce the save operation. because it gets
// called for example onChange of text inputs (which
// could be quite often).
_this.saveData=__WEBPACK_IMPORTED_MODULE_1_debounce_promise___default()(_this.saveData.bind(_this),250);_this.state={// data contains the the settings data.
// if a setting gets changed, we are just gonna
// save the entire data away.
data:null,// keep the last successfully saved data arround.
// so we can revert to that data if something fails.
lastSavedData:null,errorCode:null};return _this;}_createClass(_class,[{key:'setData',value:function setData(data){var save=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var triggerSettingsUpdate=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;// for now we will optimisticly update data
// to keep the UI more responsive.
this.setState(function(){return{data:data};});if(triggerSettingsUpdate){Object(__WEBPACK_IMPORTED_MODULE_5__commons_services_Wix__["g" /* triggerSettingsUpdatedEvent */])(data);}if(save){// store the settings in the backend
return this.saveData(data);}}},{key:'saveData',value:function saveData(dataArg){var _this2=this;// filter data which should not be saved
var data=__WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(dataArg,{$unset:['hoverBadge']});return __WEBPACK_IMPORTED_MODULE_3__commons_services_request__["a" /* default */].put('/api/settings/draft',data).catch(function(err){// revert data if save failed
_this2.setState(function(_ref){var lastSavedData=_ref.lastSavedData;Object(__WEBPACK_IMPORTED_MODULE_5__commons_services_Wix__["g" /* triggerSettingsUpdatedEvent */])(lastSavedData);return{data:lastSavedData,errorCode:err.response.status===403?__WEBPACK_IMPORTED_MODULE_6__commons_services_errorCodes__["a" /* AUTH_ERROR */]:__WEBPACK_IMPORTED_MODULE_6__commons_services_errorCodes__["b" /* UNEXPECTED_ERROR */]};});return Promise.reject(err);}).then(function(res){_this2.setState(function(){return{lastSavedData:data};});return res;});}// update data using immutability-helper
},{key:'updateData',value:function updateData(data,spec,save,triggerSettingsUpdate){return this.setData(__WEBPACK_IMPORTED_MODULE_0_immutability_helper___default()(data,spec),save,triggerSettingsUpdate);}},{key:'fetchData',value:function fetchData(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_3__commons_services_request__["a" /* default */].get('/api/settings/draft').then(function(_ref2){var data=_ref2.data;_this3.setState(function(){return{data:data,lastSavedData:data};});},function(err){_this3.setState(function(){return{errorCode:err.response.status===403?__WEBPACK_IMPORTED_MODULE_6__commons_services_errorCodes__["a" /* AUTH_ERROR */]:__WEBPACK_IMPORTED_MODULE_6__commons_services_errorCodes__["b" /* UNEXPECTED_ERROR */]};});});}},{key:'componentDidMount',value:function componentDidMount(){this.fetchData();}},{key:'render',value:function render(){var errorCode=this.state.errorCode;if(errorCode){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commons_components_SelectErrorMessage__["a" /* default */],{code:errorCode});}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrappedComponent,Object.assign({},this.state,this.props,{updateData:this.updateData,fetchData:this.fetchData}));}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);}/* harmony default export */ __webpack_exports__["a"] = (createSettingsStateContainer);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* global setTimeout, clearTimeout */

module.exports = function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var lastCallAt = void 0;
  var deferred = void 0;
  var timer = void 0;
  var pendingArgs = [];
  return function debounced() {
    var currentWait = getWait(wait);
    var currentTime = new Date().getTime();

    var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;

    lastCallAt = currentTime;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isCold && options.leading) {
      return options.accumulate ? Promise.resolve(fn.call(this, [args])).then(function (result) {
        return result[0];
      }) : Promise.resolve(fn.call.apply(fn, [this].concat(args)));
    }

    if (deferred) {
      clearTimeout(timer);
    } else {
      deferred = defer();
    }

    pendingArgs.push(args);
    timer = setTimeout(flush.bind(this), currentWait);

    if (options.accumulate) {
      var _ret = function () {
        var argsIndex = pendingArgs.length - 1;
        return {
          v: deferred.promise.then(function (results) {
            return results[argsIndex];
          })
        };
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }

    return deferred.promise;
  };

  function flush() {
    var thisDeferred = deferred;
    clearTimeout(timer);

    Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);

    pendingArgs = [];
    deferred = null;
  }
};

function getWait(wait) {
  return typeof wait === 'function' ? wait() : wait;
}

function defer() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(53);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var bind = __webpack_require__(27);
var Axios = __webpack_require__(55);
var defaults = __webpack_require__(16);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(31);
axios.CancelToken = __webpack_require__(70);
axios.isCancel = __webpack_require__(30);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(71);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(16);
var utils = __webpack_require__(4);
var InterceptorManager = __webpack_require__(65);
var dispatchRequest = __webpack_require__(66);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(29);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var transformData = __webpack_require__(67);
var isCancel = __webpack_require__(30);
var defaults = __webpack_require__(16);
var isAbsoluteURL = __webpack_require__(68);
var combineURLs = __webpack_require__(69);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(31);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorMessage__ = __webpack_require__(33);
function AuthErrorMessage(){return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__ErrorMessage__["a" /* default */],{title:'Authentication failed',message:'The backend could not authenticate the incoming request.'});}/* harmony default export */ __webpack_exports__["a"] = (AuthErrorMessage);

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorMessage__ = __webpack_require__(33);
function AuthErrorMessage(){return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__ErrorMessage__["a" /* default */],{title:'Unexpected error',message:'There was an unexpected error. Please reload the app.'});}/* harmony default export */ __webpack_exports__["a"] = (AuthErrorMessage);

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badges_index_js__ = __webpack_require__(77);
/* harmony default export */ __webpack_exports__["a"] = ({badgesList:__WEBPACK_IMPORTED_MODULE_0__badges_index_js__["a" /* badgesList */]});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return badgesList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__simple_index__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__radial_1_index__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radial_2_index__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radial_3_index__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__radial_4_index__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__radial_5_index__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__radial_6_index__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__radial_7_index__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__radial_8_index__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__radial_9_index__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__radial_10_index__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__radial_11_index__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__radial_12_index__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__radial_13_index__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__radial_14_index__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__burger_index__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__blank_1_index__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__blank_2_index__ = __webpack_require__(129);
var badgesList=[__WEBPACK_IMPORTED_MODULE_0__simple_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1__radial_1_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__radial_2_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3__radial_3_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__radial_4_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5__radial_5_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_6__radial_6_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_15__burger_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_7__radial_7_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_8__radial_8_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_17__blank_2_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_9__radial_9_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_10__radial_10_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_11__radial_11_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_16__blank_1_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_12__radial_12_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_13__radial_13_index__["a" /* default */],__WEBPACK_IMPORTED_MODULE_14__radial_14_index__["a" /* default */]];/* unused harmony default export */ var _unused_webpack_default_export = ({simple:__WEBPACK_IMPORTED_MODULE_0__simple_index__["a" /* default */],radial_1:__WEBPACK_IMPORTED_MODULE_1__radial_1_index__["a" /* default */],radial_2:__WEBPACK_IMPORTED_MODULE_2__radial_2_index__["a" /* default */],radial_3:__WEBPACK_IMPORTED_MODULE_3__radial_3_index__["a" /* default */],radial_4:__WEBPACK_IMPORTED_MODULE_4__radial_4_index__["a" /* default */],radial_5:__WEBPACK_IMPORTED_MODULE_5__radial_5_index__["a" /* default */],radial_6:__WEBPACK_IMPORTED_MODULE_6__radial_6_index__["a" /* default */],burger:__WEBPACK_IMPORTED_MODULE_15__burger_index__["a" /* default */],radial_7:__WEBPACK_IMPORTED_MODULE_7__radial_7_index__["a" /* default */],radial_8:__WEBPACK_IMPORTED_MODULE_8__radial_8_index__["a" /* default */],blank_2:__WEBPACK_IMPORTED_MODULE_17__blank_2_index__["a" /* default */],radial_9:__WEBPACK_IMPORTED_MODULE_9__radial_9_index__["a" /* default */],radial_10:__WEBPACK_IMPORTED_MODULE_10__radial_10_index__["a" /* default */],radial_11:__WEBPACK_IMPORTED_MODULE_11__radial_11_index__["a" /* default */],blank_1:__WEBPACK_IMPORTED_MODULE_16__blank_1_index__["a" /* default */],radial_12:__WEBPACK_IMPORTED_MODULE_12__radial_12_index__["a" /* default */],radial_13:__WEBPACK_IMPORTED_MODULE_13__radial_13_index__["a" /* default */],radial_14:__WEBPACK_IMPORTED_MODULE_14__radial_14_index__["a" /* default */]});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(79);
/* harmony default export */ __webpack_exports__["a"] = ({id:'simple',title:'Simple',isDefault:true,premium:false,animated:true,supportsNoSubline:true,colors:3,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},es:{small:true},fin:{small:true}}});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line3=_ref.line3,line4=_ref.line4,disableSubline=_ref.disableSubline,languageSettings=_ref.languageSettings,showFreePlanClaim=_ref.showFreePlanClaim;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'SimpleBadge Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'MOUNTING'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ellipse',{cx:'199.75',cy:'9.47',rx:'9.5',ry:'9.47',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'298.32 121.33 195.27 9.89 199.68 5.83 302.73 117.27 298.32 121.33',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'101.68 121.33 204.73 9.89 200.32 5.83 97.27 117.27 101.68 121.33',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'RECTANGLE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{y:'110.59',width:'400',height:'199.47',rx:'20',ry:'20',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M375,125.55a10,10,0,0,1,10,10v149.6a10,10,0,0,1-10,10H25a10,10,0,0,1-10-10V135.53a10,10,0,0,1,10-10H375m0-3H25a13,13,0,0,0-13,13v149.6a13,13,0,0,0,13,13H375a13,13,0,0,0,13-13V135.53a13,13,0,0,0-13-13Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY_RIGHT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M372.86,136s-.38,9.29-.65,23.24c-.15,7-.27,15.11-.35,23.82,0,4.36-.09,8.86-.09,13.44s0,9.22,0,13.87,0,9.29,0,13.87.07,9.08.1,13.43c.08,8.72.2,16.85.35,23.82.27,13.95.65,23.24.65,23.24s.38-9.29.65-23.24c.15-7,.27-15.1.35-23.82,0-4.35.09-8.86.1-13.43s0-9.23,0-13.87,0-9.3,0-13.87-.06-9.08-.09-13.44c-.08-8.71-.2-16.85-.35-23.82C373.24,145.25,372.86,136,372.86,136Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'326.01 212.27 367.75 211.19 367.75 213.36 326.01 212.27',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'335.09 225.95 367.75 219.67 367.75 221.86 335.09 225.95',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'339.27 236.88 367.75 227.58 367.75 229.81 339.27 236.88',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'344.77 247.73 367.75 235.59 367.75 237.99 344.77 247.73',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'348.07 259.63 367.75 244.79 367.75 247.23 348.07 259.63',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'355.2 268.45 367.75 256.11 367.75 258.46 355.2 268.45',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'361.88 277.17 367.75 269.37 367.75 271.49 361.88 277.17',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'335.09 198.53 367.75 204.68 367.75 202.53 335.09 198.53',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'339.27 187.86 367.75 196.94 367.75 194.76 339.27 187.86',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'344.77 177.24 367.75 189.11 367.75 186.76 344.77 177.24',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'348.07 165.6 367.75 180.13 367.75 177.73 348.07 165.6',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'355.2 156.98 367.75 169.04 367.75 166.75 355.2 156.98',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'361.88 148.46 367.75 156.08 367.75 154.01 361.88 148.46',className:'Badge__ThirdFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY_LEFT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M27.14,136s.38,9.29.65,23.24c.15,7,.27,15.11.35,23.82,0,4.36.09,8.86.09,13.44s0,9.22.05,13.87,0,9.29,0,13.87-.07,9.08-.1,13.43c-.08,8.72-.2,16.85-.35,23.82-.27,13.95-.65,23.24-.65,23.24s-.38-9.29-.65-23.24c-.15-7-.27-15.1-.35-23.82,0-4.35-.09-8.86-.1-13.43s0-9.23,0-13.87,0-9.3,0-13.87.06-9.08.09-13.44c.08-8.71.2-16.85.35-23.82C26.76,145.25,27.14,136,27.14,136Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'73.99 212.27 32.25 211.19 32.25 213.36 73.99 212.27',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'64.91 225.95 32.25 219.67 32.25 221.86 64.91 225.95',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'60.73 236.88 32.25 227.58 32.25 229.81 60.73 236.88',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'55.23 247.73 32.25 235.59 32.25 237.99 55.23 247.73',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'51.93 259.63 32.25 244.79 32.25 247.23 51.93 259.63',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'44.8 268.45 32.25 256.11 32.25 258.46 44.8 268.45',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'38.12 277.17 32.25 269.37 32.25 271.49 38.12 277.17',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'64.91 198.53 32.25 204.68 32.25 202.53 64.91 198.53',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'60.73 187.86 32.25 196.94 32.25 194.76 60.73 187.86',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'55.23 177.24 32.25 189.11 32.25 186.76 55.23 177.24',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'51.93 165.6 32.25 180.13 32.25 177.73 51.93 165.6',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'44.8 156.98 32.25 169.04 32.25 166.75 44.8 156.98',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'38.12 148.46 32.25 156.08 32.25 154.01 38.12 148.46',className:'Badge__ThirdFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'49%',y:disableSubline?'50%':'48%',dy:'.9ex',textAnchor:'middle',fontFamily:'Norican',fontSize:languageSettings.small?'3.5em':'6em',letterSpacing:'0em',className:'Badge__SecondFillColor'},line0),!disableSubline?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:languageSettings.small?'63%':'66%',textAnchor:'middle',fontFamily:'Rajdhani',fontSize:languageSettings.small?'1em':'1.4em',fontWeight:'700',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},line3.toUpperCase(),' ',line4.toUpperCase()):null,showFreePlanClaim?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{className:'Badge__FirstFillColor',x:'25%',y:'30%',width:'200',height:'30'}):null,showFreePlanClaim?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'35%',textAnchor:'middle',fontFamily:'Rajdhani',fontSize:'1.4em',fontWeight:'700',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},'++ FREE PLAN ++'):null));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(82);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_1',title:'Radial_1',colors:3,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_1 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_1__TopCircle',d:'M 47 200 A 50 50 0 0 1 353 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_1__BottomCircle',d:'M 47 200 A 50 50 0 0 0 353 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'CIRCLE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'200',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHAPE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,388.42C96.11,388.42,11.58,303.89,11.58,200S96.11,11.58,200,11.58,388.42,96.11,388.42,200,303.89,388.42,200,388.42Zm0-371.88C98.84,16.54,16.54,98.84,16.54,200S98.84,383.46,200,383.46,383.46,301.16,383.46,200,301.16,16.54,200,16.54Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,325.2A125.2,125.2,0,1,1,325.2,200,125.35,125.35,0,0,1,200,325.2Zm0-245.44A120.24,120.24,0,1,0,320.24,200,120.38,120.38,0,0,0,200,79.76Z',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'STARS'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'48.81 181.35 45.38 175.04 42.06 181.4 35.01 182.72 40.03 187.85 39.11 194.96 45.53 191.78 52.01 194.85 50.97 187.75 55.89 182.53 48.81 181.35',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'361.74 182.53 354.67 181.35 351.24 175.04 347.91 181.4 340.86 182.72 345.88 187.85 344.96 194.96 351.38 191.78 357.87 194.85 356.81 187.75 361.74 182.53',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'216.94 116 205.46 114.07 199.89 103.83 194.5 114.16 183.06 116.31 191.21 124.63 189.71 136.16 200.13 131 210.66 135.98 208.94 124.46 216.94 116',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'250.59 127.5 243.41 126.29 239.93 119.89 236.56 126.35 229.41 127.69 234.5 132.89 233.57 140.11 240.08 136.87 246.66 139.99 245.59 132.79 250.59 127.5',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'170.59 127.5 163.41 126.29 159.93 119.89 156.56 126.35 149.41 127.69 154.5 132.89 153.57 140.11 160.08 136.87 166.66 139.99 165.59 132.79 170.59 127.5',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TREES'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M176.3,310.08a102.33,102.33,0,0,0,11.49-16h-5.48a83.23,83.23,0,0,0,9.75-13.95h-5.93c5.79-6.36,11.1-17.07,13.89-23.21v0c2.78,6.14,8.1,16.85,13.89,23.21H208a82.08,82.08,0,0,0,9.75,13.95h-5.49a103.64,103.64,0,0,0,11.49,16h-6.46c2.32,3.8,4.76,7.51,7.28,11q-11.87-.46-23.73-.47-12.69,0-25.39.53c2.53-3.5,5-7.23,7.32-11.05Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M149.82,309.88A52.87,52.87,0,0,0,156,301h-3.78c3.69-4.06,7.08-10.88,8.85-14.79v0h0v0c1.77,3.91,5.16,10.73,8.85,14.79h-3.78a52.33,52.33,0,0,0,6.22,8.89h-3.5a66.64,66.64,0,0,0,7.32,10.21Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M225.82,320.09a66,66,0,0,0,7.32-10.21h-3.5a52.33,52.33,0,0,0,6.22-8.89h-3.78c3.69-4.06,7.08-10.88,8.85-14.79v0h0v0c1.77,3.91,5.16,10.73,8.85,14.79H246a52.87,52.87,0,0,0,6.21,8.89Z',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'45%',textAnchor:'middle',dy:'.7ex',fontFamily:'Lobster',fontSize:languageSettings.small?'3em':'6em',letterSpacing:'0em',transform:'rotate(-10) translate(-40,45)',className:'Badge__SecondFillColor'},line0),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Abel',fontSize:languageSettings.small?'1.9em':'2.3em',letterSpacing:'0.07em',className:'Badge__FirstFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_1__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Abel',fontSize:languageSettings.small?'1.9em':'2.3em',letterSpacing:'0.07em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_1__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(85);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_2',title:'Radial_2',colors:3,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_2 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_2__TopCircle',d:'M 73 200 A 50 50 0 0 1 323 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_2__BottomCircle',d:'M 73 200 A 50 50 0 0 0 323 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'CIRCLE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'200',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'STARS'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'323.02 196.83 320 190.72 316.98 196.83 310.23 197.81 315.12 202.56 313.97 209.28 320 206.12 326.04 209.28 324.88 202.56 329.77 197.81 323.02 196.83',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'83.02 196.83 80 190.72 76.98 196.83 70.23 197.81 75.12 202.56 73.97 209.28 80 206.12 86.04 209.28 84.88 202.56 89.77 197.81 83.02 196.83',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'RADIAL_LINE_DOTS'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M383.55,204.2l-9.07-.25a1,1,0,0,0-1.05,1,1,1,0,0,0,1,1.05l9.06.25h0a1,1,0,0,0,0-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M383.32,210.47l-9.05-.56a1,1,0,1,0-.13,2l9.05.56h.07a1,1,0,0,0,.06-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M382.88,216.72l-9-.87a1,1,0,0,0-.19,2l9,.86h.1a1,1,0,0,0,.1-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M382.18,223l-9-1.17a1,1,0,0,0-.26,2l9,1.17H382a1,1,0,0,0,.14-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M381.31,229.16l-8.95-1.48a1,1,0,0,0-.33,2l8.94,1.48h.17a1,1,0,0,0,.17-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M380.24,235.34l-8.89-1.78a1,1,0,1,0-.4,2l8.89,1.78a.68.68,0,0,0,.2,0,1,1,0,0,0,.2-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M378.9,241.47l-8.83-2.09a1,1,0,1,0-.47,2l8.83,2.09a.85.85,0,0,0,.23,0,1,1,0,0,0,.24-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M377.39,247.56l-8.75-2.4a1,1,0,0,0-.54,2l8.75,2.39a.84.84,0,0,0,.27,0,1,1,0,0,0,.27-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M375.71,253.6l-8.66-2.69a1,1,0,0,0-1.28.67,1,1,0,0,0,.67,1.27l8.66,2.7a1,1,0,0,0,1.28-.67A1,1,0,0,0,375.71,253.6Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M373.73,259.55l-8.56-3a1,1,0,1,0-.67,1.93l8.56,3a1,1,0,0,0,.34.06,1,1,0,0,0,.33-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M371.59,265.45l-8.45-3.28a1,1,0,1,0-.74,1.9l8.45,3.28a1,1,0,0,0,.74-1.9Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M369.29,271.28,361,267.71a1,1,0,0,0-.8,1.88l8.33,3.57a1.19,1.19,0,0,0,.41.08,1,1,0,0,0,.4-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M366.74,277l-8.21-3.85a1,1,0,1,0-.87,1.84l8.21,3.86a1.11,1.11,0,0,0,.43.09,1,1,0,0,0,.44-1.94Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M364,282.65l-8.07-4.14a1,1,0,1,0-.93,1.82l8.07,4.13a1,1,0,0,0,.46.12,1,1,0,0,0,.91-.56A1,1,0,0,0,364,282.65Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M361.08,288.2l-7.92-4.4a1,1,0,1,0-1,1.78l7.92,4.41a1.13,1.13,0,0,0,.5.13,1,1,0,0,0,.49-1.92Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M358,293.66,350.22,289a1,1,0,0,0-1.4.35,1,1,0,0,0,.35,1.4l7.77,4.68a1,1,0,0,0,.52.14,1,1,0,0,0,.53-1.89Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M354.67,299,347.06,294a1,1,0,1,0-1.11,1.71l7.61,4.94a1,1,0,0,0,.55.16,1,1,0,0,0,.56-1.87Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M343.76,299a1,1,0,0,0-1.17,1.68l7.44,5.19a1,1,0,0,0,.58.19,1,1,0,0,0,.84-.44,1,1,0,0,0-.25-1.42Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M340.32,303.88a1,1,0,0,0-1.42.2,1,1,0,0,0,.2,1.43l7.25,5.44a1,1,0,0,0,.61.21,1,1,0,0,0,.82-.41,1,1,0,0,0-.2-1.43Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M336.67,308.58a1,1,0,0,0-1.44.16,1,1,0,0,0,.16,1.43l7.06,5.69a1,1,0,0,0,1.44-.15,1,1,0,0,0-.16-1.44Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M332.87,313.18a1,1,0,0,0-1.34,1.54l6.87,5.93a1,1,0,0,0,.67.25,1,1,0,0,0,.77-.36,1,1,0,0,0-.11-1.44Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M328.94,317.66a1,1,0,0,0-1.39,1.5l6.67,6.15a1,1,0,0,0,.69.28,1,1,0,0,0,.69-1.77Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M324.85,322a1,1,0,0,0-1.44,0,1,1,0,0,0,0,1.44l6.44,6.38a1,1,0,0,0,.72.29,1,1,0,0,0,.72-1.74Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M320.59,326.17a1,1,0,1,0-1.48,1.41l6.23,6.59a1,1,0,0,0,.74.32,1.05,1.05,0,0,0,.7-.28,1,1,0,0,0,0-1.44Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M316.22,330.22a1,1,0,0,0-1.53,1.35l6,6.8a1,1,0,0,0,.76.35,1,1,0,0,0,.68-.26,1,1,0,0,0,.09-1.44Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M311.73,334.15a1,1,0,0,0-1.44-.14,1,1,0,0,0-.13,1.44l5.76,7a1,1,0,0,0,.79.37,1.05,1.05,0,0,0,.65-.23,1,1,0,0,0,.14-1.44Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M307.06,337.86a1,1,0,0,0-1.43-.19,1,1,0,0,0-.19,1.43l5.53,7.2a1,1,0,0,0,.81.39,1,1,0,0,0,.62-.21,1,1,0,0,0,.19-1.43Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M302.29,341.43a1,1,0,0,0-1.42-.24,1,1,0,0,0-.24,1.43l5.28,7.37a1,1,0,1,0,1.66-1.18Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M297.42,344.87a1,1,0,1,0-1.7,1.13l5,7.55a1,1,0,0,0,.85.45,1,1,0,0,0,.57-.17,1,1,0,0,0,.28-1.41Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M292.42,348.11a1,1,0,0,0-1.74,1.08l4.76,7.71a1,1,0,0,0,.87.49,1,1,0,0,0,.54-.15,1,1,0,0,0,.33-1.41Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M287.3,351.17a1,1,0,1,0-1.77,1l4.49,7.87a1,1,0,0,0,.89.52,1,1,0,0,0,.5-.14,1,1,0,0,0,.38-1.39Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M282.09,354.07a1,1,0,0,0-1.37-.43,1,1,0,0,0-.43,1.38l4.22,8a1,1,0,0,0,.91.54,1,1,0,0,0,.47-.11,1,1,0,0,0,.43-1.38Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M276.8,356.82a1,1,0,1,0-1.83.89l3.94,8.17a1,1,0,0,0,.92.57,1,1,0,0,0,.45-.1,1,1,0,0,0,.47-1.36Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M271.39,359.32a1,1,0,1,0-1.86.82l3.66,8.3a1,1,0,0,0,.93.61,1.06,1.06,0,0,0,.42-.09,1,1,0,0,0,.52-1.35Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M265.91,361.66a1,1,0,1,0-1.89.76l3.38,8.42a1,1,0,0,0,.94.64,1,1,0,0,0,.38-.08,1,1,0,0,0,.57-1.32Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M260.37,363.85a1,1,0,0,0-1.92.69l3.09,8.53a1,1,0,0,0,1.92-.69Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M254.73,365.79a1,1,0,0,0-1.94.63l2.79,8.63a1,1,0,0,0,1,.71,1.19,1.19,0,0,0,.32-.05,1,1,0,0,0,.66-1.29Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249,367.55a1,1,0,1,0-2,.56l2.49,8.72a1,1,0,0,0,1,.74,1.35,1.35,0,0,0,.28,0,1,1,0,0,0,.7-1.27Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M243.3,369.14a1,1,0,0,0-1.24-.74,1,1,0,0,0-.74,1.24l2.19,8.8a1,1,0,0,0,1,.77l.25,0a1,1,0,0,0,.74-1.24Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M237.5,370.52a1,1,0,0,0-2,.42l1.89,8.87a1,1,0,0,0,1,.81.75.75,0,0,0,.21,0,1,1,0,0,0,.78-1.21Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M230.47,370.84a1,1,0,0,0-.83,1.18l1.58,8.93a1,1,0,0,0,1,.85l.17,0a1,1,0,0,0,.83-1.18l-1.58-8.93A1,1,0,0,0,230.47,370.84Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M224.62,371.79a1,1,0,0,0-.87,1.16l1.28,9a1,1,0,0,0,1,.88h.14a1,1,0,0,0,.87-1.15l-1.28-9A1,1,0,0,0,224.62,371.79Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M218.74,372.54a1,1,0,0,0-.91,1.12l1,9a1,1,0,0,0,1,.91h.11a1,1,0,0,0,.91-1.12l-1-9A1,1,0,0,0,218.74,372.54Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M212.83,373a1,1,0,0,0-.94,1.09l.66,9a1,1,0,0,0,1,.95h.07a1,1,0,0,0,1-1.1l-.66-9A1.06,1.06,0,0,0,212.83,373Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M206.92,373.39a1,1,0,0,0-1,1.05l.35,9.06a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1.06l-.35-9.06A1,1,0,0,0,206.92,373.39Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M201,373.53h0a1,1,0,0,0-1,1l.05,9.07a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1l-.06-9.07A1,1,0,0,0,201,373.53Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M195.06,373.43a1.07,1.07,0,0,0-1.05,1l-.25,9.07a1,1,0,0,0,1,1.05h0a1,1,0,0,0,1-1l.25-9.07A1,1,0,0,0,195.06,373.43Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M189.14,373.19a1,1,0,0,0-1.08.95l-.56,9.05a1,1,0,0,0,.95,1.09h.07a1,1,0,0,0,1-1l.56-9.05A1,1,0,0,0,189.14,373.19Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M183.23,372.74a1,1,0,0,0-1.12.92l-.86,9a1,1,0,0,0,.92,1.12h.09a1,1,0,0,0,1-.92l.86-9A1,1,0,0,0,183.23,372.74Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M177.34,372a1,1,0,0,0-1.14.88l-1.17,9a1,1,0,0,0,.88,1.15H176a1,1,0,0,0,1-.88l1.17-9A1,1,0,0,0,177.34,372Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M171.48,371.19a1,1,0,0,0-1.17.84L168.83,381a1,1,0,0,0,.84,1.18h.16a1,1,0,0,0,1-.85l1.48-8.95A1,1,0,0,0,171.48,371.19Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M165.64,370.14a1,1,0,0,0-1.2.8l-1.78,8.9a1,1,0,0,0,.8,1.2l.2,0a1,1,0,0,0,1-.82l1.78-8.89A1,1,0,0,0,165.64,370.14Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M159.86,368.84a1,1,0,0,0-1.22.76l-2.09,8.83a1,1,0,0,0,.75,1.22,1,1,0,0,0,.24,0,1,1,0,0,0,1-.79l2.09-8.82A1,1,0,0,0,159.86,368.84Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M154.12,367.39a1,1,0,0,0-1.25.71l-2.39,8.75a1,1,0,0,0,.71,1.25.84.84,0,0,0,.27,0,1,1,0,0,0,1-.75l2.39-8.75A1,1,0,0,0,154.12,367.39Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M148.42,365.77a1,1,0,0,0-1.28.67l-2.69,8.66a1,1,0,0,0,.67,1.28,1.15,1.15,0,0,0,.31,0,1,1,0,0,0,1-.71l2.69-8.66A1,1,0,0,0,148.42,365.77Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M142.81,363.87a1,1,0,0,0-1.3.63l-3,8.56a1,1,0,0,0,.63,1.3,1,1,0,0,0,.33.06,1,1,0,0,0,1-.69l3-8.56A1,1,0,0,0,142.81,363.87Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M137.25,361.82a1,1,0,0,0-1.32.58l-3.28,8.45a1,1,0,0,0,.58,1.32,1,1,0,0,0,.37.07,1,1,0,0,0,1-.65l3.28-8.45A1,1,0,0,0,137.25,361.82Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M131.75,359.61a1,1,0,0,0-1.34.54l-3.56,8.33a1,1,0,0,0,.53,1.34,1,1,0,0,0,.4.09,1,1,0,0,0,.94-.62l3.57-8.34A1,1,0,0,0,131.75,359.61Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M126.35,357.17a1,1,0,0,0-1.35.49l-3.86,8.21a1,1,0,0,0,.49,1.36,1.12,1.12,0,0,0,.44.09,1,1,0,0,0,.92-.58l3.85-8.21A1,1,0,0,0,126.35,357.17Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M121,354.54a1,1,0,0,0-1.37.45l-4.13,8.07a1,1,0,0,0,.44,1.37,1,1,0,0,0,.46.11,1,1,0,0,0,.91-.55l4.14-8.07A1,1,0,0,0,121,354.54Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M115.81,351.77a1,1,0,0,0-1.39.4L110,360.09a1,1,0,0,0,.4,1.39,1,1,0,0,0,.49.13,1,1,0,0,0,.9-.53l4.4-7.92A1,1,0,0,0,115.81,351.77Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M110.67,348.82a1,1,0,0,0-1.4.34l-4.68,7.77a1,1,0,0,0,.88,1.55,1,1,0,0,0,.87-.49l4.68-7.77A1,1,0,0,0,110.67,348.82Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M105.66,345.65a1,1,0,0,0-1.41.3l-4.94,7.61a1,1,0,0,0,.3,1.41,1,1,0,0,0,.56.16,1,1,0,0,0,.85-.46l4.94-7.61A1,1,0,0,0,105.66,345.65Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M100.74,342.34a1,1,0,0,0-1.42.25L94.13,350a1,1,0,0,0,.25,1.42,1,1,0,0,0,.58.18,1,1,0,0,0,.84-.43l5.2-7.44A1,1,0,0,0,100.74,342.34Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M95.92,338.89a1,1,0,0,0-1.43.21l-5.44,7.25a1,1,0,0,0,.81,1.64,1,1,0,0,0,.82-.41l5.44-7.26A1,1,0,0,0,95.92,338.89Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M91.26,335.23a1,1,0,0,0-1.43.16l-5.69,7.06a1,1,0,0,0,.15,1.43,1,1,0,0,0,.64.23,1,1,0,0,0,.8-.38l5.69-7.06A1,1,0,0,0,91.26,335.23Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M86.72,331.43a1,1,0,0,0-1.44.1l-5.93,6.87a1,1,0,0,0,.11,1.44,1,1,0,0,0,1.44-.11l5.92-6.86A1,1,0,0,0,86.72,331.43Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M82.28,327.5a1,1,0,0,0-1.44.05l-6.16,6.67a1,1,0,0,0,.06,1.44,1,1,0,0,0,.69.27,1,1,0,0,0,.75-.33l6.16-6.66A1,1,0,0,0,82.28,327.5Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M78,323.41a1,1,0,0,0-1.44,0l-6.38,6.44a1,1,0,0,0,0,1.45,1,1,0,0,0,.72.29,1,1,0,0,0,.72-.3L78,324.85A1,1,0,0,0,78,323.41Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M73.87,319.15a1,1,0,0,0-1.45,0l-6.59,6.23a1,1,0,0,0,.7,1.76,1,1,0,0,0,.7-.28l6.6-6.23A1,1,0,0,0,73.87,319.15Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M69.87,314.78a1,1,0,0,0-1.44-.09l-6.8,6a1,1,0,0,0,.67,1.78,1,1,0,0,0,.68-.25l6.8-6A1,1,0,0,0,69.87,314.78Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M66,310.29a1,1,0,0,0-1.44-.14l-7,5.77a1,1,0,0,0-.14,1.44,1,1,0,0,0,1.44.14l7-5.77A1,1,0,0,0,66,310.29Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M62.33,305.63a1,1,0,0,0-1.44-.18L53.7,311a1,1,0,0,0,.63,1.83,1.05,1.05,0,0,0,.62-.21l7.19-5.53A1,1,0,0,0,62.33,305.63Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M58.8,300.87a1,1,0,0,0-1.42-.24L50,305.91a1,1,0,0,0,.59,1.85,1,1,0,0,0,.59-.19l7.38-5.28A1,1,0,0,0,58.8,300.87Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M55.42,296a1,1,0,0,0-1.42-.28l-7.55,5a1,1,0,0,0,.57,1.87,1,1,0,0,0,.56-.17l7.55-5A1,1,0,0,0,55.42,296Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M52.22,291a1,1,0,0,0-1.41-.33l-7.71,4.76a1,1,0,0,0,.53,1.89,1,1,0,0,0,.54-.15l7.72-4.76A1,1,0,0,0,52.22,291Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M49.21,285.91a1,1,0,0,0-1.39-.38L40,290a1,1,0,0,0,.5,1.91.94.94,0,0,0,.51-.14l7.87-4.49A1,1,0,0,0,49.21,285.91Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M46.36,280.72a1,1,0,0,0-1.38-.43l-8,4.22a1,1,0,0,0,.48,1.93,1,1,0,0,0,.47-.12l8-4.23A1,1,0,0,0,46.36,280.72Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M43.65,275.44a1,1,0,0,0-1.36-.47l-8.16,3.95a1,1,0,0,0,.44,1.93,1,1,0,0,0,.44-.1l8.17-3.94A1,1,0,0,0,43.65,275.44Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M41.2,270.05a1,1,0,0,0-1.34-.52l-8.3,3.66a1,1,0,0,0-.52,1.35,1,1,0,0,0,.93.6,1,1,0,0,0,.42-.08l8.29-3.67A1,1,0,0,0,41.2,270.05Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M38.91,264.59a1,1,0,0,0-1.33-.57l-8.42,3.38a1,1,0,0,0,.38,2,1,1,0,0,0,.38-.07l8.42-3.38A1,1,0,0,0,38.91,264.59Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M36.76,259.06a1,1,0,0,0-1.3-.61l-8.53,3.09a1,1,0,0,0-.61,1.3,1,1,0,0,0,1,.68.83.83,0,0,0,.34-.07l8.53-3.08A1,1,0,0,0,36.76,259.06Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M34.86,253.45a1,1,0,0,0-1.28-.66L25,255.58a1,1,0,0,0,.32,2,.89.89,0,0,0,.31-.06l8.63-2.79A1,1,0,0,0,34.86,253.45Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M33.15,247.78a1,1,0,0,0-1.26-.7l-8.72,2.49a1,1,0,0,0,.28,2,.86.86,0,0,0,.28,0L32.45,249A1,1,0,0,0,33.15,247.78Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M31.6,242.06a1,1,0,0,0-1.24-.74l-8.8,2.19a1,1,0,0,0,.25,2l.25,0,8.8-2.19A1,1,0,0,0,31.6,242.06Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M30.27,236.29a1,1,0,0,0-1.21-.79l-8.87,1.89a1,1,0,0,0,.21,2,.76.76,0,0,0,.21,0l8.87-1.88A1,1,0,0,0,30.27,236.29Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M28.33,231.65a1,1,0,0,0-.35-2l-8.93,1.58a1,1,0,0,0,.17,2l.18,0Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M27.34,225.77a1,1,0,1,0-.28-2l-9,1.28a1,1,0,0,0,.14,2h.14Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M17.54,220.83l9-1a1,1,0,0,0,.9-1.12,1,1,0,0,0-1.12-.91l-9,1a1,1,0,0,0,.11,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M17,214.59l9-.66a1,1,0,0,0,.94-1.1,1,1,0,0,0-1.09-.94l-9,.66a1,1,0,0,0,.07,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M16.57,208.33l9.07-.36a1,1,0,1,0-.08-2l-9.07.35a1,1,0,0,0,0,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M16.38,202.06h0l9.07-.05a1,1,0,0,0,0-2h0l-9.07.05a1,1,0,0,0,0,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M16.45,195.8l9.07.25h0a1,1,0,0,0,0-2l-9.06-.25a1.07,1.07,0,0,0-1.05,1A1,1,0,0,0,16.45,195.8Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M16.68,189.53l9.05.56h.07a1,1,0,0,0,1-1,1,1,0,0,0-.95-1.08l-9-.56a1,1,0,0,0-1.08.95A1,1,0,0,0,16.68,189.53Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M17.12,183.28l9,.87h.1a1,1,0,0,0,.09-2l-9-.86a1,1,0,1,0-.2,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M17.83,177.05l9,1.17H27a1,1,0,0,0,.13-2l-9-1.17a1,1,0,1,0-.26,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M18.69,170.84l9,1.48h.17a1,1,0,0,0,.16-2L19,168.82a1,1,0,0,0-1.18.85A1,1,0,0,0,18.69,170.84Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M19.76,164.66l8.89,1.78a.75.75,0,0,0,.21,0,1,1,0,0,0,.19-2l-8.89-1.78a1,1,0,1,0-.4,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M21.1,158.53l8.83,2.09.23,0a1,1,0,0,0,1-.79,1,1,0,0,0-.76-1.22l-8.83-2.09a1,1,0,0,0-1.22.75A1,1,0,0,0,21.1,158.53Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M22.61,152.44l8.75,2.4a1.24,1.24,0,0,0,.27,0,1,1,0,0,0,1-.75,1,1,0,0,0-.71-1.25l-8.75-2.39a1,1,0,1,0-.54,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M24.29,146.4,33,149.09a1.12,1.12,0,0,0,.31,0,1,1,0,0,0,1-.72,1,1,0,0,0-.67-1.27l-8.66-2.7a1,1,0,1,0-.61,2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M26.27,140.45l8.56,3a1,1,0,0,0,.34.05,1,1,0,0,0,.33-2l-8.56-3a1,1,0,0,0-.67,1.93Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M28.41,134.55l8.45,3.28a1,1,0,0,0,.37.07,1,1,0,0,0,.37-2l-8.45-3.28a1,1,0,0,0-1.32.58A1,1,0,0,0,28.41,134.55Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M30.71,128.72l8.34,3.57a1,1,0,0,0,.4.08,1,1,0,0,0,.4-2l-8.33-3.57a1,1,0,0,0-1.34.54A1,1,0,0,0,30.71,128.72Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M33.26,123l8.21,3.85a1,1,0,0,0,.44.1,1,1,0,0,0,.43-1.94l-8.21-3.86a1,1,0,0,0-1.35.49A1,1,0,0,0,33.26,123Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M36,117.35l8.07,4.14a1.12,1.12,0,0,0,.47.11,1,1,0,0,0,.46-1.93l-8.07-4.13a1,1,0,0,0-1.37.44A1,1,0,0,0,36,117.35Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M38.92,111.8l7.92,4.4a1,1,0,0,0,.5.13,1,1,0,0,0,.49-1.91L39.91,110a1,1,0,1,0-1,1.79Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M42,106.34,49.78,111a1,1,0,0,0,.53.14,1,1,0,0,0,.52-1.89l-7.77-4.68A1,1,0,0,0,42,106.34Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M45.33,101,52.94,106a1,1,0,1,0,1.11-1.71l-7.61-4.94A1,1,0,0,0,45.33,101Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M56.24,101a1,1,0,0,0,.58.18,1,1,0,0,0,.59-1.86L50,94.13A1,1,0,1,0,48.8,95.8Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M59.68,96.12a1,1,0,0,0,.61.21,1,1,0,0,0,.81-.41,1,1,0,0,0-.2-1.43l-7.25-5.44a1,1,0,1,0-1.23,1.63Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M63.33,91.42a1,1,0,0,0,.64.22,1,1,0,0,0,.64-1.81l-7.06-5.69a1,1,0,1,0-1.28,1.59Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M67.13,86.82a1,1,0,0,0,1.34-1.54L61.6,79.35a1,1,0,0,0-1.33,1.55Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M71.06,82.34a1,1,0,0,0,.69.27,1,1,0,0,0,.75-.33,1,1,0,0,0,0-1.44l-6.67-6.15a1,1,0,1,0-1.38,1.49Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M75.15,78a1,1,0,0,0,.72.29,1,1,0,0,0,.72-1.74l-6.45-6.38a1,1,0,1,0-1.44,1.45Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M79.41,73.83a1,1,0,0,0,.74.32,1.05,1.05,0,0,0,.7-.28,1,1,0,0,0,0-1.45l-6.23-6.59a1,1,0,1,0-1.48,1.4Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M83.78,69.78a1.05,1.05,0,0,0,.77.34,1,1,0,0,0,.67-.25,1,1,0,0,0,.09-1.44l-6-6.8a1,1,0,0,0-1.44-.09A1,1,0,0,0,77.78,63Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M88.27,65.85a1,1,0,0,0,.79.37,1,1,0,0,0,.65-.23,1,1,0,0,0,.13-1.44l-5.76-7a1,1,0,1,0-1.58,1.3Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M92.94,62.14a1,1,0,0,0,.81.4,1.05,1.05,0,0,0,.62-.21,1,1,0,0,0,.19-1.43L89,53.71A1,1,0,0,0,87.41,55Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M97.71,58.57a1,1,0,0,0,.83.42,1,1,0,0,0,.59-.19,1,1,0,0,0,.24-1.42L94.09,50a1,1,0,1,0-1.66,1.18Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M102.58,55.13a1,1,0,0,0,.85.46,1.08,1.08,0,0,0,.57-.17,1,1,0,0,0,.28-1.42l-5-7.55a1,1,0,0,0-1.7,1.13Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M107.58,51.89a1,1,0,0,0,.87.48,1.08,1.08,0,0,0,.54-.15,1,1,0,0,0,.33-1.41l-4.76-7.71a1,1,0,0,0-1.41-.33,1,1,0,0,0-.33,1.4Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M112.7,48.84a1,1,0,0,0,.89.51.93.93,0,0,0,.5-.14,1,1,0,0,0,.38-1.39L110,40a1,1,0,0,0-1.77,1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M117.91,45.93a1,1,0,0,0,.9.54,1,1,0,0,0,.47-.11,1,1,0,0,0,.43-1.38l-4.22-8a1,1,0,0,0-1.81.95Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M123.2,43.18a1,1,0,0,0,1.36.47,1,1,0,0,0,.47-1.36l-3.94-8.16a1,1,0,1,0-1.84.88Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M128.61,40.68a1,1,0,0,0,.93.61,1,1,0,0,0,.41-.09,1,1,0,0,0,.53-1.34l-3.67-8.3a1,1,0,1,0-1.87.83Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M134.09,38.34A1,1,0,0,0,135,39a1,1,0,0,0,.38-.07,1,1,0,0,0,.57-1.33l-3.38-8.42a1,1,0,0,0-1.89.76Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M139.63,36.15a1,1,0,0,0,1,.67,1.07,1.07,0,0,0,.35-.06,1,1,0,0,0,.61-1.3l-3.09-8.53a1,1,0,0,0-1.92.69Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M145.27,34.21a1,1,0,0,0,1,.7.84.84,0,0,0,.31,0,1,1,0,0,0,.66-1.28L144.42,25a1,1,0,0,0-1.29-.66,1,1,0,0,0-.66,1.29Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M151,32.45a1,1,0,0,0,1,.74.9.9,0,0,0,.28,0,1,1,0,0,0,.7-1.26l-2.49-8.72a1,1,0,0,0-2,.56Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M156.7,30.86a1,1,0,0,0,1,.77,1.07,1.07,0,0,0,.25,0,1,1,0,0,0,.74-1.24l-2.19-8.8a1,1,0,0,0-1.24-.74,1,1,0,0,0-.74,1.24Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M163.5,30.29l.21,0a1,1,0,0,0,.79-1.21l-1.89-8.87a1,1,0,1,0-2,.42l1.88,8.87A1,1,0,0,0,163.5,30.29Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M169.53,29.16a1,1,0,0,0,.83-1.18l-1.58-8.93a1,1,0,0,0-1.18-.83,1,1,0,0,0-.83,1.18l1.58,8.93a1,1,0,0,0,1,.85Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M175.38,28.21a1,1,0,0,0,.87-1.15l-1.28-9a1,1,0,0,0-1.15-.87,1,1,0,0,0-.87,1.15l1.28,9a1,1,0,0,0,1,.88Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M182.17,26.34l-1-9a1,1,0,0,0-2,.22l1,9a1,1,0,0,0,1,.91h.11A1,1,0,0,0,182.17,26.34Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M188.11,25.87l-.66-9a1,1,0,0,0-1.09-.95,1,1,0,0,0-1,1.1l.67,9a1,1,0,0,0,1,.95h.08A1,1,0,0,0,188.11,25.87Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M194.06,25.56l-.35-9.07a1.06,1.06,0,0,0-1.06-1,1,1,0,0,0-1,1.06l.35,9.07a1,1,0,0,0,1,1h0A1,1,0,0,0,194.06,25.56Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,16.37a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1l.06,9.07a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M206.24,16.51a1,1,0,0,0-1-1.05,1,1,0,0,0-1.05,1L204,25.52a1,1,0,0,0,1,1.05h0a1,1,0,0,0,1-1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M212.5,16.81a1,1,0,0,0-.95-1.09,1,1,0,0,0-1.08,1l-.56,9.05a1,1,0,0,0,1,1.08h.07a1,1,0,0,0,1-1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M218.75,17.32a1,1,0,0,0-.92-1.12,1,1,0,0,0-1.11.92l-.86,9a1,1,0,0,0,.91,1.11h.1a1,1,0,0,0,1-.93Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M225,18.09a1,1,0,0,0-.88-1.15,1.06,1.06,0,0,0-1.15.88l-1.17,9a1,1,0,0,0,.88,1.14h.13a1,1,0,0,0,1-.89Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M231.17,19a1,1,0,1,0-2-.34l-1.48,9a1,1,0,0,0,.84,1.17l.17,0a1,1,0,0,0,1-.86Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M237.34,20.16a1,1,0,0,0-2-.4l-1.78,8.89a1,1,0,0,0,.8,1.2.65.65,0,0,0,.2,0,1,1,0,0,0,1-.82Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M243.45,21.57a1,1,0,0,0-2-.47l-2.09,8.83a1,1,0,0,0,.76,1.23.91.91,0,0,0,.23,0,1,1,0,0,0,1-.79Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249.52,23.15a1,1,0,0,0-.71-1.25,1,1,0,0,0-1.26.71l-2.39,8.75a1,1,0,0,0,.72,1.25.84.84,0,0,0,.27,0,1,1,0,0,0,1-.75Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M255.55,24.9a1,1,0,0,0-.68-1.28,1,1,0,0,0-1.27.67L250.91,33a1,1,0,0,0,.67,1.27,1,1,0,0,0,.3.05,1,1,0,0,0,1-.72Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M261.48,26.94a1,1,0,0,0-1.93-.67l-3,8.56a1,1,0,0,0,.63,1.3,1,1,0,0,0,.34.06,1,1,0,0,0,1-.69Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M267.35,29.15a1,1,0,0,0-.58-1.32,1,1,0,0,0-1.32.58l-3.28,8.45a1,1,0,0,0,.58,1.32.94.94,0,0,0,.37.07,1,1,0,0,0,.95-.65Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M268.25,40.39a.92.92,0,0,0,.4.08,1,1,0,0,0,.94-.62l3.57-8.33a1,1,0,0,0-.54-1.34,1,1,0,0,0-1.34.53l-3.57,8.34A1,1,0,0,0,268.25,40.39Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M273.65,42.83a.94.94,0,0,0,.43.1,1,1,0,0,0,.92-.59l3.86-8.21a1,1,0,1,0-1.85-.87l-3.85,8.21A1,1,0,0,0,273.65,42.83Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M279,45.46a1.11,1.11,0,0,0,.46.11,1,1,0,0,0,.91-.56l4.13-8.07a1,1,0,0,0-1.81-.93l-4.13,8.07A1,1,0,0,0,279,45.46Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M284.19,48.23a1,1,0,0,0,1.39-.4L290,39.91a1,1,0,1,0-1.78-1l-4.41,7.92A1,1,0,0,0,284.19,48.23Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M289.33,51.18a1,1,0,0,0,.53.15,1,1,0,0,0,.87-.5l4.68-7.77A1,1,0,0,0,293.66,42L289,49.78A1,1,0,0,0,289.33,51.18Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M294.34,54.35a1,1,0,0,0,1.41-.3l4.94-7.61A1,1,0,0,0,299,45.33L294,52.94A1,1,0,0,0,294.34,54.35Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M299.26,57.66a1,1,0,0,0,.58.18,1,1,0,0,0,.84-.43L305.87,50a1,1,0,1,0-1.67-1.17L299,56.24A1,1,0,0,0,299.26,57.66Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M304.08,61.1a1,1,0,0,0,.61.21,1,1,0,0,0,.82-.41L311,53.65a1,1,0,0,0-1.63-1.23l-5.44,7.26A1,1,0,0,0,304.08,61.1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M308.74,64.77a1,1,0,0,0,.64.22,1,1,0,0,0,.79-.38l5.69-7.06a1,1,0,0,0-1.59-1.28l-5.69,7.06A1,1,0,0,0,308.74,64.77Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M313.28,68.57a1,1,0,0,0,1.44-.1l5.93-6.87a1,1,0,1,0-1.55-1.33l-5.92,6.86A1,1,0,0,0,313.28,68.57Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M317.72,72.5a1,1,0,0,0,1.44,0l6.16-6.67a1,1,0,1,0-1.5-1.38l-6.16,6.66A1,1,0,0,0,317.72,72.5Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M322,76.59a1,1,0,0,0,.72.3,1,1,0,0,0,.72-.31l6.38-6.44a1,1,0,1,0-1.45-1.44L322,75.15A1,1,0,0,0,322,76.59Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M326.13,80.85a1,1,0,0,0,.75.32,1,1,0,0,0,.7-.28l6.59-6.23a1,1,0,0,0-1.4-1.48l-6.6,6.23A1,1,0,0,0,326.13,80.85Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M330.13,85.22a1,1,0,0,0,.77.35,1,1,0,0,0,.67-.26l6.8-6a1,1,0,0,0,.09-1.44,1,1,0,0,0-1.44-.09l-6.8,6A1,1,0,0,0,330.13,85.22Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M334,89.71a1,1,0,0,0,.79.37,1.05,1.05,0,0,0,.65-.23l7-5.77a1,1,0,0,0-1.3-1.58l-7,5.77A1,1,0,0,0,334,89.71Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M337.67,94.37a1,1,0,0,0,.81.4,1.06,1.06,0,0,0,.63-.21L346.3,89a1,1,0,0,0-1.25-1.62l-7.19,5.53A1,1,0,0,0,337.67,94.37Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M341.2,99.13a1,1,0,0,0,1.42.24L350,94.09a1,1,0,0,0-1.18-1.66l-7.38,5.28A1,1,0,0,0,341.2,99.13Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M344.58,104a1,1,0,0,0,.85.45,1,1,0,0,0,.57-.17l7.55-5a1,1,0,0,0-1.13-1.7l-7.55,5A1,1,0,0,0,344.58,104Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M347.78,109a1,1,0,0,0,.87.48,1.08,1.08,0,0,0,.54-.15l7.71-4.76a1,1,0,0,0,.34-1.41,1,1,0,0,0-1.41-.33l-7.72,4.76A1,1,0,0,0,347.78,109Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M350.79,114.09a1,1,0,0,0,.88.52,1.06,1.06,0,0,0,.51-.14l7.87-4.49a1,1,0,0,0-1-1.77l-7.87,4.49A1,1,0,0,0,350.79,114.09Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M353.64,119.28a1,1,0,0,0,.91.55,1,1,0,0,0,.47-.12l8-4.22a1,1,0,0,0-.95-1.81l-8,4.23A1,1,0,0,0,353.64,119.28Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M356.35,124.56a1,1,0,0,0,1.36.47l8.16-3.94a1,1,0,0,0,.48-1.37,1,1,0,0,0-1.36-.47l-8.17,3.94A1,1,0,0,0,356.35,124.56Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M358.8,130a1,1,0,0,0,.93.61,1,1,0,0,0,.41-.09l8.3-3.66a1,1,0,0,0-.83-1.87l-8.29,3.67A1,1,0,0,0,358.8,130Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M361.09,135.41a1,1,0,0,0,1,.64,1,1,0,0,0,.38-.07l8.42-3.38a1,1,0,0,0-.76-1.89l-8.42,3.38A1,1,0,0,0,361.09,135.41Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M363.24,140.94a1,1,0,0,0,1.3.61l8.53-3.09a1,1,0,1,0-.69-1.91l-8.53,3.08A1,1,0,0,0,363.24,140.94Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M365.14,146.55a1,1,0,0,0,1,.71,1.12,1.12,0,0,0,.31,0l8.63-2.79a1,1,0,0,0,.66-1.29,1,1,0,0,0-1.29-.65l-8.63,2.79A1,1,0,0,0,365.14,146.55Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M366.85,152.22a1,1,0,0,0,1,.74,1,1,0,0,0,.28,0l8.72-2.49a1,1,0,0,0-.56-2L367.55,151A1,1,0,0,0,366.85,152.22Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M368.4,157.94a1,1,0,0,0,1,.77l.25,0,8.8-2.19a1,1,0,0,0,.74-1.23,1,1,0,0,0-1.24-.75l-8.8,2.19A1,1,0,0,0,368.4,157.94Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M369.73,163.71a1,1,0,0,0,1,.81.75.75,0,0,0,.21,0l8.87-1.89a1,1,0,1,0-.42-2l-8.87,1.88A1,1,0,0,0,369.73,163.71Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M371.67,168.35a1,1,0,0,0,.17,2l.18,0,8.93-1.58a1,1,0,0,0,.83-1.18,1,1,0,0,0-1.18-.83Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M372.66,174.23a1,1,0,0,0,.14,2h.14l9-1.28a1,1,0,1,0-.28-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M373.44,180.14a1,1,0,0,0,.11,2h.11l9-1a1,1,0,0,0-.22-2Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M374,186.07a1,1,0,0,0-.94,1.1,1,1,0,0,0,1,.94h.08l9-.66a1,1,0,0,0,.95-1.09,1.07,1.07,0,0,0-1.1-1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M374.36,192a1,1,0,0,0-1,1.05,1,1,0,0,0,1,1h0l9.07-.35a1,1,0,0,0,1-1.06,1,1,0,0,0-1.05-1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M383.62,197.94h0l-9.07.05a1,1,0,1,0,0,2h0l9.07-.05a1,1,0,0,0,0-2Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'CIRCLE_OUTLINE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,357.53c-86.86,0-157.53-70.67-157.53-157.53S113.14,42.47,200,42.47,357.53,113.14,357.53,200,286.86,357.53,200,357.53Zm0-313.14C114.2,44.39,44.39,114.2,44.39,200S114.2,355.61,200,355.61,355.61,285.8,355.61,200,285.8,44.39,200,44.39Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY_TOP'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'202.38 98.47 201.05 150.18 203.72 150.18 202.38 98.47',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'219.12 109.73 211.43 150.18 214.12 150.18 219.12 109.73',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'232.5 114.9 221.12 150.18 223.85 150.18 232.5 114.9',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'245.78 121.72 230.91 150.18 233.86 150.18 245.78 121.72',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'260.35 125.8 242.18 150.18 245.17 150.18 260.35 125.8',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'271.14 134.64 256.04 150.18 258.92 150.18 271.14 134.64',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'281.81 142.91 272.27 150.18 274.86 150.18 281.81 142.91',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'185.57 109.73 193.09 150.18 190.46 150.18 185.57 109.73',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'172.5 114.9 183.62 150.18 180.94 150.18 172.5 114.9',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'159.5 121.72 174.04 150.18 171.16 150.18 159.5 121.72',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'145.26 125.8 163.04 150.18 160.1 150.18 145.26 125.8',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'134.71 134.64 149.47 150.18 146.66 150.18 134.71 134.64',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'124.28 142.91 133.6 150.18 131.08 150.18 124.28 142.91',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY_BOTTOM'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'202.38 301.53 201.05 250.44 203.72 250.44 202.38 301.53',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'219.12 290.42 211.43 250.44 214.12 250.44 219.12 290.42',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'232.5 285.3 221.12 250.44 223.85 250.44 232.5 285.3',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'245.78 278.56 230.91 250.44 233.86 250.44 245.78 278.56',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'260.35 274.53 242.18 250.44 245.17 250.44 260.35 274.53',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'271.14 265.79 256.04 250.44 258.92 250.44 271.14 265.79',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'281.81 257.62 272.27 250.44 274.86 250.44 281.81 257.62',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'185.57 290.42 193.09 250.44 190.46 250.44 185.57 290.42',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'172.5 285.3 183.62 250.44 180.94 250.44 172.5 285.3',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'159.5 278.56 174.04 250.44 171.16 250.44 159.5 278.56',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'145.26 274.53 163.04 250.44 160.1 250.44 145.26 274.53',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'134.71 265.79 149.47 250.44 146.66 250.44 134.71 265.79',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'124.28 257.62 133.6 250.44 131.08 250.44 124.28 257.62',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY_TOP_LINE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M109,156.51s11.38-.47,28.44-.81c8.54-.18,18.5-.32,29.16-.43,5.34,0,10.84-.11,16.44-.12l17-.05,17,.05c5.6,0,11.11.09,16.44.12,10.67.1,20.62.25,29.16.43,17.06.33,28.44.81,28.44.81s-11.38.47-28.44.8c-8.54.19-18.49.34-29.16.44-5.33,0-10.84.12-16.44.12l-17,0-17,0c-5.6,0-11.1-.08-16.44-.13-10.66-.1-20.62-.24-29.16-.43C120.36,157,109,156.51,109,156.51Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHINY_BOTTOM_LINE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M109,244.19s11.38.46,28.44.79c8.54.18,18.5.33,29.16.42,5.34,0,10.84.12,16.44.12l17,.06,17-.05c5.6,0,11.11-.09,16.44-.12,10.67-.1,20.62-.25,29.16-.43,17.06-.33,28.44-.79,28.44-.79s-11.38-.47-28.44-.81c-8.54-.17-18.49-.32-29.16-.42-5.33,0-10.84-.11-16.44-.12l-17,0-17,0c-5.6,0-11.1.08-16.44.11-10.66.1-20.62.25-29.16.43C120.36,243.72,109,244.19,109,244.19Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'50%',dy:'.6ex',textAnchor:'middle',fontFamily:'Miriam Libre',fontSize:languageSettings.small?'1.8em':'3.5em',fontWeight:'700',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},line0.toUpperCase()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.6ex',textAnchor:'middle',fontFamily:'Teko',fontSize:languageSettings.small?'1.8em':'2.1em',fontWeight:'300',letterSpacing:'0.08em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_2__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.65ex',textAnchor:'middle',fontFamily:'Teko',fontSize:languageSettings.small?'1.8em':'2.1em',fontWeight:'300',letterSpacing:'0.08em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_2__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(88);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_3',title:'Radial_3',colors:3,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_3 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_3__TopCircle',d:'M 60 210 A 50 50 0 0 1 340 210'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_3__BottomCircle',d:'M 70 210 A 50 50 0 0 0 330 210'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M397.68,158.2c-1.43-6.83-8.5-12.1-10.62-18.65s.46-15-2.35-21.33-10.85-10-14.3-16-2.68-14.8-6.75-20.38S351,74.29,346.35,69.15s-5.67-13.9-10.82-18.54-14-4.75-19.56-8.83-8.41-12.42-14.42-15.9-14.63-1.74-21-4.57-10.8-10.39-17.42-12.54-14.64,1.35-21.46-.08S229,.78,222,.07s-14,4.38-21,4.38-14.2-5.1-21-4.38-12.94,7.19-19.66,8.62-14.91-2-21.46.08-11.14,9.73-17.42,12.54-15,1.12-21,4.57-8.83,11.83-14.42,15.9S71.66,46,66.52,50.61,60.33,64,55.7,69.15,42.46,76.23,38.38,81.83s-3.27,14.38-6.74,20.38-11.47,9.66-14.3,16-.2,14.72-2.35,21.34S5.8,151.37,4.35,158.2s2.9,14.4,2.17,21.35S0,193,0,200s5.82,13.63,6.52,20.45S2.94,235.09,4.35,241.8,12.86,253.9,15,260.45s-.46,15,2.35,21.34,10.84,10,14.3,16,2.67,14.79,6.74,20.38,12.68,7.55,17.31,12.69,5.67,13.9,10.82,18.54,14,4.75,19.56,8.82,8.41,12.43,14.42,15.91,14.63,1.74,21,4.57,10.79,10.39,17.42,12.54,14.64-1.35,21.46.09,12.71,7.89,19.66,8.61,14-4.38,21-4.38,14.2,5.1,21,4.38,12.94-7.19,19.66-8.61,14.92,2,21.46-.09,11.12-9.73,17.41-12.54,15-1.12,21-4.57,8.83-11.83,14.41-15.9,14.43-4.2,19.57-8.83,6.18-13.4,10.81-18.54,13.24-7.08,17.32-12.68,3.27-14.37,6.75-20.39,11.46-9.65,14.29-16,.2-14.72,2.36-21.34,9.19-11.82,10.62-18.65-2.89-14.4-2.17-21.35S402,207,402,200s-5.82-13.63-6.53-20.45S399.11,164.91,397.68,158.2Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M201,381.33C101,381.33,19.69,300,19.69,200S101,18.67,201,18.67,382.35,100,382.35,200,301,381.33,201,381.33Zm0-360.45C102.25,20.88,21.9,101.23,21.9,200S102.25,379.12,201,379.12,380.14,298.77,380.14,200,299.79,20.88,201,20.88Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'TEETH'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M379.43,204.08l-8.81-.24a.92.92,0,0,0-1,1,1,1,0,0,0,1,1l8.81.25h0a1,1,0,0,0,0-2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M379.21,210.17l-8.8-.54a1,1,0,0,0-.12,2l8.8.54h.06a1,1,0,0,0,.06-2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M378.78,216.25l-8.78-.84a1,1,0,0,0-1.08.89,1,1,0,0,0,.89,1.09l8.78.84h.1a1,1,0,0,0,1-.9A1,1,0,0,0,378.78,216.25Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M378.1,222.31l-8.75-1.14a1,1,0,0,0-1.11.85,1,1,0,0,0,.86,1.12l8.74,1.14H378a1,1,0,0,0,.13-2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M377.25,228.34l-8.7-1.43a1,1,0,0,0-1.14.82,1,1,0,0,0,.82,1.14l8.7,1.43.16,0a1,1,0,0,0,1-.83A1,1,0,0,0,377.25,228.34Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M376.21,234.35l-8.64-1.73a1,1,0,1,0-.39,1.94l8.64,1.74.2,0a1,1,0,0,0,.19-2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M374.91,240.31l-8.58-2a1,1,0,0,0-1.19.73,1,1,0,0,0,.73,1.2l8.58,2a.9.9,0,0,0,.23,0,1,1,0,0,0,.23-1.95Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M373.44,246.23l-8.5-2.33a1,1,0,1,0-.52,1.91l8.5,2.33a1.09,1.09,0,0,0,.26,0,1,1,0,0,0,.26-1.94Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M371.81,252.1l-8.42-2.62a1,1,0,0,0-1.24.65,1,1,0,0,0,.65,1.25l8.42,2.61a1,1,0,0,0,.29,0,1,1,0,0,0,.3-1.94Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M369.89,257.89,361.57,255a1,1,0,1,0-.66,1.87l8.32,2.91a1,1,0,0,0,.33.05,1,1,0,0,0,.94-.66A1,1,0,0,0,369.89,257.89Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M367.81,263.61l-8.22-3.19a1,1,0,0,0-.72,1.86l8.22,3.19a1.13,1.13,0,0,0,.36.06,1,1,0,0,0,.92-.63A1,1,0,0,0,367.81,263.61Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M365.57,269.28l-8.1-3.47a1,1,0,0,0-.79,1.83l8.11,3.47a1,1,0,0,0,.39.08,1,1,0,0,0,.39-1.91Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M363.09,274.85l-8-3.74a1,1,0,0,0-.85,1.79l8,3.75a1,1,0,0,0,.42.09,1,1,0,0,0,.89-.57A1,1,0,0,0,363.09,274.85Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M360.42,280.33l-7.85-4a1,1,0,0,0-1.33.43,1,1,0,0,0,.43,1.33l7.85,4a1,1,0,0,0,.9-1.77Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M357.6,285.73l-7.71-4.28a1,1,0,1,0-1,1.74l7.7,4.28a1,1,0,0,0,.48.12,1,1,0,0,0,.87-.51A1,1,0,0,0,357.6,285.73Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M354.59,291,347,286.49a1,1,0,1,0-1,1.7l7.55,4.55a1.06,1.06,0,0,0,.51.14,1,1,0,0,0,.85-.48A1,1,0,0,0,354.59,291Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M351.36,296.2l-7.4-4.79a1,1,0,0,0-1.08,1.66l7.4,4.8a1,1,0,0,0,.54.16,1,1,0,0,0,.54-1.83Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M340.76,296.23a1,1,0,0,0-1.38.25,1,1,0,0,0,.24,1.38l7.23,5.05a1,1,0,0,0,1.38-.25,1,1,0,0,0-.25-1.38Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M337.42,301a1,1,0,0,0-1.19,1.59l7,5.29a1,1,0,0,0,1.38-.2,1,1,0,0,0-.19-1.39Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M333.86,305.54a1,1,0,0,0-1.39.16,1,1,0,0,0,.15,1.39l6.86,5.53a1.07,1.07,0,0,0,.62.22,1,1,0,0,0,.78-.37,1,1,0,0,0-.15-1.4Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M330.17,310a1,1,0,1,0-1.3,1.5l6.68,5.76a1,1,0,0,0,.64.24,1,1,0,0,0,.76-.34,1,1,0,0,0-.11-1.4Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M326.35,314.37a1,1,0,0,0-1.35,1.45l6.48,6a1,1,0,0,0,1.4-.06,1,1,0,0,0-.06-1.4Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M322.38,318.58A1,1,0,1,0,321,320l6.27,6.19a1,1,0,0,0,.7.29,1,1,0,0,0,.69-1.7Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M318.24,322.64a1,1,0,0,0-1.45,1.37l6.06,6.4a1,1,0,0,0,.72.31,1,1,0,0,0,.68-.27,1,1,0,0,0,0-1.4Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M314,326.58a1,1,0,1,0-1.48,1.31l5.83,6.61a1,1,0,0,0,.74.34,1,1,0,0,0,.66-.25,1,1,0,0,0,.09-1.4Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M309.62,330.4a1,1,0,1,0-1.53,1.26l5.61,6.8a1,1,0,0,0,.76.36,1,1,0,0,0,.77-1.62Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M305.09,334a1,1,0,0,0-1.58,1.21l5.37,7a1,1,0,0,0,.79.39,1,1,0,0,0,.6-.21,1,1,0,0,0,.19-1.39Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M300.45,337.47a1,1,0,1,0-1.62,1.16l5.13,7.16a1,1,0,0,0,1.62-1.15Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M295.71,340.81a1,1,0,0,0-1.37-.28,1,1,0,0,0-.28,1.38l4.88,7.34a1,1,0,0,0,.83.44,1,1,0,0,0,.82-1.54Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M290.85,344a1,1,0,0,0-1.36-.33,1,1,0,0,0-.33,1.37l4.63,7.5a1,1,0,0,0,.85.47.94.94,0,0,0,.52-.15,1,1,0,0,0,.32-1.36Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M285.87,346.94a1,1,0,0,0-1.35-.38,1,1,0,0,0-.37,1.36l4.37,7.65a1,1,0,0,0,1.36.37,1,1,0,0,0,.36-1.35Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M280.82,349.76a1,1,0,0,0-1.76.92l4.11,7.8a1,1,0,0,0,1.34.42,1,1,0,0,0,.41-1.34Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M275.67,352.43a1,1,0,1,0-1.78.86l3.84,7.94a1,1,0,0,0,.89.56,1,1,0,0,0,.43-.1,1,1,0,0,0,.46-1.32Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M270.41,354.86a1,1,0,1,0-1.81.8l3.56,8.06a1,1,0,0,0,.91.59,1,1,0,0,0,.4-.08,1,1,0,0,0,.51-1.31Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M265.09,357.13a1,1,0,0,0-1.29-.55,1,1,0,0,0-.55,1.29l3.28,8.18a1,1,0,0,0,.92.63,1.21,1.21,0,0,0,.37-.07,1,1,0,0,0,.55-1.3Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M259.7,359.26a1,1,0,0,0-1.87.68l3,8.29a1,1,0,0,0,.94.65,1,1,0,0,0,.33-.06,1,1,0,0,0,.6-1.27Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M254.22,361.15a1,1,0,0,0-1.25-.64,1,1,0,0,0-.64,1.25l2.72,8.39a1,1,0,0,0,.94.69,1.18,1.18,0,0,0,.31,0,1,1,0,0,0,.63-1.25Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M248.69,362.85a1,1,0,0,0-1.23-.68,1,1,0,0,0-.68,1.23l2.42,8.48a1,1,0,0,0,1,.72,1.36,1.36,0,0,0,.27,0,1,1,0,0,0,.68-1.23Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M243.11,364.41a1,1,0,0,0-1.21-.72,1,1,0,0,0-.72,1.2l2.13,8.55a1,1,0,0,0,1,.75l.24,0a1,1,0,0,0,.72-1.2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M237.47,365.74a1,1,0,0,0-1.18-.76,1,1,0,0,0-.76,1.18l1.83,8.62a1,1,0,0,0,1,.79l.21,0a1,1,0,0,0,.76-1.17Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M230.63,366.06a1,1,0,0,0-.8,1.15l1.54,8.68a1,1,0,0,0,1,.82l.18,0a1,1,0,0,0,.8-1.15l-1.54-8.68A1,1,0,0,0,230.63,366.06Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M225,367a1,1,0,0,0-.84,1.12l1.24,8.73a1,1,0,0,0,1,.85h.14a1,1,0,0,0,.84-1.12l-1.24-8.73A1,1,0,0,0,225,367Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M219.24,367.71a1,1,0,0,0-.88,1.09l.94,8.76a1,1,0,0,0,1,.89h.11a1,1,0,0,0,.88-1.09l-.94-8.76A1,1,0,0,0,219.24,367.71Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M213.49,368.19a1,1,0,0,0-.91,1.07l.64,8.79a1,1,0,0,0,1,.92h.07a1,1,0,0,0,.92-1.06l-.64-8.79A1,1,0,0,0,213.49,368.19Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.74,368.53a1,1,0,0,0-1,1l.35,8.81a1,1,0,0,0,1,.95h0a1,1,0,0,0,1-1l-.35-8.81A1,1,0,0,0,207.74,368.53Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M202,368.68h0a1,1,0,0,0-1,1l0,8.82a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1l-.05-8.82A1,1,0,0,0,202,368.68Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M196.22,368.58a1,1,0,0,0-1,1l-.25,8.81a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1l.24-8.81A1,1,0,0,0,196.22,368.58Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M190.46,368.34a1,1,0,0,0-1.05.93l-.54,8.8a1,1,0,0,0,.93,1.05h.06a1,1,0,0,0,1-.93l.54-8.8A1,1,0,0,0,190.46,368.34Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M184.72,367.9a1,1,0,0,0-1.09.89l-.84,8.78a1,1,0,0,0,.9,1.08h.09a1,1,0,0,0,1-.9l.84-8.78A1,1,0,0,0,184.72,367.9Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M179,367.22a1,1,0,0,0-1.12.86l-1.14,8.74a1,1,0,0,0,.86,1.11h.13a1,1,0,0,0,1-.86l1.14-8.74A1,1,0,0,0,179,367.22Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M173.3,366.39a1,1,0,0,0-1.14.82l-1.44,8.7a1,1,0,0,0,.82,1.14h.16a1,1,0,0,0,1-.83l1.44-8.7A1,1,0,0,0,173.3,366.39Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M167.63,365.38a1,1,0,0,0-1.17.78l-1.74,8.64a1,1,0,0,0,.78,1.17l.2,0a1,1,0,0,0,1-.8l1.73-8.64A1,1,0,0,0,167.63,365.38Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M162,364.12a1,1,0,0,0-1.2.73l-2,8.58a1,1,0,0,0,.74,1.19.91.91,0,0,0,.23,0,1,1,0,0,0,1-.76l2-8.58A1,1,0,0,0,162,364.12Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M156.43,362.7a1,1,0,0,0-1.22.69l-2.33,8.51a1,1,0,0,0,.7,1.21.78.78,0,0,0,.26,0,1,1,0,0,0,1-.73l2.32-8.5A1,1,0,0,0,156.43,362.7Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M150.89,361.13a1,1,0,0,0-1.25.65L147,370.2a1,1,0,0,0,.65,1.24,1,1,0,0,0,.3,0,1,1,0,0,0,.94-.69l2.62-8.42A1,1,0,0,0,150.89,361.13Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M145.43,359.28a1,1,0,0,0-1.26.61l-2.91,8.32a1,1,0,0,0,.61,1.27,1,1,0,0,0,.33,0,1,1,0,0,0,.94-.66l2.9-8.32A1,1,0,0,0,145.43,359.28Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M140,357.29a1,1,0,0,0-1.28.56l-3.19,8.22a1,1,0,0,0,.56,1.28.92.92,0,0,0,.36.07,1,1,0,0,0,.93-.63l3.18-8.22A1,1,0,0,0,140,357.29Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M134.69,355.14a1,1,0,0,0-1.31.52l-3.47,8.11a1,1,0,0,0,.52,1.3,1.1,1.1,0,0,0,.4.08,1,1,0,0,0,.91-.6l3.47-8.11A1,1,0,0,0,134.69,355.14Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M129.44,352.77a1,1,0,0,0-1.32.48l-3.75,8a1,1,0,0,0,.48,1.31.9.9,0,0,0,.42.1,1,1,0,0,0,.9-.57l3.74-8A1,1,0,0,0,129.44,352.77Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M124.27,350.22a1,1,0,0,0-1.33.43l-4,7.84a1,1,0,0,0,.43,1.34,1.06,1.06,0,0,0,.45.11,1,1,0,0,0,.89-.54l4-7.85A1,1,0,0,0,124.27,350.22Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M119.18,347.52a1,1,0,0,0-1.35.39l-4.28,7.7a1,1,0,0,0,.39,1.35,1,1,0,0,0,.48.12,1,1,0,0,0,.87-.51l4.28-7.7A1,1,0,0,0,119.18,347.52Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M114.19,344.65a1,1,0,0,0-1.36.34l-4.55,7.55a1,1,0,0,0,.34,1.36,1,1,0,0,0,.51.15,1,1,0,0,0,.85-.48l4.55-7.56A1,1,0,0,0,114.19,344.65Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M109.32,341.57a1,1,0,0,0-1.37.29l-4.8,7.4a1,1,0,0,0,1.66,1.08l4.8-7.4A1,1,0,0,0,109.32,341.57Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M104.54,338.36a1,1,0,0,0-1.38.24l-5,7.23a1,1,0,0,0,.25,1.38,1,1,0,0,0,1.38-.25l5.05-7.22A1,1,0,0,0,104.54,338.36Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M99.85,335a1,1,0,0,0-1.38.19l-5.29,7.05a1,1,0,0,0,.19,1.39,1,1,0,0,0,.6.2,1,1,0,0,0,.79-.39l5.29-7.05A1,1,0,0,0,99.85,335Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M95.33,331.45a1,1,0,0,0-1.4.15l-5.53,6.86a1,1,0,0,0,.15,1.4,1.07,1.07,0,0,0,.62.22,1,1,0,0,0,.78-.37l5.53-6.87A1,1,0,0,0,95.33,331.45Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M90.91,327.75a1,1,0,0,0-1.4.1l-5.76,6.68a1,1,0,0,0,.1,1.39,1,1,0,0,0,1.4-.1L91,329.15A1,1,0,0,0,90.91,327.75Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M86.6,323.93a1,1,0,0,0-1.4.05l-6,6.48a1,1,0,0,0,.06,1.4,1,1,0,0,0,.67.26,1,1,0,0,0,.73-.31l6-6.48A1,1,0,0,0,86.6,323.93Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M82.43,320A1,1,0,0,0,81,320l-6.19,6.27a1,1,0,0,0,0,1.4,1,1,0,0,0,.7.29,1,1,0,0,0,.71-.3l6.19-6.27A1,1,0,0,0,82.43,320Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M78.42,315.81a1,1,0,0,0-1.4,0l-6.41,6.06a1,1,0,0,0,0,1.4,1,1,0,0,0,.72.31,1,1,0,0,0,.68-.27l6.41-6A1,1,0,0,0,78.42,315.81Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M74.53,311.56a1,1,0,0,0-1.4-.08l-6.61,5.83a1,1,0,0,0-.09,1.4,1,1,0,0,0,.75.34,1,1,0,0,0,.65-.25L74.44,313A1,1,0,0,0,74.53,311.56Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M70.76,307.21a1,1,0,0,0-1.4-.14l-6.8,5.6a1,1,0,0,0-.13,1.4,1,1,0,0,0,.76.36,1,1,0,0,0,.63-.22l6.81-5.61A1,1,0,0,0,70.76,307.21Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M67.2,302.67a1,1,0,0,0-1.39-.18l-7,5.37a1,1,0,0,0-.18,1.4,1,1,0,0,0,.79.38,1,1,0,0,0,.6-.2l7-5.38A1,1,0,0,0,67.2,302.67Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M63.78,298a1,1,0,0,0-1.39-.23l-7.16,5.13a1,1,0,0,0-.23,1.39,1,1,0,0,0,.8.41,1,1,0,0,0,.58-.18l7.17-5.13A1,1,0,0,0,63.78,298Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M60.49,293.32a1,1,0,0,0-1.38-.28l-7.34,4.88a1,1,0,0,0-.27,1.38,1,1,0,0,0,.82.44.94.94,0,0,0,.55-.17l7.34-4.88A1,1,0,0,0,60.49,293.32Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M57.38,288.47a1,1,0,0,0-1.37-.33l-7.5,4.63a1,1,0,0,0,.52,1.84,1,1,0,0,0,.52-.15l7.5-4.63A1,1,0,0,0,57.38,288.47Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M54.46,283.5a1,1,0,0,0-1.36-.37l-7.65,4.37a1,1,0,0,0,.49,1.86,1.05,1.05,0,0,0,.49-.13l7.66-4.38A1,1,0,0,0,54.46,283.5Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M51.68,278.46a1,1,0,0,0-1.34-.42l-7.8,4.11a1,1,0,0,0-.42,1.34A1,1,0,0,0,43,284a1,1,0,0,0,.46-.12l7.8-4.1A1,1,0,0,0,51.68,278.46Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M49.05,273.33a1,1,0,0,0-1.32-.46l-7.94,3.84a1,1,0,0,0,.43,1.88.91.91,0,0,0,.43-.1l7.94-3.84A1,1,0,0,0,49.05,273.33Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M46.67,268.09a1,1,0,0,0-1.31-.51l-8.06,3.56a1,1,0,0,0,.4,1.9,1.14,1.14,0,0,0,.4-.08l8.06-3.56A1,1,0,0,0,46.67,268.09Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M44.44,262.78a1,1,0,0,0-1.29-.55L35,265.51a1,1,0,0,0-.55,1.29,1,1,0,0,0,.92.62,1,1,0,0,0,.37-.07l8.18-3.28A1,1,0,0,0,44.44,262.78Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M42.35,257.41a1,1,0,0,0-1.27-.6l-8.29,3a1,1,0,0,0,.34,1.93,1,1,0,0,0,.34-.06l8.29-3A1,1,0,0,0,42.35,257.41Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M40.51,252a1,1,0,0,0-1.25-.64L30.87,254a1,1,0,0,0,.31,1.93.79.79,0,0,0,.3-.05l8.39-2.71A1,1,0,0,0,40.51,252Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M38.85,246.44a1,1,0,0,0-1.23-.68l-8.48,2.42a1,1,0,0,0,.28,1.95,1.26,1.26,0,0,0,.27,0l8.47-2.42A1,1,0,0,0,38.85,246.44Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M37.33,240.88a1,1,0,0,0-1.2-.72l-8.55,2.13a1,1,0,0,0,.24,2,1,1,0,0,0,.24,0l8.55-2.13A1,1,0,0,0,37.33,240.88Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M36,235.27a1,1,0,0,0-1.18-.76l-8.62,1.83a1,1,0,0,0,.21,2,.68.68,0,0,0,.2,0l8.63-1.83A1,1,0,0,0,36,235.27Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M34.16,230.76a1,1,0,0,0-.35-1.95l-8.68,1.54a1,1,0,0,0,.18,2l.17,0Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M33.2,225.05a1,1,0,1,0-.28-2l-8.73,1.24a1,1,0,0,0,.14,2h.14Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M23.67,220.25l8.76-.94a1,1,0,0,0-.21-2l-8.76.95a1,1,0,0,0,.1,2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M23.12,214.18l8.79-.64a1,1,0,0,0,.92-1.07,1,1,0,0,0-1.06-.91L23,212.2a1,1,0,0,0,.07,2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M22.73,208.1l8.81-.35a1,1,0,0,0-.08-2l-8.81.35a1,1,0,0,0,0,2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M22.54,202h0l8.82,0a1,1,0,0,0,0-2h0l-8.82.05a1,1,0,0,0,0,2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M22.61,195.92l8.81.24h0a1,1,0,0,0,0-2l-8.81-.25a1,1,0,0,0-1,1A1,1,0,0,0,22.61,195.92Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M22.83,189.83l8.8.54h.06a1,1,0,0,0,.06-2L23,187.85a1,1,0,0,0-1.06.93A1,1,0,0,0,22.83,189.83Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M23.26,183.75l8.78.84h.09a1,1,0,0,0,1-.89,1,1,0,0,0-.89-1.09l-8.78-.84a1,1,0,0,0-.19,2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M24,177.69l8.74,1.14h.13a1,1,0,0,0,.12-2l-8.74-1.14a1,1,0,0,0-1.11.86A1,1,0,0,0,24,177.69Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M24.79,171.66l8.7,1.43.16,0a1,1,0,0,0,.16-2l-8.7-1.44a1,1,0,0,0-1.14.81A1,1,0,0,0,24.79,171.66Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M25.83,165.65l8.64,1.73a.68.68,0,0,0,.2,0,1,1,0,0,0,.19-2l-8.64-1.74a1,1,0,1,0-.39,2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M27.13,159.69l8.58,2a.91.91,0,0,0,.23,0,1,1,0,0,0,1-.76,1,1,0,0,0-.73-1.2l-8.58-2a1,1,0,0,0-.46,1.93Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M28.6,153.77l8.5,2.33a.84.84,0,0,0,.27,0,1,1,0,0,0,.26-1.95l-8.51-2.33a1,1,0,0,0-1.22.7A1,1,0,0,0,28.6,153.77Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M30.23,147.9l8.42,2.62a1,1,0,0,0,.3,0,1,1,0,0,0,.94-.69,1,1,0,0,0-.65-1.25L30.82,146a1,1,0,1,0-.59,1.89Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M32.15,142.11,40.48,145a.87.87,0,0,0,.32.06,1,1,0,0,0,.94-.67,1,1,0,0,0-.61-1.26l-8.32-2.91a1,1,0,1,0-.66,1.87Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M34.23,136.39l8.22,3.19a1.13,1.13,0,0,0,.36.06,1,1,0,0,0,.92-.63,1,1,0,0,0-.56-1.29L35,134.53a1,1,0,0,0-.72,1.86Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M36.47,130.72l8.11,3.47a1,1,0,0,0,.39.08,1,1,0,0,0,.39-1.91l-8.11-3.47a1,1,0,0,0-.78,1.83Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M39,125.15l8,3.74a.92.92,0,0,0,.42.1,1,1,0,0,0,.43-1.89l-8-3.75a1,1,0,0,0-.85,1.8Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M41.62,119.67l7.85,4a.91.91,0,0,0,.45.11,1,1,0,0,0,.88-.54,1,1,0,0,0-.43-1.33l-7.84-4a1,1,0,1,0-.91,1.77Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M44.45,114.27l7.7,4.28a1,1,0,0,0,.48.12,1,1,0,0,0,.48-1.86l-7.7-4.28a1,1,0,0,0-1,1.74Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M47.46,109,55,113.51a.94.94,0,0,0,.51.14,1,1,0,0,0,.51-1.84l-7.55-4.55a1,1,0,0,0-1,1.7Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M50.68,103.8l7.4,4.79a1,1,0,0,0,.54.16,1,1,0,0,0,.54-1.82l-7.4-4.8a1,1,0,0,0-1.37.29A1,1,0,0,0,50.68,103.8Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M61.28,103.77a1,1,0,0,0,.57.18,1,1,0,0,0,.57-1.81l-7.23-5a1,1,0,1,0-1.13,1.63Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M64.62,99a1,1,0,0,0,.6.2,1,1,0,0,0,.6-1.78l-7-5.3a1,1,0,1,0-1.19,1.59Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M68.18,94.46a1,1,0,0,0,.62.22,1,1,0,0,0,.62-1.77l-6.86-5.53a1,1,0,1,0-1.25,1.55Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M71.87,90a1,1,0,0,0,.65.24,1,1,0,0,0,.75-.34,1,1,0,0,0-.1-1.4l-6.68-5.76a1,1,0,0,0-1.29,1.5Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M75.69,85.63a1,1,0,0,0,.67.26,1,1,0,0,0,.73-.31,1,1,0,0,0,0-1.41l-6.48-6a1,1,0,1,0-1.34,1.46Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M79.67,81.41a1,1,0,0,0,.69.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-6.27-6.19a1,1,0,1,0-1.39,1.41Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M83.8,77.36A1,1,0,0,0,85.25,76l-6.06-6.41A1,1,0,0,0,77.75,71Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M88.06,73.42a1,1,0,1,0,1.48-1.31L83.71,65.5a1,1,0,1,0-1.49,1.31Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M92.42,69.61a1,1,0,0,0,.77.36,1,1,0,0,0,.62-.23,1,1,0,0,0,.14-1.4l-5.61-6.8a1,1,0,0,0-1.53,1.26Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M97,66a1,1,0,0,0,.79.39,1,1,0,0,0,.6-.21,1,1,0,0,0,.19-1.39l-5.37-7A1,1,0,0,0,91.58,59Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M101.59,62.53a1,1,0,0,0,.81.41,1,1,0,0,0,.58-.18,1,1,0,0,0,.23-1.39l-5.13-7.16A1,1,0,0,0,96.69,54a1,1,0,0,0-.23,1.38Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M106.33,59.19a1,1,0,0,0,.83.44.94.94,0,0,0,.55-.17,1,1,0,0,0,.27-1.37l-4.88-7.34a1,1,0,0,0-1.38-.28,1,1,0,0,0-.27,1.38Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M111.19,56a1,1,0,0,0,1.36.33,1,1,0,0,0,.33-1.37l-4.63-7.5a1,1,0,0,0-1.69,1Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M116.17,53.07a1,1,0,0,0,1.35.37,1,1,0,0,0,.37-1.36l-4.37-7.65a1,1,0,1,0-1.72,1Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M121.22,50.24a1,1,0,0,0,.88.53.92.92,0,0,0,.46-.11,1,1,0,0,0,.42-1.34l-4.11-7.8a1,1,0,1,0-1.75.92Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M126.37,47.57a1,1,0,0,0,.89.56,1,1,0,0,0,.43-.1,1,1,0,0,0,.46-1.32l-3.83-7.94a1,1,0,0,0-1.33-.46,1,1,0,0,0-.46,1.32Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M131.63,45.14a1,1,0,0,0,.91.59,1,1,0,0,0,.4-.08,1,1,0,0,0,.5-1.31l-3.56-8.06a1,1,0,0,0-1.82.8Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M137,42.87a1,1,0,0,0,.92.62.94.94,0,0,0,.37-.07,1,1,0,0,0,.55-1.29L135.51,34a1,1,0,0,0-1.84.73Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M142.34,40.74a1,1,0,0,0,.93.65,1,1,0,0,0,.34-.06,1,1,0,0,0,.6-1.27l-3-8.29a1,1,0,0,0-1.87.68Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M147.82,38.85a1,1,0,0,0,.94.69,1.12,1.12,0,0,0,.31,0,1,1,0,0,0,.64-1.25L147,29.85a1,1,0,1,0-1.88.61Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M153.35,37.14a1,1,0,0,0,1,.72,1.24,1.24,0,0,0,.27,0,1,1,0,0,0,.68-1.23l-2.42-8.48a1,1,0,1,0-1.91.55Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M158.94,35.59a1,1,0,0,0,1,.75.66.66,0,0,0,.24,0,1,1,0,0,0,.72-1.2l-2.13-8.55a1,1,0,0,0-1.92.48Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M165.54,35l.21,0a1,1,0,0,0,.76-1.18l-1.83-8.62a1,1,0,0,0-1.94.41l1.83,8.63A1,1,0,0,0,165.54,35Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M171.41,33.94a1,1,0,0,0,.8-1.15l-1.54-8.68a1,1,0,0,0-1.95.35l1.54,8.68a1,1,0,0,0,1,.82Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M177.09,33a1,1,0,0,0,.84-1.12l-1.24-8.73a1,1,0,0,0-1.12-.84,1,1,0,0,0-.84,1.12L176,32.18a1,1,0,0,0,1,.85Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M183.69,31.2l-.95-8.76a1,1,0,1,0-2,.21l.94,8.76a1,1,0,0,0,1,.89h.11A1,1,0,0,0,183.69,31.2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M189.46,30.75,188.82,22a1,1,0,0,0-1.06-.92,1,1,0,0,0-.92,1.06l.65,8.79a1,1,0,0,0,1,.92h.08A1,1,0,0,0,189.46,30.75Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M195.25,30.44l-.35-8.81a1,1,0,0,0-1-.95,1,1,0,0,0-1,1l.35,8.81a1,1,0,0,0,1,.95h0A1,1,0,0,0,195.25,30.44Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M201,21.51a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1l.05,8.82a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.09,21.65a1,1,0,0,0-1-1,1,1,0,0,0-1,1l-.25,8.81a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M213.17,21.94a1,1,0,1,0-2-.13l-.54,8.8a1,1,0,0,0,.93,1.05h.06a1,1,0,0,0,1-.93Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M219.25,22.43a1,1,0,0,0-.89-1.08,1,1,0,0,0-1.09.89L216.43,31a1,1,0,0,0,.89,1.08h.1a1,1,0,0,0,1-.89Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M225.3,23.18a1,1,0,0,0-.86-1.11,1,1,0,0,0-1.11.86l-1.14,8.74a1,1,0,0,0,.85,1.11h.13a1,1,0,0,0,1-.87Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M231.32,24.09a1,1,0,0,0-.81-1.14,1,1,0,0,0-1.14.82l-1.44,8.7a1,1,0,0,0,.81,1.14h.17a1,1,0,0,0,1-.83Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M237.32,25.2a1,1,0,0,0-1.95-.39l-1.73,8.64a1,1,0,0,0,.78,1.17l.19,0a1,1,0,0,0,1-.8Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M243.26,26.57a1,1,0,0,0-.74-1.19,1,1,0,0,0-1.19.73l-2,8.58a1,1,0,0,0,.73,1.19l.23,0a1,1,0,0,0,1-.76Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249.16,28.1a1,1,0,0,0-1.92-.52l-2.32,8.5a1,1,0,0,0,.69,1.22,1.26,1.26,0,0,0,.27,0,1,1,0,0,0,1-.73Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M255,29.8a1,1,0,0,0-.65-1.24,1,1,0,0,0-1.24.65l-2.62,8.42a1,1,0,0,0,.66,1.24.93.93,0,0,0,.29.05,1,1,0,0,0,1-.7Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M260.78,31.79a1,1,0,1,0-1.87-.66L256,39.45a1,1,0,0,0,.61,1.27,1,1,0,0,0,.33.05,1,1,0,0,0,.93-.66Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M266.48,33.93a1,1,0,0,0-1.84-.72l-3.19,8.22a1,1,0,0,0,.56,1.28.92.92,0,0,0,.36.07,1,1,0,0,0,.92-.63Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M267.36,44.86a1,1,0,0,0,.39.08,1,1,0,0,0,.91-.6l3.47-8.11a1,1,0,0,0-.52-1.3,1,1,0,0,0-1.3.52l-3.47,8.11A1,1,0,0,0,267.36,44.86Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M272.6,47.23a1.08,1.08,0,0,0,.43.1,1,1,0,0,0,.89-.58l3.75-8a1,1,0,0,0-1.8-.85l-3.74,8A1,1,0,0,0,272.6,47.23Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M277.77,49.78a.91.91,0,0,0,.45.11,1,1,0,0,0,.88-.54l4-7.84a1,1,0,0,0-1.77-.91l-4,7.85A1,1,0,0,0,277.77,49.78Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M282.86,52.48a1,1,0,0,0,.48.12,1,1,0,0,0,.86-.51l4.29-7.7a1,1,0,1,0-1.73-1l-4.29,7.7A1,1,0,0,0,282.86,52.48Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M287.85,55.35a1,1,0,0,0,.51.14,1,1,0,0,0,.85-.48l4.55-7.55a1,1,0,1,0-1.7-1L287.51,54A1,1,0,0,0,287.85,55.35Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M292.72,58.43a1,1,0,0,0,.54.16,1,1,0,0,0,.83-.45l4.8-7.4a1,1,0,1,0-1.66-1.08l-4.8,7.4A1,1,0,0,0,292.72,58.43Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M297.5,61.64a.91.91,0,0,0,.56.18,1,1,0,0,0,.82-.42l5.05-7.23A1,1,0,1,0,302.3,53l-5.05,7.22A1,1,0,0,0,297.5,61.64Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M302.19,65a.92.92,0,0,0,.59.2,1,1,0,0,0,.79-.39l5.3-7.06a1,1,0,0,0-.2-1.38,1,1,0,0,0-1.39.19L302,63.61A1,1,0,0,0,302.19,65Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M306.72,68.55a1,1,0,0,0,1.39-.15l5.53-6.86a1,1,0,1,0-1.55-1.25l-5.53,6.87A1,1,0,0,0,306.72,68.55Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M311.13,72.25a1,1,0,0,0,.65.24,1,1,0,0,0,.75-.34l5.76-6.68a1,1,0,0,0-1.5-1.29L311,70.85A1,1,0,0,0,311.13,72.25Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M315.44,76.07a1,1,0,0,0,.68.27,1,1,0,0,0,.73-.32l6-6.48a1,1,0,0,0-1.46-1.34l-6,6.47A1,1,0,0,0,315.44,76.07Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M319.62,80.05a1,1,0,0,0,.69.28A1,1,0,0,0,321,80l6.19-6.27a1,1,0,0,0,0-1.4,1,1,0,0,0-1.41,0l-6.19,6.27A1,1,0,0,0,319.62,80.05Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M323.62,84.19a1,1,0,0,0,.72.31,1,1,0,0,0,.68-.27l6.41-6.06a1,1,0,1,0-1.36-1.44l-6.41,6A1,1,0,0,0,323.62,84.19Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M327.51,88.44a1,1,0,0,0,.75.33,1,1,0,0,0,.65-.25l6.61-5.83a1,1,0,0,0-1.31-1.49L327.6,87A1,1,0,0,0,327.51,88.44Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M331.28,92.79a1,1,0,0,0,.77.37,1,1,0,0,0,.63-.23l6.8-5.61a1,1,0,0,0-1.26-1.53l-6.8,5.61A1,1,0,0,0,331.28,92.79Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M334.84,97.33a1,1,0,0,0,.79.38,1,1,0,0,0,.6-.2l7-5.37A1,1,0,0,0,342,90.56l-7,5.37A1,1,0,0,0,334.84,97.33Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M338.26,102a1,1,0,0,0,.81.41,1,1,0,0,0,.58-.18l7.17-5.13a1,1,0,0,0,.22-1.39,1,1,0,0,0-1.38-.23l-7.17,5.13A1,1,0,0,0,338.26,102Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M341.56,106.68a1,1,0,0,0,.82.45,1,1,0,0,0,.55-.17l7.34-4.88a1,1,0,1,0-1.1-1.65l-7.34,4.88A1,1,0,0,0,341.56,106.68Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M344.67,111.53a1,1,0,0,0,1.36.33l7.5-4.63a1,1,0,0,0-1-1.69l-7.5,4.63A1,1,0,0,0,344.67,111.53Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M347.58,116.5a1,1,0,0,0,1.36.37l7.65-4.37a1,1,0,0,0-1-1.73L348,115.15A1,1,0,0,0,347.58,116.5Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M350.36,121.54a1,1,0,0,0,.88.53,1,1,0,0,0,.46-.11l7.8-4.11a1,1,0,1,0-.92-1.75l-7.8,4.1A1,1,0,0,0,350.36,121.54Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M353,126.67a1,1,0,0,0,.89.56.91.91,0,0,0,.43-.1l7.94-3.83a1,1,0,0,0-.86-1.79l-7.94,3.84A1,1,0,0,0,353,126.67Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M355.37,131.92a1,1,0,0,0,.91.59,1,1,0,0,0,.4-.09l8.06-3.56a1,1,0,0,0,.51-1.31,1,1,0,0,0-1.31-.5l-8.06,3.56A1,1,0,0,0,355.37,131.92Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M357.6,137.22a1,1,0,0,0,.92.62.94.94,0,0,0,.37-.07l8.18-3.28a1,1,0,0,0-.73-1.84l-8.19,3.28A1,1,0,0,0,357.6,137.22Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M359.69,142.59a1,1,0,0,0,.93.66,1,1,0,0,0,.34-.06l8.29-3a1,1,0,0,0,.59-1.27,1,1,0,0,0-1.27-.6l-8.29,3A1,1,0,0,0,359.69,142.59Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M361.53,148.05a1,1,0,0,0,1,.68,1,1,0,0,0,.3,0l8.39-2.72a1,1,0,0,0,.64-1.25,1,1,0,0,0-1.25-.63l-8.39,2.71A1,1,0,0,0,361.53,148.05Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M363.2,153.56a1,1,0,0,0,.95.72.84.84,0,0,0,.27,0l8.48-2.42a1,1,0,0,0-.55-1.91l-8.47,2.42A1,1,0,0,0,363.2,153.56Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M364.71,159.12a1,1,0,0,0,1,.75l.24,0,8.55-2.13a1,1,0,1,0-.48-1.92l-8.55,2.13A1,1,0,0,0,364.71,159.12Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M366,164.73a1,1,0,0,0,1,.78.75.75,0,0,0,.21,0l8.62-1.83a1,1,0,0,0-.41-1.94l-8.63,1.83A1,1,0,0,0,366,164.73Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M367.88,169.24a1,1,0,0,0,.17,2l.18,0,8.68-1.54a1,1,0,0,0-.35-2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M368.84,175a1,1,0,0,0,.14,2h.14l8.73-1.24a1,1,0,0,0-.28-2Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M369.61,180.69a1,1,0,0,0-.88,1.1,1,1,0,0,0,1,.88h.11l8.76-.95a1,1,0,0,0,.88-1.09,1,1,0,0,0-1.09-.88Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M370.13,186.46a1,1,0,0,0,.07,2h.07l8.8-.64a1,1,0,0,0,.91-1.06,1,1,0,0,0-1.06-.92Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M370.5,192.25a1,1,0,0,0,0,2h0l8.81-.35a1,1,0,0,0,.95-1,1,1,0,0,0-1-.95Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M379.5,198h0l-8.82,0a1,1,0,0,0,0,2h0l8.82-.05a1,1,0,0,0,0-2Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'50%',dy:'.7ex',textAnchor:'middle',fontFamily:'Leckerli One',fontSize:languageSettings.small?'3.8em':'6.5em',letterSpacing:'0em',transform:'translate(-5,-2)',className:'Badge__ThirdFillColor'},line2),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'50%',dy:'.6ex',textAnchor:'middle',fontFamily:'Miriam Libre',fontSize:'1.4em',fontWeight:'700',letterSpacing:'0.05em',transform:'translate(40,-49)',className:'Badge__SecondFillColor'},line1.toUpperCase()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'51%',dy:'.6ex',textAnchor:'middle',fontFamily:'Miriam Libre',fontSize:languageSettings.small?'1.0em':'1.2em',fontWeight:'700',letterSpacing:'0.05em',transform:'translate(0,60)',className:'Badge__ThirdFillColor'},line3.toUpperCase(),' ',line4.toUpperCase()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.6ex',textAnchor:'middle',fontFamily:'Abel',fontSize:'2em',letterSpacing:'0.05em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_3__TopCircle',startOffset:'50%'},'\uD83D\uDE1B \uD83D\uDE1B \uD83D\uDE1B \uD83D\uDE1B \uD83D\uDE1B')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.6ex',textAnchor:'middle',fontFamily:'Abel',fontSize:'2em',letterSpacing:'0.05em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_3__BottomCircle',startOffset:'50%'},'\uD83D\uDE1B \uD83D\uDE1B \uD83D\uDE1B \uD83D\uDE1B \uD83D\uDE1B'))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(91);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_4',title:'Radial_4',colors:3,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_4 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_4__TopCircle',d:'M 38 200 A 50 50 0 0 1 362 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_4__BottomCircle',d:'M 38 200 A 50 50 0 0 0 362 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'200',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'PIZZA'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M199.25,337.65C123.36,337.65,61.61,275.9,61.61,200S123.36,62.35,199.25,62.35,336.9,124.1,336.9,200,275.15,337.65,199.25,337.65Zm0-271.8C125.29,65.85,65.11,126,65.11,200s60.18,134.15,134.14,134.15S333.4,274,333.4,200,273.22,65.85,199.25,65.85Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M320.15,200h-3.5a36.36,36.36,0,0,1,1.27-8.25c.74-3.17,1.43-6.17,1-9s-2-5.64-3.59-8.52a36.32,36.32,0,0,1-3.45-7.36,36.59,36.59,0,0,1-1.09-8.19c-.19-3.27-.37-6.36-1.56-9s-3.45-4.82-5.82-7.12a36.2,36.2,0,0,1-5.42-6.11,36.12,36.12,0,0,1-3.35-7.52c-1.11-3.1-2.16-6-4-8.2s-4.64-3.63-7.55-5.16a36.22,36.22,0,0,1-7-4.38,35.94,35.94,0,0,1-5.3-6.25c-1.94-2.67-3.76-5.19-6.2-6.76s-5.45-2.17-8.67-2.82A36.78,36.78,0,0,1,248,93.18a35.65,35.65,0,0,1-6.8-4.47c-2.62-2-5.1-3.94-7.9-4.76s-5.81-.53-9.07-.25a36.47,36.47,0,0,1-8.29.08,35.37,35.37,0,0,1-7.75-2.36c-3.09-1.2-6-2.34-9-2.34s-5.87,1.14-9,2.34a35.37,35.37,0,0,1-7.75,2.36,36.47,36.47,0,0,1-8.29-.08c-3.26-.28-6.34-.55-9.07.25s-5.28,2.73-7.9,4.76a36.5,36.5,0,0,1-6.8,4.48,37.33,37.33,0,0,1-7.93,2.25c-3.22.65-6.26,1.27-8.68,2.83s-4.26,4.08-6.19,6.75a36.84,36.84,0,0,1-5.3,6.26,37,37,0,0,1-7,4.37c-2.91,1.54-5.66,3-7.55,5.17s-2.93,5.09-4,8.19a35.89,35.89,0,0,1-3.35,7.52,36.27,36.27,0,0,1-5.42,6.12c-2.37,2.29-4.61,4.47-5.82,7.11s-1.37,5.69-1.56,9a37.09,37.09,0,0,1-1.09,8.18,36.32,36.32,0,0,1-3.45,7.36c-1.63,2.88-3.17,5.61-3.59,8.52s.3,5.79,1,9A36.36,36.36,0,0,1,81.86,200h-3.5a33.19,33.19,0,0,0-1.18-7.45c-.78-3.35-1.58-6.81-1.09-10.26s2.28-6.7,4-9.74a33,33,0,0,0,3.14-6.62,33.63,33.63,0,0,0,1-7.41c.2-3.45.4-7,1.86-10.22s4.07-5.74,6.57-8.17a32.75,32.75,0,0,0,4.92-5.5,33.34,33.34,0,0,0,3-6.8c1.16-3.26,2.37-6.64,4.69-9.31s5.49-4.35,8.56-6a33.15,33.15,0,0,0,6.29-3.93,33.37,33.37,0,0,0,4.77-5.66c2-2.82,4.14-5.72,7.13-7.65s6.47-2.62,9.87-3.31A33.55,33.55,0,0,0,149,90a33.26,33.26,0,0,0,6.12-4.06c2.76-2.13,5.62-4.34,9.05-5.35s6.92-.67,10.36-.38a33.14,33.14,0,0,0,7.49.11,32,32,0,0,0,7-2.16c3.26-1.27,6.63-2.58,10.23-2.58s7,1.31,10.24,2.58a32.08,32.08,0,0,0,7,2.16,33.22,33.22,0,0,0,7.5-.11c3.44-.29,7-.6,10.36.38s6.28,3.21,9,5.35A33.32,33.32,0,0,0,249.49,90a33.39,33.39,0,0,0,7.17,2c3.39.69,6.9,1.4,9.87,3.31s5.09,4.83,7.13,7.64a33,33,0,0,0,4.76,5.67,32.9,32.9,0,0,0,6.3,3.92c3.07,1.62,6.24,3.3,8.56,6s3.53,6,4.69,9.31a33.34,33.34,0,0,0,3,6.8,33.15,33.15,0,0,0,4.92,5.5c2.5,2.42,5.08,4.93,6.56,8.17s1.67,6.77,1.87,10.22a33.71,33.71,0,0,0,1,7.41,32.92,32.92,0,0,0,3.14,6.61c1.72,3.05,3.49,6.19,4,9.75s-.32,6.91-1.09,10.26A33.19,33.19,0,0,0,320.15,200Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M318.4,201.75a1.75,1.75,0,0,1-1.75-1.75,36.36,36.36,0,0,1,1.27-8.25c.74-3.17,1.43-6.17,1-9s-2-5.64-3.59-8.52a36.32,36.32,0,0,1-3.45-7.36,36.59,36.59,0,0,1-1.09-8.19c-.19-3.27-.37-6.36-1.56-9s-3.45-4.82-5.82-7.12a36.2,36.2,0,0,1-5.42-6.11,36.12,36.12,0,0,1-3.35-7.52c-1.11-3.1-2.16-6-4-8.2s-4.64-3.63-7.55-5.16a36.22,36.22,0,0,1-7-4.38,35.94,35.94,0,0,1-5.3-6.25c-1.94-2.67-3.76-5.19-6.2-6.76s-5.45-2.17-8.67-2.82A36.78,36.78,0,0,1,248,93.18a35.65,35.65,0,0,1-6.8-4.47c-2.62-2-5.1-3.94-7.9-4.76s-5.81-.53-9.07-.25a36.47,36.47,0,0,1-8.29.08,35.37,35.37,0,0,1-7.75-2.36c-3.09-1.2-6-2.34-9-2.34s-5.87,1.14-9,2.34a35.37,35.37,0,0,1-7.75,2.36,36.47,36.47,0,0,1-8.29-.08c-3.26-.28-6.34-.55-9.07.25s-5.28,2.73-7.9,4.76a36.5,36.5,0,0,1-6.8,4.48,37.33,37.33,0,0,1-7.93,2.25c-3.22.65-6.26,1.27-8.68,2.83s-4.26,4.08-6.19,6.75a36.84,36.84,0,0,1-5.3,6.26,37,37,0,0,1-7,4.37c-2.91,1.54-5.66,3-7.55,5.17s-2.93,5.09-4,8.19a35.89,35.89,0,0,1-3.35,7.52,36.27,36.27,0,0,1-5.42,6.12c-2.37,2.29-4.61,4.47-5.82,7.11s-1.37,5.69-1.56,9a37.09,37.09,0,0,1-1.09,8.18,36.32,36.32,0,0,1-3.45,7.36c-1.63,2.88-3.17,5.61-3.59,8.52s.3,5.79,1,9A36.36,36.36,0,0,1,81.86,200a1.75,1.75,0,0,1-3.5,0,33.19,33.19,0,0,0-1.18-7.45c-.78-3.35-1.58-6.81-1.09-10.26s2.28-6.7,4-9.74a33,33,0,0,0,3.14-6.62,33.63,33.63,0,0,0,1-7.41c.2-3.45.4-7,1.86-10.22s4.07-5.74,6.57-8.17a32.75,32.75,0,0,0,4.92-5.5,33.34,33.34,0,0,0,3-6.8c1.16-3.26,2.37-6.64,4.69-9.31s5.49-4.35,8.56-6a33.15,33.15,0,0,0,6.29-3.93,33.37,33.37,0,0,0,4.77-5.66c2-2.82,4.14-5.72,7.13-7.65s6.47-2.62,9.87-3.31A33.55,33.55,0,0,0,149,90a33.26,33.26,0,0,0,6.12-4.06c2.76-2.13,5.62-4.34,9.05-5.35s6.92-.67,10.36-.38a33.14,33.14,0,0,0,7.49.11,32,32,0,0,0,7-2.16c3.26-1.27,6.63-2.58,10.23-2.58s7,1.31,10.24,2.58a32.08,32.08,0,0,0,7,2.16,33.22,33.22,0,0,0,7.5-.11c3.44-.29,7-.6,10.36.38s6.28,3.21,9,5.35A33.32,33.32,0,0,0,249.49,90a33.39,33.39,0,0,0,7.17,2c3.39.69,6.9,1.4,9.87,3.31s5.09,4.83,7.13,7.64a33,33,0,0,0,4.76,5.67,32.9,32.9,0,0,0,6.3,3.92c3.07,1.62,6.24,3.3,8.56,6s3.53,6,4.69,9.31a33.34,33.34,0,0,0,3,6.8,33.15,33.15,0,0,0,4.92,5.5c2.5,2.42,5.08,4.93,6.56,8.17s1.67,6.77,1.87,10.22a33.71,33.71,0,0,0,1,7.41,32.92,32.92,0,0,0,3.14,6.61c1.72,3.05,3.49,6.19,4,9.75s-.32,6.91-1.09,10.26a33.19,33.19,0,0,0-1.18,7.45A1.75,1.75,0,0,1,318.4,201.75Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M199.25,323.18c-3.6,0-6.89-1.66-10.07-3.26a24.22,24.22,0,0,0-7.05-2.73,24.76,24.76,0,0,0-7.73.65c-3.45.63-7,1.29-10.38.3s-6.12-3.52-8.71-5.94a24.46,24.46,0,0,0-6-4.64,25,25,0,0,0-7.54-1.56c-3.51-.37-7.13-.75-10.1-2.66s-4.84-5.08-6.64-8.13a24.78,24.78,0,0,0-4.5-6.18,24.68,24.68,0,0,0-6.78-3.6c-3.27-1.34-6.65-2.73-9-5.41s-3.21-6.2-4.08-9.63a24.73,24.73,0,0,0-2.6-7.23,24.59,24.59,0,0,0-5.47-5.32c-2.77-2.22-5.63-4.51-7.12-7.75s-1.32-6.83-1.19-10.35a24.66,24.66,0,0,0-.46-7.71,24.71,24.71,0,0,0-3.71-6.61c-2-2.92-4.15-5.93-4.65-9.49s.66-6.88,1.77-10.19A25,25,0,0,0,79,198.13a1.75,1.75,0,0,1,3.5,0,27.81,27.81,0,0,1-1.93,8.72c-1,3.07-2,6-1.63,8.59s2.17,5.28,4.06,8a27.51,27.51,0,0,1,4.2,7.62,27.78,27.78,0,0,1,.6,8.83c-.12,3.26-.24,6.33.88,8.77s3.55,4.42,6.11,6.46a27.64,27.64,0,0,1,6.23,6.17,27.61,27.61,0,0,1,3,8.26c.81,3.17,1.57,6.16,3.34,8.2s4.63,3.22,7.65,4.47a27.3,27.3,0,0,1,7.74,4.18,27.56,27.56,0,0,1,5.23,7.06c1.66,2.82,3.23,5.48,5.52,7s5.33,1.78,8.57,2.12a28,28,0,0,1,8.63,1.86,27.35,27.35,0,0,1,7,5.26c2.4,2.25,4.67,4.37,7.3,5.14s5.58.2,8.77-.38a27.65,27.65,0,0,1,8.86-.67,27.08,27.08,0,0,1,8.12,3.06c2.95,1.49,5.73,2.89,8.5,2.89s5.56-1.4,8.51-2.89a27.08,27.08,0,0,1,8.12-3.06,27.65,27.65,0,0,1,8.86.67c3.19.58,6.21,1.13,8.77.38s4.9-2.89,7.3-5.14a27.35,27.35,0,0,1,7-5.26,27.69,27.69,0,0,1,8.63-1.86c3.25-.34,6.31-.67,8.58-2.13s3.85-4.13,5.51-6.95a20.28,20.28,0,0,1,13-11.25c3-1.24,5.88-2.42,7.65-4.46s2.53-5,3.34-8.2a20.24,20.24,0,0,1,9.28-14.43c2.56-2,5-4,6.11-6.46s1-5.52.88-8.77a27.78,27.78,0,0,1,.6-8.83,27.26,27.26,0,0,1,4.2-7.62c1.89-2.7,3.67-5.25,4.06-8s-.6-5.51-1.63-8.58a27.81,27.81,0,0,1-1.93-8.72,1.75,1.75,0,0,1,3.5,0,25,25,0,0,0,1.75,7.61c1.11,3.31,2.26,6.75,1.77,10.19s-2.61,6.57-4.65,9.49a24.71,24.71,0,0,0-3.71,6.61,24.64,24.64,0,0,0-.46,7.71c.13,3.52.27,7.15-1.19,10.35s-4.35,5.53-7.12,7.75a24.53,24.53,0,0,0-5.46,5.32,24.45,24.45,0,0,0-2.61,7.23c-.87,3.42-1.77,7-4.08,9.63s-5.7,4.07-9,5.41a17.1,17.1,0,0,0-11.28,9.78c-1.8,3.05-3.65,6.21-6.64,8.13s-6.59,2.29-10.1,2.66a25.06,25.06,0,0,0-7.54,1.56,24.46,24.46,0,0,0-6,4.64c-2.59,2.42-5.27,4.94-8.71,5.94s-6.93.33-10.38-.3a24.76,24.76,0,0,0-7.73-.65,24.07,24.07,0,0,0-7,2.73C206.15,321.52,202.86,323.18,199.25,323.18Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{x:'197.5',y:'79.09',width:'3.5',height:'241.81',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{x:'78.35',y:'198.25',width:'241.81',height:'3.5',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{x:'197.51',y:'79.09',width:'3.5',height:'241.81',transform:'translate(-83.06 199.47) rotate(-45)',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{x:'78.35',y:'198.25',width:'241.81',height:'3.5',transform:'translate(-83.06 199.47) rotate(-45)',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M296.06,186.76a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,296.06,186.76Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.66,5.66,0,0,0,296.06,172Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M229,116.26a9.16,9.16,0,1,1,9.15-9.15A9.17,9.17,0,0,1,229,116.26Zm0-14.81a5.66,5.66,0,1,0,5.65,5.66A5.67,5.67,0,0,0,229,101.45Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M292.15,229.16A9.15,9.15,0,1,1,301.3,220,9.16,9.16,0,0,1,292.15,229.16Zm0-14.8A5.65,5.65,0,1,0,297.8,220,5.65,5.65,0,0,0,292.15,214.36Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M150,195.78a9.15,9.15,0,1,1,9.16-9.15A9.16,9.16,0,0,1,150,195.78Zm0-14.8a5.65,5.65,0,1,0,5.66,5.65A5.66,5.66,0,0,0,150,181Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M136.2,243.29a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,136.2,243.29Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.66,5.66,0,0,0,136.2,228.49Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M217.52,136.72a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,217.52,136.72Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.65,5.65,0,0,0,217.52,121.92Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M221.58,253.65a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,221.58,253.65Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.65,5.65,0,0,0,221.58,238.85Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M176.6,305a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,176.6,305Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.66,5.66,0,0,0,176.6,290.21Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M283.28,254.86a9.15,9.15,0,0,1-6.63-15.45l2.54,2.41a5.65,5.65,0,1,0,8.2,7.78l2.54,2.4a9.09,9.09,0,0,1-6.4,2.86Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M237.61,222.53a9.17,9.17,0,0,1-8.84-6.84l3.39-.89A5.65,5.65,0,1,0,243.09,212l3.39-.89a9.16,9.16,0,0,1-6.54,11.17A9.25,9.25,0,0,1,237.61,222.53Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M218,271.83l-.66,0a9.15,9.15,0,0,1-8.49-9.77l3.49.24a5.65,5.65,0,0,0,11.28.79l3.49.25a9.17,9.17,0,0,1-9.11,8.51Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M251.6,125.29a9.15,9.15,0,0,1-9.1-8.28l3.49-.33a5.66,5.66,0,0,0,6.16,5.09,5.66,5.66,0,0,0,5.09-6.16l3.48-.34a9.14,9.14,0,0,1-8.24,10A8.64,8.64,0,0,1,251.6,125.29Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M186,108.65l-2-2.88a5.65,5.65,0,1,0-6.45-9.28l-2-2.88a9.15,9.15,0,0,1,10.44,15Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M116.77,147a9.15,9.15,0,0,1-8.1-4.87l3.09-1.64a5.65,5.65,0,1,0,10-5.29l3.1-1.64A9.17,9.17,0,0,1,121,146,9,9,0,0,1,116.77,147Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M212.81,171.84a9.15,9.15,0,0,1,12.62-13.26L223,161.12a5.65,5.65,0,1,0-7.79,8.19Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M102.91,222.43a9.2,9.2,0,0,1-2.07-.24,9.15,9.15,0,0,1-6.84-11l3.41.8a5.63,5.63,0,0,0,4.22,6.78,5.65,5.65,0,0,0,6.78-4.22l3.41.79A9.16,9.16,0,0,1,102.91,222.43Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M152.31,228.05h-.26l.1-3.5a5.65,5.65,0,1,0,.32-11.3l.1-3.49a9.15,9.15,0,0,1-.26,18.29Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M259.8,236.12h0a1.8,1.8,0,0,1-1.23-.53l-5.4-5.59a1.75,1.75,0,0,1,0-2.47L267,214.17a1.8,1.8,0,0,1,1.25-.5,1.76,1.76,0,0,1,1.23.54l5.4,5.58a1.76,1.76,0,0,1,0,2.48L261,235.63A1.78,1.78,0,0,1,259.8,236.12Zm-2.92-7.29,3,3.07L271.15,221l-3-3.07Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M182.78,170a1.67,1.67,0,0,1-.62-.12,1.69,1.69,0,0,1-1-.92l-7.84-17.55a1.74,1.74,0,0,1,.88-2.31l7.1-3.17a1.75,1.75,0,0,1,2.31.89l7.84,17.55a1.75,1.75,0,0,1-.89,2.31l-7.09,3.17A1.79,1.79,0,0,1,182.78,170Zm-5.52-18.42L183.67,166l3.9-1.74-6.41-14.36Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M139.73,288.51a1.77,1.77,0,0,1-1.12-.4,1.72,1.72,0,0,1-.62-1.19l-.73-7.73a1.75,1.75,0,0,1,1.58-1.91L158,275.49a1.77,1.77,0,0,1,1.91,1.58l.72,7.74a1.75,1.75,0,0,1-1.58,1.9l-19.14,1.79Zm1.18-7.91.4,4.25L157,283.39l-.4-4.25Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M109.71,256.61a1.68,1.68,0,0,1-.72-.16l-7.09-3.2a1.75,1.75,0,0,1-.87-2.31l7.9-17.52a1.77,1.77,0,0,1,2.32-.88l7.08,3.2a1.71,1.71,0,0,1,.92,1,1.78,1.78,0,0,1,0,1.34l-7.91,17.52A1.76,1.76,0,0,1,109.71,256.61Zm-4.77-5.83,3.89,1.76,6.47-14.33-3.9-1.76Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M273,156.84a1.74,1.74,0,0,1-1.74-1.62l-.58-7.75a1.74,1.74,0,0,1,1.61-1.87l19.17-1.44a1.75,1.75,0,0,1,1.87,1.61l.58,7.75a1.74,1.74,0,0,1-1.61,1.88l-19.17,1.43Zm1.3-7.88.32,4.25L290.27,152l-.32-4.26Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M99.2,195.14a1.74,1.74,0,0,1-1.57-1L89.09,177a1.74,1.74,0,0,1-.09-1.34,1.75,1.75,0,0,1,.88-1l7-3.45a1.74,1.74,0,0,1,1.34-.09,1.75,1.75,0,0,1,1,.88l8.54,17.22a1.76,1.76,0,0,1-.79,2.34L100,195A1.74,1.74,0,0,1,99.2,195.14ZM93,177,100,191l3.82-1.89-7-14.09Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M236.6,151.48a1.73,1.73,0,0,1-.64-.12l-7.23-2.87a1.74,1.74,0,0,1-1-2.27L233,133a1.76,1.76,0,0,1,2.28-1l7.22,2.86a1.74,1.74,0,0,1,1,2.27l-5.21,13.19a1.75,1.75,0,0,1-.93,1A1.73,1.73,0,0,1,236.6,151.48Zm-4.95-5.6,4,1.58,3.92-9.94-4-1.57Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M260,192.78a3.76,3.76,0,0,1-1.24-.21l-9.35-3.33h0a3.72,3.72,0,0,1-2.18-4.94l.66-1.56a.22.22,0,0,0-.07-.27c-6.62-3.36-5.83-9.37-5.61-10.54a3.66,3.66,0,0,1,.17-.59,12.81,12.81,0,0,1,11.45-8.81,24.24,24.24,0,0,1,9.8,1.29,26.57,26.57,0,0,1,8.16,4.86c3.94,3.61,5.2,7.86,3.63,12.28-2.74,7.69-8.59,7.35-11,6.85a.22.22,0,0,0-.26.15l-.6,2.12a3.7,3.7,0,0,1-3.58,2.7Zm-9.42-6.84,9.35,3.33a.2.2,0,0,0,.17,0,.22.22,0,0,0,.11-.14l.6-2.12a3.71,3.71,0,0,1,4.35-2.61c3.29.69,5.63-.86,7-4.61,1.09-3.07.21-5.86-2.69-8.51a22.77,22.77,0,0,0-7-4.15,21.09,21.09,0,0,0-8.29-1.11,9.31,9.31,0,0,0-8.51,6.53c-.21,1.09-.53,4.64,3.75,6.81a3.71,3.71,0,0,1,1.7,4.75l-.65,1.56a.17.17,0,0,0,0,.17.17.17,0,0,0,.12.11Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M262.44,189.23a2,2,0,0,1-.41,0,1.75,1.75,0,0,1-1.29-2.11l1.74-7.09a2.94,2.94,0,0,1,4.71-1.6,5.22,5.22,0,0,1,1.64,6.11,3.81,3.81,0,0,1-4.39,2.2l-.3,1.21A1.74,1.74,0,0,1,262.44,189.23Zm2.83-5.95c.19,0,.27,0,.3-.08a2,2,0,0,0,0-1.3Zm.33-.13h0Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249.52,184.92a1.81,1.81,0,0,1-.75-.16,1.77,1.77,0,0,1-.83-2.34l.4-.85a3.9,3.9,0,0,1-1.74-1.8,4,4,0,0,1-.14-3,5.22,5.22,0,0,1,5.11-3.68h0a2.9,2.9,0,0,1,2.47,1.37,2.93,2.93,0,0,1,.17,2.84l-3.13,6.59A1.74,1.74,0,0,1,249.52,184.92Zm1.07-8.07a2,2,0,0,0-.84,1.14.34.34,0,0,0,.1.4Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M124.79,183.79a3.81,3.81,0,0,1-.82-.09,3.76,3.76,0,0,1-2.38-1.74l-.85-1.46a.23.23,0,0,0-.26-.11c-6.66,3.31-11-.92-11.81-1.8a3,3,0,0,1-.37-.48,12.81,12.81,0,0,1-.23-14.45,24.21,24.21,0,0,1,6.89-7.08c4.85-3.24,15.42-7.25,20.79.77,4.54,6.8.77,11.29-1.07,12.91a.22.22,0,0,0,0,.29L136,172.3a3.72,3.72,0,0,1-.88,5.35l-8.25,5.51A3.76,3.76,0,0,1,124.79,183.79Zm-4.26-6.91a3.76,3.76,0,0,1,3.23,1.85l.85,1.46a.24.24,0,0,0,.14.1.19.19,0,0,0,.16,0h0l8.25-5.51a.21.21,0,0,0,.1-.14.22.22,0,0,0,0-.17l-1.34-1.75a3.73,3.73,0,0,1,.5-5.05c2.52-2.22,2.68-5,.47-8.33-4.78-7.15-15.82.11-15.93.19a20.83,20.83,0,0,0-5.84,6,9.27,9.27,0,0,0,.16,10.72c.74.82,3.4,3.2,7.69,1.07A3.59,3.59,0,0,1,120.53,176.88Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M133.26,173.37a1.76,1.76,0,0,1-1.35-.64l-4.65-5.62a2.94,2.94,0,0,1,1.53-4.73,5.24,5.24,0,0,1,5.89,2.33,3.8,3.8,0,0,1-.87,4.83l.8,1a1.75,1.75,0,0,1-1.35,2.87Zm-2.59-7.62.91,1.09c.12-.14.13-.23.11-.29A1.86,1.86,0,0,0,130.67,165.75Zm1,.75h0Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M122.09,181.16a1.76,1.76,0,0,1-1.55-.93l-.44-.83a3.9,3.9,0,0,1-2.49.32,4,4,0,0,1-2.46-1.66,5.2,5.2,0,0,1,.11-6.31,2.92,2.92,0,0,1,2.57-1.17,3,3,0,0,1,2.39,1.56l3.41,6.45a1.75,1.75,0,0,1-.72,2.37A1.84,1.84,0,0,1,122.09,181.16Zm-4.44-6.38a2,2,0,0,0,.42,1.35.34.34,0,0,0,.38.16Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M165.22,142.67a13.07,13.07,0,0,1-8.74-3.54,24.39,24.39,0,0,1-5.75-8,26.28,26.28,0,0,1-2-9.28c-.06-5.34,2.19-9.16,6.49-11,7.49-3.25,11.24,1.26,12.51,3.35a.21.21,0,0,0,.28.09l2-1a3.7,3.7,0,0,1,5.1,1.82l4,9.1a3.71,3.71,0,0,1-2.13,5l-1.58.58a.22.22,0,0,0-.16.23c2.07,7.14-2.87,10.67-3.88,11.3a3.35,3.35,0,0,1-.53.28A14,14,0,0,1,165.22,142.67Zm-5.09-29.53a9,9,0,0,0-3.53.84c-3,1.3-4.42,3.85-4.38,7.79a22.79,22.79,0,0,0,1.72,7.92,21,21,0,0,0,4.85,6.81,9.3,9.3,0,0,0,10.58,1.76c.94-.58,3.75-2.77,2.42-7.38a3.72,3.72,0,0,1,2.31-4.49l1.59-.59a.25.25,0,0,0,.12-.11.25.25,0,0,0,0-.17h0l-4-9.1a.18.18,0,0,0-.12-.12.2.2,0,0,0-.17,0l-2,1a3.73,3.73,0,0,1-4.88-1.39A5.16,5.16,0,0,0,160.13,113.14Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M161.85,121.24a3,3,0,0,1-1.4-.35,2.93,2.93,0,0,1-1.54-2.38,5.24,5.24,0,0,1,3.34-5.37,3.81,3.81,0,0,1,4.61,1.71l1.08-.61a1.75,1.75,0,1,1,1.72,3.05l-6.37,3.57A2.85,2.85,0,0,1,161.85,121.24Zm1.68-4.84a1.93,1.93,0,0,0-1,.86l1.24-.69C163.68,116.42,163.6,116.39,163.53,116.4Zm0,0h0Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M169.55,135.25a5.17,5.17,0,0,1-3.84-1.75,3,3,0,0,1,1.28-4.81l6.95-2.21a1.75,1.75,0,0,1,1.06,3.34l-.9.28a3.86,3.86,0,0,1-2.19,4.63A5.86,5.86,0,0,1,169.55,135.25Zm-.43-3.56a2.08,2.08,0,0,0,1.41-.17.35.35,0,0,0,.22-.35Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M242.62,301.7a3.57,3.57,0,0,1-.92-.12,3.71,3.71,0,0,1-2.33-1.8l-.82-1.48a.21.21,0,0,0-.25-.11c-6.75,3.12-11-1.22-11.76-2.12a3.34,3.34,0,0,1-.37-.51,12.82,12.82,0,0,1,.17-14.43,24.4,24.4,0,0,1,7.08-6.9c4.93-3.1,15.61-6.82,20.76,1.34,4.35,6.91.46,11.3-1.41,12.87a.22.22,0,0,0-.05.29l1.3,1.78a3.72,3.72,0,0,1-1,5.33l-8.39,5.29A3.79,3.79,0,0,1,242.62,301.7Zm-4.27-7a3.76,3.76,0,0,1,3.27,1.93l.81,1.48a.21.21,0,0,0,.14.1.18.18,0,0,0,.16,0h0l8.4-5.3a.19.19,0,0,0,.09-.14.22.22,0,0,0,0-.16l-1.3-1.78a3.74,3.74,0,0,1,.63-5c2.58-2.16,2.81-5,.69-8.32-4.58-7.27-15.81-.31-15.92-.24a21,21,0,0,0-6,5.83,9.29,9.29,0,0,0-.13,10.72c.72.84,3.31,3.29,7.67,1.27A3.68,3.68,0,0,1,238.35,294.68Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M251.31,291.51a1.74,1.74,0,0,1-1.38-.67l-4.5-5.75a3,3,0,0,1-.46-2.81,2.92,2.92,0,0,1,2.12-1.88,5.23,5.23,0,0,1,5.82,2.49,3.82,3.82,0,0,1-1,4.81l.77,1a1.75,1.75,0,0,1-1.38,2.83Zm-2.44-7.7.88,1.13c.16-.17.15-.27.15-.27A1.87,1.87,0,0,0,248.87,283.81Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M239.93,299a1.77,1.77,0,0,1-1.57-1l-.41-.85a4,4,0,0,1-2.5.26,4,4,0,0,1-2.42-1.73,5.22,5.22,0,0,1,.28-6.31,2.95,2.95,0,0,1,4.94.53l3.25,6.54a1.74,1.74,0,0,1-.79,2.34A1.69,1.69,0,0,1,239.93,299Zm-4.31-6.5a2,2,0,0,0,.38,1.36.34.34,0,0,0,.38.17Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M179.51,272.8a8.74,8.74,0,0,1-8.58-6.11.23.23,0,0,0-.27-.14l-2.12.6a3.73,3.73,0,0,1-4.64-2.8l-2.06-9.71a3.67,3.67,0,0,1,.57-2.88,3.71,3.71,0,0,1,2.5-1.56l1.67-.26a.2.2,0,0,0,.19-.2c-.6-7.4,4.93-9.88,6-10.3a5.54,5.54,0,0,1,.58-.17,12.84,12.84,0,0,1,13.51,5.15,24.3,24.3,0,0,1,4,9,26.64,26.64,0,0,1,.13,9.5c-1,5.25-4,8.54-8.55,9.52A14.76,14.76,0,0,1,179.51,272.8Zm-8.8-9.76a3.74,3.74,0,0,1,3.51,2.47c1.13,3.17,3.68,4.35,7.57,3.53,3.19-.68,5.1-2.89,5.84-6.76a22.74,22.74,0,0,0-.11-8.11,21.2,21.2,0,0,0-3.4-7.64,9.3,9.3,0,0,0-10-3.83c-1,.39-4.24,2-3.85,6.76a3.71,3.71,0,0,1-3.15,3.94l-1.67.26a.24.24,0,0,0-.15.09.22.22,0,0,0,0,.16h0l2.07,9.71a.22.22,0,0,0,.09.14.25.25,0,0,0,.17,0l2.12-.6A3.83,3.83,0,0,1,170.71,263Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M175.54,268.78a3.81,3.81,0,0,1-3.63-2.63l-1.19.38a1.75,1.75,0,0,1-1.07-3.33L176.6,261a2.95,2.95,0,0,1,3.83,3.18,5.23,5.23,0,0,1-4.35,4.6A3.12,3.12,0,0,1,175.54,268.78Zm0-3.49h0Zm-.28-.22c.08.17.17.21.23.22a2,2,0,0,0,1.12-.65Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M167.09,253.35a1.75,1.75,0,0,1-.19-3.49l.94-.1a3.91,3.91,0,0,1,.62-2.43,4,4,0,0,1,2.45-1.67,5.21,5.21,0,0,1,5.83,2.43,2.94,2.94,0,0,1-2.21,4.46l-7.25.79Zm5.16-4.34a3.79,3.79,0,0,0-.63.07.34.34,0,0,0-.28.3l1.7-.19A1.67,1.67,0,0,0,172.25,249Z',className:'Badge__SecondFillColor'})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'366.65 245.52 33.35 245.52 53.8 203.24 33.35 162.62 366.65 162.62 346.2 204.07 366.65 245.52',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M366.65,247.27H33.35a1.76,1.76,0,0,1-1.58-2.51l20.08-41.51L31.79,163.41a1.72,1.72,0,0,1,.07-1.7,1.75,1.75,0,0,1,1.49-.84h333.3a1.78,1.78,0,0,1,1.49.83,1.75,1.75,0,0,1,.08,1.7l-20.07,40.67,20.07,40.67a1.75,1.75,0,0,1-1.57,2.53Zm-330.51-3.5h327.7l-19.21-38.92a1.76,1.76,0,0,1,0-1.55l19.21-38.93H36.19l19.17,38.08a1.76,1.76,0,0,1,0,1.55Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'50%',dy:'.74ex',textAnchor:'middle',fontFamily:'Teko',fontSize:languageSettings.small?'2.2em':'4em',fontWeight:'700',letterSpacing:'.35em',transform:'translate(0,0)',className:'Badge__ThirdFillColor'},line0.toUpperCase()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.6ex',textAnchor:'middle',fontFamily:'Teko',fontSize:languageSettings.small?'1.5em':'1.9em',fontWeight:'700',letterSpacing:'0.2em',className:'Badge__FirstFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_4__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.65ex',textAnchor:'middle',fontFamily:'Teko',fontSize:languageSettings.small?'1.5em':'1.9em',fontWeight:'700',letterSpacing:'0.2em',className:'Badge__FirstFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_4__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(94);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_5',title:'Radial_5',colors:3,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_5 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_5__TopCircle',d:'M 60 200 A 50 50 0 0 1 340 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_5__BottomCircle',d:'M 60 200 A 50 50 0 0 0 340 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'200',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'OUTLINE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M265.17,22.1a27.23,27.23,0,0,1,7.46,13,179.62,179.62,0,0,1,24.13,13c-1.93-11.39-11.42-17-11.52-17.1l.07-.12A187.14,187.14,0,0,0,265.17,22.1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M233.36,13.49A27.14,27.14,0,0,1,242.93,25a178,178,0,0,1,26,8.53c-3.88-10.88-14.2-14.8-14.3-14.83l0-.13A186.13,186.13,0,0,0,233.36,13.49Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200.61,10.55a27.21,27.21,0,0,1,11.32,9.68l0,0A178.9,178.9,0,0,1,239,24.11C233.29,14.05,222.43,12,222.32,12l0-.09A192.37,192.37,0,0,0,200.61,10.55Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M120.47,38.23l-.09.19A179.25,179.25,0,0,1,146,28.12c-9.38-5.58-19.22-2.7-20.5-2.29a190.83,190.83,0,0,0-19.36,9.66A27.17,27.17,0,0,1,120.47,38.23Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M149.75,26.92l-.06.08a178.85,178.85,0,0,1,26.9-5.64c-8.81-7.57-19.79-5.79-19.91-5.77v0a185.7,185.7,0,0,0-20.75,6.16A27.1,27.1,0,0,1,149.75,26.92Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M167.76,13.3a27.15,27.15,0,0,1,12.79,7.56l-.05,0A182,182,0,0,1,200,19.84c2.66,0,5.31.07,7.94.19-7.36-9-18.47-9.13-18.59-9.13v-.05A189.16,189.16,0,0,0,167.76,13.3Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M93.61,54.46l-.09.31A181.07,181.07,0,0,1,117,40.11c-9.21-3.53-17.61-.19-20.07,1A191.35,191.35,0,0,0,79.13,54.22,27.16,27.16,0,0,1,93.61,54.46Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M104.47,363.55a27.17,27.17,0,0,1-5-14.12h0a182.4,182.4,0,0,1-21.5-17c-.17,11.65,8.28,18.93,8.36,19l0,0A190.83,190.83,0,0,0,104.47,363.55Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M375,242.89a179.2,179.2,0,0,1-8.54,26c10.64-4,14.49-14.08,14.53-14.19l.37.14a190.12,190.12,0,0,0,5.24-22A27.33,27.33,0,0,1,375,242.89Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M378.05,135.27A27.3,27.3,0,0,1,373,149.59a179.79,179.79,0,0,1,5.64,26.78c7.26-8.76,5.53-19.47,5.51-19.58l.34-.06A188.27,188.27,0,0,0,378.05,135.27Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M364.14,105.49a27.16,27.16,0,0,1-2.58,14.87,178.66,178.66,0,0,1,10.22,25.34c5.65-9.89,2.08-20.16,2-20.26l.28-.1A189.64,189.64,0,0,0,364.14,105.49Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M388.79,189.45h.36a188.13,188.13,0,0,0-2.57-22.32,27.28,27.28,0,0,1-7.5,13.29A180.83,180.83,0,0,1,380.15,200c0,2.61-.07,5.19-.18,7.77C388.64,200.41,388.79,189.56,388.79,189.45Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M324.59,70a181.78,181.78,0,0,1,18.25,20.36c2.05-11.33-4.91-19.86-5-20l.11-.09a191.78,191.78,0,0,0-15.9-15.07A27.3,27.3,0,0,1,324.59,70Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M345.31,78.59a27.16,27.16,0,0,1-.05,15,181.12,181.12,0,0,1,14.46,23.17c3.92-10.76-1.42-20.3-1.47-20.4l.18-.1A190.89,190.89,0,0,0,345.31,78.59Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M379.75,211.84a178.94,178.94,0,0,1-3.85,27.08c9.79-5.75,11.82-16.38,11.83-16.49l.37.06A189,189,0,0,0,389.44,200,27.23,27.23,0,0,1,379.75,211.84Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M134.5,377.78a27.29,27.29,0,0,1-7.54-13.1,179.14,179.14,0,0,1-24.14-13c1.9,11.43,11.43,17.11,11.53,17.16l-.07.12A188.91,188.91,0,0,0,134.5,377.78Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M364.83,272.66a179.92,179.92,0,0,1-13,24.15c11.2-2,16.77-11.36,16.83-11.46l.31.18a188.48,188.48,0,0,0,9-20.69A27.34,27.34,0,0,1,364.83,272.66Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M349.63,300.22a181.12,181.12,0,0,1-17,21.53c11.43,0,18.56-8.28,18.63-8.37l.24.2a188.58,188.58,0,0,0,12.39-18.7A27.27,27.27,0,0,1,349.63,300.22Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M25,156.75l.09.19a179.82,179.82,0,0,1,8.66-26.26c-9.82,3.38-14.06,12-14.92,14A187.38,187.38,0,0,0,13.6,166,27.15,27.15,0,0,1,25,156.75Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M20.75,219.14l.12.13a180.38,180.38,0,0,1-1-19.27c0-2.79.07-5.56.2-8.33-8.26,6.7-9.14,16.56-9.23,18.38a189.53,189.53,0,0,0,2.42,21.76A27.15,27.15,0,0,1,20.75,219.14Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M20.13,187.76l.12.19a179.78,179.78,0,0,1,3.94-27.36c-9.1,5-11.76,14.32-12.24,16.37a188.36,188.36,0,0,0-1.39,21.9A27.07,27.07,0,0,1,20.13,187.76Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M35.12,127l.06.26a179.38,179.38,0,0,1,13.13-24.41c-9.91,1.54-15.56,8.82-17,11a190,190,0,0,0-8.94,20.33A27.23,27.23,0,0,1,35.12,127Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M21.6,263.78a27.16,27.16,0,0,1,5.21-13.84l.1.07a178.06,178.06,0,0,1-5.6-27c-7.63,8.82-5.85,19.85-5.83,20h0A188.7,188.7,0,0,0,21.6,263.78Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M75,329.73h.12A180.57,180.57,0,0,1,56.8,309.19c-2.08,10.79,4.07,19.1,4.85,20.1a191.51,191.51,0,0,0,15.77,15A27.11,27.11,0,0,1,75,329.73Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M35.4,293.72a27.12,27.12,0,0,1,2.73-14.5l.12.06A178.93,178.93,0,0,1,28,253.73c-6,10-2.29,20.52-2.25,20.63h0A188.46,188.46,0,0,0,35.4,293.72Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M329.89,324.71A182.26,182.26,0,0,1,309.48,343c11.26,2,19.72-4.93,19.81-5l.17.21A190.62,190.62,0,0,0,344.81,322,27.24,27.24,0,0,1,329.89,324.71Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M166.48,386.49a27.35,27.35,0,0,1-9.76-11.6,179.66,179.66,0,0,1-26-8.6c3.89,10.83,14.19,14.74,14.29,14.78l-.07.2A186.47,186.47,0,0,0,166.48,386.49Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M49.09,85.59a192.34,192.34,0,0,0-12.54,18.7,27.29,27.29,0,0,1,13.72-4.74l0,.33A181.5,181.5,0,0,1,67.51,78.06C58,77.84,51.29,83.44,49.09,85.59Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M219.22,379.13a179.63,179.63,0,0,1-19.23,1c-2.73,0-5.46-.07-8.17-.19,7.37,8.77,18.31,8.93,18.42,8.93v.27a188.59,188.59,0,0,0,22.21-2.51A27.27,27.27,0,0,1,219.22,379.13Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M250.09,373.06a179,179,0,0,1-26.82,5.6c8.76,7.31,19.52,5.57,19.63,5.55l.06.33a188.68,188.68,0,0,0,21.49-6.38A27.38,27.38,0,0,1,250.09,373.06Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M54.51,306.13A180.73,180.73,0,0,1,40,282.72c-3.89,10.23.68,19.45,1.3,20.6a187.76,187.76,0,0,0,12.9,17.5,27.13,27.13,0,0,1,.18-14.73Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M279.38,361.69A178,178,0,0,1,254,371.89c9.89,5.65,20.16,2.08,20.27,2l.11.3a190.31,190.31,0,0,0,20-10A27.29,27.29,0,0,1,279.38,361.69Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M199.41,389.45a27.4,27.4,0,0,1-11.64-9.71,180.66,180.66,0,0,1-27.11-3.92c5.73,9.95,16.49,12,16.6,12l0,.24A191.3,191.3,0,0,0,199.41,389.45Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M70,75.11l0,.36A183.21,183.21,0,0,1,90.64,56.93c-9.32-1.85-16.8,2.45-19.37,4.21A189,189,0,0,0,55.72,77.36,27.18,27.18,0,0,1,70,75.11Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M306.23,345.4A181,181,0,0,1,283,359.86c10.73,3.86,20.24-1.45,20.33-1.51l.15.25a190.41,190.41,0,0,0,17.9-13.27A27.27,27.27,0,0,1,306.23,345.4Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M313.27,48.4l.09-.1a189.64,189.64,0,0,0-18.28-12.11,27.23,27.23,0,0,1,5.05,14.12,180.59,180.59,0,0,1,21.51,16.93C321.72,55.69,313.36,48.47,313.27,48.4Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'INNER_OUTLINE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,304.1A104.1,104.1,0,1,1,304.1,200,104.22,104.22,0,0,1,200,304.1Zm0-205.32A101.22,101.22,0,1,0,301.22,200,101.34,101.34,0,0,0,200,98.78Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'Icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M256.29,163.23l-15.64,15.64a1.24,1.24,0,0,1-1.75,0h0a1.23,1.23,0,0,1,0-1.74l15.64-15.64-2.35-2.36-15.64,15.65a1.24,1.24,0,0,1-1.75,0h0a1.24,1.24,0,0,1,0-1.75l15.64-15.64L248.09,155l-15.64,15.64a1.23,1.23,0,0,1-1.74,0h0a1.24,1.24,0,0,1,0-1.75l15.64-15.64L244,150.94l-15.64,15.64a1.23,1.23,0,0,1-1.75,0h0a1.23,1.23,0,0,1,0-1.74l15.64-15.64-2.3-2.3-19.62,19.62a13.18,13.18,0,0,0,0,18.63h0a13.19,13.19,0,0,0,18.64,0l19.62-19.62Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M154.11,251.38h0a5.9,5.9,0,0,1,.16-8.5l65-61,4.31,4.31-61,65A5.89,5.89,0,0,1,154.11,251.38Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M184.86,203.41l1.73-1.73,3.44,3.68,7.28-6.83-3.78-3.79h0l-40.39-40.38a6.87,6.87,0,0,0-10.2,9.17l31.72,39.33A6.87,6.87,0,0,0,184.86,203.41Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207,208.17l-7.15,7.63,33,35.34a6,6,0,1,0,8.54-8.54Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'STARS'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'202.9 134.52 200 128.65 197.1 134.52 190.62 135.47 195.31 140.03 194.21 146.49 200 143.44 205.8 146.49 204.69 140.03 209.38 135.47 202.9 134.52',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'202.9 259.38 200 253.51 197.1 259.38 190.62 260.33 195.31 264.89 194.21 271.35 200 268.31 205.8 271.35 204.69 264.89 209.38 260.33 202.9 259.38',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'270.13 201.76 267.24 195.88 264.33 201.76 257.85 202.7 262.54 207.26 261.44 213.72 267.24 210.68 273.04 213.72 271.92 207.26 276.61 202.7 270.13 201.76',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'135.67 201.76 132.77 195.88 129.87 201.76 123.39 202.7 128.08 207.26 126.97 213.72 132.77 210.68 138.57 213.72 137.46 207.26 142.15 202.7 135.67 201.76',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{x:'46',y:'198.5',width:'50',height:'3',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{x:'304',y:'198.5',width:'50',height:'3',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Merriweather',fontSize:languageSettings.small?'1.5em':'2em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_5__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Abel',fontSize:languageSettings.small?'1.6em':'2.1em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_5__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(97);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_6',title:'Radial_6',colors:3,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_6 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_6__TopCircle',d:'M 60 200 A 50 50 0 0 1 340 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_6__BottomCircle',d:'M 60 200 A 50 50 0 0 0 340 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{width:'400',height:'400',opacity:'0'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M359.59,77.52l-15-14.75V31.52H328.07L199.39.88,70.71,31.52H55.63V62.77l-15,14.75h-6v245h6.31l14.69,14.57v31.43H72.2l128.69,30.81,128.67-30.81h15.07V337.09l14.7-14.57h6.3v-245Zm-1.4,238.62h-4.11l-16.37,16.23V361H324.43L200,391.06l-.35-.08L75.59,361h-13V332.37L46.19,316.14H42.07V83.91h3.87L62.56,67.52V39H74.41L199.52,9.25l.35.08L324.62,39h13.09V67.52l16.62,16.39h3.86Z',className:'Badge__FirstFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'334.71 68.77 334.71 42.04 324.09 42 199.52 12.33 74.76 42.04 65.56 42.04 65.56 68.77 47.17 86.91 45.07 86.91 45.07 313.14 47.42 313.14 65.56 331.12 65.56 358.01 76.12 358.05 200.01 387.98 324.08 358.01 334.71 358.01 334.71 331.12 352.85 313.14 355.19 313.14 355.19 86.91 353.1 86.91 334.71 68.77',className:'Badge__FirstFillColor',fillRule:'evenodd'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M197.72,270.44l-16.64,9.79a5.31,5.31,0,0,0-4.37-2.11,7.82,7.82,0,0,0-3.07.61,7.19,7.19,0,0,0-3.54,3.09,4.64,4.64,0,0,0-.34,4.11,5.72,5.72,0,0,1-4.32.87,3.86,3.86,0,0,1-2.23-1.76l-.49.25-.5.25a5,5,0,0,0,2.9,2.32,5.1,5.1,0,0,0,1.3.19,7.82,7.82,0,0,0,3.91-1.16,5.44,5.44,0,0,0,4.23,1.92,7.89,7.89,0,0,0,3.07-.61,7.27,7.27,0,0,0,3.54-3.08,4.75,4.75,0,0,0,.47-3.75L194.51,276l4.44-.21,2.54-2.07,3.13,2.72,4.43.35,12.9,5.87a4.72,4.72,0,0,0,.3,3.9,7.19,7.19,0,0,0,3.44,3.19,7.67,7.67,0,0,0,3,.71,5.12,5.12,0,0,0,4.9-2.71,4.67,4.67,0,0,0-.21-4.14,7.19,7.19,0,0,0-3.44-3.19,7.81,7.81,0,0,0-3-.71,5.4,5.4,0,0,0-4.38,1.89v0l-17.31-10.93L225.63,254l-24.18,14.21-22.81-14.4,19.08,16.59Zm25.52,15.62a3.58,3.58,0,0,1-.19-3.17,4,4,0,0,1,3.87-2.07,6.72,6.72,0,0,1,2.6.61,6.15,6.15,0,0,1,2.92,2.69,3.57,3.57,0,0,1,.18,3.17,4,4,0,0,1-3.87,2.06,6.58,6.58,0,0,1-2.6-.61,6.1,6.1,0,0,1-2.91-2.68ZM201.43,272a1.09,1.09,0,0,1-1.06-1.1,1.07,1.07,0,0,1,1.09-1.06,1.08,1.08,0,1,1,0,2.16ZM180.2,284.58a6.1,6.1,0,0,1-3,2.59,6.6,6.6,0,0,1-2.62.53A4.2,4.2,0,0,1,171,286a2.23,2.23,0,0,1-.26-.48,3.58,3.58,0,0,1,.29-3.16,6,6,0,0,1,3-2.59,6.53,6.53,0,0,1,2.62-.53,4,4,0,0,1,3.79,2.19.42.42,0,0,1,0,.1l-.1.36.2-.09A3.71,3.71,0,0,1,180.2,284.58Z',className:'Badge__SecondFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M212.2,126.75c-1.53-1.16-4.31-3.09-6.22-2.56,0,0-3.89.2-6,2.94-2.09-2.74-6-2.94-6-2.94-1.91-.53-4.69,1.4-6.22,2.56a53.77,53.77,0,0,1-7,4.7c-3.61,2.12-8.84,1.6-12.72-.06-2.52-1.08-4.43-2.87-4.34-6.26a5.36,5.36,0,0,1,5.31-5.47c2.71,0,7.29,3,5.67,6.69-1.42,3.26-4.89.9-4.89.9.1,1,1.3,1.6,2,1.76,1.89.43,4.37-1.77,4-4.58a6.78,6.78,0,0,0-3.76-5.14,7.2,7.2,0,0,0-9.75,1.83c-.86,1.19-4.38,7.88,2.43,15.43s17.67,7.9,20.78,7.9c1.88,0,10.81.58,14.45-7.55,3.64,8.13,12.57,7.55,14.45,7.55,3.11,0,14-.34,20.78-7.9s3.29-14.24,2.43-15.43a7.2,7.2,0,0,0-9.75-1.83,6.81,6.81,0,0,0-3.77,5.14c-.35,2.81,2.12,5,4,4.58.72-.16,1.92-.75,2-1.76,0,0-3.47,2.36-4.89-.9-1.62-3.69,3-6.69,5.67-6.69a5.36,5.36,0,0,1,5.31,5.47c.09,3.39-1.82,5.18-4.35,6.26-3.87,1.66-9.1,2.18-12.72.06A54.29,54.29,0,0,1,212.2,126.75Z',className:'Badge__SecondFillColor',fillRule:'evenodd'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'45%',textAnchor:'middle',dy:'.7ex',fontFamily:'Lobster',fontSize:languageSettings.small?'3.5em':'6em',letterSpacing:'0em',transform:'rotate(-10) translate(-40,45)',className:'Badge__SecondFillColor'},line0),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Merriweather',fontSize:languageSettings.small?'1.1em':'1.2em',letterSpacing:'0.1em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_6__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Abel',fontSize:languageSettings.small?'1.2em':'1.4em',letterSpacing:'0.1em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_6__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(100);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_7',title:'Radial_7',colors:3,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_7 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_7__TopCircle',d:'M 70 200 A 50 50 0 0 1 330 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_7__BottomCircle',d:'M 80 205 A 50 50 0 0 0 320 205'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{width:'400',height:'400',opacity:'0'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M176,10.2,60.43,56.88C50.22,61,40.56,75.31,40.56,86.33V313.67c0,11,9.66,25.32,19.87,29.45L176,389.79c7.19,2.9,16.32,3.83,24,3.83s16.82-.93,24-3.83l115.58-46.67c10.2-4.12,19.87-18.44,19.87-29.45V86.33c0-11-9.67-25.33-19.87-29.45L224,10.2c-7.17-2.89-16.32-3.82-24-3.82S183.17,7.3,176,10.2Z',className:'Badge__SecondFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M169.54,5.15,63.67,47.91c-17.85,7.2-32.36,28.71-32.36,47.94v208.3c0,19.23,14.51,40.74,32.36,47.94l105.87,42.76c8.23,3.32,19,5.15,30.46,5.15s22.25-1.83,30.46-5.15l105.89-42.76c17.82-7.21,32.34-28.71,32.34-47.94V95.85c0-19.23-14.52-40.74-32.34-47.94L230.46,5.15C222.25,1.83,211.41,0,200,0s-22.23,1.83-30.46,5.15ZM46.37,245.86v-150c0-13.18,10.7-29.06,22.93-34L175.17,19.1C181.66,16.48,190.47,15,200,15s18.36,1.45,24.83,4.06L330.71,61.86c12.21,4.93,22.93,20.81,22.93,34v208.3c0,13.17-10.72,29.06-22.93,34L224.83,380.9c-6.47,2.61-15.3,4.06-24.83,4.06s-18.35-1.45-24.83-4.06L69.3,338.13c-12.23-4.93-22.93-20.81-22.93-34Z',className:'Badge__FirstFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M178,26.11,72.12,68.87c-9.35,3.78-18.2,16.89-18.2,27v208.3c0,10.09,8.85,23.2,18.2,27L178,373.89c6.59,2.65,15,3.51,22,3.51s15.41-.86,22-3.51l105.89-42.77c9.35-3.77,18.21-16.89,18.21-27V95.85c0-10.08-8.86-23.2-18.21-27L222,26.11c-6.57-2.65-14.95-3.51-22-3.51S184.58,23.45,178,26.11Z',className:'Badge__FirstFillColor',fillRule:'evenodd'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_','data-name':'<Gruppe>',opacity:'0.2',className:'STRIPES'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_','data-name':'<Pfad>',d:'M200,120.93a1,1,0,0,0-1,1V181.1a1,1,0,0,0,1.92,0V121.89A1,1,0,0,0,200,120.93Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_2','data-name':'<Pfad>',d:'M183.15,133.39a1,1,0,0,0-1.86.5l14.12,52.7a1,1,0,0,0,.93.71l.25,0a1,1,0,0,0,.68-1.18Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_3','data-name':'<Pfad>',d:'M186.92,179.27a1,1,0,0,0,.83.48,1,1,0,0,0,.48-.13,1,1,0,0,0,.35-1.31l-26.81-46.44a1,1,0,0,0-1.66,1Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_4','data-name':'<Pfad>',d:'M189.32,190.68a1,1,0,0,0,.68.28.94.94,0,0,0,.68-.28,1,1,0,0,0,0-1.36l-38.51-38.5a1,1,0,0,0-1.35,1.35Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_5','data-name':'<Pfad>',d:'M131.87,161.77l48.25,27.86a1,1,0,0,0,.47.13,1,1,0,0,0,.84-.48,1,1,0,0,0-.36-1.31l-48.24-27.86a1,1,0,0,0-1,1.66Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_6','data-name':'<Pfad>',d:'M132.11,182.8l54,14.47.25,0a1,1,0,0,0,.25-1.89L132.6,181a1,1,0,1,0-.49,1.85Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_7','data-name':'<Pfad>',d:'M182.06,200a1,1,0,0,0-1-1H121.89a1,1,0,1,0,0,1.92H181.1A1,1,0,0,0,182.06,200Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_8','data-name':'<Pfad>',d:'M186.09,202.73l-52.7,14.12a1,1,0,0,0-.67,1.18,1,1,0,0,0,.92.71,1.07,1.07,0,0,0,.25,0l52.7-14.12a1,1,0,0,0-.5-1.86Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_9','data-name':'<Pfad>',d:'M179.62,211.77a1,1,0,0,0-1.31-.35l-46.44,26.81a1,1,0,0,0,.48,1.78,1,1,0,0,0,.48-.12l46.44-26.81A1,1,0,0,0,179.62,211.77Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_10','data-name':'<Pfad>',d:'M190.68,209.32a1,1,0,0,0-1.36,0l-38.5,38.51a1,1,0,0,0,.68,1.63.92.92,0,0,0,.67-.28l38.51-38.5A1,1,0,0,0,190.68,209.32Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_11','data-name':'<Pfad>',d:'M189.28,218.57a1,1,0,0,0-1.31.36l-27.86,48.24a1,1,0,0,0,.36,1.31,1,1,0,0,0,.47.12,1,1,0,0,0,.83-.47l27.86-48.25A1,1,0,0,0,189.28,218.57Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_12','data-name':'<Pfad>',d:'M196.59,212.73a1,1,0,0,0-1.18.68L181,267.4a.94.94,0,0,0,.68,1.17,1,1,0,0,0,.24,0,1,1,0,0,0,.93-.72l14.47-54A1,1,0,0,0,196.59,212.73Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_13','data-name':'<Pfad>',d:'M200,217.94a1,1,0,0,0-1,1v59.21a1,1,0,0,0,1.92,0V218.9A1,1,0,0,0,200,217.94Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_14','data-name':'<Pfad>',d:'M204.59,213.41a1,1,0,1,0-1.86.5l14.12,52.7a1,1,0,0,0,.93.71.73.73,0,0,0,.25,0,1,1,0,0,0,.68-1.17Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_15','data-name':'<Pfad>',d:'M213.08,220.73a1,1,0,0,0-1.31-.35,1,1,0,0,0-.35,1.31l26.81,46.44a1,1,0,0,0,.83.47,1.07,1.07,0,0,0,.48-.12,1,1,0,0,0,.35-1.31Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_16','data-name':'<Pfad>',d:'M210.68,209.32a1,1,0,0,0-1.36,1.36l38.51,38.5a.92.92,0,0,0,.67.28,1,1,0,0,0,.68-1.63Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_17','data-name':'<Pfad>',d:'M268.13,238.23l-48.25-27.86a1,1,0,1,0-.95,1.66l48.24,27.86a1,1,0,0,0,.48.12,1,1,0,0,0,.48-1.78Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_18','data-name':'<Pfad>',d:'M267.89,217.2l-54-14.47a1,1,0,1,0-.5,1.86l54,14.46a1.07,1.07,0,0,0,.25,0,1,1,0,0,0,.24-1.88Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_19','data-name':'<Pfad>',d:'M278.11,199H218.9a1,1,0,0,0,0,1.92h59.21a1,1,0,1,0,0-1.92Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_20','data-name':'<Pfad>',d:'M266.11,181.29l-52.7,14.12a1,1,0,0,0,.25,1.89,1.07,1.07,0,0,0,.25,0l52.7-14.12a1,1,0,0,0-.5-1.86Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_21','data-name':'<Pfad>',d:'M220.38,188.23a1,1,0,0,0,.83.48.91.91,0,0,0,.48-.13l46.44-26.81a1,1,0,0,0-1-1.66l-46.44,26.81A1,1,0,0,0,220.38,188.23Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_22','data-name':'<Pfad>',d:'M209.32,190.68a1,1,0,0,0,1.36,0l38.5-38.51a1,1,0,0,0-1.35-1.35l-38.51,38.5A1,1,0,0,0,209.32,190.68Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_23','data-name':'<Pfad>',d:'M210.72,181.43a1.07,1.07,0,0,0,.48.12.94.94,0,0,0,.83-.48l27.86-48.24a1,1,0,0,0-1.66-1l-27.86,48.25A1,1,0,0,0,210.72,181.43Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_24','data-name':'<Pfad>',d:'M203.41,187.27l.25,0a1,1,0,0,0,.93-.71l14.46-54a1,1,0,1,0-1.85-.49l-14.47,54A1,1,0,0,0,203.41,187.27Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M229.84,196.19s17.8-16-1.8-37.83c0,0-1.63.58,0-2.94s6.65-17.7-5.06-23.9c0,0,6.9-23.75-18.29-26.7,0,0-6.33.67-4.24,4.15s7.18,3.43.29,10.29S178.21,127,180.13,148c0,0,.06,2-2.62,3.43s-12.27,11.89-4.94,29.44c0,0-6.8,7.71-2.16,17.34,0,0,2.8-.6,32.61-.6S229.84,196.19,229.84,196.19Z',fill:'#f5f5f5'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M229.45,198.51l-1.83-1.71c5.94-6.36,8.73-13,8.3-19.78-.7-11.07-9.83-18.78-9.92-18.86l1.59-1.92c.41.34,10.06,8.49,10.83,20.62C238.89,184.34,235.87,191.62,229.45,198.51Z',fill:'#462712'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M169.61,199.41c-.06-.1-5.5-9.46,1.48-18.15-1.74-3.8-8.18-20.54,7.06-31.89,8.76-6.53,17.11-8.8,25.2-11,6.41-1.74,12.47-3.38,18.51-7l.13-.07c2.14-1,4.47-.12,6.38,2.35,3.81,4.91,5.79,16.41-.6,24.35-4.73,5.88-16.73,9.38-28.33,12.77-9.41,2.75-19.14,5.59-23.8,9.47-9.59,8-4.12,17.51-3.88,17.91Zm53.47-65.88c-6.31,3.81-12.8,5.57-19.08,7.27-7.86,2.13-16,4.32-24.36,10.57-12.95,9.66-8.68,23.29-6.71,27.91q.52-.5,1.11-1c5.06-4.2,14.6-7,24.7-9.94,11.23-3.28,22.84-6.67,27.08-11.94,5.39-6.68,4-16.88.58-21.25C225.73,134.3,224.43,133,223.08,133.53Z',fill:'#462712'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M179.32,149.66c-.18-.48-4.34-11.89,4.2-20.66,3.65-3.75,8.22-6.17,11.89-8.13,5-2.63,7.73-4.24,7.25-6.7-.34-1.73-1-2.85-1.94-3.34a3.48,3.48,0,0,1-1.88-2.9,3.16,3.16,0,0,1,1.47-2.83c2.43-1.55,6.74-2.69,13.5.61a20.24,20.24,0,0,1,10.61,12.94c1.51,5.26,1.16,11.19-.85,14.43l-2.12-1.32c1.4-2.26,2.05-7.26.56-12.42A17.74,17.74,0,0,0,212.72,108c-4.53-2.22-8.36-2.48-11.06-.75a.65.65,0,0,0-.32.61.92.92,0,0,0,.53.78c1.66.86,2.75,2.57,3.25,5.09.86,4.4-3.49,6.71-8.53,9.39-3.71,2-7.9,4.2-11.28,7.67-7.45,7.64-3.69,17.93-3.65,18Z',fill:'#462712'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M226.07,207l-21.45,84.82a4.27,4.27,0,0,1-8.33,0L174.84,207Z',fill:'#b79780'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200.45,296.42a5.52,5.52,0,0,1-5.37-4.27l-21.85-86.37h54.45l-21.85,86.37A5.53,5.53,0,0,1,200.45,296.42Zm-24-88.14,21.06,83.26a3,3,0,0,0,5.91,0l21.06-83.26Z',fill:'#462712'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{x:'168.99',y:'197.65',width:'63.5',height:'10.79',rx:'2.09',ry:'2.09',fill:'#eecbb5'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M230.39,209.7H171.08a3.35,3.35,0,0,1-3.34-3.35v-6.6a3.35,3.35,0,0,1,3.34-3.35h59.31a3.35,3.35,0,0,1,3.34,3.35v6.6A3.35,3.35,0,0,1,230.39,209.7Zm-59.31-10.8a.85.85,0,0,0-.84.85v6.6a.85.85,0,0,0,.84.85h59.31a.84.84,0,0,0,.84-.85v-6.6a.85.85,0,0,0-.84-.85Z',fill:'#462712'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Fjalla One',fontSize:languageSettings.small?'1.1em':'1.5em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_7__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Fjalla One',fontSize:languageSettings.small?'1.1em':'1.5em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_7__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(103);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_8',title:'Radial_8',colors:3,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_8 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_8__TopCircle',d:'M 70 190 A 50 50 0 0 1 330 190'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_8__BottomCircle',d:'M 80 205 A 50 50 0 0 0 320 205'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{width:'400',height:'400',opacity:'0'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SHAPE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M43.69,105v53.73h.2c0,1.83,0,3.65,0,5.43,0,10,0,20.09,0,30.15,0,15.36-.14,30.73-.14,46.1,0,41.56,21.7,79.7,55.82,103.06a23.23,23.23,0,0,0,2.3,1.37l88.25,45.34a21.89,21.89,0,0,0,19.89,0L298.2,344.8a22.13,22.13,0,0,0,2.3-1.37c34.11-23.36,55.81-61.5,55.81-103.06q0-49.76,0-99.53h0V73a20.37,20.37,0,0,0-9.88-17.36L324.1,42A240.21,240.21,0,0,0,75.9,42L53.57,55.66A20.37,20.37,0,0,0,43.69,73Z',className:'Badge__SecondFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M49.87,108.72v51.6h.19c0,1.76,0,3.5,0,5.21,0,9.65,0,19.31,0,29,0,14.75-.13,29.52-.13,44.27,0,39.92,20.84,76.56,53.61,99a19.83,19.83,0,0,0,2.21,1.32l84.76,43.54a21,21,0,0,0,19.11,0l84.76-43.54a19.83,19.83,0,0,0,2.21-1.32c32.76-22.43,53.6-59.07,53.6-99V143.18h0V78a19.55,19.55,0,0,0-9.48-16.67L319.2,48.25a230.7,230.7,0,0,0-238.4,0L59.36,61.36A19.58,19.58,0,0,0,49.87,78Z',className:'Badge__FirstFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M35,175.39H34.8V78A34.64,34.64,0,0,1,51.5,48.5L72.94,35.4a245.76,245.76,0,0,1,254.12,0L348.5,48.5A34.61,34.61,0,0,1,365.2,78V238.77c0,44.93-23.31,86.2-60.16,111.43a36.2,36.2,0,0,1-3.83,2.29L216.44,396a36.06,36.06,0,0,1-32.88,0L98.8,352.49A36.2,36.2,0,0,1,95,350.2C58.12,325,34.8,283.7,34.8,238.77c0-14.77.09-29.54.12-44.31q0-9.53,0-19.07Zm11.61-11.77h.16v2.82q0,14,0,28.05c0,14.76-.13,29.52-.13,44.28,0,41,21.41,78.69,55.05,101.71a23.79,23.79,0,0,0,2.56,1.54l84.76,43.54a24.32,24.32,0,0,0,22.12,0L295.83,342a23.79,23.79,0,0,0,2.56-1.54c33.63-23,55-60.67,55-101.71V78a22.89,22.89,0,0,0-11.06-19.49L320.92,45.45a234,234,0,0,0-241.84,0L57.64,58.55A22.88,22.88,0,0,0,46.57,78Z',className:'Badge__FirstFillColor',fillRule:'evenodd'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'ILLUSTRATION'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'264.77 263.42 204.1 255.98 133.99 263.99 187.64 277.78 264.77 263.42',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M187.64,278.76a.67.67,0,0,1-.24,0l-53.66-13.79a1,1,0,0,1,.14-1.91L204,255h.23l60.67,7.45a1,1,0,0,1,.85.93,1,1,0,0,1-.79,1l-77.13,14.36Zm-48.31-14.4,48.35,12.43,70.72-13.17L204.1,257Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M264.77,263.42c4-12.78-2.93-19-2.93-19l-74.28,12.68s3.63,12.77.08,20.67Z',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M187.64,278.76a1,1,0,0,1-.76-.38,1,1,0,0,1-.12-1c3.35-7.5-.1-19.89-.13-20a1,1,0,0,1,.77-1.22l74.27-12.68a1,1,0,0,1,.82.23c.3.27,7.34,6.79,3.21,20a1,1,0,0,1-.75.67l-77.13,14.36Zm1.13-20.87c.73,3,2.53,11.86.39,18.62L264,262.58c3-10.2-1.26-15.75-2.51-17.11Zm76,5.53h0Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'261.84 244.43 204.02 235.3 134.95 243.35 187.56 257.11 261.84 244.43',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M187.56,258.08l-.24,0-52.61-13.76a1,1,0,0,1-.73-1,1,1,0,0,1,.86-.9l69.07-8a.76.76,0,0,1,.26,0L262,243.47a1,1,0,0,1,.82.95,1,1,0,0,1-.81,1l-74.27,12.67ZM140.2,243.72l47.41,12.39,68.23-11.65L204,236.28Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'264.77 263.42 204.1 255.98 133.99 263.99 187.64 277.78 264.77 263.42',fill:'#d23068'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M138.55,244.29s1.93,12,.25,19.09l50.86,12.75s2.48-1.67,2.42-2.21-.54-13.63-.54-13.63L190.25,258,188,255.79l-47.65-12.1Z',fill:'#fbfaf6'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M189.66,277.1l-.24,0-50.86-12.75a1,1,0,0,1-.71-1.17c1.62-6.8-.24-18.59-.26-18.7a1,1,0,0,1,.66-1.08l1.84-.6a.91.91,0,0,1,.54,0l47.65,12.1a1,1,0,0,1,.45.25l2.21,2.23a1.16,1.16,0,0,1,.16.21l1.29,2.27a.93.93,0,0,1,.12.44c.19,5.2.5,13.11.54,13.58s.11,1.11-2.85,3.11A1,1,0,0,1,189.66,277.1Zm-49.72-14.44,49.53,12.42a12.7,12.7,0,0,0,1.63-1.33c-.1-1.75-.43-10.74-.52-13.19l-1.11-1.95-1.93-1.94-47.11-12-.79.26C140,247.69,141.1,256.49,139.94,262.66ZM191.11,274h0Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'191.64',y1:'273.79',x2:'140.79',y2:'261.49',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M191.64,274.28h-.11L140.68,262a.49.49,0,0,1,.22-1l50.86,12.3a.49.49,0,0,1-.12,1Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'191.75',y1:'271.16',x2:'140.89',y2:'258.86',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M191.75,271.65l-.12,0-50.85-12.3a.49.49,0,0,1-.36-.59.47.47,0,0,1,.59-.35l50.85,12.3a.49.49,0,0,1-.11,1Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'191.85',y1:'268.52',x2:'140.99',y2:'256.22',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M191.85,269h-.11l-50.86-12.3a.5.5,0,0,1-.36-.59.49.49,0,0,1,.59-.36L192,268.05a.49.49,0,0,1,.36.59A.48.48,0,0,1,191.85,269Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'191.95',y1:'265.89',x2:'141.1',y2:'253.59',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M192,266.38l-.11,0L141,254.06a.49.49,0,0,1-.36-.59.48.48,0,0,1,.59-.35l50.86,12.3a.47.47,0,0,1,.35.58A.48.48,0,0,1,192,266.38Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'192.05',y1:'263.25',x2:'141.2',y2:'250.95',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M192.05,263.74h-.11l-50.86-12.3a.49.49,0,0,1,.23-1l50.86,12.3a.49.49,0,0,1,.36.59A.5.5,0,0,1,192.05,263.74Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'192.16',y1:'260.62',x2:'141.3',y2:'248.32',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M192.16,261.1H192l-50.85-12.3a.49.49,0,0,1,.23-.95l50.85,12.31a.48.48,0,0,1,.36.58A.47.47,0,0,1,192.16,261.1Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M264.77,263.42c4-12.78-2.93-19-2.93-19l-74.28,12.68s3.63,12.77.08,20.67Z',fill:'#ea5c87'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M245.17,261.11c5.47-.53,11-1.49,15.56-4.64a16.11,16.11,0,0,0,4.78-5.05,14.34,14.34,0,0,0-3.67-7l-74.28,12.68a50.8,50.8,0,0,1,1.47,8.35c1.13.3,2.26.6,3.39,1a49.94,49.94,0,0,0,11.48,2l3.48-.3c5.7-1,11.41-1.8,17.12-2.65,3-.45,6-.93,9.05-1.41l7.6-1.63,2.06-.42A3.13,3.13,0,0,1,245.17,261.11Z',fill:'#d23068'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M187.64,278.76a1,1,0,0,1-.76-.38,1,1,0,0,1-.12-1c3.35-7.5-.1-19.89-.13-20a1,1,0,0,1,.77-1.22l74.27-12.68a1,1,0,0,1,.82.23c.3.27,7.34,6.79,3.21,20a1,1,0,0,1-.75.67l-77.13,14.36Zm1.13-20.87c.73,3,2.53,11.86.39,18.62L264,262.58c3-10.2-1.26-15.75-2.51-17.11Zm76,5.53h0Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'261.84 244.43 204.02 235.3 134.95 243.35 187.56 257.11 261.84 244.43',fill:'#ea5c87'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M146.33,244.64c2,.59,4,1,6,1.41s4.11,1,6.18,1.52l1.64.37c1.67.31,3.34.65,5,1.07h0c1.82.4,3.64.81,5.44,1.29,2.08.54,4.12,1.17,6.14,1.91l1.06.37.21,0c2.17.53,4.4.8,6.57,1.35,1.41.36,2.78.77,4.21,1.06a28.17,28.17,0,0,1,4.39,1.1l68.67-11.72L204,235.3l-63.18,7.36C142.7,243.2,144.47,244.09,146.33,244.64Z',fill:'#d23068'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M187.56,258.08l-.24,0-52.61-13.76a1,1,0,0,1-.73-1,1,1,0,0,1,.86-.9l69.07-8a.76.76,0,0,1,.26,0L262,243.47a1,1,0,0,1,.82.95,1,1,0,0,1-.81,1l-74.27,12.67ZM140.2,243.72l47.41,12.39,68.23-11.65L204,236.28Z',fill:'#333052'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'136.22 238.87 193.84 235.83 259.34 247.95 207.91 257.44 136.22 238.87',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.91,258.41a1.07,1.07,0,0,1-.25,0L136,239.81a1,1,0,0,1,.2-1.91l57.61-3a.87.87,0,0,1,.23,0L259.51,247a1,1,0,0,1,.8.95,1,1,0,0,1-.8,1l-51.42,9.48Zm-65.35-18.9,65.38,16.93L254,248l-60.21-11.14Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M136.22,238.87c-2.93-12.3,4-17.7,4-17.7L209.34,238s-4.25,11.79-1.43,19.47Z',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.91,258.41l-.25,0L136,239.81a1,1,0,0,1-.7-.71c-3-12.76,4-18.46,4.36-18.69a.93.93,0,0,1,.82-.18L209.57,237a1,1,0,0,1,.62.49,1,1,0,0,1,.06.79c0,.11-4.09,11.55-1.43,18.8a1,1,0,0,1-.19,1A1,1,0,0,1,207.91,258.41ZM137,238.08l69.45,18c-1.53-6.46.69-14.56,1.59-17.4l-67.59-16.42C139.21,223.46,134.94,228.38,137,238.08Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'140.22 221.17 195.26 216.36 259.78 228.46 209.34 237.97 140.22 221.17',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M209.34,238.94a.85.85,0,0,1-.23,0L140,222.12a1,1,0,0,1,.15-1.91l55-4.82a.74.74,0,0,1,.26,0L260,227.5a1,1,0,0,1,0,1.91l-50.44,9.51A.55.55,0,0,1,209.34,238.94Zm-63.13-17.31L209.36,237l45.15-8.51-59.29-11.12Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'136.22 238.87 193.84 235.83 259.34 247.95 207.91 257.44 136.22 238.87',fill:'#6aa7b7'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.91,258.41a1.07,1.07,0,0,1-.25,0L136,239.81a1,1,0,0,1,.2-1.91l57.61-3a.87.87,0,0,1,.23,0L259.51,247a1,1,0,0,1,.8.95,1,1,0,0,1-.8,1l-51.42,9.48Zm-65.35-18.9,65.38,16.93L254,248l-60.21-11.14Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M256.32,229.11s-2.59,11.18-1.47,17.95l-48.73,8.68s-2.23-1.73-2.14-2.23,1.4-12.81,1.4-12.81l1.37-2,2.22-2,45.66-8.28Z',fill:'#fbfaf6'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M206.12,256.72a1,1,0,0,1-.6-.21c-2.68-2.09-2.57-2.76-2.5-3.17s.88-7.86,1.4-12.74a1,1,0,0,1,.15-.43l1.37-2.06a1,1,0,0,1,.16-.19l2.23-1.95a.91.91,0,0,1,.47-.23l45.66-8.28a1,1,0,0,1,.54.06l1.69.69a1,1,0,0,1,.58,1.12c0,.11-2.54,11.08-1.46,17.58A1,1,0,0,1,255,248l-48.73,8.68ZM205,253.39a11.17,11.17,0,0,0,1.4,1.32l47.37-8.44c-.66-5.85.9-14,1.45-16.57l-.67-.27-45.12,8.18-1.93,1.69L206.33,241C206.08,243.35,205.18,251.7,205,253.39Zm0,.26v0Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'204.4',y1:'253.42',x2:'253.09',y2:'245.16',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M204.4,253.9a.48.48,0,0,1-.48-.4.49.49,0,0,1,.4-.56L253,244.68a.48.48,0,0,1,.56.4.48.48,0,0,1-.4.56l-48.69,8.26Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'204.48',y1:'250.93',x2:'253.17',y2:'242.67',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M204.48,251.42a.49.49,0,0,1-.08-1l48.69-8.26a.49.49,0,1,1,.16,1l-48.69,8.26Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'204.55',y1:'248.44',x2:'253.25',y2:'240.18',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M204.55,248.93a.49.49,0,0,1-.08-1l48.69-8.26a.51.51,0,0,1,.57.4.49.49,0,0,1-.4.56l-48.69,8.26Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'204.63',y1:'245.95',x2:'253.32',y2:'237.69',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M204.63,246.44a.49.49,0,0,1-.08-1l48.69-8.25a.48.48,0,0,1,.56.39.47.47,0,0,1-.4.56l-48.69,8.26Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'204.71',y1:'243.47',x2:'253.4',y2:'235.21',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M204.7,244a.48.48,0,0,1-.47-.4.47.47,0,0,1,.39-.56l48.7-8.26a.49.49,0,0,1,.56.4.5.5,0,0,1-.4.56l-48.69,8.25Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'204.78',y1:'240.98',x2:'253.47',y2:'232.72',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M204.78,241.46a.48.48,0,0,1-.08-1l48.69-8.26a.48.48,0,0,1,.56.4.48.48,0,0,1-.4.56l-48.69,8.26Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M136.22,238.87c-2.93-12.3,4-17.7,4-17.7L209.34,238s-4.25,11.79-1.43,19.47Z',fill:'#8ddff4'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M208.1,242.28c-2.32-.75-4.65-1.37-7.06-1.93-5.58-1.28-11.22-2.34-16.8-3.64-2.82-.66-5.59-1.5-8.43-2.06s-5.67-1-8.5-1.5-5.65-1.31-8.46-2l-.26-.06a10.74,10.74,0,0,1-1.78-.43l-.9-.21a3.2,3.2,0,0,1-2-.25c-.29-.13-.59-.26-.89-.37l-2.84-.55a38.6,38.6,0,0,1-4.87-1.24l-.72-.16c-2.54-.6-4.85-1.91-7.32-2.63-1.42,2.88-2.49,7.36-1,13.64l71.69,18.57C206.17,252.71,207.12,246.42,208.1,242.28Z',fill:'#6aa7b7'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.91,258.41l-.25,0L136,239.81a1,1,0,0,1-.7-.71c-3-12.76,4-18.46,4.36-18.69a.93.93,0,0,1,.82-.18L209.57,237a1,1,0,0,1,.62.49,1,1,0,0,1,.06.79c0,.11-4.09,11.55-1.43,18.8a1,1,0,0,1-.19,1A1,1,0,0,1,207.91,258.41ZM137,238.08l69.45,18c-1.53-6.46.69-14.56,1.59-17.4l-67.59-16.42C139.21,223.46,134.94,228.38,137,238.08Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'140.22 221.17 195.26 216.36 259.78 228.46 209.34 237.97 140.22 221.17',fill:'#8ddff4'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M209.34,238.94a.85.85,0,0,1-.23,0L140,222.12a1,1,0,0,1,.15-1.91l55-4.82a.74.74,0,0,1,.26,0L260,227.5a1,1,0,0,1,0,1.91l-50.44,9.51A.55.55,0,0,1,209.34,238.94Zm-63.13-17.31L209.36,237l45.15-8.51-59.29-11.12Z',fill:'#333052'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ellipse',{cx:'200.88',cy:'224.98',rx:'19.05',ry:'2.89',fill:'#6aa7b7'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M245.85,152.8l-.65,0a12.42,12.42,0,0,1-10.45-7.29,1,1,0,0,1,1.78-.78,10.22,10.22,0,0,0,18.21,1.06,1,1,0,0,1,1.68,1A12.45,12.45,0,0,1,245.85,152.8Z',fill:'#333052'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M254.68,143.41a2.85,2.85,0,0,0,5.69.32C260.69,139.93,254.78,139.58,254.68,143.41Z',fill:'#f8e780'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M257.51,147.31h-.19a3.94,3.94,0,0,1-3.61-3.92h0a3.61,3.61,0,0,1,1.93-3.22,4.2,4.2,0,0,1,4.13.23,3.6,3.6,0,0,1,1.57,3.41A4,4,0,0,1,257.51,147.31Zm0-5.63a2.13,2.13,0,0,0-1,.22,1.65,1.65,0,0,0-.88,1.54h0a1.88,1.88,0,0,0,3.75.21,1.65,1.65,0,0,0-.71-1.63A2.15,2.15,0,0,0,257.5,141.68Zm-2.82,1.73h0Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'162.31 202.64 240.34 205.69 228.55 110.13 168.1 112.02 162.31 202.64',fill:'#ddca6c'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M240.34,206.66h0l-78-3a1,1,0,0,1-.94-1l5.8-90.62a1,1,0,0,1,.94-.91l60.45-1.89h0a1,1,0,0,1,1,.85l11.8,95.56a1,1,0,0,1-.25.78A1,1,0,0,1,240.34,206.66Zm-77-4.95,75.9,3-11.55-93.54L169,113Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'163.86 199.85 237.95 202.16 241.95 189.18 176.23 185.99 164.77 193.7 163.86 199.85',fill:'#fbfaf6'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M238,203.13h0l-74.09-2.31a1,1,0,0,1-.72-.34,1,1,0,0,1-.22-.77l.92-6.15a1,1,0,0,1,.42-.67l11.45-7.71a1,1,0,0,1,.59-.16L242,188.21a1,1,0,0,1,.75.42,1,1,0,0,1,.13.84l-4,13A1,1,0,0,1,238,203.13Zm-73-4.22,72.26,2.25,3.41-11.07L176.5,187l-10.83,7.29Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'163.74',y1:'197.38',x2:'236.46',y2:'199.93',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M236.46,200.42h0l-72.71-2.55a.49.49,0,0,1-.47-.51.53.53,0,0,1,.5-.47l72.71,2.56a.49.49,0,0,1,0,1Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'164.52',y1:'195.38',x2:'237.23',y2:'197.93',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M237.24,198.42h0l-72.72-2.56a.48.48,0,0,1-.46-.5.53.53,0,0,1,.5-.47l72.71,2.55a.49.49,0,0,1,.47.51A.48.48,0,0,1,237.24,198.42Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'165.3',y1:'193.37',x2:'238.01',y2:'195.92',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M238,196.41h0l-72.72-2.55a.51.51,0,0,1-.47-.51.49.49,0,0,1,.49-.47h0L238,195.44a.49.49,0,0,1,0,1Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line',{x1:'166.08',y1:'191.37',x2:'238.79',y2:'193.92',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M238.79,194.4h0l-72.72-2.55a.48.48,0,0,1-.47-.5.51.51,0,0,1,.51-.47l72.71,2.55a.49.49,0,0,1,0,1Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M162.31,202.64l-7.9-83.9s4.26-12.49,13.85-12.42l8,83.47S168.4,191.07,162.31,202.64Z',fill:'#e8d470'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M167,188.63a35.94,35.94,0,0,0,.84-9.2c.12-13.11.37-26.34-1.47-39.36a76.12,76.12,0,0,0-1.92-9.71,57.27,57.27,0,0,1-2-9.54,39.37,39.37,0,0,0-1.38-7.85,7,7,0,0,0-1.27-2.58c.11.14,0,0-.2-.12a25.54,25.54,0,0,0-5.2,8.47l7.9,83.9a34.09,34.09,0,0,1,4-6C165.47,194,166.25,191.26,167,188.63Z',fill:'#d1bb5d'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M162.31,203.61a.58.58,0,0,1-.19,0,1,1,0,0,1-.78-.86l-7.9-83.89a1,1,0,0,1,.05-.41c.18-.53,4.58-13.08,14.68-13.08h.1a1,1,0,0,1,1,.88l8,83.46a1,1,0,0,1-.81,1.06c-.07,0-7.45,1.4-13.21,12.34A1,1,0,0,1,162.31,203.61Zm-6.91-84.74L163,199.51c4.77-7.55,10.1-9.83,12.18-10.46l-7.79-81.72C159.79,108,156,117.41,155.4,118.87Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'168.24 106.14 231.81 110.33 243.12 191.89 176.2 189.6 168.24 106.14',fill:'#f8e780'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M229.88,184.56l-.93-.17c-2,.11-3.93.25-5.82.27-7.75.12-15.48-.71-23.23-.86-4.94-.09-11.59.81-14.46-4.33-1.34-2.39-1.36-5.14-1.57-7.8-.29-3.63-.78-7.23-1.28-10.83-.76-5.46-1.54-10.93-1.77-16.44-.53-1.75-1-3.51-1.38-5.33a106.5,106.5,0,0,1-1.75-11.93,53.08,53.08,0,0,1,.6-15.42,29.63,29.63,0,0,1,.79-3.41c.13-.48.26-1,.42-1.43l-11.26-.74,8,83.46,66.92,2.29-.39-2.85C238.82,186.61,234.36,185.42,229.88,184.56Z',fill:'#e8d470'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M203.15,109.47c1.84,1,3.71,1.91,5.58,2.83,6.19,3.06,12.27,6.26,16.6,11.8,3.8,4.86,6.07,10.58,7.91,16.42,1,3.07,1.8,6.18,2.85,9.23.54,1.59,1.16,3.13,1.84,4.66l-6.11-44.08-30.78-2C201.74,108.69,202.44,109.09,203.15,109.47Z',fill:'#fbf4c2'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M243.12,192.86h0l-66.92-2.28a1,1,0,0,1-.93-.88l-8-83.47a1,1,0,0,1,1-1.06l63.57,4.19a1,1,0,0,1,.9.84l11.3,81.55a1,1,0,0,1-.24.79A1,1,0,0,1,243.12,192.86Zm-66-4.2L242,190.88l-11-79.63-61.64-4.07Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M186.7,136.09a2.09,2.09,0,1,1-1.76-2.38A2.09,2.09,0,0,1,186.7,136.09Z',fill:'#333052'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M224.24,136.77a2.09,2.09,0,1,1-1.76-2.37A2.08,2.08,0,0,1,224.24,136.77Z',fill:'#333052'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M204,146.61H204a13.4,13.4,0,0,1-7.86-2.42,7.56,7.56,0,0,1-3.39-6.11,1,1,0,0,1,1-1h0a1,1,0,0,1,1,1,5.68,5.68,0,0,0,2.6,4.53,11.46,11.46,0,0,0,6.72,2H204a11.46,11.46,0,0,0,6.67-2,5.66,5.66,0,0,0,2.64-4.5,1,1,0,0,1,1-1h0a1,1,0,0,1,1,1,7.54,7.54,0,0,1-3.46,6.07A13.36,13.36,0,0,1,204,146.61Z',fill:'#333052'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M152.44,160a15.79,15.79,0,0,1-6.05-1.18,16.26,16.26,0,0,1-9.78-12.89,1,1,0,1,1,1.93-.24,14.08,14.08,0,0,0,22.69,9.38,1,1,0,0,1,1.36.16,1,1,0,0,1-.16,1.37A16.18,16.18,0,0,1,152.44,160Z',fill:'#333052'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M134.91,144.11a3.45,3.45,0,0,0,5.36-4.34C137.49,136.22,132,140.65,134.91,144.11Z',fill:'#f8e780'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M137.6,146.27a4.47,4.47,0,0,1-3.43-1.54,4.11,4.11,0,0,1-.78-4.18,4.88,4.88,0,0,1,3.72-3,4.12,4.12,0,0,1,3.93,1.63,4.54,4.54,0,0,1-.7,6.16A4.36,4.36,0,0,1,137.6,146.27Zm.15-6.83-.34,0a2.93,2.93,0,0,0-2.2,1.78,2.15,2.15,0,0,0,.45,2.24h0a2.47,2.47,0,0,0,3.85-3.11A2.18,2.18,0,0,0,137.75,139.44Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M189.83,222.51l-.19,0a1,1,0,0,1-.76-1.14,89.13,89.13,0,0,0,1.48-22.59,1,1,0,1,1,1.94-.12,90.67,90.67,0,0,1-1.52,23.08A1,1,0,0,1,189.83,222.51Z',fill:'#333052'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M195.36,223.07a1.93,1.93,0,0,1,.94,1.68c-.13.84-1.11,1.23-2,1.31a7.73,7.73,0,0,1-4-.66c-1.83-.85-2.89-2.66-.53-3.41A6.46,6.46,0,0,1,195.36,223.07Z',fill:'#f8e780'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M193.55,227.08a8.69,8.69,0,0,1-3.64-.8c-1.56-.72-2.52-1.94-2.45-3.09,0-.57.35-1.59,2-2.13a7.44,7.44,0,0,1,6.45,1.23h0a2.77,2.77,0,0,1,1.32,2.61c-.17,1.15-1.25,2-2.81,2.13C194.15,227.06,193.85,227.08,193.55,227.08Zm-2.15-4.36a4.28,4.28,0,0,0-1.31.2c-.55.17-.69.36-.69.39s.37.76,1.33,1.2a6.74,6.74,0,0,0,3.51.59c.63-.07,1.07-.31,1.1-.5s-.17-.45-.57-.76h0A5.75,5.75,0,0,0,191.4,222.72Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.6,223h-.13a1,1,0,0,1-.83-1.09c1.14-8.49.79-14.44.12-22.53a1,1,0,0,1,1.94-.16c.67,8.22,1,14.26-.13,22.95A1,1,0,0,1,207.6,223Z',fill:'#333052'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M212.61,222.49a1.94,1.94,0,0,1,.95,1.68c-.13.84-1.12,1.23-2,1.32a7.76,7.76,0,0,1-4-.67c-1.83-.84-2.89-2.65-.53-3.41A6.49,6.49,0,0,1,212.61,222.49Z',fill:'#f8e780'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M210.8,226.5a8.61,8.61,0,0,1-3.63-.8c-1.56-.72-2.53-1.93-2.46-3.09,0-.56.35-1.58,2-2.12a7.42,7.42,0,0,1,6.45,1.23,2.79,2.79,0,0,1,1.32,2.6c-.18,1.16-1.26,2-2.82,2.14C211.4,226.49,211.1,226.5,210.8,226.5Zm-2.15-4.35a4.28,4.28,0,0,0-1.31.19c-.55.17-.68.36-.68.39,0,.2.43.8,1.32,1.21a6.86,6.86,0,0,0,3.52.58c.61-.06,1.07-.31,1.09-.5s-.16-.45-.57-.75h0A5.75,5.75,0,0,0,208.65,222.15Z',fill:'#333052'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M226,142.31c0,.49-1.5.9-3.35.9s-3.36-.41-3.36-.9,1.5-.91,3.36-.91S226,141.81,226,142.31Z',fill:'#ea5c87'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M188.92,141.4c0,.5-1.5.91-3.35.91s-3.36-.41-3.36-.91,1.51-.9,3.36-.9S188.92,140.91,188.92,141.4Z',fill:'#ea5c87'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Ropa Sans',fontSize:languageSettings.small?'1.2em':'1.5em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_8__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Ropa Sans',fontSize:languageSettings.small?'1.2em':'1.5em',letterSpacing:'0.1em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_8__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(106);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_9',title:'Radial_9',colors:3,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_9 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_9__TopCircle',d:'M 70 200 A 50 50 0 0 1 330 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_9__BottomCircle',d:'M 80 205 A 50 50 0 0 0 320 205'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'400 200 388.26 214.16 397.79 229.89 384.09 242.14 391.16 259.13 375.78 269.18 380.23 287.04 363.52 294.67 365.26 312.99 347.61 318.03 346.61 336.41 328.4 338.77 324.7 356.81 306.35 356.43 300.02 373.71 281.92 370.6 273.09 386.74 255.66 380.94 244.51 395.56 228.15 387.22 214.94 400 200 389.31 185.06 400 171.85 387.22 155.49 395.56 144.33 380.94 126.91 386.74 118.07 370.6 99.98 373.71 93.65 356.43 75.29 356.8 71.59 338.77 53.39 336.41 52.39 318.03 34.74 312.98 36.47 294.66 19.77 287.04 24.21 269.18 8.84 259.13 15.91 242.14 2.21 229.89 11.73 214.16 0 200 11.73 185.84 2.21 170.11 15.91 157.86 8.84 140.87 24.22 130.82 19.77 112.96 36.48 105.33 34.74 87.01 52.39 81.97 53.39 63.59 71.6 61.23 75.3 43.2 93.65 43.57 99.98 26.29 118.08 29.4 126.91 13.26 144.34 19.06 155.49 4.43 171.85 12.78 185.06 0 200 10.69 214.94 0 228.15 12.78 244.51 4.43 255.67 19.06 273.09 13.27 281.93 29.4 300.02 26.29 306.35 43.57 324.71 43.2 328.41 61.23 346.61 63.59 347.61 81.97 365.26 87.02 363.53 105.34 380.23 112.97 375.79 130.82 391.16 140.87 384.09 157.86 397.79 170.11 388.26 185.84 400 200',className:'DOTS Badge__FillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,375c-96.25,0-174.56-78.52-174.56-175S103.75,25,200,25s174.56,78.52,174.56,175S296.25,375,200,375ZM200,27C104.85,27,27.44,104.59,27.44,200S104.85,373,200,373s172.56-77.63,172.56-173S295.15,27,200,27Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M202.35,358.62a1,1,0,0,1-1-1,1,1,0,0,1,1-1c1.66,0,3.33-.08,5-.16a1,1,0,0,1,1,1,1,1,0,0,1-1,1c-1.66.08-3.35.13-5,.16Zm-5,0h0c-1.67,0-3.36-.08-5-.16a1,1,0,0,1-1-1.05,1,1,0,0,1,1.05-.95c1.64.08,3.31.13,5,.16a1,1,0,0,1,0,2Zm15-.45a1,1,0,0,1-.07-2c1.66-.13,3.32-.29,4.94-.47a1,1,0,0,1,1.11.89,1,1,0,0,1-.89,1.1c-1.64.18-3.33.34-5,.47Zm-25,0h-.08c-1.66-.13-3.35-.3-5-.48a1,1,0,0,1-.88-1.11,1,1,0,0,1,1.1-.88c1.64.18,3.31.34,4.94.47a1,1,0,0,1-.07,2Zm34.9-1.07a1,1,0,0,1-1-.85,1,1,0,0,1,.85-1.14c1.64-.23,3.3-.49,4.9-.77a1,1,0,0,1,1.16.81,1,1,0,0,1-.81,1.16c-1.63.28-3.3.55-5,.78Zm-44.84,0h-.14c-1.64-.24-3.31-.5-5-.8a1,1,0,0,1-.81-1.16,1,1,0,0,1,1.16-.81c1.64.29,3.29.56,4.9.79a1,1,0,0,1-.14,2Zm54.69-1.68a1,1,0,0,1-.21-2c1.61-.33,3.24-.7,4.85-1.09a1,1,0,1,1,.47,1.94c-1.63.4-3.28.77-4.91,1.11Zm-64.53-.06-.21,0c-1.63-.35-3.28-.72-4.9-1.12a1,1,0,0,1-.74-1.2,1,1,0,0,1,1.21-.74c1.61.39,3.24.76,4.84,1.1a1,1,0,0,1-.2,2ZM241.83,353a1,1,0,0,1-.26-2c1.58-.44,3.18-.91,4.76-1.4a1,1,0,0,1,.6,1.91c-1.6.49-3.23,1-4.83,1.42A1.24,1.24,0,0,1,241.83,353Zm-84-.08a.84.84,0,0,1-.27,0c-1.62-.45-3.24-.93-4.83-1.42a1,1,0,0,1-.65-1.26,1,1,0,0,1,1.25-.65c1.57.49,3.17,1,4.77,1.41a1,1,0,0,1-.27,2Zm93.5-2.89a1,1,0,0,1-.33-1.94c1.55-.54,3.12-1.11,4.67-1.71A1,1,0,0,1,257,347a1,1,0,0,1-.58,1.29c-1.57.6-3.16,1.18-4.73,1.73A1.19,1.19,0,0,1,251.38,350Zm-103.06-.1a1,1,0,0,1-.33-.06c-1.58-.55-3.18-1.14-4.73-1.74a1,1,0,1,1,.72-1.86c1.53.59,3.11,1.17,4.67,1.71a1,1,0,0,1-.33,1.95Zm112.38-3.47a1,1,0,0,1-.93-.61,1,1,0,0,1,.54-1.31c1.52-.64,3-1.31,4.53-2a1,1,0,1,1,.84,1.82c-1.51.69-3.06,1.37-4.6,2A1,1,0,0,1,260.7,346.45ZM139,346.31a.91.91,0,0,1-.39-.08c-1.55-.65-3.11-1.34-4.61-2a1,1,0,1,1,.84-1.82c1.48.69,3,1.36,4.55,2a1,1,0,0,1-.39,1.92Zm130.79-4a1,1,0,0,1-.45-1.89c1.49-.75,3-1.51,4.41-2.28a1,1,0,1,1,.94,1.76c-1.45.78-3,1.56-4.45,2.31A1,1,0,0,1,269.76,342.3Zm-139.89-.18a1,1,0,0,1-.44-.11c-1.49-.74-3-1.53-4.47-2.33a1,1,0,0,1-.41-1.35,1,1,0,0,1,1.36-.41c1.46.79,2.94,1.57,4.41,2.3a1,1,0,0,1,.45,1.35A1,1,0,0,1,129.87,342.12Zm148.68-4.54a1,1,0,0,1-.51-1.87c1.42-.82,2.85-1.68,4.25-2.55a1,1,0,0,1,1.38.32,1,1,0,0,1-.32,1.37c-1.42.89-2.87,1.76-4.3,2.59A1,1,0,0,1,278.55,337.58Zm-157.48-.23a.94.94,0,0,1-.51-.14c-1.46-.85-2.91-1.73-4.31-2.6a1,1,0,0,1,1.07-1.7c1.38.87,2.81,1.74,4.25,2.58a1,1,0,0,1,.36,1.37A1,1,0,0,1,121.07,337.35Zm166-5.05a1,1,0,0,1-.56-1.83c1.37-.92,2.75-1.87,4.08-2.82a1,1,0,1,1,1.16,1.63c-1.35,1-2.74,1.92-4.13,2.85A.94.94,0,0,1,287,332.3ZM112.59,332a1,1,0,0,1-.56-.17c-1.39-.94-2.79-1.91-4.14-2.88a1,1,0,0,1-.22-1.4,1,1,0,0,1,1.39-.22c1.34,1,2.71,1.91,4.08,2.84a1,1,0,0,1,.28,1.38A1,1,0,0,1,112.59,332Zm182.55-5.54a1,1,0,0,1-.79-.4,1,1,0,0,1,.18-1.4c1.32-1,2.63-2,3.9-3.07a1,1,0,1,1,1.26,1.55c-1.28,1.05-2.61,2.09-3.94,3.11A1,1,0,0,1,295.14,326.5Zm-190.68-.31a1,1,0,0,1-.6-.2c-1.32-1-2.65-2.07-4-3.13a1,1,0,1,1,1.27-1.55c1.28,1.05,2.59,2.09,3.89,3.09a1,1,0,0,1-.61,1.79Zm198.43-6a1,1,0,0,1-.66-1.76c1.25-1.08,2.49-2.2,3.7-3.31a1,1,0,1,1,1.35,1.46c-1.21,1.13-2.47,2.26-3.74,3.36A1,1,0,0,1,302.89,320.19Zm-206.16-.34a1,1,0,0,1-.66-.24c-1.25-1.1-2.5-2.23-3.73-3.38a1,1,0,1,1,1.36-1.46c1.21,1.13,2.46,2.25,3.69,3.33a1,1,0,0,1-.66,1.75Zm213.49-6.45a1,1,0,0,1-.71-.3,1,1,0,0,1,0-1.42c1.18-1.16,2.35-2.35,3.48-3.54a1,1,0,1,1,1.45,1.38c-1.15,1.2-2.33,2.41-3.53,3.59A1,1,0,0,1,310.22,313.4ZM89.42,313a1,1,0,0,1-.71-.29c-1.18-1.18-2.36-2.39-3.51-3.6a1,1,0,0,1,1.45-1.38c1.13,1.2,2.3,2.39,3.47,3.56a1,1,0,0,1-.7,1.71Zm227.69-6.88a1,1,0,0,1-.66-.26,1,1,0,0,1-.08-1.41c1.1-1.24,2.19-2.5,3.25-3.76a1,1,0,1,1,1.53,1.29c-1.07,1.27-2.17,2.55-3.29,3.8A1,1,0,0,1,317.11,306.16Zm-234.56-.38a1,1,0,0,1-.75-.34c-1.11-1.25-2.21-2.53-3.27-3.81a1,1,0,1,1,1.53-1.28c1,1.26,2.14,2.53,3.24,3.76a1,1,0,0,1-.08,1.42A1,1,0,0,1,82.55,305.78Zm241-7.29a1,1,0,0,1-.79-1.62c1-1.3,2-2.63,3-3.95a1,1,0,1,1,1.61,1.18c-1,1.34-2,2.69-3.05,4A1,1,0,0,1,323.54,298.49ZM76.16,298.1a1,1,0,0,1-.79-.38c-1-1.32-2.05-2.67-3-4a1,1,0,0,1,.22-1.4,1,1,0,0,1,1.39.22c1,1.32,2,2.65,3,4a1,1,0,0,1-.79,1.61Zm253.31-7.67a1,1,0,0,1-.57-.17,1,1,0,0,1-.26-1.39c.94-1.37,1.87-2.76,2.76-4.15a1,1,0,1,1,1.68,1.09c-.9,1.4-1.84,2.81-2.79,4.19A1,1,0,0,1,329.47,290.43ZM70.27,290a1,1,0,0,1-.83-.43c-1-1.38-1.88-2.79-2.77-4.19A1,1,0,0,1,67,284a1,1,0,0,1,1.39.3c.88,1.38,1.8,2.77,2.73,4.14a1,1,0,0,1-.26,1.39A1,1,0,0,1,70.27,290Zm264.61-8a.94.94,0,0,1-.51-.14,1,1,0,0,1-.35-1.37c.85-1.43,1.69-2.88,2.49-4.31a1,1,0,0,1,1.75,1c-.81,1.45-1.66,2.92-2.52,4.37A1,1,0,0,1,334.88,282Zm-270-.38a1,1,0,0,1-.86-.49c-.85-1.43-1.69-2.9-2.49-4.35a1,1,0,0,1,.39-1.36,1,1,0,0,1,1.36.39c.79,1.43,1.62,2.88,2.46,4.3a1,1,0,0,1-.35,1.37A.94.94,0,0,1,64.89,281.63Zm274.86-8.37a1,1,0,0,1-.46-.11,1,1,0,0,1-.43-1.35c.76-1.47,1.5-3,2.21-4.46a1,1,0,1,1,1.8.86c-.71,1.51-1.46,3-2.23,4.52A1,1,0,0,1,339.75,273.26ZM60.07,272.9a1,1,0,0,1-.89-.54c-.76-1.49-1.51-3-2.22-4.51a1,1,0,1,1,1.81-.85c.7,1.48,1.44,3,2.19,4.45a1,1,0,0,1-.44,1.34A.91.91,0,0,1,60.07,272.9Zm284-8.69a.92.92,0,0,1-.4-.08,1,1,0,0,1-.52-1.32c.67-1.51,1.31-3.06,1.92-4.59a1,1,0,0,1,1.3-.56,1,1,0,0,1,.56,1.3c-.62,1.55-1.27,3.12-1.94,4.65A1,1,0,0,1,344.05,264.21Zm-288.24-.32a1,1,0,0,1-.92-.6c-.66-1.53-1.31-3.09-1.92-4.63a1,1,0,0,1,.56-1.3,1,1,0,0,1,1.3.56c.6,1.52,1.24,3.06,1.9,4.57a1,1,0,0,1-.52,1.32A1.14,1.14,0,0,1,55.81,263.89Zm292-9a1,1,0,0,1-.34-.06,1,1,0,0,1-.6-1.29c.56-1.55,1.11-3.14,1.62-4.71a1,1,0,1,1,1.9.62c-.52,1.6-1.07,3.2-1.64,4.78A1,1,0,0,1,347.77,254.91Zm-295.64-.3a1,1,0,0,1-.94-.66c-.57-1.57-1.12-3.18-1.64-4.76a1,1,0,1,1,1.91-.61c.5,1.56,1,3.14,1.61,4.69a1,1,0,0,1-.6,1.28A1.06,1.06,0,0,1,52.13,254.61Zm298.75-9.22a.9.9,0,0,1-.28,0,1,1,0,0,1-.68-1.24c.47-1.59.91-3.2,1.32-4.79a1,1,0,1,1,1.93.5c-.41,1.61-.86,3.24-1.33,4.85A1,1,0,0,1,350.88,245.39ZM49,245.11a1,1,0,0,1-1-.73c-.47-1.61-.92-3.24-1.33-4.85a1,1,0,0,1,.72-1.22,1,1,0,0,1,1.22.73c.41,1.58.84,3.19,1.31,4.79a1,1,0,0,1-.68,1.24A1.45,1.45,0,0,1,49,245.11Zm304.34-9.4-.22,0a1,1,0,0,1-.76-1.2c.36-1.6.7-3.24,1-4.86a1,1,0,1,1,2,.37c-.31,1.65-.65,3.31-1,4.93A1,1,0,0,1,353.38,235.71Zm-306.82-.29a1,1,0,0,1-1-.78c-.36-1.63-.7-3.29-1-4.93a1,1,0,0,1,2-.37c.3,1.62.64,3.26,1,4.87a1,1,0,0,1-.76,1.19A.86.86,0,0,1,46.56,235.42Zm308.69-9.53h-.15a1,1,0,0,1-.84-1.15c.26-1.63.5-3.28.7-4.91a1,1,0,1,1,2,.25c-.21,1.65-.45,3.33-.71,5A1,1,0,0,1,355.25,225.89ZM44.7,225.6a1,1,0,0,1-1-.85c-.25-1.65-.49-3.32-.69-5a1,1,0,0,1,.87-1.11,1,1,0,0,1,1.11.87c.2,1.63.44,3.28.69,4.92a1,1,0,0,1-.83,1.14ZM356.5,216h-.09a1,1,0,0,1-.91-1.09c.16-1.64.29-3.31.39-4.95A1,1,0,0,1,357,209a1,1,0,0,1,.94,1.06c-.11,1.67-.24,3.36-.39,5A1,1,0,0,1,356.5,216Zm-313-.29a1,1,0,0,1-1-.91c-.16-1.66-.28-3.35-.38-5a1,1,0,1,1,2-.12c.1,1.64.23,3.3.38,5a1,1,0,0,1-.91,1.09ZM357.12,206h0a1,1,0,0,1-1-1c.05-1.64.08-3.32.08-5a1,1,0,0,1,2,0c0,1.67,0,3.37-.08,5A1,1,0,0,1,357.12,206Zm-314.25-.3a1,1,0,0,1-1-1c0-1.56-.07-3.15-.07-4.73v-.3a1,1,0,0,1,1-1,1,1,0,0,1,1,1V200c0,1.56,0,3.13.07,4.67a1,1,0,0,1-1,1Zm314.27-9.12a1,1,0,0,1-1-1c-.05-1.65-.12-3.32-.22-5a1,1,0,1,1,2-.12c.1,1.66.17,3.36.22,5a1,1,0,0,1-1,1Zm-314.25-.87h0a1,1,0,0,1-1-1c0-1.66.13-3.35.24-5a1,1,0,1,1,2,.13c-.11,1.65-.19,3.32-.24,5A1,1,0,0,1,42.89,195.71Zm313.66-9.11a1,1,0,0,1-1-.91c-.15-1.63-.33-3.3-.53-4.94a1,1,0,0,1,2-.24c.2,1.66.38,3.34.53,5a1,1,0,0,1-.91,1.09Zm-313-.87h-.1a1,1,0,0,1-.9-1.1c.16-1.66.35-3.34.56-5a1,1,0,0,1,2,.25c-.21,1.63-.4,3.29-.56,4.94A1,1,0,0,1,43.53,185.73Zm311.81-9a1,1,0,0,1-1-.85c-.25-1.63-.53-3.28-.83-4.89a1,1,0,1,1,2-.37c.31,1.63.59,3.3.85,5a1,1,0,0,1-.84,1.14ZM44.8,175.82l-.16,0a1,1,0,0,1-.83-1.14c.26-1.65.56-3.32.87-5a1,1,0,0,1,2,.38c-.32,1.62-.61,3.26-.87,4.89A1,1,0,0,1,44.8,175.82Zm308.7-9a1,1,0,0,1-1-.79c-.36-1.61-.75-3.24-1.15-4.83a1,1,0,1,1,1.94-.49c.41,1.61.8,3.26,1.16,4.89a1,1,0,0,1-.76,1.19ZM46.69,166l-.22,0a1,1,0,0,1-.76-1.2c.37-1.62.77-3.26,1.19-4.89a1,1,0,0,1,1.22-.71,1,1,0,0,1,.72,1.21c-.42,1.61-.81,3.23-1.18,4.83A1,1,0,0,1,46.69,166ZM351,157.17a1,1,0,0,1-1-.72c-.46-1.59-.94-3.19-1.45-4.76a1,1,0,0,1,1.9-.61c.52,1.59,1,3.2,1.47,4.81a1,1,0,0,1-.68,1.24A.9.9,0,0,1,351,157.17ZM49.2,156.33a1.35,1.35,0,0,1-.28,0,1,1,0,0,1-.68-1.25c.48-1.6,1-3.22,1.5-4.8a1,1,0,1,1,1.9.63c-.51,1.56-1,3.15-1.48,4.74A1,1,0,0,1,49.2,156.33ZM348,147.66A1,1,0,0,1,347,147c-.56-1.55-1.15-3.11-1.75-4.65a1,1,0,0,1,1.86-.73c.61,1.56,1.21,3.14,1.77,4.71a1,1,0,0,1-.6,1.28A1,1,0,0,1,348,147.66Zm-295.64-.84a1,1,0,0,1-.94-1.35c.58-1.57,1.18-3.15,1.81-4.71a1,1,0,1,1,1.85.75c-.61,1.53-1.21,3.1-1.78,4.65A1,1,0,0,1,52.33,146.82Zm292-8.45a1,1,0,0,1-.91-.6c-.65-1.5-1.34-3-2-4.52a1,1,0,0,1,1.81-.85c.71,1.52,1.4,3.06,2.06,4.58a1,1,0,0,1-.52,1.31A.92.92,0,0,1,344.3,138.37Zm-288.23-.86a.92.92,0,0,1-.4-.08,1,1,0,0,1-.52-1.32c.67-1.52,1.38-3.07,2.1-4.58a1,1,0,0,1,1.34-.47,1,1,0,0,1,.47,1.33c-.72,1.5-1.41,3-2.08,4.53A1,1,0,0,1,56.07,137.51Zm284-8.16a1,1,0,0,1-.89-.54c-.75-1.47-1.53-2.94-2.32-4.38a1,1,0,0,1,1.75-1c.81,1.46,1.6,3,2.35,4.44a1,1,0,0,1-.44,1.34A.91.91,0,0,1,340.06,129.35Zm-279.67-.87a1,1,0,0,1-.46-.12A1,1,0,0,1,59.5,127c.76-1.48,1.57-3,2.39-4.44a1,1,0,1,1,1.74,1c-.81,1.46-1.6,2.93-2.35,4.39A1,1,0,0,1,60.39,128.48Zm274.86-7.87a1,1,0,0,1-.86-.49c-.84-1.41-1.71-2.83-2.59-4.22a1,1,0,1,1,1.68-1.08c.9,1.41,1.78,2.85,2.63,4.28a1,1,0,0,1-.35,1.37A.94.94,0,0,1,335.25,120.61Zm-270-.88a1,1,0,0,1-.51-.14,1,1,0,0,1-.34-1.37c.85-1.43,1.75-2.86,2.66-4.28A1,1,0,1,1,68.76,115c-.9,1.39-1.78,2.81-2.63,4.22A1,1,0,0,1,65.27,119.73Zm264.63-7.54a1,1,0,0,1-.83-.43c-.92-1.36-1.89-2.72-2.86-4.06a1,1,0,1,1,1.62-1.18c1,1.35,2,2.74,2.89,4.11a1,1,0,0,1-.26,1.39A1,1,0,0,1,329.9,112.19Zm-259.2-.87a1,1,0,0,1-.57-.17,1,1,0,0,1-.25-1.39c1-1.39,1.94-2.76,2.92-4.1a1,1,0,0,1,1.4-.21,1,1,0,0,1,.21,1.4c-1,1.32-2,2.68-2.89,4A1,1,0,0,1,70.7,111.32ZM324,104.12a1,1,0,0,1-.79-.38c-1-1.3-2.06-2.6-3.11-3.87a1,1,0,1,1,1.54-1.28c1.06,1.28,2.12,2.6,3.15,3.92a1,1,0,0,1-.79,1.61Zm-247.38-.84a1,1,0,0,1-.61-.22,1,1,0,0,1-.17-1.4c1-1.32,2.11-2.63,3.18-3.9A1,1,0,1,1,80.57,99c-1.06,1.26-2.11,2.56-3.14,3.86A1,1,0,0,1,76.64,103.28Zm241-6.84a1,1,0,0,1-.75-.34c-1.1-1.24-2.22-2.47-3.35-3.67a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0c1.14,1.21,2.28,2.46,3.39,3.71a1,1,0,0,1-.09,1.42A1,1,0,0,1,317.64,96.44ZM83.08,95.62A1,1,0,0,1,82.34,94c1.11-1.24,2.26-2.48,3.42-3.69a1,1,0,1,1,1.44,1.38c-1.14,1.2-2.28,2.42-3.37,3.64A1,1,0,0,1,83.08,95.62Zm227.7-6.46a1,1,0,0,1-.7-.29c-1.16-1.16-2.37-2.32-3.58-3.45A1,1,0,0,1,307.87,84c1.22,1.15,2.44,2.32,3.62,3.5a1,1,0,0,1,0,1.41A1,1,0,0,1,310.78,89.16ZM90,88.4a1,1,0,0,1-.71-.3,1,1,0,0,1,0-1.42c1.18-1.16,2.41-2.32,3.64-3.47a1,1,0,0,1,1.36,1.48c-1.22,1.12-2.43,2.27-3.6,3.42A1,1,0,0,1,90,88.4Zm213.49-6.06a1,1,0,0,1-.66-.25c-1.24-1.09-2.52-2.18-3.78-3.22a1,1,0,1,1,1.27-1.55c1.28,1.06,2.57,2.16,3.83,3.26a1,1,0,0,1-.66,1.76ZM97.34,81.62a1,1,0,0,1-.76-.34,1,1,0,0,1,.1-1.41c1.27-1.1,2.56-2.19,3.86-3.23a1,1,0,0,1,1.4.14,1,1,0,0,1-.14,1.41c-1.28,1-2.56,2.11-3.81,3.19A1,1,0,0,1,97.34,81.62ZM295.76,76a1,1,0,0,1-.61-.21c-1.29-1-2.63-2-4-3a1,1,0,1,1,1.17-1.62c1.37,1,2.73,2,4,3a1,1,0,0,1,.18,1.4A1,1,0,0,1,295.76,76Zm-190.67-.65a1,1,0,0,1-.79-.4,1,1,0,0,1,.19-1.4c1.32-1,2.68-2,4.05-3a1,1,0,0,1,1.16,1.63c-1.35,1-2.7,1.95-4,2.94A1,1,0,0,1,105.09,75.33Zm182.56-5.21a1,1,0,0,1-.56-.17c-1.37-.92-2.77-1.84-4.16-2.71a1,1,0,0,1,1.06-1.7c1.41.89,2.83,1.82,4.22,2.75a1,1,0,0,1,.27,1.39A1,1,0,0,1,287.65,70.12Zm-174.42-.58a1,1,0,0,1-.55-1.84c1.38-.92,2.8-1.83,4.22-2.71a1,1,0,0,1,1.06,1.7c-1.4.87-2.81,1.77-4.18,2.68A1,1,0,0,1,113.23,69.54Zm166-4.75a1,1,0,0,1-.51-.13c-1.41-.83-2.86-1.65-4.33-2.45a1,1,0,1,1,1-1.76c1.48.81,3,1.64,4.38,2.48A1,1,0,0,1,280,64.3,1,1,0,0,1,279.18,64.79Zm-157.47-.51a1,1,0,0,1-.5-1.87c1.45-.83,2.92-1.65,4.39-2.44a1,1,0,0,1,.94,1.76c-1.45.78-2.9,1.59-4.33,2.41A1,1,0,0,1,121.71,64.28ZM270.38,60a1,1,0,0,1-.45-.1c-1.48-.75-3-1.48-4.48-2.17a1,1,0,0,1-.48-1.33,1,1,0,0,1,1.32-.48c1.51.7,3,1.43,4.54,2.19a1,1,0,0,1-.45,1.89ZM130.5,59.57a1,1,0,0,1-.44-1.9c1.49-.74,3-1.46,4.53-2.15a1,1,0,1,1,.83,1.82c-1.5.68-3,1.4-4.47,2.12A.93.93,0,0,1,130.5,59.57ZM261.29,55.8a1.09,1.09,0,0,1-.39-.08c-1.52-.65-3.08-1.28-4.61-1.87A1,1,0,0,1,257,52c1.56.6,3.13,1.24,4.67,1.9a1,1,0,0,1-.39,1.92Zm-121.72-.37a1,1,0,0,1-.38-1.92c1.54-.64,3.11-1.27,4.66-1.86a1,1,0,0,1,1.29.58,1,1,0,0,1-.58,1.29c-1.53.58-3.08,1.2-4.6,1.84A1.07,1.07,0,0,1,139.57,55.43ZM252,52.18a1,1,0,0,1-.33-.06c-1.57-.55-3.16-1.08-4.73-1.57a1,1,0,0,1,.6-1.91c1.59.5,3.2,1,4.79,1.59a1,1,0,0,1,.61,1.28A1,1,0,0,1,252,52.18Zm-103-.3a1,1,0,0,1-.32-1.94c1.58-.55,3.19-1.07,4.78-1.57a1,1,0,0,1,.59,1.92c-1.57.48-3.16,1-4.72,1.54A1.26,1.26,0,0,1,148.9,51.88Zm93.5-2.71a.84.84,0,0,1-.27,0c-1.58-.44-3.2-.87-4.81-1.26a1,1,0,0,1,.48-1.95c1.63.4,3.27.83,4.87,1.28a1,1,0,0,1,.69,1.24A1,1,0,0,1,242.4,49.17Zm-84-.24a1,1,0,0,1-.26-2c1.61-.45,3.25-.87,4.87-1.26a1,1,0,0,1,.47,1.95c-1.6.38-3.22.8-4.81,1.24A1.24,1.24,0,0,1,158.45,48.93Zm74.24-2.15-.21,0c-1.6-.34-3.24-.66-4.87-.95a1,1,0,0,1-.81-1.16,1,1,0,0,1,1.16-.81c1.66.29,3.32.62,4.94,1a1,1,0,0,1-.21,2Zm-64.52-.18a1,1,0,0,1-1-.8,1,1,0,0,1,.78-1.18c1.64-.34,3.3-.65,4.94-.94a1,1,0,1,1,.34,2c-1.62.28-3.26.6-4.88.93ZM222.85,45h-.14c-1.63-.24-3.29-.45-4.93-.64a1,1,0,1,1,.23-2c1.66.19,3.34.41,5,.65a1,1,0,0,1-.15,2ZM178,44.89a1,1,0,0,1-.14-2c1.64-.23,3.32-.43,5-.62a1,1,0,0,1,.22,2c-1.65.18-3.31.39-4.93.61Zm34.9-1h-.08c-1.64-.14-3.31-.24-5-.33a1,1,0,1,1,.1-2c1.67.08,3.36.19,5,.33a1,1,0,0,1-.08,2Zm-25-.07a1,1,0,0,1-.08-2c1.65-.13,3.34-.23,5-.31a1,1,0,1,1,.09,2c-1.66.08-3.33.18-5,.3Zm15-.43h0c-1,0-2.06,0-3.09,0H198a1,1,0,0,1-1-1,1,1,0,0,1,1-1H200l3,0a1,1,0,0,1,1,1A1,1,0,0,1,202.94,43.39Z',className:'DOTS2 Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M264.19,194.78l-.58,2.86c-2.14,10.3-4.15,19.75-3.57,23.9L264.62,241l-.15,1-3.58,8.73H247.3l2.57-2.72a14.32,14.32,0,0,0,3.44-5.44,9.16,9.16,0,0,0,.29-5.15L244,222.11c-4.87,12.88-8,22.33-8,22.33l-.43,1.14h-1.14v4.87l-13.89-.29,2-2.57A34.93,34.93,0,0,0,228,237.14a27.8,27.8,0,0,0,1.57-10.73c-.43-3.3-1.57-5.3-3.29-6.44s-4.72-1.58-8.73-1.58H203.36l-.86-.29c-2.58-1.57-4.87-2.43-6.73-2.43a5.64,5.64,0,0,0-4.29,1.43,26.32,26.32,0,0,1-.86,5.87,28.94,28.94,0,0,0-.86,6,31.78,31.78,0,0,0,.86,6.16,37.6,37.6,0,0,1,.86,6.72v1.72h-1.72v5.87H176.45l1.29-2.58a19.24,19.24,0,0,0,2.72-7.73,16.43,16.43,0,0,0-1-7.44l-2.72-5.44a19.72,19.72,0,0,0-1.43,3.15,7.34,7.34,0,0,0-.57,3.72v.15l-.15,10-.14.72-3.29,6.73h-12.6l2-2.72a17.15,17.15,0,0,0,3-5.73,18.83,18.83,0,0,0,.29-5.58l-.29-12.59a25.38,25.38,0,0,1-10.3-10.6,38.67,38.67,0,0,1-4.3-16.45,25.38,25.38,0,0,1-12.88-6.16,6.37,6.37,0,0,1-5-.86,13.7,13.7,0,0,1-4.86-4.72l-2.86.43-.72-.14A6.89,6.89,0,0,1,119.2,183a7.67,7.67,0,0,1-1.57-4,8.54,8.54,0,0,1,1-4.15,6.76,6.76,0,0,1,3-3h0c1.14-.58,2.29-1.15,3.58-1.86a33.48,33.48,0,0,0,3.43-2.15c3.58-2.72,3.72-4,3.72-4a12.15,12.15,0,0,1,2.29-5.72,10.77,10.77,0,0,1,4.72-3.44l2,2.44a8.54,8.54,0,0,0-1.43,3.72v1a11.94,11.94,0,0,0,3.58-3,30.51,30.51,0,0,0,3.72-5.72c.28-.57.71-1.29,1-2,.28-.57.43-1.28.71-1.86h3.15a25.16,25.16,0,0,1,.86,8.16,19.93,19.93,0,0,1-.86,3.72,148.51,148.51,0,0,1,16.18,1.29,97.33,97.33,0,0,1,16.6,3.87h54.24a20.59,20.59,0,0,1,8.87-.72,19,19,0,0,1,8.59,3.15,20.05,20.05,0,0,1,6.58,6.44,23.39,23.39,0,0,1,3,8.73l3.43,28.62a12,12,0,0,1,2.72,6.16,9.66,9.66,0,0,1-1.86,6.58l-.71.72-.86-.15a6.65,6.65,0,0,1-3.29-1.28A7.18,7.18,0,0,1,262.9,217a17.37,17.37,0,0,1,3-6.87Zm-21.76-25.91L241.14,180l21,.86a15.87,15.87,0,0,0-1.86-3.86,15.62,15.62,0,0,0-5.44-5.58,17.28,17.28,0,0,0-7.3-2.58,15.35,15.35,0,0,0-5.15,0Zm-1.72,14.46-2.57,22.18c.28.43.71.86,1,1.29,10.45-1.58,17.46-2.58,19.75-2.86.43-2.29,1-4.58,1.43-7,.86-4.29,1.86-8.58,2.58-12.73Zm-5.43,19L239,169.59H222.82l-.43,26.19a22.63,22.63,0,0,1,12,5.87,4.08,4.08,0,0,1,.86.71Zm22.89,5c-2.71.43-8.44,1.15-17,2.43a57.27,57.27,0,0,1,4,7.88L256.46,236l.28.43a13.46,13.46,0,0,1-.28,7.16,23.89,23.89,0,0,1-1.86,3.86h4.15l2.43-6.15L256.74,222c-.43-3,.29-8.3,1.43-14.6ZM219.1,195.63l.43-26H205.65l-.72,25.62Zm-14.31,2.87-.57,16.6h13.31c4.58,0,8,.57,10.59,2.15s4,4.43,4.72,8.73v.14a35.25,35.25,0,0,1-1.71,12.16A44.66,44.66,0,0,1,227,247h4.16l.14-4.87,2,.14c1-3.15,4.15-12.45,8.59-23.76-2.29-5.58-5.44-10.87-9.59-14.45a18.49,18.49,0,0,0-12.59-5.15Zm-3.86,15.17.57-15.17-15.17-.43a45.88,45.88,0,0,1-2.15,13.16A38.7,38.7,0,0,1,178.74,223c1.29,2.43,2.58,5,3.72,7.44a19.68,19.68,0,0,1,1.29,9,24.84,24.84,0,0,1-1.86,6.73h4.58v-5.73l1.72-.14a24,24,0,0,0-.86-4.44,37.53,37.53,0,0,1-.86-6.87,34.42,34.42,0,0,1,.86-6.72,29,29,0,0,0,.86-6v-.71l.57-.43a9.29,9.29,0,0,1,7.16-2.72,11.34,11.34,0,0,1,5,1.29Zm.71-18.46.86-25.62H186.33v25.33ZM183,198.07l-21-.43a92.11,92.11,0,0,0,.43,12.59c.57,4.44,1.71,8.59,3.86,11.6l.57.28.29,14.17a21.53,21.53,0,0,1-.43,6.73,27.89,27.89,0,0,1-1.72,4.43h4.15L171.3,243l.14-9.59a11.2,11.2,0,0,1,.72-5.15,38.21,38.21,0,0,1,3.29-6.3l1.15-1.72a34.5,34.5,0,0,0,4.43-9.87,47.24,47.24,0,0,0,2-12.31Zm-24.33-.57-6.44-.15a34.16,34.16,0,0,0,3.86,14.6,29.06,29.06,0,0,0,4.72,6.3,42,42,0,0,1-1.57-7.59,81.89,81.89,0,0,1-.57-13.16Zm-8-3.44,8.16.14,1-29.34-6.15-.43a148.49,148.49,0,0,1-5.58,18.47,50.7,50.7,0,0,1-4.44,9.16,26.81,26.81,0,0,0,7,2Zm11.45.29,20.9.43V169.16a120.74,120.74,0,0,0-15.32-3.44c-1.57-.28-3-.43-4.72-.57Zm-21.32-3.87a38.74,38.74,0,0,0,4.15-8.73,172.1,172.1,0,0,0,5.43-17.32h-4.72l2.44-2.71a9.28,9.28,0,0,0,1.57-4.73v-1.43A22.94,22.94,0,0,1,146,161a13.48,13.48,0,0,1-6.59,4.58l-1.14.29-.72-.86a6,6,0,0,1-.85-3.87,11.11,11.11,0,0,0-1.15,3.29h0s-.14,2.58-5,6v.14a32.18,32.18,0,0,1-3.72,2.29,18.22,18.22,0,0,1-3.72,1.86,3.64,3.64,0,0,0-1.58,1.72,4.77,4.77,0,0,0-.57,2.43,6.46,6.46,0,0,0,.86,2.29,6.86,6.86,0,0,0,1.58,1.29l4.29-.72.57.86c1.58,2.29,3,3.87,4.44,4.58a3.2,3.2,0,0,0,3.15.43l1-.43.71.72c1,.86,2.15,1.71,3.3,2.57ZM269.05,219a8,8,0,0,0-2-4.29,11.58,11.58,0,0,0-.86,2.72,4.78,4.78,0,0,0,.14,2.86,3.54,3.54,0,0,0,1.29,1.58,1.42,1.42,0,0,0,.72.57,6,6,0,0,0,.71-3.44Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Bitter',fontSize:languageSettings.small?'1.5em':'1.8em',fontWeight:'700',letterSpacing:'0.13em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_9__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Anton',fontSize:languageSettings.small?'1.5em':'1.8em',letterSpacing:'0.13em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_9__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(109);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_10',title:'Radial_10',colors:2,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_10 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_10__TopCircle',d:'M 35 200 A 50 50 0 0 1 365 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_10__BottomCircle',d:'M 35 200 A 50 50 0 0 0 365 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'200',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,337.47C124.2,337.47,62.53,275.8,62.53,200S124.2,62.53,200,62.53,337.46,124.2,337.46,200,275.8,337.47,200,337.47Zm0-270.25C126.78,67.22,67.22,126.78,67.22,200S126.78,332.78,200,332.78,332.78,273.22,332.78,200,273.21,67.22,200,67.22Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M219,327.84c-6.36-.46-12.7-.69-18.95-.69s-12.59.23-18.85.69l-.1-1.17,0-1.17c6.23-.46,12.62-.7,18.93-.7s12.7.24,19,.7a1.19,1.19,0,0,1,1.1,1.21A1.16,1.16,0,0,1,219,327.84Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M157.45,322a1.18,1.18,0,0,1-1.15-1,1.16,1.16,0,0,1,1-1.34,264.64,264.64,0,0,1,85.46,0,1.17,1.17,0,1,1-.38,2.31,262.78,262.78,0,0,0-84.7,0Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M256.62,316.06a1.06,1.06,0,0,1-.31,0,262.19,262.19,0,0,0-112.67,0,1.19,1.19,0,0,1-1.4-.89,1.18,1.18,0,0,1,.89-1.4,264.59,264.59,0,0,1,113.67,0l.15,0,.25.05.15.15a1.18,1.18,0,0,1-.28,2A1.2,1.2,0,0,1,256.62,316.06Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M267.41,310.07a1,1,0,0,1-.3,0,260.58,260.58,0,0,0-134.22,0,1.17,1.17,0,0,1-.6-2.26,262.87,262.87,0,0,1,135.42,0,1.17,1.17,0,0,1-.3,2.3Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M276.35,304a1.06,1.06,0,0,1-.35-.05,260.16,260.16,0,0,0-152,0,1.17,1.17,0,0,1-.68-2.24,262.55,262.55,0,0,1,153.38,0,1.17,1.17,0,0,1-.34,2.29Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M284,297.83a1.21,1.21,0,0,1-.38-.06,259.95,259.95,0,0,0-167.26,0,1.17,1.17,0,0,1-.76-2.22,262.38,262.38,0,0,1,168.77,0,1.17,1.17,0,0,1-.37,2.28Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M109.3,291.59a1.17,1.17,0,0,1-.41-2.27,262,262,0,0,1,182.21,0,1.17,1.17,0,1,1-.82,2.19,259.84,259.84,0,0,0-180.57,0A1.15,1.15,0,0,1,109.3,291.59Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M296.61,285.23a1.15,1.15,0,0,1-.44-.09,259.63,259.63,0,0,0-192.35,0A1.17,1.17,0,0,1,103,283a262,262,0,0,1,194.1,0,1.17,1.17,0,0,1,.65,1.52A1.19,1.19,0,0,1,296.61,285.23Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M98.12,278.76a1.17,1.17,0,0,1-.46-2.25,262.05,262.05,0,0,1,204.68,0,1.17,1.17,0,1,1-.92,2.16,259.61,259.61,0,0,0-202.84,0A1.25,1.25,0,0,1,98.12,278.76Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M306.58,272.19a1.15,1.15,0,0,1-.48-.1,259.41,259.41,0,0,0-212.2,0,1.17,1.17,0,0,1-1-2.14,261.71,261.71,0,0,1,214.12,0,1.17,1.17,0,0,1-.48,2.24Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M89.23,265.48a1.18,1.18,0,0,1-1.06-.67,1.16,1.16,0,0,1,.56-1.56,261.71,261.71,0,0,1,222.53,0,1.18,1.18,0,0,1,.56,1.56,1.17,1.17,0,0,1-1.56.56,259.33,259.33,0,0,0-220.53,0A1.33,1.33,0,0,1,89.23,265.48Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M85.8,258.64h-.28a1.17,1.17,0,0,1-.42-2.27,261.61,261.61,0,0,1,229.89,0,1.17,1.17,0,0,1-1,2.11,259.21,259.21,0,0,0-227.92,0Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M74.68,227.69a1.18,1.18,0,0,1-1.15-.93,129.24,129.24,0,1,1,252.92,0,1.17,1.17,0,1,1-2.29-.48,126.89,126.89,0,1,0-248.34,0,1.17,1.17,0,0,1-.9,1.39Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M321.31,105.72a1.08,1.08,0,0,1-1.5-.3c-10.44-13.33-22.73-23.62-36.35-33.49a1,1,0,1,1,1.1-1.67,205.36,205.36,0,0,1,36.82,33.92A1.08,1.08,0,0,1,321.31,105.72Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M315.57,90.46a1.13,1.13,0,0,1-1.56-.2,160.17,160.17,0,0,0-27.49-23,1,1,0,1,1,1.1-1.67,162.55,162.55,0,0,1,27.84,23.24A1.13,1.13,0,0,1,315.57,90.46Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M330.08,135.12l1.48-.35c.43-.1,1.93-.45,3.92-.8-4.25-2.74-11.72-11.4-12.66-12.41l-1.14-1.22,1.43-.52a66.82,66.82,0,0,1,9-2.54,15,15,0,0,1-5.71-5c-3.66-5.31-7.79-24.53-8-25.35l-.5-1.74,1.72.58c.81.3,20.09,8.47,24.24,14.51a15.43,15.43,0,0,1,2.79,8c2.51-3.55,5.39-6.88,5.91-7.48l1-1.17c.35.76.52,1.14.85,1.9.71,1.58,5.79,14.8,5.64,20.54,1.47-1.43,2.62-2.49,2.95-2.79l1.15-1c.25.79.37,1.19.61,2,.52,1.64,4,15.3,3.19,21,1.62-1.25,2.9-2.17,3.26-2.43s.76-.53,1.26-.9c.16.81.24,1.22.38,2,.32,1.67,2.22,15.59.76,21.12,1.75-1.06,3.12-1.82,3.51-2l1.35-.74c.07.82.09,1.23.15,2,.12,1.7.42,15.73-1.66,21.06,1.87-.85,3.3-1.45,3.72-1.62l1.43-.59c0,.82-.05,1.23-.09,2.06-.07,1.7-1.38,15.73-4.07,20.79,1.95-.63,3.46-1.07,3.89-1.19l1.49-.42c-.13.82-.19,1.23-.32,2-.27,1.68-3.18,15.52-6.43,20.28,2-.41,3.55-.67,4-.74l1.53-.25c-.22.8-.33,1.2-.56,2-.5,1.8-5.87,17.34-9.66,20.44a7.08,7.08,0,0,1-6.39,1.61,7.41,7.41,0,0,1-4.67-4.24.75.75,0,0,1-.1-.2.9.9,0,0,1-.08-.21,5.36,5.36,0,0,1-.25-.62,219.36,219.36,0,0,1-21.27,49.37,1,1,0,1,1-1.68-1.07,217,217,0,0,0,21-48.78c-.17.15-.33.29-.51.42l-.17.15-.19.12a7.11,7.11,0,0,1-6.12,1.23,7.78,7.78,0,0,1-4.85-4.18c-2-4-2.13-17.31-2.21-18.8,0-.67-.06-1-.11-1.66l1.44.51c.41.15,1.87.68,3.72,1.47-2.07-4.64-3.65-16-3.88-17.3l-.3-1.62,1.48.34c.43.1,1.94.46,3.88,1-2.6-4.34-5.46-15.34-5.85-16.66l-.48-1.57,1.51.16c.44,0,2,.24,4,.58-3.07-4-7.17-14.57-7.7-15.83-.26-.61-.39-.91-.66-1.51H343c.45,0,2,0,4,.12-3.51-3.62-8.78-13.67-9.46-14.85-.32-.57-.49-.86-.82-1.43l1.51-.18c.44,0,2-.23,4-.35-3.91-3.18-10.31-12.6-11.12-13.71Zm-4.67-13.74c3.25,3.44,9,10,11.61,11.05a5.83,5.83,0,0,0,4.82,0,5.32,5.32,0,0,0,2.63-2.79c-2.78-1.27-4.17-1.86-7-3a1.32,1.32,0,0,1-.78-1.46.88.88,0,0,1,1.23-.67c2.81,1.09,4.22,1.68,7,2.94a8.35,8.35,0,0,0-5.1-8.2C337.15,118.26,329.48,120.09,325.41,121.38Zm16.82-20c-2.76-4-14.9-10.45-21.15-12.85,1.83,6.44,4.52,19,7,22.58,2.94,4.28,8,6.23,11.94,4.56-2.69-4.5-4.13-6.71-7.19-11a1,1,0,1,1,1.63-1.16c3.09,4.35,4.55,6.59,7.27,11.15C345.08,112,345.49,106.15,342.23,101.41ZM353.31,104c-2.83,3.28-7.9,9.4-8.35,12.35a9.64,9.64,0,0,0,4.11,9.07c.66-3,1-4.6,1.47-7.74a.85.85,0,0,1,1.24-.67,1.59,1.59,0,0,1,.87,1.62c-.54,3.16-.85,4.71-1.53,7.77,2,.33,3,.2,3.85-.21a5.4,5.4,0,0,0,2.9-4C358.45,119.21,355.49,109.33,353.31,104Zm10.07,18.53c-3.2,2.93-8.94,8.41-9.74,11.28a9.11,9.11,0,0,0,.38,5.69,9.33,9.33,0,0,0,2.64,3.75c1-2.95,1.49-4.45,2.37-7.49a.84.84,0,0,1,1.3-.53A1.55,1.55,0,0,1,361,137c-.9,3.06-1.38,4.56-2.42,7.51,2,.56,2.95.54,3.85.23a5.36,5.36,0,0,0,3.34-3.62C366.71,138.15,364.92,128.05,363.38,122.56ZM371.21,142c-3.52,2.54-9.87,7.31-11,10.06a9.43,9.43,0,0,0,1.92,9.69c1.34-2.8,2-4.23,3.2-7.15a.85.85,0,0,1,1.36-.37,1.54,1.54,0,0,1,.47,1.75c-1.24,2.93-1.9,4.37-3.27,7.19,1.9.76,2.87.85,3.8.65a5.43,5.43,0,0,0,3.74-3.21C372.72,157.85,372.09,147.64,371.21,142Zm5.52,20.18c-3.78,2.12-10.63,6.12-12.05,8.73a9.49,9.49,0,0,0,.8,9.85c1.65-2.63,2.45-4,4-6.74a.85.85,0,0,1,1.39-.22,1.58,1.58,0,0,1,.27,1.81c-1.57,2.77-2.39,4.12-4.07,6.76,1.81,1,2.75,1.19,3.71,1.1a5.4,5.4,0,0,0,4.07-2.78C376.42,178.1,377,167.89,376.73,162.21Zm3.2,20.68c-4,1.68-11.26,4.88-13,7.31a9,9,0,0,0-1.55,5.47,9.15,9.15,0,0,0,1.22,4.43c1.94-2.43,2.89-3.68,4.75-6.25a.86.86,0,0,1,1.41-.06,1.59,1.59,0,0,1,.06,1.83c-1.88,2.57-2.85,3.82-4.82,6.26a5.28,5.28,0,0,0,3.55,1.52,5.37,5.37,0,0,0,4.37-2.29C377.81,198.67,379.52,188.56,379.93,182.89Zm.8,21c-4.17,1.2-11.74,3.55-13.73,5.77a9.21,9.21,0,0,0-2.18,5.29,9.3,9.3,0,0,0,.7,4.57c2.22-2.21,3.31-3.35,5.45-5.7a.84.84,0,0,1,1.4.11,1.6,1.6,0,0,1-.15,1.84c-2.17,2.35-3.27,3.49-5.51,5.7a5.12,5.12,0,0,0,8,.13C376.81,219.36,379.67,209.46,380.73,203.87ZM362.15,238.8c2.46-2,3.68-3,6.08-5.09a.83.83,0,0,1,1.38.28,1.59,1.59,0,0,1-.36,1.81c-2.43,2.11-3.66,3.12-6.15,5.07a5.2,5.2,0,0,0,3.09,2.33A5.39,5.39,0,0,0,371,242c2.39-2,6.41-11.57,8.11-17.06-4.28.72-12.1,2.21-14.31,4.2a9.21,9.21,0,0,0-2.79,5A9.39,9.39,0,0,0,362.15,238.8Zm-15.61-18.36c.31,4.73.58,13.5,1.87,16a5.85,5.85,0,0,0,3.71,3.11,5.25,5.25,0,0,0,3.8-.49c-1.32-2.79-2-4.15-3.44-6.8a1.36,1.36,0,0,1,.33-1.64.88.88,0,0,1,1.38.28c1.46,2.66,2.16,4,3.51,6.81a8.57,8.57,0,0,0,1.33-9.67C357.59,225.54,350.5,222.05,346.54,220.44Zm1.34-17.23c.86,4.61,2.15,13.22,3.73,15.57a5.84,5.84,0,0,0,4,2.64,5.34,5.34,0,0,0,3.73-.9c-1.64-2.59-2.49-3.85-4.22-6.3a1.34,1.34,0,0,1,.13-1.66.89.89,0,0,1,1.4.11c1.77,2.45,2.63,3.71,4.29,6.3a8.39,8.39,0,0,0,.18-9.65C359.43,207,352,204.34,347.88,203.21ZM347.22,186c1.38,4.48,3.65,12.83,5.5,15a5.88,5.88,0,0,0,4.32,2.14,5.29,5.29,0,0,0,3.59-1.33c-1.92-2.37-2.91-3.51-4.92-5.73a1.32,1.32,0,0,1,0-1.65.9.9,0,0,1,1.4,0c2,2.22,3,3.37,5,5.73a8.31,8.31,0,0,0-.93-9.56C359.13,188.41,351.44,186.68,347.22,186Zm-2.62-17c1.88,4.28,5.11,12.3,7.18,14.2a5.83,5.83,0,0,0,4.53,1.63,5.25,5.25,0,0,0,3.42-1.73c-2.19-2.12-3.3-3.14-5.55-5.11a1.34,1.34,0,0,1-.24-1.63.9.9,0,0,1,1.39-.22c2.27,2,3.4,3,5.61,5.11a8,8,0,0,0,.58-4.45,7.87,7.87,0,0,0-2.6-4.92C356.71,170.07,348.87,169.23,344.6,169.07Zm-4.53-16.54c2.36,4,6.47,11.64,8.75,13.29a5.88,5.88,0,0,0,4.69,1.09,5.41,5.41,0,0,0,3.2-2.1c-2.41-1.86-3.64-2.75-6.1-4.45a1.32,1.32,0,0,1-.42-1.59.9.9,0,0,1,1.36-.37c2.48,1.7,3.71,2.58,6.14,4.43a8.24,8.24,0,0,0-3.07-9.07C352.21,152.14,344.33,152.2,340.07,152.53Zm3.82-3.72a5.87,5.87,0,0,0,4.78.55,5.27,5.27,0,0,0,2.93-2.46c-2.6-1.57-3.92-2.32-6.55-3.73a1.3,1.3,0,0,1-.61-1.52.89.89,0,0,1,1.3-.53c2.67,1.4,4,2.15,6.62,3.71a8,8,0,0,0-.44-4.48,7.9,7.9,0,0,0-3.65-4.21c-2.59-1.33-10.42-.38-14.61.43C336.48,140.34,341.43,147.43,343.89,148.81Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M314.62,81.87A1.16,1.16,0,0,1,313,81.7a137.38,137.38,0,0,0-23.56-18.84,1,1,0,1,1,1.11-1.67A139.76,139.76,0,0,1,314.4,80.27,1.16,1.16,0,0,1,314.62,81.87Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M323.34,83.16a1.18,1.18,0,0,1-1.61-.26,255.39,255.39,0,0,0-29.34-24.49,1,1,0,1,1,1.1-1.66,256.5,256.5,0,0,1,29.68,24.77A1.17,1.17,0,0,1,323.34,83.16Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M338.54,92.45a1.2,1.2,0,0,1-1.61-.44,176,176,0,0,0-41.49-38.22,1.05,1.05,0,1,1,1.1-1.66,177.55,177.55,0,0,1,42,38.65A1.21,1.21,0,0,1,338.54,92.45Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M77.45,103.69a1.09,1.09,0,0,0,1.5-.31c10.43-13.32,22.73-23.61,36.35-33.49a1,1,0,1,0-1.1-1.66,205,205,0,0,0-36.82,33.92A1.07,1.07,0,0,0,77.45,103.69Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M83.18,88.42a1.12,1.12,0,0,0,1.57-.2,160.17,160.17,0,0,1,27.49-23,1,1,0,1,0-1.1-1.66A161.26,161.26,0,0,0,83.3,86.85,1.12,1.12,0,0,0,83.18,88.42Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M68.68,133.09l-1.49-.35c-.42-.11-1.92-.45-3.91-.8,4.25-2.75,11.72-11.4,12.66-12.42.45-.49.68-.73,1.14-1.21l-1.43-.52a65.13,65.13,0,0,0-9.05-2.54,15.11,15.11,0,0,0,5.72-5c3.65-5.31,7.79-24.53,8-25.36l.5-1.74-1.72.59C78.31,84,59,92.2,54.88,98.24a15.48,15.48,0,0,0-2.78,8c-2.51-3.55-5.39-6.89-5.92-7.49l-1-1.17c-.35.76-.52,1.15-.85,1.91-.71,1.58-5.8,14.79-5.65,20.54-1.46-1.44-2.61-2.49-2.94-2.79l-1.15-1c-.25.79-.38,1.18-.62,2-.51,1.64-4,15.31-3.18,21-1.63-1.26-2.9-2.17-3.27-2.43l-1.25-.9c-.16.81-.24,1.21-.39,2-.31,1.67-2.21,15.6-.75,21.13-1.76-1.06-3.12-1.82-3.51-2l-1.35-.75c-.07.82-.09,1.23-.15,2.05-.12,1.71-.42,15.74,1.66,21.07-1.87-.85-3.31-1.45-3.72-1.62l-1.43-.59c0,.82.05,1.23.09,2,.07,1.71,1.37,15.74,4.07,20.8-2-.64-3.46-1.07-3.89-1.19l-1.49-.42c.12.81.19,1.22.32,2,.27,1.68,3.18,15.51,6.43,20.27-2-.4-3.55-.66-4-.73l-1.53-.25c.22.8.33,1.2.56,2,.5,1.8,5.87,17.34,9.66,20.44a7.05,7.05,0,0,0,6.38,1.61,7.4,7.4,0,0,0,4.67-4.25.68.68,0,0,0,.11-.19,1,1,0,0,0,.08-.22,4.19,4.19,0,0,0,.24-.62A220.54,220.54,0,0,0,59.6,287.8a1,1,0,1,0,1.69-1.08,216.81,216.81,0,0,1-21-48.78,5.5,5.5,0,0,0,.51.43,1.27,1.27,0,0,0,.17.14.84.84,0,0,0,.19.12,7.13,7.13,0,0,0,6.12,1.24,7.79,7.79,0,0,0,4.85-4.19c2-4,2.13-17.31,2.21-18.8,0-.66.06-1,.11-1.66l-1.44.51c-.41.15-1.87.68-3.72,1.48,2.07-4.65,3.65-16,3.88-17.3l.3-1.62-1.49.34c-.43.1-1.93.45-3.88,1,2.61-4.34,5.47-15.35,5.86-16.66.19-.63.28-.95.48-1.58l-1.51.17c-.44,0-2,.23-4,.57,3.07-4,7.16-14.57,7.7-15.83.26-.6.39-.9.66-1.5H55.78c-.44,0-2,0-4,.11,3.51-3.62,8.78-13.66,9.45-14.85l.83-1.42-1.51-.18c-.44,0-2-.23-4-.35,3.91-3.19,10.32-12.6,11.13-13.71C68.08,133.88,68.28,133.62,68.68,133.09Zm4.67-13.74c-3.25,3.43-9,10-11.61,11a5.83,5.83,0,0,1-4.82,0,5.23,5.23,0,0,1-2.63-2.78c2.77-1.27,4.17-1.87,7-3a1.35,1.35,0,0,0,.78-1.47.9.9,0,0,0-1.24-.67c-2.81,1.1-4.21,1.69-7,2.94a8.08,8.08,0,0,1,1-4.41,8,8,0,0,1,4.13-3.78C61.61,116.22,69.27,118.06,73.35,119.35Zm-16.82-20c2.76-4,14.9-10.45,21.14-12.84-1.82,6.43-4.51,19-7,22.58-2.94,4.27-8,6.23-11.93,4.56,2.69-4.51,4.13-6.71,7.19-11a1,1,0,1,0-1.63-1.16c-3.1,4.35-4.55,6.59-7.27,11.14C53.68,109.93,53.27,104.11,56.53,99.37ZM45.44,102c2.84,3.29,7.91,9.4,8.36,12.36a9.62,9.62,0,0,1-4.12,9.07c-.66-3-1-4.6-1.47-7.74A.84.84,0,0,0,47,115a1.57,1.57,0,0,0-.87,1.62c.54,3.15.84,4.71,1.53,7.77-2,.33-3,.19-3.86-.22a5.39,5.39,0,0,1-2.89-4C40.3,117.18,43.27,107.29,45.44,102ZM35.38,120.52c3.2,2.93,8.94,8.42,9.73,11.29a9,9,0,0,1-.38,5.68,9.17,9.17,0,0,1-2.64,3.75c-1-2.94-1.48-4.44-2.36-7.49a.84.84,0,0,0-1.31-.52,1.55,1.55,0,0,0-.67,1.69c.91,3.06,1.39,4.56,2.43,7.51-2,.56-3,.54-3.86.23A5.42,5.42,0,0,1,33,139C32,136.11,33.84,126,35.38,120.52ZM27.55,140c3.52,2.54,9.86,7.3,11,10.05a9.52,9.52,0,0,1-1.92,9.7c-1.34-2.8-2-4.23-3.21-7.15a.84.84,0,0,0-1.35-.38,1.55,1.55,0,0,0-.47,1.76c1.24,2.93,1.9,4.37,3.26,7.18-1.9.77-2.86.86-3.8.66a5.41,5.41,0,0,1-3.73-3.22C26,155.81,26.67,145.6,27.55,140ZM22,160.18c3.79,2.12,10.63,6.12,12.06,8.72a9,9,0,0,1,.92,5.61,9.18,9.18,0,0,1-1.72,4.25c-1.66-2.64-2.46-4-4-6.75a.85.85,0,0,0-1.39-.21,1.55,1.55,0,0,0-.27,1.81c1.57,2.76,2.38,4.12,4.06,6.75-1.8,1-2.75,1.2-3.7,1.1a5.39,5.39,0,0,1-4.08-2.78C22.34,176.07,21.78,165.85,22,160.18Zm-3.19,20.68c4,1.68,11.26,4.88,13,7.31a9,9,0,0,1,1.56,5.47,9.18,9.18,0,0,1-1.22,4.43c-1.94-2.44-2.9-3.69-4.75-6.26a.85.85,0,0,0-1.41-.05,1.56,1.56,0,0,0-.06,1.82c1.88,2.57,2.85,3.83,4.82,6.26a5.12,5.12,0,0,1-7.92-.76C21,196.64,19.24,186.53,18.83,180.86Zm-.8,21c4.16,1.2,11.74,3.55,13.72,5.78a9.15,9.15,0,0,1,2.19,5.29,9.27,9.27,0,0,1-.71,4.56c-2.21-2.2-3.3-3.34-5.44-5.7a.84.84,0,0,0-1.4.12,1.58,1.58,0,0,0,.15,1.83c2.16,2.35,3.27,3.49,5.51,5.7a5.3,5.3,0,0,1-3.35,1.92,5.38,5.38,0,0,1-4.61-1.78C22,217.33,19.08,207.43,18,201.83Zm18.58,34.93c-2.47-2-3.68-3-6.09-5.08a.83.83,0,0,0-1.38.27,1.61,1.61,0,0,0,.37,1.82c2.43,2.1,3.66,3.12,6.15,5.07a5.26,5.26,0,0,1-3.1,2.33,5.37,5.37,0,0,1-4.79-1.26c-2.39-2-6.41-11.57-8.12-17,4.28.72,12.11,2.2,14.32,4.19a9.3,9.3,0,0,1,2.79,5.06A9.46,9.46,0,0,1,36.61,236.76Zm15.6-18.36c-.31,4.73-.57,13.5-1.87,16a5.77,5.77,0,0,1-3.7,3.11,5.17,5.17,0,0,1-3.81-.49c1.32-2.78,2-4.14,3.45-6.8a1.35,1.35,0,0,0-.33-1.63.88.88,0,0,0-1.38.27c-1.47,2.66-2.17,4-3.51,6.81a8.55,8.55,0,0,1-1.33-9.66C41.17,223.51,48.25,220,52.21,218.4Zm-1.33-17.23c-.86,4.62-2.15,13.23-3.74,15.58a5.86,5.86,0,0,1-4,2.63,5.26,5.26,0,0,1-3.72-.9c1.64-2.59,2.48-3.85,4.22-6.3a1.31,1.31,0,0,0-.14-1.65.88.88,0,0,0-1.4.1c-1.76,2.46-2.62,3.72-4.28,6.31a8.41,8.41,0,0,1-.18-9.66C39.33,204.93,46.76,202.31,50.88,201.17ZM51.54,184c-1.38,4.49-3.66,12.84-5.51,15a5.89,5.89,0,0,1-4.31,2.14,5.29,5.29,0,0,1-3.59-1.33c1.92-2.37,2.91-3.51,4.92-5.74a1.31,1.31,0,0,0,.05-1.64.89.89,0,0,0-1.41,0c-2,2.22-3,3.36-5,5.73a8.35,8.35,0,0,1,.93-9.56C39.63,186.38,47.32,184.64,51.54,184ZM54.16,167c-1.89,4.28-5.11,12.31-7.18,14.2a5.88,5.88,0,0,1-4.54,1.64A5.3,5.3,0,0,1,39,181.14C41.21,179,42.32,178,44.57,176a1.32,1.32,0,0,0,.25-1.63.91.91,0,0,0-1.4-.21c-2.27,2-3.39,3-5.6,5.11a8,8,0,0,1-.59-4.46,7.93,7.93,0,0,1,2.61-4.91C42.05,168,49.89,167.19,54.16,167Zm4.53-16.53c-2.36,4-6.47,11.63-8.75,13.28a5.85,5.85,0,0,1-4.69,1.09,5.32,5.32,0,0,1-3.2-2.09c2.41-1.86,3.63-2.75,6.09-4.46a1.3,1.3,0,0,0,.43-1.58.9.9,0,0,0-1.36-.37c-2.48,1.69-3.71,2.58-6.15,4.43a8.29,8.29,0,0,1,3.08-9.08C46.55,150.11,54.43,150.17,58.69,150.5Zm-3.82-3.72a5.83,5.83,0,0,1-4.78.54,5.29,5.29,0,0,1-2.94-2.46c2.61-1.57,3.92-2.31,6.56-3.72a1.31,1.31,0,0,0,.61-1.53.9.9,0,0,0-1.31-.52c-2.66,1.4-4,2.14-6.62,3.7a8.18,8.18,0,0,1,.44-4.48,7.93,7.93,0,0,1,3.66-4.2c2.59-1.34,10.41-.39,14.61.43C62.28,138.3,57.32,145.4,54.87,146.78Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M84.14,79.84a1.17,1.17,0,0,0,1.6-.17A137.67,137.67,0,0,1,109.3,60.83a1,1,0,1,0-1.1-1.67A140.2,140.2,0,0,0,84.36,78.23,1.16,1.16,0,0,0,84.14,79.84Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M75.41,81.12A1.17,1.17,0,0,0,77,80.86a254.28,254.28,0,0,1,29.34-24.48,1.05,1.05,0,1,0-1.11-1.67A257.5,257.5,0,0,0,75.59,79.49,1.17,1.17,0,0,0,75.41,81.12Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M60.22,90.42A1.21,1.21,0,0,0,61.83,90a175.18,175.18,0,0,1,41.48-38.22c.64-.43.93-1.14.63-1.61a1.26,1.26,0,0,0-1.73-.06,177.79,177.79,0,0,0-42,38.66A1.21,1.21,0,0,0,60.22,90.42Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M241.35,137.79h-82.7l8.83-32.1h65Zm-79.63-2.34h76.56L230.73,108H169.27Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M173.1,220.55H173a1.17,1.17,0,0,1-1.08-1.25L178,136.53a1.17,1.17,0,0,1,1.25-1.08,1.18,1.18,0,0,1,1.09,1.26l-6.09,82.76A1.17,1.17,0,0,1,173.1,220.55Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M226.9,220.55a1.18,1.18,0,0,1-1.17-1.08l-6.08-82.77a1.17,1.17,0,0,1,1.08-1.25,1.19,1.19,0,0,1,1.26,1.08l6.08,82.77a1.17,1.17,0,0,1-1.08,1.25Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M205.38,219a1.17,1.17,0,0,1-1.17-1.17V196.21h-8.42v21.64a1.17,1.17,0,0,1-2.34,0V195a1.17,1.17,0,0,1,1.17-1.17h10.76a1.17,1.17,0,0,1,1.17,1.17v22.81A1.17,1.17,0,0,1,205.38,219Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'165.55 196.94 147.72 174.51 195.98 133.75 204.32 142.79 165.55 196.94',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'159.17 180.3 154.58 174.6 164.83 165.22 168.88 170.09 159.17 180.3',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'165.89 188.65 161.18 182.8 170.65 172.22 174.79 177.19 165.89 188.65',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'171.71 167.12 167.81 162.48 175.01 155.9 178.5 159.97 171.71 167.12',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'177.37 173.87 173.4 169.14 180.03 161.74 183.59 165.88 177.37 173.87',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'180.54 157.82 177.17 153.92 182.5 149.04 185.57 152.53 180.54 157.82',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'185.44 163.49 182.01 159.52 186.9 154.06 190.02 157.6 185.44 163.49',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'187.11 150.91 184.13 147.55 188.23 143.79 190.97 146.85 187.11 150.91',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'191.43 155.79 188.4 152.38 192.16 148.18 194.94 151.27 191.43 155.79',className:'Badge__FirstFillColor'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'229.09 88.9 246.94 105.91 204.07 143.06 195.74 134.01 229.09 88.9',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'236.07 101.32 240.78 105.84 232.44 113.61 228.3 109.52 236.07 101.32',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'229.46 94.95 234.06 99.38 226.53 107.77 222.47 103.77 229.46 94.95',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'225.95 112 229.92 115.95 223.69 121.75 220.13 118.14 225.95 112',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'220.35 106.43 224.25 110.31 218.6 116.6 215.11 113.05 220.35 106.43',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'218.34 120.04 221.77 123.54 216.93 128.04 213.82 124.81 218.34 120.04',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'213.49 115.09 216.87 118.54 212.48 123.42 209.41 120.24 213.49 115.09',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'212.4 126.3 215.42 129.45 211.57 133.04 208.79 130.11 212.4 126.3',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'208.13 121.85 211.11 124.95 207.6 128.86 204.86 125.97 208.13 121.85',className:'Badge__FirstFillColor'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'153.05 105.91 170.91 88.9 204.26 134.01 195.92 143.06 153.05 105.91',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'165.94 99.38 170.54 94.95 177.53 103.76 173.47 107.78 165.94 99.38',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'159.22 105.84 163.92 101.32 171.7 109.52 167.56 113.61 159.22 105.84',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'175.75 110.31 179.64 106.43 184.89 113.05 181.39 116.6 175.75 110.31',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'170.08 115.95 174.05 112 179.87 118.14 176.31 121.75 170.08 115.95',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'183.13 118.54 186.51 115.09 190.59 120.24 187.52 123.42 183.13 118.54',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'178.23 123.54 181.66 120.04 186.18 124.81 183.06 128.04 178.23 123.54',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'188.89 124.95 191.87 121.85 195.14 125.97 192.4 128.86 188.89 124.95',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'184.57 129.45 187.6 126.3 191.21 130.11 188.43 133.04 184.57 129.45',className:'Badge__FirstFillColor'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'252.27 174.51 234.44 196.94 195.68 142.79 204.01 133.75 252.27 174.51',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'238.82 182.8 234.11 188.65 225.21 177.19 229.35 172.22 238.82 182.8',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'245.42 174.6 240.82 180.3 231.12 170.09 235.17 165.22 245.42 174.6',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'226.59 169.14 222.62 173.87 216.41 165.88 219.97 161.74 226.59 169.14',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'232.19 162.48 228.29 167.12 221.5 159.97 224.99 155.9 232.19 162.48',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'217.99 159.52 214.55 163.49 209.97 157.6 213.09 154.05 217.99 159.52',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'222.83 153.92 219.46 157.82 214.43 152.53 217.5 149.04 222.83 153.92',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'211.59 152.38 208.57 155.79 205.06 151.27 207.83 148.18 211.59 152.38',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'215.87 147.55 212.89 150.91 209.02 146.85 211.76 143.79 215.87 147.55',className:'Badge__FirstFillColor'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M202.79,141.39a3.7,3.7,0,0,1-5.58,0,4.52,4.52,0,0,1,0-6,3.72,3.72,0,0,1,5.53,0A4.51,4.51,0,0,1,202.79,141.39Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,145.79a6.54,6.54,0,0,1-4.88-2.21,7.79,7.79,0,0,1,.07-10.36,6.48,6.48,0,0,1,9.61,0,7.78,7.78,0,0,1,.08,10.36A6.54,6.54,0,0,1,200,145.79Zm0-13.52a5.38,5.38,0,0,0-3.95,1.75,6.57,6.57,0,0,0-.06,8.77,5.31,5.31,0,0,0,8,0A6.6,6.6,0,0,0,204,134,5.4,5.4,0,0,0,200,132.27Z',className:'Badge__FirstFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M240.73,223.31l.06-.13c17.9,0,39.69,17,39.69,26.75s-7.12,28-75.28,28-85.68-13.59-85.68-27.39c0-10.36,6.74-18.51,14.71-18.51,0,0,11-7.38,24.38-7.38a35.54,35.54,0,0,1,3.89.2h0a33.33,33.33,0,0,1,17-4.94,33.75,33.75,0,0,1,9,1.28v0A44.34,44.34,0,0,1,203,218.28a31.3,31.3,0,0,1,10.85,2.11l.05-.14S225.12,216.32,240.73,223.31Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M205.2,279.14c-57.63,0-86.86-9.61-86.86-28.56,0-10.85,7.13-19.68,15.89-19.68,25.82,0,41.41,26.15,41.57,26.42a1.17,1.17,0,1,1-2,1.18c-.15-.25-15.08-25.26-39.55-25.26-7.47,0-13.54,7.78-13.54,17.34,0,12,14.66,26.22,84.51,26.22,61.25,0,74.11-14.61,74.11-26.87,0-8.67-20.8-25.58-38.52-25.58a1.17,1.17,0,0,1,0-2.34c8.43,0,18.36,3.63,27.24,10,8.4,6,13.62,12.87,13.62,18C281.65,274.07,240.08,279.14,205.2,279.14Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M203,257.49a1.18,1.18,0,0,1-1-.49l-1.23-1.78c-6.08-8.79-18.73-27.08-38.38-29.17a1.17,1.17,0,0,1-1-1.29,1.19,1.19,0,0,1,1.29-1c20.72,2.21,33.78,21.09,40.05,30.17l1.23,1.76a1.17,1.17,0,0,1-.29,1.63A1.11,1.11,0,0,1,203,257.49Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M134.23,233.24a1.17,1.17,0,0,1-.65-2.14c.46-.31,11.45-7.59,25-7.59a37.9,37.9,0,0,1,4,.21,1.17,1.17,0,0,1-.24,2.33,36,36,0,0,0-3.77-.19c-12.85,0-23.62,7.11-23.72,7.18A1.14,1.14,0,0,1,134.23,233.24Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M232.81,257.4a1.17,1.17,0,0,1-.81-.33c-2-1.92-4.23-4.28-6.6-6.79-9.5-10-22.52-23.77-37.18-27.92a30.77,30.77,0,0,0-25,3.49,1.19,1.19,0,0,1-.51.2,1.17,1.17,0,0,1-1-2h0a1.1,1.1,0,0,1,.28-.2,33,33,0,0,1,26.88-3.73c15.29,4.32,28.56,18.33,38.25,28.56,2.35,2.49,4.58,4.83,6.53,6.71a1.18,1.18,0,0,1,0,1.66A1.15,1.15,0,0,1,232.81,257.4Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M254.81,257.4a1.15,1.15,0,0,1-1-.5c-.2-.28-19.53-27.67-40.45-35.41a30.17,30.17,0,0,0-10.44-2,43.32,43.32,0,0,0-14,2.83,1.17,1.17,0,0,1-1.52-.65,1.16,1.16,0,0,1,.64-1.52,44.89,44.89,0,0,1,14.85-3,32.43,32.43,0,0,1,11.26,2.18c9.09,3.36,18.85,10.5,29,21.2a146.54,146.54,0,0,1,12.55,15.07,1.17,1.17,0,0,1-.29,1.63A1.2,1.2,0,0,1,254.81,257.4Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M271.85,251.75a1.17,1.17,0,0,1-1-.49c-9.44-13-19.75-22-30.65-26.88-15-6.73-25.89-3.06-26-3a1.17,1.17,0,0,1-1.49-.72,1.16,1.16,0,0,1,.72-1.49c.47-.17,11.87-4,27.73,3.1,11.28,5,21.9,14.32,31.58,27.64a1.16,1.16,0,0,1-.25,1.63A1.19,1.19,0,0,1,271.85,251.75Z',className:'Badge__SecondFillColor'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Bitter',fontSize:languageSettings.small?'1.3em':'2.2em',fontWeight:'700',letterSpacing:'0.15em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_10__TopCircle',startOffset:'50%'},line0.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Abel',fontSize:languageSettings.small?'1.3em':'1.8em',letterSpacing:'0.05em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_10__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(112);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_11',title:'Radial_11',colors:3,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_11 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_11__TopCircle',d:'M 85 200 A 50 50 0 0 1 315 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_11__BottomCircle',d:'M 85 200 A 50 50 0 0 0 315 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'190.34',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M393.3,200c11.95-18.27,7.22-35.67-8.7-49.47,6.76-20.49,2-37.91-17.17-47.19,1.4-21.47-11.4-34.23-32.33-38.44-4.21-20.93-17-33.73-38.44-32.33C287.38,13.38,270,8.64,249.47,15.4,235.68-.52,218.27-5.25,200,6.7c-18.27-11.95-35.67-7.22-49.47,8.7-20.49-6.76-37.91-2-47.19,17.17C81.87,31.17,69.11,44,64.9,64.9c-20.93,4.21-33.73,17-32.33,38.44C13.38,112.62,8.64,130,15.4,150.53-.52,164.32-5.25,181.73,6.7,200c-11.95,18.27-7.22,35.67,8.7,49.47-6.76,20.49-2,37.91,17.17,47.19C31.17,318.13,44,330.89,64.9,335.1c4.21,20.93,17,33.73,38.44,32.33,9.28,19.19,26.7,23.93,47.19,17.17,13.79,15.92,31.2,20.65,49.47,8.7,18.27,11.95,35.67,7.22,49.47-8.7,20.49,6.76,37.91,2,47.19-17.17,21.47,1.4,34.23-11.4,38.44-32.33,20.93-4.21,33.73-17,32.33-38.44,19.19-9.28,23.93-26.7,17.17-47.19C400.52,235.68,405.25,218.27,393.3,200ZM18.66,228.5a4.61,4.61,0,1,1,4.61-4.61A4.62,4.62,0,0,1,18.66,228.5Zm0-46.63a4.61,4.61,0,1,1,4.61-4.61A4.62,4.62,0,0,1,18.66,181.87Zm12.09,95a4.61,4.61,0,1,1,4.6-4.6A4.61,4.61,0,0,1,30.75,276.85Zm0-145.65a4.61,4.61,0,1,1,4.6-4.6A4.61,4.61,0,0,1,30.75,131.2ZM55.5,315.42a4.61,4.61,0,1,1,4.61-4.6A4.6,4.6,0,0,1,55.5,315.42Zm0-222.79A4.61,4.61,0,1,1,60.11,88,4.6,4.6,0,0,1,55.5,92.63ZM92.35,351.12a4.61,4.61,0,1,1,4.6-4.61A4.61,4.61,0,0,1,92.35,351.12Zm0-294.18a4.61,4.61,0,1,1,4.6-4.6A4.6,4.6,0,0,1,92.35,56.94Zm38.57,316.63a4.61,4.61,0,1,1,4.6-4.61A4.6,4.6,0,0,1,130.92,373.57Zm0-339.08a4.61,4.61,0,1,1,4.6-4.61A4.6,4.6,0,0,1,130.92,34.49Zm47.2,352.32a4.61,4.61,0,1,1,4.61-4.61A4.6,4.6,0,0,1,178.12,386.81Zm0-365.56a4.61,4.61,0,1,1,4.61-4.61A4.6,4.6,0,0,1,178.12,21.25ZM223,386.81a4.61,4.61,0,1,1,4.6-4.61A4.6,4.6,0,0,1,223,386.81Zm0-365.56a4.61,4.61,0,1,1,4.6-4.61A4.6,4.6,0,0,1,223,21.25Zm47.2,352.32a4.61,4.61,0,1,1,4.61-4.61A4.6,4.6,0,0,1,270.23,373.57Zm0-339.08a4.61,4.61,0,1,1,4.61-4.61A4.6,4.6,0,0,1,270.23,34.49ZM308.8,351.12a4.61,4.61,0,1,1,4.61-4.61A4.61,4.61,0,0,1,308.8,351.12Zm0-294.18a4.61,4.61,0,1,1,4.61-4.6A4.6,4.6,0,0,1,308.8,56.94Zm36.85,258.48a4.61,4.61,0,1,1,4.6-4.6A4.6,4.6,0,0,1,345.65,315.42Zm0-222.79a4.61,4.61,0,1,1,4.6-4.6A4.6,4.6,0,0,1,345.65,92.63ZM370.4,276.85a4.61,4.61,0,1,1,4.61-4.6A4.6,4.6,0,0,1,370.4,276.85Zm0-145.65a4.61,4.61,0,1,1,4.61-4.6A4.6,4.6,0,0,1,370.4,131.2Zm12.09,97.3a4.61,4.61,0,1,1,4.61-4.61A4.61,4.61,0,0,1,382.49,228.5Zm0-46.63a4.61,4.61,0,1,1,4.61-4.61A4.61,4.61,0,0,1,382.49,181.87Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200.05,362.17H199v-1H200Zm2.21,0,0-1,1.1,0,0,1Zm-5.52,0-1.1,0,0-1,1.09,0Zm8.82-.06,0-1,1.09,0,0,1Zm-12.12,0-1.11-.05,0-1,1.09,0Zm15.42-.11-.06-1,1.1-.07.06,1Zm-18.73-.05-1.1-.07.07-1,1.09.07Zm22-.16-.07-1,1.09-.09.08,1Zm-25.33-.08-1.1-.09.09-1,1.09.09Zm28.62-.2-.09-1,1.09-.11.1,1Zm-31.91-.1-1.1-.11.11-1,1.08.11Zm35.2-.24-.11-1,1.09-.13.12,1ZM180.25,361l-1.09-.14.12-1,1.09.14Zm41.78-.29-.13-1,1.08-.15.14,1ZM177,360.55l-1.09-.16.14-1,1.09.16Zm48.33-.34-.15-1,1.08-.17.16.95Zm-51.6-.16-1.09-.18.17-1,1.08.18Zm54.86-.39-.17-1,1.08-.2.18,1Zm-58.12-.18-1.08-.2.18-.95,1.08.2Zm61.37-.43-.19-.95,1.08-.22.19.95Zm-64.62-.2-1.08-.23.21-.94,1.07.22Zm67.86-.48-.21-.94,1.07-.24.22.94ZM164,358.15l-1.07-.25.22-.94,1.07.25Zm74.31-.52-.22-.94,1.06-.27.23.94Zm-77.53-.24-1.07-.27.24-.94,1.07.27Zm80.74-.57-.25-.94,1.06-.28.25.93Zm-83.94-.26-1.06-.3.26-.93,1,.29Zm87.13-.62-.27-.93,1.06-.31.27.93Zm-90.31-.28-1.06-.32.28-.92,1,.31Zm93.48-.66-.28-.93,1-.32.3.92Zm-96.66-.31-1.05-.33.3-.92,1,.33ZM251,354l-.3-.92,1-.35.31.92Zm-103-.33-1-.36.31-.91,1,.36Zm106.1-.74-.32-.91,1-.37.33.91Zm-109.23-.35-1-.39.34-.9,1,.37Zm112.34-.79-.34-.9,1-.39.35.9Zm-115.45-.37-1-.4.35-.91,1,.4Zm118.53-.83-.36-.9,1-.41.36.9Zm-121.62-.4-1-.42.37-.89,1,.42Zm124.67-.85-.38-.9,1-.43.38.89Zm-127.73-.43-1-.45.39-.88,1,.44ZM266.38,348l-.4-.89,1-.45.4.88Zm-133.78-.47-1-.46.41-.88,1,.47Zm136.77-.91-.41-.88,1-.47.43.87Zm-139.77-.5-1-.48.42-.87,1,.48Zm142.74-.95-.43-.86,1-.49.44.86Zm-145.71-.52-1-.5.45-.86,1,.5Zm148.64-1-.45-.86,1-.51.45.86Zm-151.58-.55-1-.52.47-.85,1,.52Zm154.49-1-.47-.85,1-.53.48.84Zm-157.4-.58-1-.55.48-.84,1,.54Zm160.27-1-.49-.84.95-.55.49.83Zm-163.14-.61-1-.56.49-.84,1,.56Zm166-1.08-.5-.82.93-.57.51.82Zm-168.82-.63-.94-.58.51-.83.94.58Zm171.62-1.1-.51-.82.92-.59.52.82Zm-174.42-.67-.93-.6.53-.81.92.6Zm177.2-1.13-.54-.81.91-.6.54.8Zm-180-.69-.91-.62.54-.8.91.62Zm182.7-1.16-.55-.79.89-.63.56.79Zm-185.43-.72-.9-.64.56-.79.9.64Zm188.12-1.19-.56-.78.88-.65.57.79Zm-190.81-.74-.88-.66.57-.78.89.66Zm193.47-1.22-.58-.77.87-.66.59.77Zm-196.11-.77-.88-.67.6-.77.86.67Zm198.73-1.24-.6-.76.86-.69.6.76Zm-201.34-.8-.86-.69.61-.75.85.68Zm203.91-1.27-.61-.75.84-.7.62.75Zm-206.48-.82-.84-.71.62-.74.84.7Zm209-1.3-.63-.74.83-.71.63.73Zm-211.54-.85-.83-.72.64-.73.83.72Zm214-1.33-.64-.72.81-.73.65.72Zm-216.5-.86-.82-.74.66-.72.81.74Zm219-1.36-.66-.71.8-.75.66.71Zm-221.38-.88-.8-.76.66-.7.8.75Zm223.78-1.39L312,316l.78-.76.68.69Zm-226.17-.9-.78-.78.68-.69.78.77ZM315,314.37l-.68-.69.77-.77.69.68Zm-230.86-.93-.76-.79L84,312l.77.79ZM317.28,312l-.7-.67.76-.79.7.66Zm-235.46-.94-.75-.81.71-.66.75.81Zm237.72-1.47-.71-.66.74-.81.72.65Zm-240-1-.73-.82.72-.65.73.82Zm242.17-1.51-.72-.64.72-.82.73.63C322.24,306.57,322,306.85,321.75,307.12Zm-244.36-1-.71-.83.73-.63.72.83Zm246.53-1.53-.74-.63.7-.84.75.62Zm-248.66-1-.7-.85.74-.61.7.84ZM326,302.07l-.75-.61.68-.85.76.6Zm-252.86-1-.68-.86.76-.6.68.86Zm254.92-1.59-.77-.6L328,298l.77.58Zm-257-1-.66-.88.77-.58.66.87Zm259-1.63-.78-.57.66-.89.78.58Zm-260.94-1-.64-.89.78-.56.65.88ZM332,294.17l-.78-.56.63-.9.79.56Zm-264.81-1-.63-.9.79-.55.63.89Zm266.71-1.68-.8-.55.62-.91.8.54Zm-268.58-1-.61-.91.8-.54.61.91Zm270.42-1.72-.81-.53.6-.92.81.53Zm-272.24-1-.59-.92.82-.52.59.92Zm274-1.75-.82-.51.58-.93.82.5Zm-275.79-1-.57-.94.83-.5.57.93Zm277.52-1.78-.83-.5.56-.95.83.5ZM60.08,282l-.55-1,.84-.48.55.94ZM341,280.22l-.84-.47.54-1,.84.47Zm-282.53-1-.54-1,.85-.47.53,1Zm284.14-1.85-.85-.46.52-1,.86.45Zm-285.72-1-.52-1,.86-.45.51,1Zm287.28-1.89-.87-.45.51-1,.86.44Zm-288.81-1-.49-1,.87-.43.49,1Zm290.3-1.92-.87-.43.48-1,.87.42Zm-291.76-1-.47-1,.87-.42.47,1Zm293.19-2-.88-.41.46-1,.88.4Zm-294.59-1-.46-1,.89-.4.45,1Zm296-2-.88-.39.44-1,.89.38Zm-297.3-1-.44-1,.89-.38.44,1Zm298.61-2-.89-.38.42-1,.89.36Zm-299.89-1-.42-1,.9-.36.41,1ZM351,259.3l-.91-.35.4-1,.91.35Zm-302.36-1-.4-1,.91-.35.39,1Zm303.54-2.11-.91-.34.38-1,.91.33Zm-304.7-1c-.13-.35-.25-.69-.37-1l.91-.32c.12.34.24.68.37,1Zm305.82-2.14-.92-.32.36-1,.92.31Zm-306.92-1L46,251l.92-.3.35,1Zm308-2.16-.92-.3c.11-.35.22-.7.34-1.05l.92.3C354.57,249.22,354.46,249.57,354.34,249.92Zm-309-1q-.18-.52-.33-1.05l.92-.29.33,1.05Zm310-2.19-.93-.28.32-1.05.92.27Zm-310.95-1-.31-1.06.94-.27.3,1.05Zm311.87-2.21-.93-.26.29-1.06.93.26C356.45,242.86,356.35,243.22,356.25,243.57Zm-312.77-1-.28-1.06.93-.25.29,1.06Zm313.62-2.21-.93-.24.26-1.07.94.24Zm-314.45-1-.27-1.07.95-.22c.08.35.17.7.26,1.06Zm315.24-2.23-.94-.22.25-1.07.94.22Zm-316-1-.24-1.08.94-.21.24,1.07Zm316.73-2.25-.94-.2.22-1.07.95.19Zm-317.43-1L41,231.86l.95-.19.22,1.08Zm318.09-2.25-.95-.18.2-1.08,1,.18Zm-318.73-1-.19-1.09.95-.17.2,1.08Zm319.32-2.26-1-.17.19-1.08,1,.16ZM40,226.44l-.17-1.09,1-.15.17,1.08Zm320.41-2.27-1-.14.16-1.09,1,.14Zm-320.91-1-.15-1.09,1-.14.15,1.09Zm321.37-2.28-1-.12.13-1.09,1,.12Zm-321.8-1-.13-1.1,1-.11.13,1.09Zm322.19-2.28-1-.11.12-1.09,1,.1Zm-322.56-1-.11-1.1,1-.09.11,1.09Zm322.88-2.28-1-.09.09-1.09,1,.08Zm-323.18-1-.09-1.1,1-.07.08,1.09ZM361.8,211l-1-.07.07-1.09,1,.06ZM38.13,210l-.06-1.1,1-.06.06,1.1ZM362,207.72l-1-.05.05-1.1,1,0Zm-324-1,0-1.09,1,0,0,1.09Zm324.14-2.29-1,0,0-1.09,1,0Zm-324.25-1V202.3h1l0,1.1Zm324.31-2.31h-1v-1.31h1v1.31Zm-323.37-1h-1V199h1Zm322.38-2.5,0-1.09,1,0,0,1.1Zm-322.35-.79-1,0,0-1.1,1,0Zm322.27-2.49,0-1.09,1,0,0,1.1Zm-322.17-.8-1,0,0-1.11,1,.05ZM361,191l-.07-1.09,1-.06.06,1.1Zm-321.87-.8-1-.06.07-1.1,1,.07Zm321.65-2.48-.08-1.09,1-.08.09,1.1ZM39.32,187l-1-.08.09-1.1,1,.09Zm321.14-2.48-.1-1.09,1-.1.11,1.1Zm-320.85-.8-1-.09.11-1.1,1,.1Zm320.51-2.47-.13-1.09,1-.11.13,1.09ZM40,180.42l-1-.12.14-1.09,1,.12ZM359.71,178l-.16-1.09,1-.13.16,1.09ZM40.4,177.16l-1-.14.16-1.09,1,.14Zm318.83-2.47-.18-1.08,1-.15.17,1.09ZM40.9,173.91l-1-.16.18-1.09,1,.16Zm317.78-2.46-.19-1.07.95-.18.2,1.08Zm-317.22-.78-1-.18.2-1.08.95.18Zm316.61-2.45-.22-1.07.95-.2L359,168Zm-316-.78-1-.2.22-1.08,1,.21ZM357.39,165l-.24-1.07,1-.22.24,1.08Zm-314.61-.78-.94-.22.24-1.07,1,.22Zm313.87-2.43-.26-1.06.94-.24.26,1.07ZM43.54,161l-.94-.24.27-1.07.94.24Zm312.3-2.41-.28-1.06.93-.26.29,1.07Zm-311.47-.78-.94-.25.29-1.07.94.27ZM355,155.45l-.31-1.06.93-.27.31,1.06Zm-309.71-.77-.93-.28.31-1.05.93.28ZM354,152.29l-.33-1,.92-.29.33,1Zm-307.82-.77-.92-.29.34-1.06.92.3ZM353,149.16l-.35-1,.92-.31.35,1.05Zm-305.78-.78-.92-.31.36-1,.92.32ZM352,146.05l-.37-1,.91-.33.38,1Zm-303.62-.78-.91-.33.38-1,.9.33ZM350.82,143l-.39-1,.9-.35c.14.34.27.69.4,1Zm-301.34-.8-.9-.34.4-1,.9.36Zm300.15-2.27-.42-1,.9-.37c.14.34.28.68.41,1ZM50.7,139.11l-.9-.37.42-1,.89.37Zm297.67-2.24-.43-1,.89-.39.43,1ZM52,136.06l-.88-.38.44-1,.88.4Zm295.09-2.19-.45-1,.88-.41.45,1Zm-293.75-.82-.88-.4.47-1,.87.41Zm292.37-2.15-.47-1,.87-.42.48,1Zm-291-.83-.88-.42.49-1,.87.43ZM344.25,128l-.5-1,.87-.44.49,1Zm-288.07-.84-.86-.44.5-1,.86.44ZM342.75,125l-.51-1,.85-.45.52,1Zm-285-.85-.85-.46.52-1,.85.46Zm283.49-2-.53-1,.85-.47.53,1ZM59.28,121.3l-.84-.47.54-1,.84.48Zm280.3-2-.55-.94.83-.5.56,1Zm-278.66-.86-.83-.49.56-1,.83.5Zm277-2-.57-.93.83-.51.57.94Zm-275.28-.86-.82-.51.58-.94.82.51Zm273.55-1.93-.59-.92.82-.52.59.92Zm-271.79-.86-.82-.52.6-.93.81.53Zm270-1.89-.61-.91.8-.54.61.91Zm-268.2-.86-.81-.54.62-.91.8.54Zm266.35-1.86c-.2-.3-.41-.59-.62-.89l.79-.56.63.9Zm-264.49-.85-.79-.56.64-.9.79.56Zm262.6-1.82-.65-.89.78-.57.65.89ZM70,104.7l-.78-.58.66-.88.78.57Zm258.72-1.79L328,102l.77-.58.67.87ZM72,102.06l-.77-.58.67-.88.77.59Zm254.74-1.75-.68-.86.75-.61.69.87ZM74,99.47l-.76-.6.69-.86.75.61Zm250.65-1.72c-.23-.29-.47-.57-.7-.85l.74-.62.71.85ZM76.06,96.92l-.75-.62.71-.84.74.62Zm246.46-1.69-.72-.83.73-.63c.25.27.49.55.72.83ZM78.19,94.42l-.74-.64.73-.83.73.64C78.66,93.87,78.42,94.14,78.19,94.42Zm242.16-1.66c-.24-.28-.48-.55-.73-.82l.72-.65.74.82ZM80.37,92l-.72-.65.74-.81.71.65Zm237.77-1.62-.74-.8.7-.67.75.81ZM82.59,89.54l-.7-.67.76-.8.7.67Zm233.29-1.6-.76-.78.69-.68.77.79Zm-231-.78-.69-.67L85,85.7l.68.68Zm228.7-1.56-.78-.77.68-.69.79.77ZM87.2,84.84l-.68-.69.79-.77.67.7Zm224-1.53-.8-.76.67-.7.8.76ZM89.57,82.57l-.67-.71.81-.75.66.71Zm219.24-1.51-.81-.73.65-.72.82.74ZM92,80.34l-.66-.72.83-.74.64.73C92.53,79.85,92.25,80.09,92,80.34Zm214.38-1.47-.83-.72.63-.73.83.72ZM94.45,78.16l-.64-.73.84-.72.62.73Zm209.42-1.44L303,76l.62-.75.85.71ZM97,76l-.62-.74.85-.7.61.75Zm204.39-1.4-.86-.69.61-.76.86.69ZM99.5,74l-.61-.76.86-.68.6.76Zm199.26-1.38-.87-.67.59-.77.87.68Zm-196.68-.65-.59-.77.88-.66.58.77Zm194.06-1.34-.88-.65.57-.78.89.65ZM104.71,70l-.57-.78.88-.64.57.78Zm188.77-1.31-.9-.63.56-.79.9.63Zm-186.11-.6-.55-.79.9-.63.55.79Zm183.41-1.28-.91-.62.54-.8.91.62Zm-180.7-.58-.54-.81.91-.61.54.81Zm178-1.25-.92-.6.52-.81.93.6Zm-175.22-.56-.53-.81.93-.59.52.81Zm172.44-1.21-.93-.58.51-.82.94.58ZM115.6,62.63l-.51-.82.94-.57.5.82Zm166.85-1.18-.94-.56.49-.83.95.56Zm-164-.51-.5-.83,1-.56.48.84Zm161.2-1.15-1-.54.47-.84,1,.54Zm-158.36-.48-.47-.84,1-.54.46.85Zm155.48-1.12-1-.52.46-.85,1,.52Zm-152.61-.45-.45-.86,1-.51.45.85Zm149.69-1.09-1-.5.44-.86,1,.5ZM127,56.22l-.44-.86,1-.5.44.87Zm143.84-1-1-.48.42-.87,1,.48ZM130,54.76l-.42-.87,1-.47.41.87Zm137.92-1-1-.46.4-.88,1,.46Zm-135-.38-.4-.88,1-.46.4.89Zm132-1-1-.44.38-.89c.34.15.68.29,1,.45Zm-129-.35-.38-.89,1-.44.39.89Zm125.94-.95-1-.42.37-.89,1,.42Zm-122.92-.33-.37-.89,1-.42.35.9Zm119.86-.9-1-.4.35-.9,1,.4ZM142,49.55l-.35-.91,1-.39.34.91Zm113.71-.87-1-.37.33-.91,1,.38ZM145.08,48.4l-.33-.91,1-.38.32.92Zm107.52-.82-1-.36.31-.92,1,.36Zm-104.42-.27-.31-.92,1-.35.31.92Zm101.29-.78-1.05-.33.29-.93,1.06.34Zm-98.17-.25-.29-.92,1.06-.33.28.93Zm95-.73-1.06-.31.28-.93,1,.32Zm-91.88-.23-.27-.93,1-.3.27.93Zm88.72-.68-1.06-.29.25-.93,1.07.29Zm-85.56-.21-.25-.94,1.06-.28.25.93ZM240,43.8l-1.06-.27.23-.94,1.07.27Zm-79.2-.2-.23-.94,1.07-.27.23,1Zm76-.58-1.07-.25.21-.94,1.08.24ZM164,42.83l-.21-.94,1.07-.24.21,1Zm69.6-.53-1.08-.22.2-.95,1.08.22Zm-66.39-.16-.19-1,1.08-.22.19,1Zm63.16-.49-1.08-.2.18-1,1.08.2Zm-59.93-.15-.18-1,1.09-.2.17,1Zm56.7-.43-1.08-.18.15-1,1.09.18Zm-53.46-.13-.16-1,1.09-.17.15.95Zm50.21-.39-1.09-.15.14-1,1.09.16Zm-47-.11-.14-1,1.1-.15.13,1Zm43.7-.34L219.53,40l.12-1,1.1.13ZM180.18,40l-.12-1,1.1-.13.11,1Zm37.18-.28-1.09-.11.09-1,1.1.12Zm-33.91-.08-.1-1,1.1-.1.09,1Zm30.63-.24L213,39.31l.08-1,1.1.09Zm-27.36-.06-.08-1,1.1-.08.07,1Zm24.08-.19-1.09-.06.06-1,1.1.07Zm-20.8,0-.06-1,1.1-.07.06,1ZM207.52,39l-1.09,0,0-1,1.11,0Zm-14.23,0,0-1,1.1,0,0,1Zm11-.09-1.1,0,0-1,1.1,0Zm-7.68,0,0-1,1.1,0,0,1Zm4.39,0h-1.1v-1H201Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M270.8,174.81a15.65,15.65,0,0,0-13.23-2.21,20.23,20.23,0,0,0-7,3.89c-.24-2.16-.46-3.41-.46-3.41H250c-1.86-10.75-26.09-19.25-55.73-19.25s-53.86,8.5-55.72,19.25h0s-13,72,55.77,73.07c28.36-.45,42.82-12.94,50-27.48,19.63-4.12,29.21-17.11,31.45-27.41C277.3,184.12,275.4,177.82,270.8,174.81Zm-31.06-.4c0,8.22-20.33,14.89-45.4,14.89s-45.4-6.67-45.4-14.89a4.65,4.65,0,0,1,.07-.83c-1.56,1-2.66,1.81-2.85,1.71,3.92-6.47,8.62-8.54,10.34-9.11,8.14-4,22-6.67,37.84-6.67,17.57,0,32.79,3.28,40.34,8.07a21.44,21.44,0,0,1,8.74,8.44c-.23.12-1.71-1-3.73-2.25A4.48,4.48,0,0,1,239.74,174.41Zm27.39,15c-1.55,7.1-7.9,15-18.93,19a80.1,80.1,0,0,0,2.8-19.22c2.3-3.4,5.54-7.09,9.06-8.12A6.82,6.82,0,0,1,266,182.2C267.12,183,268,185.51,267.13,189.39Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'310.94 187.31 307.13 195.01 298.63 196.25 304.78 202.25 303.33 210.72 310.94 206.72 318.54 210.72 317.09 202.25 323.25 196.25 314.74 195.01 310.94 187.31',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'89.06 187.31 85.26 195.01 76.75 196.25 82.91 202.25 81.46 210.72 89.06 206.72 96.67 210.72 95.22 202.25 101.38 196.25 92.87 195.01 89.06 187.31',className:'Badge__ThirdFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Bitter',fontSize:languageSettings.small?'1.2em':'1.6em',fontWeight:'700',letterSpacing:'0.09em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_11__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Anton',fontSize:languageSettings.small?'1.3em':'1.6em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_11__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(115);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_12',title:'Radial_12',colors:3,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_12 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_12__TopCircle',d:'M 85 200 A 50 50 0 0 1 315 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_12__BottomCircle',d:'M 85 200 A 50 50 0 0 0 315 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'200',transform:'translate(-82.84 200) rotate(-45)',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'DOTS'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M192.2,16.89h18.15A13.13,13.13,0,0,1,223.45,30h0a13.14,13.14,0,0,1-13.1,13.1H192.2A13.14,13.14,0,0,1,179.1,30h0a13.13,13.13,0,0,1,13.1-13.1Zm18.15,6.18H192.2A6.95,6.95,0,0,0,185.29,30h0a6.93,6.93,0,0,0,6.91,6.91h18.15A6.93,6.93,0,0,0,217.26,30h0a6.95,6.95,0,0,0-6.91-6.92Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M239.86,21.11l17.53,4.7a13.13,13.13,0,0,1,9.26,16h0a13.13,13.13,0,0,1-16,9.26l-17.53-4.7a13.13,13.13,0,0,1-9.26-16h0a13.13,13.13,0,0,1,16-9.26Zm15.93,10.67-17.53-4.7A6.94,6.94,0,0,0,229.79,32h0a7,7,0,0,0,4.89,8.47l17.53,4.7a6.94,6.94,0,0,0,8.47-4.89h0a6.94,6.94,0,0,0-4.89-8.47Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M284.8,37.52l15.72,9.07a13.13,13.13,0,0,1,4.79,17.9h0a13.12,13.12,0,0,1-17.89,4.79l-15.71-9.07a13.12,13.12,0,0,1-4.8-17.89h0a13.12,13.12,0,0,1,17.89-4.8ZM297.43,52l-15.72-9.07a6.94,6.94,0,0,0-9.44,2.53h0a6.94,6.94,0,0,0,2.53,9.44l15.71,9.08A6.95,6.95,0,0,0,300,61.4h0A6.95,6.95,0,0,0,297.43,52Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M324,65,336.8,77.84a13.13,13.13,0,0,1,0,18.52h0a13.12,13.12,0,0,1-18.53,0L305.44,83.53a13.13,13.13,0,0,1,0-18.52h0A13.12,13.12,0,0,1,324,65Zm8.45,17.2L319.59,69.38a6.94,6.94,0,0,0-9.77,0h0a6.93,6.93,0,0,0,0,9.78L322.65,92a6.94,6.94,0,0,0,9.77,0h0a6.93,6.93,0,0,0,0-9.78Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M354.68,101.69l9.07,15.72A13.12,13.12,0,0,1,359,135.3h0a13.12,13.12,0,0,1-17.89-4.79L332,114.79a13.13,13.13,0,0,1,4.8-17.89h0a13.12,13.12,0,0,1,17.89,4.79Zm3.72,18.81-9.07-15.72a7,7,0,0,0-9.45-2.53h0a7,7,0,0,0-2.53,9.45l9.07,15.71a6.95,6.95,0,0,0,9.45,2.53h0a6.94,6.94,0,0,0,2.53-9.44Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M374.86,145.08l4.69,17.52a13.14,13.14,0,0,1-9.26,16.05h0a13.13,13.13,0,0,1-16-9.26l-4.7-17.53a13.14,13.14,0,0,1,9.26-16.05h0a13.13,13.13,0,0,1,16.05,9.27Zm-1.28,19.13-4.7-17.53a6.94,6.94,0,0,0-8.47-4.89h0a6.95,6.95,0,0,0-4.88,8.47l4.69,17.52a6.94,6.94,0,0,0,8.47,4.89h0a6.93,6.93,0,0,0,4.89-8.46Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M383.11,192.2v18.15a13.13,13.13,0,0,1-13.1,13.1h0a13.14,13.14,0,0,1-13.1-13.1V192.2A13.14,13.14,0,0,1,370,179.1h0a13.13,13.13,0,0,1,13.1,13.1Zm-6.18,18.15V192.2a6.95,6.95,0,0,0-6.92-6.91h0a6.93,6.93,0,0,0-6.91,6.91v18.15a6.93,6.93,0,0,0,6.91,6.91h0a6.95,6.95,0,0,0,6.92-6.91Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M378.89,239.86l-4.7,17.53a13.13,13.13,0,0,1-16,9.26h0a13.13,13.13,0,0,1-9.26-16l4.7-17.53a13.13,13.13,0,0,1,16-9.26h0a13.13,13.13,0,0,1,9.26,16Zm-10.67,15.93,4.7-17.53a6.94,6.94,0,0,0-4.89-8.47h0a7,7,0,0,0-8.47,4.89l-4.7,17.53a6.94,6.94,0,0,0,4.89,8.47h0a6.94,6.94,0,0,0,8.47-4.89Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M362.48,284.8l-9.08,15.72a13.12,13.12,0,0,1-17.89,4.79h0a13.12,13.12,0,0,1-4.79-17.89l9.07-15.71a13.12,13.12,0,0,1,17.89-4.8h0a13.12,13.12,0,0,1,4.8,17.89Zm-14.43,12.63,9.07-15.72a6.94,6.94,0,0,0-2.53-9.44h0a6.94,6.94,0,0,0-9.44,2.53l-9.08,15.71A6.95,6.95,0,0,0,338.6,300h0a6.95,6.95,0,0,0,9.45-2.53Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M335,324,322.16,336.8a13.13,13.13,0,0,1-18.52,0h0a13.12,13.12,0,0,1,0-18.53l12.83-12.83a13.13,13.13,0,0,1,18.52,0h0A13.12,13.12,0,0,1,335,324Zm-17.2,8.46,12.83-12.84a6.94,6.94,0,0,0,0-9.77h0a6.93,6.93,0,0,0-9.78,0L308,322.65a7,7,0,0,0,0,9.78h0a7,7,0,0,0,9.78,0Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M298.31,354.68l-15.72,9.07A13.12,13.12,0,0,1,264.7,359h0a13.12,13.12,0,0,1,4.79-17.89L285.21,332a13.13,13.13,0,0,1,17.89,4.8h0a13.12,13.12,0,0,1-4.79,17.89ZM279.5,358.4l15.72-9.07a7,7,0,0,0,2.53-9.45h0a7,7,0,0,0-9.45-2.53l-15.71,9.07a6.95,6.95,0,0,0-2.53,9.45h0a6.94,6.94,0,0,0,9.44,2.53Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M254.92,374.86l-17.52,4.69a13.14,13.14,0,0,1-16.05-9.26h0a13.13,13.13,0,0,1,9.26-16l17.53-4.7a13.14,13.14,0,0,1,16.05,9.26h0a13.13,13.13,0,0,1-9.27,16.05Zm-19.13-1.28,17.53-4.7a6.94,6.94,0,0,0,4.89-8.47h0a6.95,6.95,0,0,0-8.47-4.88l-17.52,4.69a6.94,6.94,0,0,0-4.89,8.47h0a6.93,6.93,0,0,0,8.46,4.89Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.8,383.11H189.65a13.13,13.13,0,0,1-13.1-13.1h0a13.14,13.14,0,0,1,13.1-13.1H207.8A13.14,13.14,0,0,1,220.9,370h0a13.13,13.13,0,0,1-13.1,13.1Zm-18.15-6.18H207.8a6.95,6.95,0,0,0,6.91-6.92h0a6.93,6.93,0,0,0-6.91-6.91H189.65a6.93,6.93,0,0,0-6.91,6.91h0a6.95,6.95,0,0,0,6.91,6.92Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M160.14,378.89l-17.53-4.69a13.15,13.15,0,0,1-9.26-16.05h0a13.13,13.13,0,0,1,16-9.26l17.53,4.7a13.13,13.13,0,0,1,9.26,16h0a13.13,13.13,0,0,1-16,9.26Zm-15.93-10.67,17.53,4.7A6.93,6.93,0,0,0,170.2,368h0a7,7,0,0,0-4.89-8.47l-17.53-4.7a6.94,6.94,0,0,0-8.47,4.89h0a6.94,6.94,0,0,0,4.89,8.47Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M115.2,362.48,99.48,353.4a13.12,13.12,0,0,1-4.79-17.89h0a13.12,13.12,0,0,1,17.89-4.79l15.71,9.07a13.14,13.14,0,0,1,4.8,17.89h0a13.12,13.12,0,0,1-17.89,4.8Zm-12.63-14.43,15.72,9.07a6.94,6.94,0,0,0,9.44-2.53h0a6.94,6.94,0,0,0-2.53-9.44l-15.71-9.08A6.95,6.95,0,0,0,100,338.6h0a6.95,6.95,0,0,0,2.53,9.45Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M76,335,63.2,322.16a13.13,13.13,0,0,1,0-18.52h0a13.12,13.12,0,0,1,18.53,0l12.83,12.83a13.13,13.13,0,0,1,0,18.52h0A13.12,13.12,0,0,1,76,335Zm-8.45-17.2,12.83,12.83a6.94,6.94,0,0,0,9.77,0h0a6.93,6.93,0,0,0,0-9.78L77.35,308a6.94,6.94,0,0,0-9.77,0h0a6.93,6.93,0,0,0,0,9.78Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M45.32,298.31l-9.07-15.72A13.12,13.12,0,0,1,41,264.7h0a13.12,13.12,0,0,1,17.89,4.79L68,285.21a13.13,13.13,0,0,1-4.8,17.89h0a13.12,13.12,0,0,1-17.89-4.79ZM41.6,279.5l9.07,15.72a7,7,0,0,0,9.45,2.53h0a7,7,0,0,0,2.53-9.45l-9.07-15.71a6.95,6.95,0,0,0-9.45-2.53h0a6.94,6.94,0,0,0-2.53,9.44Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M25.14,254.92,20.45,237.4a13.14,13.14,0,0,1,9.26-16.05h0a13.13,13.13,0,0,1,16,9.26l4.7,17.53a13.14,13.14,0,0,1-9.26,16.05h0a13.13,13.13,0,0,1-16-9.27Zm1.28-19.13,4.7,17.53a6.94,6.94,0,0,0,8.47,4.89h0a6.95,6.95,0,0,0,4.88-8.47l-4.69-17.52a6.94,6.94,0,0,0-8.47-4.89h0a6.93,6.93,0,0,0-4.89,8.46Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M16.89,207.8V189.65A13.13,13.13,0,0,1,30,176.55h0a13.14,13.14,0,0,1,13.1,13.1V207.8A13.14,13.14,0,0,1,30,220.9h0a13.13,13.13,0,0,1-13.1-13.1Zm6.18-18.15V207.8A6.95,6.95,0,0,0,30,214.71h0a6.93,6.93,0,0,0,6.91-6.91V189.65A6.93,6.93,0,0,0,30,182.74h0a6.95,6.95,0,0,0-6.92,6.91Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M21.11,160.14l4.69-17.53a13.14,13.14,0,0,1,16.05-9.26h0a13.13,13.13,0,0,1,9.26,16l-4.7,17.53a13.13,13.13,0,0,1-16,9.26h0a13.13,13.13,0,0,1-9.26-16Zm10.67-15.93-4.7,17.53A6.94,6.94,0,0,0,32,170.21h0a7,7,0,0,0,8.47-4.89l4.7-17.53a6.94,6.94,0,0,0-4.89-8.47h0a6.94,6.94,0,0,0-8.47,4.89Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M37.52,115.2l9.07-15.72a13.13,13.13,0,0,1,17.9-4.79h0a13.12,13.12,0,0,1,4.79,17.89l-9.07,15.71a13.12,13.12,0,0,1-17.89,4.8h0a13.12,13.12,0,0,1-4.8-17.89ZM52,102.57l-9.07,15.72a6.94,6.94,0,0,0,2.53,9.44h0a6.94,6.94,0,0,0,9.44-2.53l9.08-15.71A6.95,6.95,0,0,0,61.4,100h0A6.94,6.94,0,0,0,52,102.57Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M65,76,77.84,63.2a13.13,13.13,0,0,1,18.52,0h0a13.12,13.12,0,0,1,0,18.53L83.53,94.56a13.13,13.13,0,0,1-18.52,0h0A13.12,13.12,0,0,1,65,76Zm17.2-8.46L69.38,80.41a6.94,6.94,0,0,0,0,9.77h0a6.93,6.93,0,0,0,9.78,0L92,77.35a7,7,0,0,0,0-9.78h0a7,7,0,0,0-9.78,0Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M101.69,45.32l15.72-9.07A13.12,13.12,0,0,1,135.3,41h0a13.12,13.12,0,0,1-4.79,17.89L114.79,68a13.13,13.13,0,0,1-17.89-4.8h0a13.12,13.12,0,0,1,4.79-17.89ZM120.5,41.6l-15.72,9.07a7,7,0,0,0-2.53,9.45h0a7,7,0,0,0,9.45,2.53l15.71-9.07a6.95,6.95,0,0,0,2.53-9.45h0a6.94,6.94,0,0,0-9.44-2.53Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M145.08,25.14l17.52-4.69a13.14,13.14,0,0,1,16.05,9.26h0a13.13,13.13,0,0,1-9.27,16l-17.52,4.7a13.14,13.14,0,0,1-16.05-9.26h0a13.13,13.13,0,0,1,9.27-16Zm19.13,1.28-17.53,4.7a6.94,6.94,0,0,0-4.89,8.47h0a6.95,6.95,0,0,0,8.47,4.88l17.52-4.69a6.94,6.94,0,0,0,4.89-8.47h0a6.93,6.93,0,0,0-8.46-4.89Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M206.81,36.18a6.19,6.19,0,1,1,1.8-12.24l24,3.52a6.19,6.19,0,1,1-1.79,12.24Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.26,33.12a3.09,3.09,0,1,1,.9-6.12l24,3.52a3.09,3.09,0,0,1-.9,6.12Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M124,54.72a6.19,6.19,0,0,1-4.57-11.5l22.57-9a6.18,6.18,0,1,1,4.57,11.49Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M122.85,51.84a3.09,3.09,0,1,1-2.29-5.74l22.57-9a3.09,3.09,0,0,1,2.29,5.75Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M164.18,40a6.19,6.19,0,0,1-1.43-12.29l24.11-2.82a6.19,6.19,0,1,1,1.44,12.29Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M163.82,36.92a3.09,3.09,0,1,1-.72-6.14L187.22,28a3.09,3.09,0,0,1,.72,6.14Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M287.81,61.53a6.19,6.19,0,0,1,7.68-9.7l19,15.06a6.18,6.18,0,1,1-7.67,9.7Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M289.73,59.11a3.09,3.09,0,1,1,3.84-4.85l19.05,15.05a3.1,3.1,0,0,1-3.84,4.86Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M320.66,89a6.19,6.19,0,1,1,9.92-7.39l14.5,19.48a6.19,6.19,0,0,1-9.92,7.39Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M323.14,87.13a3.09,3.09,0,1,1,5-3.69l14.5,19.47a3.09,3.09,0,1,1-5,3.7Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M345.28,124a6.19,6.19,0,0,1,11.5-4.57l9,22.57a6.18,6.18,0,0,1-11.49,4.57Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M348.16,122.85a3.09,3.09,0,1,1,5.74-2.29l9,22.57a3.09,3.09,0,0,1-5.75,2.29Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M43.52,151a6.19,6.19,0,0,1-11.36-4.9l9.62-22.3a6.19,6.19,0,1,1,11.36,4.9Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M40.68,149.79A3.09,3.09,0,1,1,35,147.34l9.62-22.29a3.09,3.09,0,1,1,5.68,2.45Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M61.53,112.19a6.19,6.19,0,1,1-9.7-7.68l15.06-19a6.18,6.18,0,1,1,9.7,7.67Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M59.11,110.27a3.09,3.09,0,1,1-4.85-3.84L69.31,87.38a3.1,3.1,0,0,1,4.86,3.84Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M89,79.34a6.19,6.19,0,1,1-7.39-9.92l19.48-14.5a6.19,6.19,0,0,1,7.39,9.92Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M87.13,76.86a3.09,3.09,0,1,1-3.69-5l19.47-14.5a3.09,3.09,0,1,1,3.7,5Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M356.48,249a6.19,6.19,0,1,1,11.36,4.9l-9.62,22.3a6.19,6.19,0,0,1-11.36-4.9Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M359.32,250.21a3.09,3.09,0,1,1,5.68,2.45L355.38,275a3.09,3.09,0,1,1-5.68-2.45Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M338.47,287.81a6.19,6.19,0,0,1,9.7,7.68l-15.06,19a6.18,6.18,0,1,1-9.7-7.67Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M340.89,289.73a3.09,3.09,0,1,1,4.85,3.84l-15.06,19.05a3.09,3.09,0,0,1-4.85-3.84Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M311,320.66a6.19,6.19,0,1,1,7.39,9.92l-19.48,14.5a6.19,6.19,0,0,1-7.39-9.92Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M312.87,323.14a3.09,3.09,0,1,1,3.69,5l-19.48,14.5a3.09,3.09,0,0,1-3.69-5Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M276,345.28a6.19,6.19,0,0,1,4.57,11.5l-22.57,9a6.18,6.18,0,0,1-4.57-11.49Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M277.15,348.16a3.09,3.09,0,1,1,2.28,5.74l-22.56,9a3.09,3.09,0,1,1-2.29-5.75Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M235.82,360a6.19,6.19,0,0,1,1.43,12.29l-24.11,2.82a6.19,6.19,0,1,1-1.44-12.29Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M236.18,363.08a3.09,3.09,0,0,1,.72,6.14L212.78,372a3.09,3.09,0,1,1-.72-6.14Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M193.18,363.82a6.19,6.19,0,1,1-1.79,12.24l-24-3.52a6.19,6.19,0,1,1,1.79-12.24Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M192.74,366.88a3.09,3.09,0,1,1-.9,6.12l-24-3.52a3.09,3.09,0,0,1,.9-6.12Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M151,356.48a6.19,6.19,0,0,1-4.9,11.36l-22.3-9.62a6.19,6.19,0,1,1,4.9-11.36Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M149.79,359.32a3.09,3.09,0,1,1-2.45,5.68l-22.29-9.62a3.09,3.09,0,1,1,2.45-5.68Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M112.19,338.47a6.19,6.19,0,1,1-7.68,9.7l-19-15.06a6.18,6.18,0,1,1,7.67-9.7Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M110.27,340.89a3.09,3.09,0,1,1-3.84,4.85L87.38,330.69a3.1,3.1,0,0,1,3.84-4.86Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M79.34,311a6.19,6.19,0,1,1-9.92,7.39l-14.5-19.48a6.19,6.19,0,0,1,9.92-7.39Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M76.86,312.87a3.09,3.09,0,1,1-5,3.69L57.4,297.09a3.09,3.09,0,0,1,5-3.7Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M54.72,276a6.19,6.19,0,0,1-11.5,4.57l-9-22.57a6.18,6.18,0,0,1,11.49-4.57Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M51.84,277.15a3.09,3.09,0,1,1-5.74,2.29l-9-22.57a3.09,3.09,0,0,1,5.75-2.29Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M40,235.82a6.19,6.19,0,1,1-12.29,1.43l-2.82-24.11a6.19,6.19,0,1,1,12.29-1.44Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M36.92,236.18a3.09,3.09,0,0,1-6.14.72L28,212.78a3.09,3.09,0,0,1,6.14-.72Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M36.18,193.19a6.19,6.19,0,0,1-12.24-1.8l3.52-24a6.19,6.19,0,1,1,12.24,1.79Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M33.12,192.74a3.09,3.09,0,0,1-6.12-.9l3.52-24a3.09,3.09,0,0,1,6.12.9Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M360,164.18a6.19,6.19,0,1,1,12.29-1.43l2.82,24.11a6.19,6.19,0,1,1-12.29,1.44Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M363.08,163.82a3.09,3.09,0,1,1,6.14-.72L372,187.22a3.09,3.09,0,0,1-6.14.72Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M363.82,206.81a6.19,6.19,0,0,1,12.24,1.8l-3.52,24a6.19,6.19,0,1,1-12.24-1.79Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M366.88,207.26a3.09,3.09,0,0,1,6.12.9l-3.52,24a3.09,3.09,0,0,1-6.12-.9Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249,43.52a6.19,6.19,0,1,1,4.9-11.36l22.3,9.62a6.19,6.19,0,0,1-4.9,11.36Z',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M250.21,40.68A3.09,3.09,0,1,1,252.66,35L275,44.62a3.09,3.09,0,1,1-2.45,5.68Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M243.46,164.35s-5.85-1.12-6.78-9.21l9.35-6.71s-6.61-2.15-12.56,1.61c-4.84,3.06-4.87,9.83-4.87,9.83s-1,5.59-7.25,11.66-46.44,47.15-49.89,50.36-8.16,8.73-16.77,12l-.48.1A9.3,9.3,0,1,0,166,243.7a34.49,34.49,0,0,1,8.41-12.63c6.86-6.77,54.5-55.31,56-56.62s5.62-2.82,8.28-3a15.85,15.85,0,0,0,10-3.75c3.05-2.74,3.76-5.79,3.82-9.52Zm-85,84.55a6.25,6.25,0,1,1,4.31-7.71A6.24,6.24,0,0,1,158.44,248.9Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M178.65,171.53c-6.29-6.07-7.25-11.66-7.25-11.66s0-6.77-4.87-9.83c-5.95-3.76-12.56-1.61-12.56-1.61l9.35,6.71c-.93,8.09-6.78,9.21-6.78,9.21l-9.09-6.16c.06,3.73.77,6.78,3.82,9.52a15.85,15.85,0,0,0,10,3.75c2.66.17,6.77,1.68,8.28,3,.8.69,14.37,14.46,28,28.34,2-2,4-4.06,6-6.07C192.69,185.63,181.7,174.48,178.65,171.53Zm67.14,62.41-.48-.1c-8.61-3.22-13.36-8.77-16.77-12-1.47-1.37-9.61-9.62-18.95-19.1l-6,6.06c10.13,10.28,19.27,19.54,22,22.22A34.49,34.49,0,0,1,234,243.7a9.29,9.29,0,1,0,11.78-9.76Zm3.48,10.65a6.25,6.25,0,1,1-4.31-7.72A6.24,6.24,0,0,1,249.27,244.59Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'140 185.19 143.37 194.72 153.46 194.98 145.45 201.12 148.32 210.81 140 205.08 131.68 210.81 134.55 201.12 126.54 194.98 136.63 194.72 140 185.19',className:'Badge__SecondFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'260 185.19 263.37 194.72 273.46 194.98 265.45 201.12 268.32 210.81 260 205.08 251.68 210.81 254.55 201.12 246.54 194.98 256.63 194.72 260 185.19',className:'Badge__SecondFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'200 125.19 203.37 134.72 213.46 134.98 205.45 141.12 208.32 150.81 200 145.08 191.68 150.81 194.55 141.12 186.54 134.98 196.63 134.72 200 125.19',className:'Badge__SecondFillColor',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'200 235.19 203.37 244.72 213.46 244.98 205.45 251.12 208.32 260.81 200 255.08 191.68 260.81 194.55 251.12 186.54 244.98 196.63 244.72 200 235.19',className:'Badge__SecondFillColor',fillRule:'evenodd'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Bitter',fontSize:languageSettings.small?'1.4em':'1.8em',fontWeight:'700',letterSpacing:'0.09em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_12__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Anton',fontSize:languageSettings.small?'1.3em':'1.6em',letterSpacing:'0.1em',className:'Badge__ThirdFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_12__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(118);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_13',title:'Radial_13',colors:3,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_13 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_13__TopCircle',d:'M 90 200 A 50 50 0 0 1 310 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_13__BottomCircle',d:'M 90 200 A 50 50 0 0 0 310 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M399.92,205.43c.05-1.8.08-3.61.08-5.43s0-3.63-.08-5.43a17.28,17.28,0,0,1-3.21-31q-1-5.34-2.24-10.6a17.27,17.27,0,0,1-9.6-29.63q-2.06-5-4.39-9.89a17.26,17.26,0,0,1-15.55-27q-3.07-4.47-6.37-8.77A17.24,17.24,0,0,1,337.8,54.62c-2.62-2.5-5.31-4.91-8.05-7.27A17.22,17.22,0,0,1,304.65,29q-4.59-2.84-9.34-5.44a17.2,17.2,0,0,1-28.38-12.67q-5.07-1.81-10.27-3.35A17.16,17.16,0,0,1,239.42,14,17.2,17.2,0,0,1,226.28,1.13Q220.94.43,215.52,0A17.2,17.2,0,0,1,200,9.81,17.2,17.2,0,0,1,184.48,0c-3.62.28-7.2.66-10.76,1.13A17.23,17.23,0,0,1,160.58,14a17.19,17.19,0,0,1-17.24-6.39q-5.19,1.55-10.27,3.35A17.2,17.2,0,0,1,104.69,23.6Q99.94,26.19,95.35,29a17.22,17.22,0,0,1-25.1,18.32c-2.74,2.35-5.43,4.76-8,7.26A17.24,17.24,0,0,1,41.44,77.75q-3.3,4.29-6.37,8.77a17.26,17.26,0,0,1-15.55,27q-2.34,4.88-4.39,9.89a17.29,17.29,0,0,1,4.52,17.86A17.2,17.2,0,0,1,5.53,153q-1.25,5.25-2.24,10.61a17.25,17.25,0,0,1,8.12,16.51A17.23,17.23,0,0,1,.07,194.57C0,196.37,0,198.18,0,200s0,3.63.07,5.43a17.23,17.23,0,0,1,11.34,14.45A17.27,17.27,0,0,1,3.29,236.4q1,5.34,2.24,10.6a17.2,17.2,0,0,1,14.12,11.77,17.28,17.28,0,0,1-4.52,17.86c1.37,3.34,2.83,6.65,4.39,9.89a17.26,17.26,0,0,1,15.55,27q3.07,4.47,6.37,8.78A17.23,17.23,0,0,1,62.2,345.38q3.93,3.75,8,7.27A17.22,17.22,0,0,1,95.35,371q4.59,2.84,9.34,5.44a17.2,17.2,0,0,1,28.38,12.68q5.07,1.8,10.27,3.34a17.19,17.19,0,0,1,30.38,6.45c3.56.47,7.14.85,10.76,1.13a17.18,17.18,0,0,1,31,0q5.41-.42,10.76-1.13a17.19,17.19,0,0,1,30.38-6.45q5.19-1.53,10.27-3.34a17.2,17.2,0,0,1,28.38-12.68q4.76-2.59,9.34-5.44a17.22,17.22,0,0,1,25.1-18.31q4.11-3.52,8.05-7.27a17.23,17.23,0,0,1,20.76-23.12q3.3-4.31,6.37-8.78a17.26,17.26,0,0,1,15.55-27c1.56-3.24,3-6.55,4.39-9.89a17.27,17.27,0,0,1,9.6-29.63q1.25-5.25,2.24-10.6a17.28,17.28,0,0,1,3.21-31Z',className:'Badge__FirstFillColor DOTS'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'DOTS2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M212.23,27.71h0c-6.09,0-6.1,4.72-12.21,4.72s-6.12-4.71-12.21-4.72h0a8.4,8.4,0,0,0,0,16.8h0c6.09,0,6.1-4.72,12.21-4.72s6.12,4.7,12.21,4.72h0a8.4,8.4,0,0,0,0-16.8ZM187.77,38.34A2.23,2.23,0,1,1,190,36.11,2.22,2.22,0,0,1,187.77,38.34Zm24.45,0a2.23,2.23,0,1,1,2.23-2.23A2.22,2.22,0,0,1,212.22,38.34Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M212.23,355.49h0c-6.09,0-6.1,4.72-12.21,4.72s-6.12-4.7-12.21-4.72h0a8.4,8.4,0,0,0,0,16.8h0c6.09,0,6.1-4.72,12.21-4.72s6.12,4.71,12.21,4.72h0a8.4,8.4,0,0,0,0-16.8Zm-24.46,10.63a2.23,2.23,0,1,1,2.23-2.23A2.22,2.22,0,0,1,187.77,366.12Zm24.45,0a2.23,2.23,0,1,1,2.23-2.23A2.22,2.22,0,0,1,212.22,366.12Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M167.35,30.41h0c-5.87,1.6-4.67,6.14-10.57,7.73s-7.13-3-13-1.39h0A8.39,8.39,0,0,0,148.06,53h0c5.88-1.6,4.67-6.14,10.58-7.73s7.12,3,13,1.39h0a8.4,8.4,0,0,0-4.34-16.22ZM146.47,47a2.23,2.23,0,1,1,1.58-2.73A2.22,2.22,0,0,1,146.47,47Zm23.62-6.34a2.24,2.24,0,1,1,1.58-2.74A2.23,2.23,0,0,1,170.09,40.68Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M251.94,347h0c-5.88,1.6-4.68,6.14-10.58,7.73s-7.12-2.95-13-1.39h0a8.4,8.4,0,0,0,4.34,16.22h0c5.88-1.6,4.68-6.14,10.58-7.73s7.13,3,13,1.39h0A8.39,8.39,0,0,0,251.94,347Zm-20.88,16.62a2.24,2.24,0,1,1,1.57-2.74A2.23,2.23,0,0,1,231.06,363.64Zm23.62-6.35a2.23,2.23,0,1,1,1.57-2.74A2.23,2.23,0,0,1,254.68,357.29Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M124.7,44.66h0c-5.27,3.07-2.94,7.14-8.23,10.21s-7.64-1-12.92,2h0a8.39,8.39,0,0,0,8.37,14.55h0c5.27-3.06,2.93-7.14,8.22-10.21s7.65,1,12.93-2h0a8.4,8.4,0,0,0-8.38-14.55ZM108.82,66.13a2.23,2.23,0,1,1,.82-3A2.22,2.22,0,0,1,108.82,66.13ZM130,53.87a2.23,2.23,0,1,1,.81-3A2.22,2.22,0,0,1,130,53.87Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M288.11,328.52h0c-5.27,3.06-2.93,7.14-8.22,10.21s-7.65-1-12.93,2h0a8.4,8.4,0,0,0,8.38,14.55h0c5.27-3.07,2.94-7.14,8.23-10.21s7.64,1,12.92-2h0a8.39,8.39,0,0,0-8.37-14.55ZM272.23,350A2.23,2.23,0,1,1,273,347,2.22,2.22,0,0,1,272.23,350Zm21.17-12.26a2.23,2.23,0,1,1,.82-3.05A2.23,2.23,0,0,1,293.4,337.74Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M87.18,69.5h0c-4.3,4.33-1,7.66-5.31,12s-7.64,1-12,5.32h0A8.39,8.39,0,0,0,81.73,98.73h0c4.3-4.33,1-7.66,5.31-12s7.64-1,12-5.32h0A8.39,8.39,0,0,0,87.18,69.5ZM77.39,94.36a2.23,2.23,0,1,1,0-3.16A2.23,2.23,0,0,1,77.39,94.36ZM94.68,77a2.23,2.23,0,1,1,0-3.16A2.23,2.23,0,0,1,94.68,77Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M318.27,301.27h0s0,0,0,0c-4.3,4.33-1,7.66-5.31,12s-7.65,1-12,5.33h0a8.39,8.39,0,0,0,11.85,11.88h0c4.3-4.33,1-7.66,5.31-12s7.64-1,12-5.32h0a8.39,8.39,0,0,0-11.84-11.88Zm-9.8,24.87a2.23,2.23,0,0,1-3.15,0,2.26,2.26,0,0,1,0-3.16,2.23,2.23,0,0,1,3.15,3.16Zm17.29-17.34a2.23,2.23,0,1,1,0-3.16A2.23,2.23,0,0,1,325.76,308.8Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M57.35,103.23h0c-3,5.3,1,7.66-2,13s-7.12,3-10.18,8.25h0a8.38,8.38,0,1,0,14.51,8.4h0c3-5.3-1-7.66,2-13s7.12-3,10.18-8.25v0h0a8.38,8.38,0,1,0-14.51-8.4ZM54.3,129.79a2.22,2.22,0,1,1-.81-3A2.22,2.22,0,0,1,54.3,129.79Zm12.23-21.24a2.23,2.23,0,1,1-.81-3A2.22,2.22,0,0,1,66.53,108.55Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M340.37,267.12h0c-3,5.3,1,7.66-2,13s-7.12,3-10.18,8.25h0a8.38,8.38,0,1,0,14.51,8.4h0v0c3-5.3-1-7.66,2-13s7.12-3,10.18-8.25h0a8.38,8.38,0,1,0-14.51-8.4Zm-3,26.56a2.23,2.23,0,1,1-.82-3.05A2.23,2.23,0,0,1,337.33,293.68Zm12.22-21.24a2.22,2.22,0,1,1-.81-3.05A2.22,2.22,0,0,1,349.55,272.44Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M37.24,143.56h0v0c-1.56,5.9,3,7.13,1.39,13s-6.11,4.71-7.71,10.61h0a8.38,8.38,0,1,0,16.18,4.34h0c1.56-5.91-3-7.14-1.38-13.06s6.11-4.71,7.7-10.6v0h0a8.38,8.38,0,1,0-16.18-4.35ZM41.15,170a2.23,2.23,0,1,1-1.57-2.73A2.22,2.22,0,0,1,41.15,170Zm6.33-23.68a2.23,2.23,0,1,1-1.58-2.74A2.24,2.24,0,0,1,47.48,146.32Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M352.91,228.4h0c-1.56,5.91,3,7.13,1.38,13.06s-6.11,4.71-7.7,10.6v0h0a8.38,8.38,0,1,0,16.18,4.35h0v0c1.57-5.9-3-7.13-1.38-13.05s6.11-4.71,7.71-10.61h0a8.38,8.38,0,1,0-16.18-4.34Zm3.91,26.44a2.23,2.23,0,1,1-1.57-2.74A2.22,2.22,0,0,1,356.82,254.84Zm6.33-23.69a2.23,2.23,0,1,1-1.57-2.73A2.23,2.23,0,0,1,363.15,231.15Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M28.22,187.73h0c0,6.11,4.71,6.12,4.71,12.25s-4.69,6.14-4.71,12.25h0a8.38,8.38,0,1,0,16.75,0h0c0-6.11-4.7-6.12-4.7-12.25S45,193.86,45,187.75h0a8.38,8.38,0,1,0-16.75,0Zm10.6,24.53A2.23,2.23,0,1,1,36.6,210,2.22,2.22,0,0,1,38.82,212.26Zm0-24.52a2.23,2.23,0,1,1-2.22-2.24A2.22,2.22,0,0,1,38.82,187.74Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M355,187.73h0c0,6.11,4.7,6.12,4.7,12.25s-4.69,6.14-4.7,12.25h0a8.38,8.38,0,1,0,16.75,0h0c0-6.11-4.7-6.12-4.7-12.25s4.68-6.14,4.7-12.25h0a8.38,8.38,0,1,0-16.75,0Zm10.6,24.53A2.23,2.23,0,1,1,363.4,210,2.23,2.23,0,0,1,365.63,212.26Zm0-24.52a2.23,2.23,0,1,1-2.23-2.23A2.23,2.23,0,0,1,365.63,187.74Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M30.91,232.74h0c1.6,5.9,6.13,4.69,7.71,10.61s-2.94,7.15-1.39,13.05v0h0a8.38,8.38,0,1,0,16.18-4.35h0v0c-1.59-5.89-6.12-4.69-7.7-10.61s2.95-7.14,1.39-13.05h0a8.38,8.38,0,1,0-16.18,4.35Zm16.57,20.94a2.23,2.23,0,1,1-2.73-1.58A2.24,2.24,0,0,1,47.48,253.68ZM41.15,230a2.23,2.23,0,1,1-2.73-1.58A2.23,2.23,0,0,1,41.15,230Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M346.58,147.91h0c1.59,5.9,6.12,4.69,7.7,10.61s-2.94,7.15-1.38,13.06h0a8.38,8.38,0,1,0,16.18-4.35h0c-1.6-5.9-6.13-4.69-7.71-10.61s2.95-7.15,1.38-13v0h0a8.38,8.38,0,1,0-16.18,4.35Zm16.57,20.94a2.23,2.23,0,1,1-2.73-1.58A2.23,2.23,0,0,1,363.15,168.85Zm-6.33-23.69a2.23,2.23,0,1,1-2.72-1.58A2.22,2.22,0,0,1,356.82,145.16Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M45.12,275.52h0s0,0,0,0c3.06,5.28,7.12,2.94,10.18,8.24s-1,7.67,2,13v0h0a8.38,8.38,0,1,0,14.51-8.4h0c-3.06-5.28-7.13-2.94-10.18-8.25s1-7.66-2-13h0a8.38,8.38,0,1,0-14.51,8.4Zm21.41,15.93a2.23,2.23,0,1,1-3-.82A2.23,2.23,0,0,1,66.53,291.45ZM54.31,270.21a2.24,2.24,0,0,1-.82,3.05,2.23,2.23,0,1,1,.82-3.05Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M328.14,111.63h0v0c3,5.28,7.12,2.94,10.17,8.25s-1,7.66,2,13h0a8.38,8.38,0,1,0,14.51-8.4h0c-3.06-5.28-7.12-2.94-10.18-8.25s1-7.66-2-13v0h0a8.38,8.38,0,1,0-14.51,8.4Zm21.41,15.93a2.22,2.22,0,1,1-3-.82A2.24,2.24,0,0,1,349.55,127.56Zm-12.22-21.24a2.23,2.23,0,1,1-3-.82A2.24,2.24,0,0,1,337.33,106.32Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M69.89,313.15h0c4.32,4.31,7.64,1,12,5.32s1,7.67,5.31,12h0A8.39,8.39,0,0,0,99,318.62h0c-4.31-4.31-7.64-1-12-5.33s-1-7.66-5.31-12c0,0,0,0,0,0h0a8.39,8.39,0,0,0-11.84,11.88ZM94.68,323a2.26,2.26,0,0,1,0,3.16,2.23,2.23,0,1,1,0-3.16ZM77.39,305.64a2.23,2.23,0,1,1-3.15,0A2.24,2.24,0,0,1,77.39,305.64Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M301,81.38h0c4.31,4.31,7.64,1,12,5.32s1,7.67,5.31,12h0a8.39,8.39,0,1,0,11.84-11.88h0c-4.32-4.31-7.64-1-12-5.32s-1-7.67-5.31-12h0A8.39,8.39,0,0,0,301,81.38Zm24.79,9.82a2.23,2.23,0,1,1-3.15,0A2.24,2.24,0,0,1,325.76,91.2ZM308.47,73.86a2.23,2.23,0,1,1-3.14,0A2.23,2.23,0,0,1,308.47,73.86Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M103.52,343.07h0c5.28,3,7.63-1,12.92,2s3,7.14,8.23,10.21h0a8.4,8.4,0,0,0,8.38-14.55h0a0,0,0,0,0,0,0c-5.28-3-7.63,1-12.93-2s-2.95-7.15-8.22-10.22h0a8.39,8.39,0,0,0-8.37,14.55ZM130,346.13a2.23,2.23,0,1,1-3,.82A2.22,2.22,0,0,1,130,346.13Zm-21.17-12.26a2.23,2.23,0,1,1-3,.81A2.24,2.24,0,0,1,108.83,333.87Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M266.92,59.21h0c5.28,3,7.63-1,12.93,2s2.95,7.15,8.22,10.21h0a8.39,8.39,0,0,0,8.37-14.55h0c-5.28-3-7.63,1-12.92-2s-3-7.14-8.23-10.21h0a8.4,8.4,0,0,0-8.38,14.55Zm26.48,3a2.23,2.23,0,1,1-3,.82A2.24,2.24,0,0,1,293.4,62.26ZM272.23,50a2.23,2.23,0,1,1-3,.82A2.23,2.23,0,0,1,272.23,50Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M143.73,363.24h0c5.88,1.56,7.11-3,13-1.39s4.7,6.13,10.58,7.73h0a8.4,8.4,0,0,0,4.34-16.22h0c-5.89-1.56-7.11,3-13,1.39s-4.7-6.13-10.58-7.73h0a8.39,8.39,0,0,0-4.33,16.22Zm26.37-3.92a2.24,2.24,0,1,1-2.73,1.58A2.24,2.24,0,0,1,170.1,359.32ZM146.48,353a2.24,2.24,0,1,1-2.73,1.58A2.24,2.24,0,0,1,146.48,353Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M228.31,46.63h0c5.89,1.57,7.11-3,13-1.38S246,51.38,251.92,53h0a8.4,8.4,0,0,0,4.33-16.23h0c-5.89-1.57-7.12,3-13,1.39s-4.7-6.13-10.57-7.73h0a8.4,8.4,0,0,0-4.34,16.23Zm26.37-3.92A2.23,2.23,0,1,1,252,44.29,2.23,2.23,0,0,1,254.68,42.71Zm-23.62-6.35a2.23,2.23,0,1,1-2.73,1.58A2.23,2.23,0,0,1,231.06,36.36Z',className:'Badge__ThirdFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M150.74,244.15a30.37,30.37,0,1,1,30.37-30.37A30.41,30.41,0,0,1,150.74,244.15Zm0-58.19a27.83,27.83,0,1,0,27.83,27.82A27.85,27.85,0,0,0,150.74,186Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M150.74,246.69a32.91,32.91,0,1,1,32.91-32.91A32.95,32.95,0,0,1,150.74,246.69Zm0-62.59a29.69,29.69,0,1,0,29.69,29.68A29.71,29.71,0,0,0,150.74,184.1Z',className:'Badge__ThirdFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M191.93,210.18h0l-41.16-1.64h0a3.7,3.7,0,0,0-1.1,7.23h0l39.46,12.1h0a8.93,8.93,0,0,0,2.8.45,9.07,9.07,0,0,0,0-18.13Zm-38.08.07,33.22,1.32a9,9,0,0,0-2.25,13.32L153,215.14a3.66,3.66,0,0,0,.83-4.89Zm-5.22,2a2.12,2.12,0,0,1,2.11-2.11h0a2.11,2.11,0,1,1-2.12,2.11Zm43.27,14.48a7.48,7.48,0,1,1,7.47-7.48A7.48,7.48,0,0,1,191.9,226.72Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249.26,244.15a30.37,30.37,0,1,1,30.37-30.37A30.4,30.4,0,0,1,249.26,244.15Zm0-58.19a27.83,27.83,0,1,0,27.82,27.82A27.86,27.86,0,0,0,249.26,186Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249.26,246.69a32.91,32.91,0,1,1,32.91-32.91A32.94,32.94,0,0,1,249.26,246.69Zm0-62.59a29.69,29.69,0,1,0,29.68,29.68A29.72,29.72,0,0,0,249.26,184.1Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M252.16,212.24a2.91,2.91,0,1,1-2.9-2.91A2.9,2.9,0,0,1,252.16,212.24Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M240.21,172.59a1.27,1.27,0,0,1-.35-2.49,29.75,29.75,0,0,0,6.49-2.78c2.43-1.57,2.33-4.24,1.44-6.21-2.1-4.6-9.52-2.48-9.6-2.45a1.27,1.27,0,0,1-.72-2.44,17.53,17.53,0,0,1,5-.61c3.72.12,6.36,1.65,7.64,4.45,1.65,3.63.7,7.4-2.37,9.39a31.86,31.86,0,0,1-7.16,3.09A1.49,1.49,0,0,1,240.21,172.59Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M250.4,211.69c-.33-.69-8.12-16.94-9.4-19.22-.82-1.48-6.49-18.68-10.6-31.43l7.81-2.39a1.26,1.26,0,0,0,.84-1.58,1.29,1.29,0,0,0-1.59-.85l-7.84,2.41a2.81,2.81,0,0,0-.1-.31,1.27,1.27,0,1,0-2.41.78c.33,1,1.48,4.61,2.94,9.1l-49.58,4.09-4.4-16a1.27,1.27,0,0,0-2.45.67l4.64,16.85a1.46,1.46,0,0,0,0,.21l-27.78,37a1.24,1.24,0,0,0-1,1,1.27,1.27,0,0,0,1,1.45l41.23,6.6.21,0,.2,0h0l0,0h.1l.09,0,.07,0,.07,0,.08,0,.07,0s0,0,0,0l.09-.08s0,0,0,0l39.89-43.11c2.65,8,5.34,15.95,6,17.12,1.23,2.21,9.24,18.91,9.32,19.08a1.29,1.29,0,0,0,1.15.72,1.23,1.23,0,0,0,.55-.13A1.26,1.26,0,0,0,250.4,211.69Zm-60.17,5.59-37.56-6,26.27-35Zm2.37-1-11.27-40.89,49.73-4.11.83,2.54Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M164.61,153.47c-.8.21-2.54,1.59-1.9,2.38s7.14,3.89,8.25,4,6.27-1.91,8.49-1.91,6,.87,7.69.48c1.35-.32,2.7-.71,2.38-1.74s-4-2.23-5-2.38-11.34-.24-12.93-.4S166.44,153,164.61,153.47Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.43,221.54h-.12l-15.45-1.43a1.27,1.27,0,0,1,.24-2.52L207.54,219a1.27,1.27,0,0,1-.11,2.54Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M206.84,225.5a1.1,1.1,0,0,1-.31,0,1.27,1.27,0,0,1-.92-1.54l2.07-8.06a1.26,1.26,0,1,1,2.45.63l-2.06,8.06A1.26,1.26,0,0,1,206.84,225.5Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M153.64,212.24a2.9,2.9,0,1,1-2.9-2.91A2.9,2.9,0,0,1,153.64,212.24Z',className:'Badge__SecondFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Anton',fontSize:languageSettings.small?'1.4em':'1.8em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_13__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Anton',fontSize:languageSettings.small?'1.3em':'1.8em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_13__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(121);
/* harmony default export */ __webpack_exports__["a"] = ({id:'radial_14',title:'Radial_14',colors:2,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'RadialBadge_14 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_14__TopCircle',d:'M 52 200 A 50 50 0 0 1 348 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'RadialBadge_14__BottomCircle',d:'M 60 200 A 50 50 0 0 0 340 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{width:'400',height:'400',opacity:'0'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'185.31',transform:'translate(-82.84 200) rotate(-45)',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'118.73',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'107.64',fill:'none',className:'Badge__FirstStrokeColor',strokeMiterlimit:'10',strokeWidth:'1.5'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{y:'142.67',width:'400',height:'114.66',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{cx:'200',cy:'200',r:'172.34',fill:'none',className:'Badge__SecondStrokeColor',strokeMiterlimit:'10',strokeWidth:'1.5'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'200 105.94 204.21 114.47 213.63 115.84 206.81 122.48 208.42 131.85 200 127.43 191.58 131.85 193.19 122.48 186.37 115.84 195.79 114.47 200 105.94',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'170 115.07 172.54 120.22 178.23 121.05 174.12 125.06 175.09 130.72 170 128.05 164.91 130.72 165.88 125.06 161.77 121.05 167.46 120.22 170 115.07',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'230 115.07 232.54 120.22 238.23 121.05 234.12 125.06 235.09 130.72 230 128.05 224.91 130.72 225.88 125.06 221.77 121.05 227.46 120.22 230 115.07',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'170 267.07 172.54 272.22 178.23 273.05 174.12 277.06 175.09 282.72 170 280.05 164.91 282.72 165.88 277.06 161.77 273.05 167.46 272.22 170 267.07',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'230 267.07 232.54 272.22 238.23 273.05 234.12 277.06 235.09 282.72 230 280.05 224.91 282.72 225.88 277.06 221.77 273.05 227.46 272.22 230 267.07',className:'Badge__FirstFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('polygon',{points:'200 265.94 204.21 274.47 213.63 275.84 206.81 282.48 208.42 291.85 200 287.43 191.58 291.85 193.19 282.48 186.37 275.84 195.79 274.47 200 265.94',className:'Badge__FirstFillColor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'48%',dy:'.7ex',textAnchor:'middle',fontFamily:'Anton',fontSize:languageSettings.small?'2.8em':'4em',letterSpacing:languageSettings.small?'0.2em':'0.4em',className:'Badge__SecondFillColor'},line0.toUpperCase()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Abel',fontSize:languageSettings.small?'1.3em':'1.8em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_14__TopCircle',startOffset:'50%'},line1.toUpperCase(),' ',line2.toUpperCase())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Abel',fontSize:languageSettings.small?'1.3em':'1.8em',letterSpacing:'0.1em',className:'Badge__SecondFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#RadialBadge_14__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(124);
/* harmony default export */ __webpack_exports__["a"] = ({id:'burger',title:'Burger',colors:2,animated:true,premium:true,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line1=_ref.line1,line2=_ref.line2,line3=_ref.line3,line4=_ref.line4,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 400',width:'100%',height:'100%',className:'BurgerBadge Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'BurgerBadge__TopCircle',d:'M 70 200 A 50 50 0 0 1 330 200'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'BurgerBadge__BottomCircle',d:'M 75 200 A 50 50 0 0 0 325 200'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M392.16,238.72a19.55,19.55,0,0,1-6.37,23.82l-12.68,9.16-14.66,10.59a19.63,19.63,0,0,0-8,13.83l-1.83,18-1.6,15.49a19.59,19.59,0,0,1-17.44,17.48l-15.53,1.6-12.29,1.25-5.67.61a19.53,19.53,0,0,0-13.83,7.94l-10.6,14.66-9.15,12.68a19.58,19.58,0,0,1-23.82,6.37l-14.28-6.4-3.36-1.51L208,378.39a19.49,19.49,0,0,0-8-1.72,19.26,19.26,0,0,0-8,1.72l-16.45,7.37-14.31,6.4a19.6,19.6,0,0,1-23.85-6.37l-9.12-12.68-10.57-14.63a19.72,19.72,0,0,0-13.83-8l-18-1.86L70.39,347a19.59,19.59,0,0,1-11.81-5.6A19.85,19.85,0,0,1,53,329.61l-1.6-15.53-1.83-18a19.68,19.68,0,0,0-8-13.83l-14.6-10.53-12.71-9.19a19.55,19.55,0,0,1-6.37-23.82l6.4-14.28L21.64,208a19.6,19.6,0,0,0,0-16L15.75,179l-1.51-3.36-6.4-14.31a19.53,19.53,0,0,1,6.44-23.82l12.64-9.15,14.63-10.57a19.41,19.41,0,0,0,8-13.83l.61-5.69L51.38,86,53,70.4A19.57,19.57,0,0,1,70.43,53L86,51.38l17.93-1.82a19.56,19.56,0,0,0,13.86-8l10.57-14.63,9.15-12.67a19.57,19.57,0,0,1,23.82-6.41l14.25,6.41L192,21.64a20,20,0,0,0,8,1.7,19.72,19.72,0,0,0,8-1.7l16.48-7.39,14.25-6.41a19.56,19.56,0,0,1,23.82,6.37l9.15,12.71,10.57,14.6a19.55,19.55,0,0,0,13.86,8l18,1.86L329.61,53a19.52,19.52,0,0,1,17.44,17.41l1.6,15.6,1.83,17.92a19.67,19.67,0,0,0,8,13.86l14.63,10.57,12.68,9.15a19.55,19.55,0,0,1,6.37,23.82l-6.4,14.28-7.37,16.49a19.34,19.34,0,0,0,0,16l7.37,16.46Z',className:'Badge__SecondFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M395.63,212.34l-9.89,12.14L378,234l-3.58,4.45a19.49,19.49,0,0,0-4.16,15.39l2.88,17.84,2.49,15.46a19.58,19.58,0,0,1-12.35,21.35l-14.6,5.57-3.46,1.31-13.38,5.09a19.49,19.49,0,0,0-11.3,11.3l-6.44,16.87-5.57,14.6a19.55,19.55,0,0,1-21.35,12.36l-15.46-2.5-17.8-2.88a19.67,19.67,0,0,0-15.43,4.13l-14,11.4-12.1,9.86a19.53,19.53,0,0,1-24.65,0l-12.1-9.86-14-11.4a19.74,19.74,0,0,0-15.46-4.13l-17.8,2.88-15.43,2.5a19.55,19.55,0,0,1-21.35-12.36l-5.57-14.63L79.5,331.78a19.41,19.41,0,0,0-11.3-11.3l-13.38-5.09-3.49-1.31-14.59-5.57a19.56,19.56,0,0,1-12.3-21.38l2.47-15.4,2.88-17.87a19.41,19.41,0,0,0-4.16-15.39L22,234l-7.81-9.58-9.86-12.1a19.6,19.6,0,0,1,0-24.68l9.86-12.07,11.4-14a19.59,19.59,0,0,0,4.16-15.46l-2.88-17.83-2.47-15.43a19.49,19.49,0,0,1,12.3-21.35L51.37,86,68.2,79.52a19.27,19.27,0,0,0,11.3-11.3l6.44-16.84,5.57-14.63a19.52,19.52,0,0,1,21.35-12.32l15.43,2.49,17.8,2.85a19.49,19.49,0,0,0,15.46-4.16l14-11.36,12.17-9.9a19.64,19.64,0,0,1,24.65,0l12.13,9.9,14,11.36a19.43,19.43,0,0,0,15.43,4.16l17.8-2.85,15.46-2.49a19.52,19.52,0,0,1,21.35,12.32l5.57,14.6,6.44,16.87a19.36,19.36,0,0,0,11.3,11.3L348.64,86l14.6,5.58a19.51,19.51,0,0,1,12.35,21.32l-2.49,15.46-2.88,17.83a19.57,19.57,0,0,0,4.16,15.43l11.36,14,9.86,12.1A19.56,19.56,0,0,1,395.63,212.34Z',className:'Badge__ThirdFillColor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200,394.35a14,14,0,0,1-8.79-3.13L165.09,370a25.65,25.65,0,0,0-19.86-5.31L112,370a13.54,13.54,0,0,1-2.21.18,14,14,0,0,1-13-9l-12-31.48A24.92,24.92,0,0,0,70.19,315.2l-31.45-12A14,14,0,0,1,30,288l5.34-33.26a25,25,0,0,0-5.38-19.87L8.72,208.76a14.05,14.05,0,0,1,0-17.62l21.25-26a25.25,25.25,0,0,0,5.36-19.87L30,112a14,14,0,0,1,8.75-15.24l31.48-12A24.92,24.92,0,0,0,84.75,70.14l12-31.45A14.07,14.07,0,0,1,112,29.91l33.24,5.35a25.46,25.46,0,0,0,19.91-5.37L191.21,8.65a14.38,14.38,0,0,1,17.61,0l26.1,21.24a25.25,25.25,0,0,0,19.83,5.35L288,29.91a14.09,14.09,0,0,1,15.22,8.79l12,31.47a25,25,0,0,0,14.54,14.54l31.43,12a14,14,0,0,1,8.83,15.2l-5.38,33.29A25.29,25.29,0,0,0,370,165.06l21.22,26.09a14,14,0,0,1,0,17.62L370,234.9a25,25,0,0,0-5.33,19.79L370.07,288a14,14,0,0,1-8.84,15.23l-31.42,12a25.05,25.05,0,0,0-14.55,14.56l-12,31.45A14.09,14.09,0,0,1,288,370l-33.25-5.38A25.48,25.48,0,0,0,234.92,370l-26.13,21.26A14,14,0,0,1,200,394.35Zm-50.84-38a33.47,33.47,0,0,1,21,7.41L196.27,385a6.05,6.05,0,0,0,7.47,0l26.13-21.26a33.41,33.41,0,0,1,26.17-7l33.27,5.38a6,6,0,0,0,6.48-3.78l12-31.42A33,33,0,0,1,327,307.72l31.4-12a6,6,0,0,0,3.8-6.48L356.78,256a33,33,0,0,1,7-26.1l21.26-26.13a6,6,0,0,0,0-7.51l-21.23-26.1a33.28,33.28,0,0,1-7-26.17l5.38-33.31a5.94,5.94,0,0,0-3.78-6.44L327,92.19A33,33,0,0,1,307.78,73l-12-31.45a6,6,0,0,0-6.47-3.74L256,43.16a33.2,33.2,0,0,1-26.15-7.06L203.79,14.89a6.24,6.24,0,0,0-7.54,0L170.18,36.09A33.39,33.39,0,0,1,144,43.16L110.7,37.81a6,6,0,0,0-6.47,3.74L92.24,73A32.92,32.92,0,0,1,73.05,92.19l-31.46,12a5.94,5.94,0,0,0-3.71,6.49L43.23,144a33.26,33.26,0,0,1-7,26.18l-21.25,26a6,6,0,0,0,0,7.51l21.21,26.07A33,33,0,0,1,43.23,256l-5.35,33.27a6,6,0,0,0,3.71,6.51l31.44,12A32.91,32.91,0,0,1,92.22,326.9l12,31.45a6,6,0,0,0,6.46,3.78L144,356.74A33.51,33.51,0,0,1,149.17,356.34Z',className:'Badge__SecondFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'SUNBURST'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M236.51,165.66l36.72-36.72-1.48-1.47L235,164.2C235.53,164.67,236,165.16,236.51,165.66Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M242.23,172.76,285,143.49l-1.17-1.72L241,171.05C241.45,171.61,241.85,172.18,242.23,172.76Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M285.94,190.19l-35.89,3.57c.09.68.16,1.37.22,2.07l35.88-3.57Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M246.81,181.4l47.67-20.21-.81-1.92L246,179.49C246.26,180.12,246.54,180.75,246.81,181.4Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M267.54,252.82,240.1,230.35c-.42.55-.86,1.09-1.31,1.62l27.43,22.47Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M282.71,223.66l-34-10.44c-.19.67-.38,1.34-.59,2l34,10.43Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M285.77,207.83,250.3,204c-.06.7-.12,1.39-.21,2.07l35.45,3.85Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M277,238l-31.51-16.38c-.3.63-.62,1.25-.95,1.86l31.5,16.37Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M212.12,151.89,222.83,101l-2-.42-10.71,50.92C210.77,151.59,211.45,151.74,212.12,151.89Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M228.73,159.12l28.41-43.52-1.75-1.14L227,158C227.57,158.36,228.16,158.73,228.73,159.12Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200.43,150.62l.73,0V98.93h-2.32v51.73C200,150.65,199.94,150.62,200.43,150.62Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M207.34,151l3.89-35.89-2.07-.22-3.89,35.89C206,150.88,206.65,151,207.34,151Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M197.2,150.78l-3.61-36.23-2.07.2,3.6,36.23C195.81,150.9,196.5,150.84,197.2,150.78Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M222.72,155.64c.63.3,1.25.62,1.86,1l16.61-32-1.85-1Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M220.94,154.82l20.1-48-1.93-.8L219,154C219.66,154.27,220.31,154.54,220.94,154.82Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M216.4,153.08,227,118.59l-2-.61L214.4,152.47C215.08,152.66,215.74,152.86,216.4,153.08Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M134.49,146.54l27.81,22.78c.43-.54.88-1.08,1.33-1.6l-27.82-22.8Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M265.53,144.11,238,167.25q.69.78,1.35,1.59l27.53-23.13Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M145.44,135.17l23.17,27.57c.52-.46,1.06-.9,1.6-1.34L147,133.83Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M254.16,133.16,231.33,161c.55.43,1.09.86,1.62,1.31l22.82-27.85Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249.53,190.47l50.59-10.72-.44-2-50.61,10.72C249.24,189.11,249.39,189.78,249.53,190.47Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M281.83,172.88l-34.14,10.86c.23.66.45,1.32.65,2l34.12-10.85Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M275.23,157.94l-31.51,17.22c.35.6.69,1.2,1,1.82l31.49-17.21Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M126.8,241.42l31.16-17c-.35-.6-.67-1.21-1-1.83l-31.17,17Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M120.19,226.48l33.9-10.78c-.22-.66-.42-1.32-.61-2l-33.92,10.78Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M256.58,264.19,233.8,237.08c-.52.46-1,.92-1.58,1.36L255,265.53Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M125,161.35l31.84,16.54c.31-.62.63-1.24,1-1.84L125.94,159.5Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M147.87,266.2l22.43-27.38c-.55-.43-1.08-.87-1.61-1.33l-22.43,27.39Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M116.08,209.17l35.8-3.56c-.08-.68-.14-1.38-.19-2.07l-35.81,3.56Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M119.31,175.71l34.24,10.5c.19-.67.4-1.33.62-2l-34.25-10.51Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M116.26,191.53l35.53,3.86c.06-.7.15-1.39.24-2.07l-35.55-3.86Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M136.5,255.25l27.14-22.81c-.46-.52-.9-1.05-1.33-1.6l-27.15,22.81Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M200.43,249.53c-.49,0-.43,0-1.59,0v51.59h2.32V249.51S200.64,249.53,200.43,249.53Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M210.32,248.64,221,298.78l2-.43-10.63-50.14C211.69,248.36,211,248.51,210.32,248.64Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M219.49,246l20,47.2,1.92-.81-20-47.21C220.78,245.41,220.14,245.69,219.49,246Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M215.12,247.48l10.7,33.65,2-.63L217.1,246.84C216.45,247.06,215.79,247.28,215.12,247.48Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M204.91,249.36l3.52,35.45,2.07-.2L207,249.16C206.29,249.24,205.6,249.31,204.91,249.36Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M194.6,249.1l-3.81,35.11,2.08.22,3.8-35.1C196,249.27,195.29,249.19,194.6,249.1Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M185.41,247l-10.36,33.77,2,.61,10.36-33.76C186.73,247.43,186.06,247.22,185.41,247Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M189.74,248.23,179.2,298.38l2,.43,10.54-50.15C191.1,248.53,190.42,248.38,189.74,248.23Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M235.43,235.57l36.32,36.32,1.48-1.47-36.34-36.33C236.42,234.59,235.93,235.09,235.43,235.57Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M249.27,210.89l50.45,10.6.43-2-50.47-10.61C249.55,209.53,249.42,210.21,249.27,210.89Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M250.44,198.84s0,.86,0,1.24,0,1.08,0,1.08h50.64v-2.32Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M246.36,219.81l47.48,19.89.8-1.92-47.49-19.9C246.9,218.53,246.64,219.18,246.36,219.81Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M180.81,245.21,161,292.51l1.92.8L182.73,246C182.08,245.77,181.44,245.49,180.81,245.21Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M228.24,241.35l29,42.36,1.72-1.17-29-42.37C229.39,240.57,228.82,241,228.24,241.35Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M224,243.87l16.95,31,1.83-1-16.95-31C225.2,243.21,224.59,243.55,224,243.87Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M242,227.7l43,28.1,1.14-1.74L243.16,226C242.8,226.54,242.43,227.13,242,227.7Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M156,179.68l-47.78-20-.81,1.92,47.76,20C155.41,181,155.68,180.31,156,179.68Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M167,164.2l-36.73-36.73-1.47,1.47,36.72,36.72C166,165.16,166.5,164.67,167,164.2Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M174.16,158.56l-29.34-42.91-1.72,1.18,29.33,42.9C173,159.33,173.58,158.94,174.16,158.56Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M160.37,171.91l-43.43-28.35-1.14,1.74,43.42,28.35C159.6,173.06,160,172.48,160.37,171.91Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M179,244.35c-.62-.31-1.24-.63-1.85-1l-16.29,31.37,1.84,1Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M191.87,151.48l-10.79-50.9-2,.43,10.78,50.9C190.5,151.75,191.18,151.61,191.87,151.48Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M182.82,154.09l-20.3-47.88-1.92.81,20.3,47.88Q181.85,154.48,182.82,154.09Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M178.39,156.11,161.1,124.47l-1.83,1,17.29,31.63C177.16,156.76,177.77,156.42,178.39,156.11Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M187.14,152.61,176.2,118.23l-2,.63,10.93,34.38C185.81,153,186.47,152.81,187.14,152.61Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M165.13,234.09,128.8,270.42l1.47,1.47,36.33-36.32C166.1,235.09,165.61,234.59,165.13,234.09Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M152.93,188.51l-50.62-10.64-.43,2,50.61,10.64C152.62,189.86,152.77,189.18,152.93,188.51Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M172.94,240.78l-28.05,43,1.75,1.14,28-43C174.09,241.56,173.51,241.18,172.94,240.78Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M159.44,226.84l-42.46,29,1.18,1.72,42.44-29C160.2,228,159.82,227.43,159.44,226.84Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M151.56,200.08c0-.38,0-1.24,0-1.24H98.92v2.32h52.66S151.56,200.4,151.56,200.08Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M152.36,208.92l-50.45,10.69.43,2L152.78,211C152.62,210.29,152.49,209.61,152.36,208.92Z',className:'Badge__FirstFillColor',opacity:'0.1'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M155,218.08l-47.41,20.09.82,1.92L155.75,220C155.47,219.37,155.21,218.72,155,218.08Z',className:'Badge__FirstFillColor',opacity:'0.1'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_2','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_3','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{id:'_Rechteck_','data-name':'<Rechteck>',x:'187.61',y:'232.55',width:'22.8',height:'6.14',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_4','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_5','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_6','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_','data-name':'<Pfad>',d:'M140.92,238.7H259.08a4.54,4.54,0,0,1,4.54,4.54l-2,6.51c0,7-6.67,13.67-13.67,13.67h-94.9c-7,0-15.67-6.67-15.67-13.67l-1-6.51A4.54,4.54,0,0,1,140.92,238.7Z',fill:'#f6b13a'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_7','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_2','data-name':'<Pfad>',d:'M257.1,238.7H246.58c.49,4.49-.15,12.87-11,15.55-15.1,3.71-81.34,5.24-96.41.64h0a18.17,18.17,0,0,0,15.42,8.53h90.84a18.2,18.2,0,0,0,18.2-18.2h0A6.52,6.52,0,0,0,257.1,238.7Z',fill:'#f7952c'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_8','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_3','data-name':'<Pfad>',d:'M156,248.57h-6.76a1.63,1.63,0,0,0,0,3.25H156A1.63,1.63,0,0,0,156,248.57Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_9','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_4','data-name':'<Pfad>',d:'M202.7,244.06h-3.9a1.63,1.63,0,0,0,0,3.25h3.9A1.63,1.63,0,0,0,202.7,244.06Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_10','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_5','data-name':'<Pfad>',d:'M242.43,252.87h-10a1.63,1.63,0,0,0,0,3.25h10A1.63,1.63,0,0,0,242.43,252.87Z',fill:'#fcd669'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_11','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_6','data-name':'<Pfad>',d:'M255.71,204.82H144.29a6.31,6.31,0,0,1-6.29-6.29h0a6.31,6.31,0,0,1,6.29-6.29H255.71a6.31,6.31,0,0,1,6.29,6.29h0A6.31,6.31,0,0,1,255.71,204.82Z',fill:'#bc5f46'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_12','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{id:'_Pfad_7','data-name':'<Pfad>',x:'134.34',y:'208.55',width:'131.33',height:'17.07',rx:'8.42',ry:'8.42',fill:'#f05755'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_13','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_8','data-name':'<Pfad>',d:'M257.24,208.55H230.75a12.12,12.12,0,0,1-2.64.65L223.27,218h0a2.16,2.16,0,0,1-.65,4.21c-31.25.49-87-1.14-87.35-1.15a8.43,8.43,0,0,0,7.49,4.59H257.24a6.85,6.85,0,0,0,.79,0h.11c.22,0,.44-.06.65-.11l.24,0,.53-.14.35-.11.07,0a8.44,8.44,0,0,0,5.68-8V217A8.44,8.44,0,0,0,257.24,208.55Z',fill:'#e24647'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_14','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_9','data-name':'<Pfad>',d:'M262,198.53a6.31,6.31,0,0,0-6.29-6.29H248.2c1.49,1.43,3.07,3.66,2.38,6.29-1.13,4.28-90.64,4.49-112.51.88a6.3,6.3,0,0,0,6.22,5.41H255.71A6.31,6.31,0,0,0,262,198.53Z',fill:'#aa3c26'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_15','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_16','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_17','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_18','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_10','data-name':'<Pfad>',d:'M195.5,238.7H143.58a5.59,5.59,0,0,1-5.57-5.58h0a5.59,5.59,0,0,1,5.57-5.57H195.5a5.59,5.59,0,0,1,5.58,5.57h0A5.6,5.6,0,0,1,195.5,238.7Z',fill:'#bc5f46'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_19','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_11','data-name':'<Pfad>',d:'M195.5,227.55h-1.3c.52,1.66.45,4.76-6,6.78-9.15,2.87-43.37,1.36-49.4,0a5.59,5.59,0,0,0-.68-.12,5.59,5.59,0,0,0,5.46,4.49H195.5a5.6,5.6,0,0,0,5.58-5.58h0A5.59,5.59,0,0,0,195.5,227.55Z',fill:'#aa3c26'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_20','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_21','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Zusammengesetzter_Pfad_','data-name':'<Zusammengesetzter Pfad>',d:'M195.5,240.13H143.58a7,7,0,0,1,0-14H195.5a7,7,0,1,1,0,14ZM143.58,229a4.14,4.14,0,0,0,0,8.28H195.5a4.14,4.14,0,0,0,0-8.28Z',fill:'#84171a'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_22','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_23','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_24','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_12','data-name':'<Pfad>',d:'M256.42,238.7H204.5a5.6,5.6,0,0,1-5.58-5.58h0a5.59,5.59,0,0,1,5.58-5.57h51.92a5.59,5.59,0,0,1,5.57,5.57h0A5.59,5.59,0,0,1,256.42,238.7Z',fill:'#bc5f46'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_25','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_13','data-name':'<Pfad>',d:'M256.42,227.55h-1.3c.51,1.66.44,4.76-6,6.78-9.15,2.87-43.38,1.36-49.41,0a5.59,5.59,0,0,0-.68-.12,5.61,5.61,0,0,0,5.47,4.49h51.92a5.59,5.59,0,0,0,5.57-5.58h0A5.59,5.59,0,0,0,256.42,227.55Z',fill:'#aa3c26'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_26','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_14','data-name':'<Pfad>',d:'M140.42,192.5a2.75,2.75,0,0,1,3-2.44H256.6a2.49,2.49,0,1,1,0,4.88s-14.09,1.12-16.75,3.3-2.78,3.66-7.13,2.18-5.32-4-10.28-3-4,2.37-10.87,1.28-15-4-22-1.18-5.44,6.92-13.42,5-10.28-6.82-15.72-5.74-11.24,1.29-14,.3a19.76,19.76,0,0,1-4.83-2.71A2.34,2.34,0,0,1,140.42,192.5Z',fill:'#9db73e'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_27','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_15','data-name':'<Pfad>',d:'M256.6,194.94a2.49,2.49,0,1,0,0-4.88H244.53c-1.08,1.9-3.53,5.14-7.77,5.34-6,.27-11.63-2.32-21,0-3.94,1-6.76,1.79-9.1,2.37,1.69.36,3.34.71,4.94,1,6.89,1.09,5.92-.29,10.87-1.28s5.93,1.48,10.28,3,4.47,0,7.13-2.18S256.6,194.94,256.6,194.94Z',fill:'#8da43c'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_28','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Zusammengesetzter_Pfad_2','data-name':'<Zusammengesetzter Pfad>',d:'M179.58,204.5a16.73,16.73,0,0,1-3.76-.51,28,28,0,0,1-8.53-3.74c-2.49-1.49-4.13-2.48-6.57-2-4.93,1-11.41,1.44-14.79.24a20.93,20.93,0,0,1-5.17-2.89A3.74,3.74,0,0,1,139,192.5a4.18,4.18,0,0,1,4.42-3.87H256.6a3.91,3.91,0,1,1,.06,7.75c-5.66.45-14.31,1.67-15.9,3-.48.39-.87.76-1.25,1.12-1.82,1.72-3.15,2.7-7.25,1.3a20.34,20.34,0,0,1-3.77-1.77c-1.87-1.06-3-1.7-5.76-1.15a19.68,19.68,0,0,0-3.21.93c-2.07.77-3.38,1.13-8.18.37-1.58-.25-3.18-.59-4.87-.94-5.57-1.18-11.33-2.4-16.36-.34a15.4,15.4,0,0,0-4.85,3.14C183.58,203.49,182.18,204.5,179.58,204.5Zm-17.65-9.23c2.63,0,4.69,1.23,6.83,2.52a25.47,25.47,0,0,0,7.72,3.41c4.23,1,5.06.26,6.88-1.34a18.11,18.11,0,0,1,5.66-3.64c5.85-2.39,12.32-1,18,.18,1.65.35,3.22.68,4.73.92,4.28.67,5.15.35,6.74-.23a22.07,22.07,0,0,1,3.63-1.05,9.66,9.66,0,0,1,7.74,1.46,18.31,18.31,0,0,0,3.28,1.56c2.68.91,3,.64,4.36-.68.39-.37.84-.79,1.4-1.25,2.86-2.34,15.12-3.42,17.55-3.61h.11c.91,0,1.55-.53,1.55-1s-.64-1-1.55-1H143.4c-.91,0-1.55.54-1.55,1a1,1,0,0,0,.5.72l.1.07a18.23,18.23,0,0,0,4.44,2.51c2.44.87,7.89.72,13.26-.35A8.74,8.74,0,0,1,161.93,195.27Z',fill:'#84171a'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_29','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Zusammengesetzter_Pfad_3','data-name':'<Zusammengesetzter Pfad>',d:'M245.42,264.86H154.58a19.66,19.66,0,0,1-19.64-19.64,8,8,0,0,1,8-8H257.09a8,8,0,0,1,8,8A19.66,19.66,0,0,1,245.42,264.86ZM142.91,240.13a5.11,5.11,0,0,0-5.1,5.09A16.79,16.79,0,0,0,154.58,262h90.84a16.79,16.79,0,0,0,16.77-16.77,5.11,5.11,0,0,0-5.1-5.09Z',fill:'#84171a'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_30','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_31','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_32','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_16','data-name':'<Pfad>',d:'M142.07,192.24a6.3,6.3,0,0,1-6.11-7.32c4.16-27.28,31.25-48.34,64-48.34s59.88,21.06,64,48.34a6.3,6.3,0,0,1-6.11,7.32Z',fill:'#f6b13a'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_33','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_17','data-name':'<Pfad>',d:'M264,184.92c-3.46-22.69-22.77-41.07-48-46.62,0,0,23.59,14.76,16.57,38-6.17,20.39-79,11.06-96.58,8.48l0,.18a6.3,6.3,0,0,0,6.11,7.32H257.93A6.3,6.3,0,0,0,264,184.92Z',fill:'#f7952c'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_34','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_18','data-name':'<Pfad>',d:'M161.53,161.56h-4.71a1.63,1.63,0,0,0,0,3.25h4.71A1.63,1.63,0,0,0,161.53,161.56Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_35','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_19','data-name':'<Pfad>',d:'M187.13,151.12h-9.42a1.63,1.63,0,0,0,0,3.25h9.42A1.63,1.63,0,0,0,187.13,151.12Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_36','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_20','data-name':'<Pfad>',d:'M207.61,161.77h-4.1a1.63,1.63,0,0,0,0,3.25h4.1A1.63,1.63,0,0,0,207.61,161.77Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_37','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_21','data-name':'<Pfad>',d:'M163.58,179h-5.73a1.63,1.63,0,0,0,0,3.25h5.73A1.63,1.63,0,0,0,163.58,179Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_38','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_22','data-name':'<Pfad>',d:'M215.6,175.08h-2a1.63,1.63,0,1,0,0,3.25h2a1.63,1.63,0,0,0,0-3.25Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_39','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_23','data-name':'<Pfad>',d:'M236.49,153.58H225.84a1.63,1.63,0,0,0,0,3.25h10.65A1.63,1.63,0,0,0,236.49,153.58Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_40','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_24','data-name':'<Pfad>',d:'M247.75,181.43h-5.12a1.63,1.63,0,0,0,0,3.25h5.12A1.63,1.63,0,0,0,247.75,181.43Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_41','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_25','data-name':'<Pfad>',d:'M184.88,173.44h-2.46a1.63,1.63,0,1,0,0,3.25h2.46a1.63,1.63,0,0,0,0-3.25Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_42','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_26','data-name':'<Pfad>',d:'M208.43,142.31h-3.69a1.63,1.63,0,0,0,0,3.25h3.69A1.63,1.63,0,0,0,208.43,142.31Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_43','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Zusammengesetzter_Pfad_4','data-name':'<Zusammengesetzter Pfad>',d:'M257.93,193.67H142.07a7.56,7.56,0,0,1-5.72-2.65,7.87,7.87,0,0,1-1.81-6.32c2.08-13.64,9.84-26.19,21.83-35.32s27.55-14.23,43.63-14.23,31.57,5,43.63,14.23,19.75,21.68,21.83,35.32a7.87,7.87,0,0,1-1.81,6.32A7.56,7.56,0,0,1,257.93,193.67ZM200,138c-31.6,0-58.53,20.26-62.62,47.12a5,5,0,0,0,1.14,4,4.7,4.7,0,0,0,3.55,1.65H257.93a4.69,4.69,0,0,0,3.55-1.65,5,5,0,0,0,1.14-4C258.53,158.27,231.6,138,200,138Z',fill:'#84171a'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_44','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Zusammengesetzter_Pfad_5','data-name':'<Zusammengesetzter Pfad>',d:'M255.71,206.25H144.29a7.73,7.73,0,0,1,0-15.45H255.71a7.73,7.73,0,0,1,0,15.45ZM144.29,193.67a4.86,4.86,0,1,0,0,9.71H255.71a4.86,4.86,0,1,0,0-9.71Z',fill:'#84171a'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_45','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Zusammengesetzter_Pfad_6','data-name':'<Zusammengesetzter Pfad>',d:'M257.24,227.06H142.76a9.87,9.87,0,0,1-9.86-9.86V217a9.86,9.86,0,0,1,9.86-9.85H257.24A9.86,9.86,0,0,1,267.1,217v.23A9.87,9.87,0,0,1,257.24,227.06ZM142.76,210a7,7,0,0,0-7,7v.23a7,7,0,0,0,7,7H257.24a7,7,0,0,0,7-7V217a7,7,0,0,0-7-7Z',fill:'#84171a'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_46','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_27','data-name':'<Pfad>',d:'M259.43,227.63a3.2,3.2,0,0,0-2.86-2H143.44a3,3,0,0,0-2.88,2c-.63,2,3,3.92,5,3.92,0,0,10.51,1.12,13.17,3.78s4.76,5.7,9.11,3.89,4.79-5.82,9.75-4.61,4,2.9,10.87,1.57,15-5,22-1.45,5.44,8.46,13.42,6.16,10.28-8.34,15.72-7,11.24,1.57,14,.37a19.2,19.2,0,0,0,4.83-3.32A3,3,0,0,0,259.43,227.63Z',fill:'#9db73e'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_47','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_28','data-name':'<Pfad>',d:'M256.57,225.62H244c-1.75,2.44-6,5.77-15.83,5.68-15.57-.13-24.85-3.92-36.46,2.27a52,52,0,0,1-7,3.13,23,23,0,0,0,3.73-.48c6.89-1.33,15-5,22-1.45s5.44,8.46,13.42,6.16,10.28-8.34,15.72-7,11.24,1.57,14,.37a19.2,19.2,0,0,0,4.83-3.32,3,3,0,0,0,1-3.34A3.2,3.2,0,0,0,256.57,225.62Z',fill:'#8da43c'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_48','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Zusammengesetzter_Pfad_7','data-name':'<Zusammengesetzter Pfad>',d:'M220.39,243c-2.64,0-4.06-1.26-5.75-3.08a15.43,15.43,0,0,0-4.85-3.83c-4.95-2.48-10.67-1-16.2.42-1.69.44-3.29.85-4.88,1.16-4.87.94-6.27.46-8.32-.47a16.77,16.77,0,0,0-3.17-1.12c-2.31-.56-3.16.22-4.69,1.64a13.62,13.62,0,0,1-4.17,2.9c-4.74,2-7.41-.81-9.77-3.27l-.91-.93c-1.66-1.66-8.35-2.94-12.23-3.36a8.18,8.18,0,0,1-5.67-2.82,3.28,3.28,0,0,1-.59-2.95,4.44,4.44,0,0,1,4.25-3.06H256.57a4.6,4.6,0,0,1,4.22,3h0a4.4,4.4,0,0,1-1.45,4.86,20.23,20.23,0,0,1-5.18,3.54c-3,1.31-8.87,1.2-14.93-.28-2.24-.55-3.74.45-6.41,2.41a26,26,0,0,1-8.57,4.58A14,14,0,0,1,220.39,243ZM203.7,231.85a16.16,16.16,0,0,1,7.38,1.64,18.17,18.17,0,0,1,5.66,4.44c1.85,2,2.61,2.81,6.72,1.63a23.7,23.7,0,0,0,7.67-4.14c2.64-1.95,5.13-3.78,8.78-2.89,5.23,1.28,10.75,1.47,13.11.44a18.07,18.07,0,0,0,4.43-3.05l.09-.09a1.55,1.55,0,0,0,.52-1.76h0a1.78,1.78,0,0,0-1.49-1H143.44a1.55,1.55,0,0,0-1.51,1c0,.11.07.28.16.41a5.39,5.39,0,0,0,3.44,1.66h.15c1.13.12,11.1,1.26,14,4.19.32.32.64.65.95,1,2.41,2.51,3.8,3.77,6.6,2.6a10.9,10.9,0,0,0,3.32-2.35c1.64-1.53,3.51-3.25,7.32-2.32a19.2,19.2,0,0,1,3.67,1.29c1.59.72,2.38,1.07,6.59.26,1.51-.29,3.07-.69,4.72-1.12A44.32,44.32,0,0,1,203.7,231.85Z',fill:'#84171a'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_49','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_29','data-name':'<Pfad>',d:'M259.33,204.82H141.56a1.87,1.87,0,1,0,0,3.73h45.07s26.42,6.7,38.81,10a8.29,8.29,0,0,0,5.55-.46l21.16-9.54h7.18a1.87,1.87,0,0,0,0-3.73Z',fill:'#fcd669'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_50','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Pfad_30','data-name':'<Pfad>',d:'M259.33,204.82h-22.2c-.7,3.17-3.09,9.63-11.09,10.26-10.65.84-22.87-2.31-22.87-2.31h0c7.75,2,16.52,4.25,22.27,5.78a8.29,8.29,0,0,0,5.55-.46l21.16-9.54h7.18a1.87,1.87,0,0,0,0-3.73Z',fill:'#fbc231'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{id:'_Gruppe_51','data-name':'<Gruppe>'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{id:'_Zusammengesetzter_Pfad_8','data-name':'<Zusammengesetzter Pfad>',d:'M227.57,220.26a9.51,9.51,0,0,1-2.49-.33c-11.73-3.11-36.32-9.36-38.63-9.94H141.56a3.31,3.31,0,1,1,0-6.61H259.33a3.31,3.31,0,0,1,0,6.61h-6.87l-20.88,9.41A9.8,9.8,0,0,1,227.57,220.26Zm-86-14a.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43h45.25l.17,0c.27.07,26.57,6.74,38.83,10a6.91,6.91,0,0,0,4.59-.38l21.44-9.66h7.49a.43.43,0,0,0,.43-.43.44.44,0,0,0-.43-.44Z',fill:'#84171a'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.7ex',textAnchor:'middle',fontFamily:'Miriam Libre',fontSize:languageSettings.small?'1.4em':'1.9em',letterSpacing:'0.05em',className:'Badge__FirstFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#BurgerBadge__TopCircle',startOffset:'50%'},'+ \xA0 ',line1.toUpperCase(),' ',line2.toUpperCase(),' \xA0 +')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'',y:'',dy:'.79ex',textAnchor:'middle',fontFamily:'Miriam Libre',fontSize:languageSettings.small?'1.4em':'1.9em',letterSpacing:'0.05em',className:'Badge__FirstFillColor'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textPath',{xlinkHref:'#BurgerBadge__BottomCircle',startOffset:'50%'},line3.toUpperCase(),' ',line4.toUpperCase()))));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(127);
/* harmony default export */ __webpack_exports__["a"] = ({id:'blank_1',title:'Blank_1',premium:true,supportsNoSubline:true,colors:1,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line3=_ref.line3,line4=_ref.line4,disableSubline=_ref.disableSubline,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 200',width:'100%',height:'100%',className:'BlankBadge_1 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'RECTANGLE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{width:'400',height:'200',opacity:'0',className:'Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'49%',y:'35%',dy:'.9ex',textAnchor:'middle',fontFamily:'Norican',fontSize:languageSettings.small?'5.5em':'10.5em',letterSpacing:'0em',className:'Badge__FirstFillColor'},line0),!disableSubline?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:languageSettings.small?'75%':'90%',textAnchor:'middle',fontFamily:'Rajdhani',fontSize:languageSettings.small?'1.2em':'1.6em',fontWeight:'700',letterSpacing:'0.1em',className:'Badge__FirstFillColor'},line3.toUpperCase(),' ',line4.toUpperCase()):null));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(130);
/* harmony default export */ __webpack_exports__["a"] = ({id:'blank_2',title:'Blank_2',premium:true,supportsNoSubline:true,colors:1,BadgeComponentStateless:__WEBPACK_IMPORTED_MODULE_0__Badge__["a" /* default */],languageSpecificSettings:{de:{small:true},fr:{small:true},es:{small:true},nl:{small:true},fin:{small:true},pt:{small:true}}});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Badge(_ref){var className=_ref.className,line0=_ref.line0,line3=_ref.line3,line4=_ref.line4,disableSubline=_ref.disableSubline,languageSettings=_ref.languageSettings;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 400 200',width:'100%',height:'100%',className:'BlankBadge_2 Badge '+className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'RECTANGLE'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect',{width:'400',height:'200',opacity:'0',className:'_Badge__FirstFillColor'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('g',{className:'TEXT'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:'26%',dy:'.9ex',textAnchor:'middle',fontFamily:'Anton',fontSize:languageSettings.small?'5em':'10em',letterSpacing:'0em',className:'Badge__FirstFillColor'},line0.toUpperCase()),!disableSubline?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('text',{x:'50%',y:languageSettings.small?'70%':'90%',textAnchor:'middle',fontFamily:'Rajdhani',fontSize:languageSettings.small?'1.2em':'1.5em',fontWeight:'700',letterSpacing:'0.1em',className:'Badge__FirstFillColor'},line3.toUpperCase(),' ',line4.toUpperCase()):null));}/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createBadgeContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_openingHours__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_badgeText__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createBadgeContainer(WrappedComponent){return function(_React$Component){_inherits(_class,_React$Component);function _class(props){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props));_this.state={currentDate:new Date(),hide:false};return _this;}_createClass(_class,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props$updateInterval=this.props.updateInterval,updateInterval=_props$updateInterval===undefined?1000:_props$updateInterval;this.interval=setInterval(function(){_this2.setState(function(){return{currentDate:new Date()};});},updateInterval);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.interval){clearInterval(this.interval);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){var _this3=this;// chrome keeps on animating the sign, even if the animation setting
// was disabled. This code here is supposed to be a workaround for that problem.
var isChrome=window.navigator.userAgent.indexOf('Chrome')>-1;if(!isChrome||!this.props.enableChromeRenderingHack||this.state.hide){return;}this.setState({hide:true});setTimeout(function(){_this3.setState({hide:false});},0);}},{key:'render',value:function render(){var _props=this.props,styles=_props.styles,data=_props.data,className=_props.className,languageSpecificSettings=_props.languageSpecificSettings;var hide=this.state.hide;if(!styles||!data||hide){return null;}var lang=styles.language.value;var zoneInfo=__WEBPACK_IMPORTED_MODULE_1_moment___default.a.tz.zone(styles.timezone);var openingState=Object(__WEBPACK_IMPORTED_MODULE_4__services_openingHours__["f" /* getOpeningState */])(zoneInfo,data.openingHoursByDay,Object(__WEBPACK_IMPORTED_MODULE_3__services_Wix__["c" /* isPremium */])()?data.specialOpeningHours:[]);var showFreePlanClaim=data.pricingSchema===2&&!Object(__WEBPACK_IMPORTED_MODULE_3__services_Wix__["c" /* isPremium */])();var isOpen=openingState.status==='OPENED';var lines=Object(__WEBPACK_IMPORTED_MODULE_5__services_badgeText__["a" /* createBadgeTextLines */])(openingState,zoneInfo,lang,styles.timeFormat.value,styles.dateFormat.value);var languageSettings={};if(languageSpecificSettings&&languageSpecificSettings[lang]){languageSettings=languageSpecificSettings[lang];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({},this.props,this.state,lines,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className,{'Badge--small':languageSettings.small}),isOpen:isOpen,showFreePlanClaim:showFreePlanClaim,languageSettings:languageSettings}));}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createBadgeTextLines;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TZDate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateHelpers__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__openingHours__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translations__ = __webpack_require__(36);
function isInUnderSixDays(date1,date2){var diff=Math.abs(date1.diff(date2));var diffInDays=diff/1000/60/60/24;return diffInDays<6;}function isToday(date1,date2){return date1.isSameDay(date2);}function isTomorrow(date1,date2){return date1.addDays(1).isSameDay(date2);}function createBadgeTextLines(openingState,zoneInfo,lang,timeFormat,dateFormat){var currentDate=new __WEBPACK_IMPORTED_MODULE_0__TZDate__["a" /* default */](Date.now(),zoneInfo);var openingDate=openingState.openingDate,closingDate=openingState.closingDate;var isOpen=openingState.status===__WEBPACK_IMPORTED_MODULE_3__openingHours__["c" /* OPENED */];if(isOpen){var line0=Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('open_standalone',lang);// This should be used if the word 'Open' is not part of the sentence "Yes, we're Open"
var line1=Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('yes_we_are',lang);var line2=Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('open',lang);var closingTimeFormated=closingDate&&Object(__WEBPACK_IMPORTED_MODULE_1__dateHelpers__["a" /* formatTZDate */])(closingDate,timeFormat,__WEBPACK_IMPORTED_MODULE_2__static__["c" /* DEFAULT_TIME_FORMAT */]);var closingDateFormated=closingDate&&Object(__WEBPACK_IMPORTED_MODULE_1__dateHelpers__["a" /* formatTZDate */])(closingDate,dateFormat,__WEBPACK_IMPORTED_MODULE_2__static__["b" /* DEFAULT_DATE_FORMAT */]);var closingDayId=closingDate&&closingDate.getDayString().toLowerCase();var closingDayFormated=closingDayId&&Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])(closingDayId,lang);if(!closingDate){// open 24/7
return{line0:line0,line1:line1,line2:line2,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('twentyfourseven',lang),line4:''};// TODO: re-add support for this case
//} else if (isInUnderAnHour(currentDate, closingDate)) {
// closing in under 60 minutes
//  return {
//    line0,
//    line1,
//    line2,
//    line3: translate('closing', lang),
//    line4: closingDate.locale(lang).fromNow()
//  };
}else if(isToday(currentDate,closingDate)){// closing today
return{line0:line0,line1:line1,line2:line2,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('closing',lang),line4:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('at_x',lang,{x:closingTimeFormated})// TODO: add arguments
};}else if(isTomorrow(currentDate,closingDate)){// closing tomorrow
return{line0:line0,line1:line1,line2:line2,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('closing_tomorrow',lang),line4:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('at_x',lang,{x:closingTimeFormated})};}else if(isInUnderSixDays(currentDate,closingDate)){// closing in under 7 days
return{line0:line0,line1:line1,line2:line2,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('closing_x',lang,{x:closingDayFormated,isWeekday:true}),// TODO: add arguments
line4:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('at_x',lang,{x:closingTimeFormated})};}else{// closing sometime later in the future
return{line0:line0,line1:line1,line2:line2,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('closing_x',lang,{x:closingDateFormated}),line4:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('at_x',lang,{x:closingTimeFormated})};}}else{var _line=Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('closed_standalone',lang);// This should be used if the word 'Closed' is not part of the sentence "Sorry, we're Closed"
var _line2=Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('sorry_we_are',lang);var _line3=Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('closed',lang);var openingTimeFormated=openingDate&&Object(__WEBPACK_IMPORTED_MODULE_1__dateHelpers__["a" /* formatTZDate */])(openingDate,timeFormat,__WEBPACK_IMPORTED_MODULE_2__static__["c" /* DEFAULT_TIME_FORMAT */]);// moment.tz(openingDate.getTimestamp(), zoneInfo.name).format(timeFormat);
var openingDateFormated=openingDate&&Object(__WEBPACK_IMPORTED_MODULE_1__dateHelpers__["a" /* formatTZDate */])(openingDate,dateFormat,__WEBPACK_IMPORTED_MODULE_2__static__["b" /* DEFAULT_DATE_FORMAT */]);// moment.tz(openingDate.getTimestamp(), zoneInfo.name).format(dateFormat);
var openingDayId=openingDate&&openingDate.getDayString().toLowerCase();var openingDayFormated=openingDayId&&Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])(openingDayId,lang);if(!openingDate){// closed forever
return{line0:_line,line1:_line2,line2:_line3,line3:'',line4:''};// TODO: re-add support for this case
//} else if (isInUnderAnHour(currentDate, openingDate)) {
//  opening in under 60 minutes
//  return {
//  line0,
//  line1,
//  line2,
//  line3: translate('opening', lang),
//  line4: openingDate.locale(lang).fromNow()
//  };
}else if(isToday(currentDate,openingDate)){// opening today
return{line0:_line,line1:_line2,line2:_line3,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('opening',lang),line4:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('at_x',lang,{x:openingTimeFormated})};}else if(isTomorrow(currentDate,openingDate)){// opening tomorrow
return{line0:_line,line1:_line2,line2:_line3,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('opening_tomorrow',lang),line4:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('at_x',lang,{x:openingTimeFormated})};}else if(isInUnderSixDays(currentDate,openingDate)){// opening in under 7 days
return{line0:_line,line1:_line2,line2:_line3,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('opening_x',lang,{x:openingDayFormated,isWeekday:true}),line4:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('at_x',lang,{x:openingTimeFormated})};}else{// opening sometime later in the future
return{line0:_line,line1:_line2,line2:_line3,line3:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('opening_x',lang,{x:openingDateFormated}),line4:Object(__WEBPACK_IMPORTED_MODULE_4__translations__["b" /* translate */])('at_x',lang,{x:openingTimeFormated})};}}}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({open_standalone:'Geöffnet',closed_standalone:'Geschlossen',open:'Geöffnet',closed:'Geschlossen',opening:'Wir öffnen',closing:'Schließt',yes_we_are:'Wir haben',sorry_we_are:'Wir haben',twentyfourseven:'Durchgehend',closing_tomorrow:'Schließt morgen',opening_tomorrow:'Öffnet morgen',at_x:'um %x%',closing_x:'Schließt %x%',opening_x:'Öffnet %x%',monday:'Montag',tuesday:'Dienstag',wednesday:'Mittwoch',thursday:'Donnerstag',friday:'Freitag',saturday:'Samstag',sunday:'Sonntag',businessHours:'Öffnungszeiten'});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({open_standalone:'Open',closed_standalone:'Closed',open:'Open',closed:'Closed',opening:'Opens',closing:'Closes',yes_we_are:"Yes, we're",sorry_we_are:"Sorry, we're",twentyfourseven:'24/7',closing_tomorrow:'Closes tomorrow',opening_tomorrow:'Opens tomorrow',at_x:'%x%',closing_x:'Closes %x%',opening_x:'Opens %x%',monday:'Monday',tuesday:'Tuesday',wednesday:'Wednesday',thursday:'Thursday',friday:'Friday',saturday:'Saturday',sunday:'Sunday',businessHours:'Business Hours'});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({open_standalone:'Open',closed_standalone:'Gesloten',open:'Open',closed:'Gesloten',opening:'Opent',closing:'Sluit',yes_we_are:'Ja, we zijn',sorry_we_are:'Sorry, wij zijn',twentyfourseven:'Blijvend',closing_tomorrow:'Sluit morgen',opening_tomorrow:'Opent morgen',at_x:'om %x%',closing_x:'Sluit %x%',opening_x:'Opent %x%',monday:'maandag',tuesday:'dinsdag',wednesday:'woensdag',thursday:'donderdag',friday:'vrijdag',saturday:'zaterdag',sunday:'zondag',businessHours:'Kantooruren'});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({open_standalone:'Ouvert',closed_standalone:'Fermé',open:'Ouverts',closed:'Fermés',opening:'Ouvre',closing:'Fermé',yes_we_are:'Nous sommes',sorry_we_are:'Nous sommes',twentyfourseven:'24h/24',closing_tomorrow:'Fermé demain',opening_tomorrow:'Ouvre demain',at_x:'à %x%',closing_x:'Fermé %x%',opening_x:'Ouvre %x%',monday:'lundi',tuesday:'mardi',wednesday:'mercredi',thursday:'jeudi',friday:'vendredi',saturday:'samedi',sunday:'dimanche',businessHours:"Heures d'ouverture"});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({open_standalone:'Abierto',closed_standalone:'Cerrado',open:'Abierto',closed:'Cerrado',opening:'Abre',closing:'Cierra',yes_we_are:'Estamos',sorry_we_are:'Fueron',twentyfourseven:'Permanente',closing_tomorrow:'Cierra mañana',opening_tomorrow:'Abre mañana',at_x:'a las %x%',closing_x:'Cerrar a %x%',opening_x:'Abre %x%',monday:'lunes',tuesday:'martes',wednesday:'miércoles',thursday:'jueves',friday:'viernes',saturday:'sábado',sunday:'domingo',businessHours:'horarios de apertura'});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({open_standalone:'Avoinna',closed_standalone:'Suljettu',open:'Avoinna',closed:'Suljettu',opening:'Avaamme',closing:'Suljemme',yes_we_are:'Kyllä, olemme',sorry_we_are:'Anteeksi, olemme',twentyfourseven:'24/7',closing_tomorrow:'Suljemme huomenna',opening_tomorrow:'Avaamme huomenna',at_x:'kello %x%',closing_x:function closing_x(opts){return'Suljemme %x%'+(opts.isWeekday?'na':'');},opening_x:function opening_x(opts){return'Avaamme %x%'+(opts.isWeekday?'na':'');},monday:'maanantai',tuesday:'tiistai',wednesday:'keskiviikko',thursday:'torstai',friday:'perjantai',saturday:'lauantai',sunday:'sunnuntai',businessHours:'Aukioloajat',midnight:'keskiyö'});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({open_standalone:'Abertos',closed_standalone:'Fechados',open:'Abertos',closed:'Fechados',opening:'Abrimos',closing:'Fechamos',yes_we_are:'Sim, estamos',sorry_we_are:'Desculpe, estamos',twentyfourseven:'24/7',closing_tomorrow:'Fechamos amanhã',opening_tomorrow:'Abrimos amanhã',at_x:'às %x%',closing_x:'Fechamos %x%',opening_x:'Abrimos %x%',monday:'Segunda-feira',tuesday:'Terça-feira',wednesday:'Quarta-feira',thursday:'Quinta-feira',friday:'Sexta-feira',saturday:'Sábado',sunday:'Domingo',businessHours:'Horário Comercial'});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({open_standalone:'Öppet',closed_standalone:'Stängt',open:'Öppet',closed:'Stängt',opening:'Öppnar',closing:'Stänger',yes_we_are:'Ja, vi har',sorry_we_are:'Tyvärr, vi har',twentyfourseven:'24/7',closing_tomorrow:'Stänger imorgon',opening_tomorrow:'Öppnar I morgon',at_x:'kl. %x%',closing_x:'Stänger %x%',opening_x:'Öppnar %x%',monday:'Måndag',tuesday:'Tisdag',wednesday:'Onsdag',thursday:'Torsdag',friday:'Fredag',saturday:'Lördag',sunday:'Söndag',businessHours:'Öppetider'});

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__ = __webpack_require__(1);
function UpgradeSection(_ref){var onUpgradeClick=_ref.onUpgradeClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'upgrade-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'app-description'},'Upgrade App to enjoy awesome additional features'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].button,{className:'btn-upgrade-banner',label:'Upgrade Now',onClick:onUpgradeClick})));}/* harmony default export */ __webpack_exports__["a"] = (function(_ref2){var onUpdate=_ref2.onUpdate,onPrimaryButtonClick=_ref2.onPrimaryButtonClick,onSecondaryButtonClick=_ref2.onSecondaryButtonClick,onUpgradeClick=_ref2.onUpgradeClick,data=_ref2.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MainTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'app-logo',src:'assets/images/oh_icon.svg',width:'80',height:'80',alt:'app logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'app-description'},'Let visitors know when you\u2019re open and closed with a stylish sign.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].button,{className:'btn-confirm-primary',label:'Set Hours',onClick:onPrimaryButtonClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].button,{className:'btn-confirm-secondary',label:'Choose Sign',onClick:onSecondaryButtonClick}),!Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["c" /* isPremium */])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpgradeSection,{onUpgradeClick:onUpgradeClick}));});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_services_static__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_components_createNavigationContainer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_services_styles__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_badges__ = __webpack_require__(9);
var TIMEZONES=__WEBPACK_IMPORTED_MODULE_1_moment___default.a.tz.names().map(function(val,i){return{value:''+i,label:val};});function PremiumTeaser(_ref){var onUpgradeClick=_ref.onUpgradeClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PremiumTeaserContainer',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PremiumTeaserUpgradeSymbol'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].symbol,{name:'premiumLarge',onClick:onUpgradeClick})),'Please upgrade to premium in order to show your business hours in a table when a user clicks the sign.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].toggleSwitch,{label:'Show business hours',defaultValue:true,disabled:true}));}function BadgeSettings(_ref2){var data=_ref2.data;var selectedBadge=Object(__WEBPACK_IMPORTED_MODULE_7__commons_badges__["c" /* getNormalizedBadgeId */])(data.selectedBadge);var badgeIsAnimated=__WEBPACK_IMPORTED_MODULE_7__commons_badges__["a" /* badgesById */][selectedBadge].animated;var supportsNoSubline=__WEBPACK_IMPORTED_MODULE_7__commons_badges__["a" /* badgesById */][selectedBadge].supportsNoSubline;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Sign Settings'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),badgeIsAnimated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].toggleSwitch,{label:'Animate Sign',infoText:'Choose if you want your sign to be animated.',defaultValue:true,'wix-param':__WEBPACK_IMPORTED_MODULE_6__commons_services_styles__["b" /* params */].animateEnabled}):null,supportsNoSubline?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].toggleSwitch,{label:'Disable Subline',infoText:'Select if you want the sign to only display \'Open\' or \'Closed\' without further information.',defaultValue:false,'wix-param':__WEBPACK_IMPORTED_MODULE_6__commons_services_styles__["b" /* params */].noSublineEnabled}):null,badgeIsAnimated||supportsNoSubline?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].dropDownSelect,{defaultValue:''+__WEBPACK_IMPORTED_MODULE_1_moment___default.a.tz.names().indexOf(__WEBPACK_IMPORTED_MODULE_1_moment___default.a.tz.guess()),title:'Time Zone',options:TIMEZONES,'wix-param':__WEBPACK_IMPORTED_MODULE_6__commons_services_styles__["b" /* params */].timezone}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].dropDownSelect,{title:'Language (beta)',options:__WEBPACK_IMPORTED_MODULE_4__commons_services_static__["i" /* wixLanguages */],'wix-param':__WEBPACK_IMPORTED_MODULE_6__commons_services_styles__["b" /* params */].language}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].dropDownSelect,{title:'First day of the week',options:__WEBPACK_IMPORTED_MODULE_4__commons_services_static__["k" /* wixWeekdays */],'wix-param':__WEBPACK_IMPORTED_MODULE_6__commons_services_styles__["b" /* params */].firstDayOfWeek}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].dropDownSelect,{title:'Time format',options:__WEBPACK_IMPORTED_MODULE_4__commons_services_static__["j" /* wixTimeFormats */],'wix-param':__WEBPACK_IMPORTED_MODULE_6__commons_services_styles__["b" /* params */].timeFormat}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].dropDownSelect,{title:'Date format',options:__WEBPACK_IMPORTED_MODULE_4__commons_services_static__["h" /* wixDateFormats */],'wix-param':__WEBPACK_IMPORTED_MODULE_6__commons_services_styles__["b" /* params */].dateFormat}));}function ModalSettings(_ref3){var onUpgradeClick=_ref3.onUpgradeClick;var toggleSwitch=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].toggleSwitch,{label:'Show business hours',infoText:'If a visitor clicks on your sign it will show your business hours in a table.',defaultValue:true,'wix-param':__WEBPACK_IMPORTED_MODULE_6__commons_services_styles__["b" /* params */].modalEnabled});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Table Settings'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),Object(__WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__["c" /* isPremium */])()?toggleSwitch:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PremiumTeaser,{onUpgradeClick:onUpgradeClick}));}function SettingsTab(_ref4){var data=_ref4.data,onUpgradeClick=_ref4.onUpgradeClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BadgeSettings,{data:data}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalSettings,{onUpgradeClick:onUpgradeClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'200px'}}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__commons_components_createNavigationContainer__["a" /* default */])(SettingsTab));

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_TZDate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_components_OpeningHoursContainer__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_components_SpecialOpeningHoursContainer__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_components_DrilldownMenuList__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_components_withBackButton__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_components_createNavigationContainer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons_services_static__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons_services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commons_services_Wix__ = __webpack_require__(1);
var MAX_SPECIALS=10;function randomId(){return Math.random().toString(36).substr(2,9);}var OpeningHoursContainerWithBackButton=Object(__WEBPACK_IMPORTED_MODULE_6__commons_components_withBackButton__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__commons_components_OpeningHoursContainer__["a" /* default */]);function formatTimerangesForSubline(timeranges){return timeranges.map(function(_ref){var from=_ref.from,to=_ref.to;return from+' to '+to;}).join(', ');}function formatDatesForSubline(startDate,endDate){// TODO: should we have a special case for when startDate === endDate?
if(startDate===endDate){return startDate;}return'From '+startDate+' to '+endDate;}function HoursSettings(_ref2){var onUpdate=_ref2.onUpdate,data=_ref2.data,styles=_ref2.styles,addComponentToPath=_ref2.addComponentToPath;var firstIndex=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(__WEBPACK_IMPORTED_MODULE_8__commons_services_static__["g" /* weekdays */],function(day){return day.value===__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(styles,'firstDayOfWeek.value','monday');});var orderedWeekdays=__WEBPACK_IMPORTED_MODULE_8__commons_services_static__["g" /* weekdays */].slice(firstIndex,__WEBPACK_IMPORTED_MODULE_8__commons_services_static__["g" /* weekdays */].length).concat(__WEBPACK_IMPORTED_MODULE_8__commons_services_static__["g" /* weekdays */].slice(0,firstIndex));var items=orderedWeekdays.map(function(day){var timeranges=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(data,'openingHoursByDay.'+day.value+'.openingHours',[]);function edit(){addComponentToPath(OpeningHoursContainerWithBackButton,{day:day.value});}var subLabel=formatTimerangesForSubline(timeranges);return{label:day.label,subLabel:subLabel||'No time slots defined',onClick:edit,menuItems:[]};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commons_components_DrilldownMenuList__["a" /* default */],{items:items});}var SpecialOpeningHoursContainerWithBackButton=Object(__WEBPACK_IMPORTED_MODULE_6__commons_components_withBackButton__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__commons_components_SpecialOpeningHoursContainer__["a" /* default */]);function SpecialHoursSettings(_ref3){var onUpdate=_ref3.onUpdate,data=_ref3.data,addComponentToPath=_ref3.addComponentToPath;function getIdxById(id){return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(data.specialOpeningHours,function(special){return special.id===id;});}function getById(id){var idx=getIdxById(id);if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(idx)){return data.specialOpeningHours[idx];}}function edit(id){addComponentToPath(SpecialOpeningHoursContainerWithBackButton,{id:id});}function copy(id){var originSpecial=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(getById(id));var newSpecial=Object.assign({},originSpecial,{id:randomId()});onUpdate(data,{specialOpeningHours:{$push:[newSpecial]}});}function del(id){var newSpecialOpeningHours=data.specialOpeningHours.filter(function(special){return special.id!==id;});onUpdate(data,{specialOpeningHours:{$set:newSpecialOpeningHours}});}function add(){var id=randomId();var inOneWeek=new __WEBPACK_IMPORTED_MODULE_2__commons_services_TZDate__["a" /* default */]().addDays(7);onUpdate(data,{specialOpeningHours:{$push:[{id:id,note:'',start:inOneWeek.getLocalDateString(),end:inOneWeek.getLocalDateString(),openingHours:[]}]}});edit(id);}var items=data.specialOpeningHours.map(function(special,idx){return{label:idx+1+'. Special Event',subLabel:formatDatesForSubline(special.start,special.end),onClick:function onClick(){return edit(special.id);},menuItems:[{label:'Edit',iconSRC:'assets/images/symbol_edit.svg',onClick:function onClick(ev){ev.stopPropagation();edit(special.id);}},{label:'Duplicate',iconSRC:'assets/images/symbol_duplicate.svg',onClick:function onClick(ev){ev.stopPropagation();copy(special.id);}},{label:'Delete',iconSRC:'assets/images/symbol_delete.svg',onClick:function onClick(ev){ev.stopPropagation();del(special.id);}}]};});var isAddDisabled=items.length>=MAX_SPECIALS;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SpecialHoursContainer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commons_components_DrilldownMenuList__["a" /* default */],{items:items}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commons_services_UI__["a" /* default */].button,{className:'btn add',onClick:add,disabled:isAddDisabled,label:'Add Special Event'}));}function PremiumTeaser(_ref4){var onUpgradeClick=_ref4.onUpgradeClick;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'PremiumTeaserContainer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'PremiumTeaserUpgradeSymbol'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commons_services_UI__["a" /* default */].symbol,{name:'premiumLarge',onClick:onUpgradeClick})),'Upgrade App in order to add special events, like a Happy Hour, to your business hours.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commons_services_UI__["a" /* default */].button,{className:'btn',label:'Add Special Event',disabled:true}));}function HoursTab(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'HoursTab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Business Hours',infoText:'Edit your business hours for each weekday'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'OpeningHoursContainer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(HoursSettings,props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Special Events',infoText:'Overwrite your regular business hours for a specific time period e.g., if you\u2019re going on vacation.'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),Object(__WEBPACK_IMPORTED_MODULE_10__commons_services_Wix__["c" /* isPremium */])()?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SpecialHoursSettings,props):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PremiumTeaser,{onUpgradeClick:props.onUpgradeClick}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{height:'200px'}}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__commons_components_createNavigationContainer__["a" /* default */])(HoursTab));

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpeningHours__ = __webpack_require__(147);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OpeningHoursContainer=function(_React$Component){_inherits(OpeningHoursContainer,_React$Component);function OpeningHoursContainer(){_classCallCheck(this,OpeningHoursContainer);return _possibleConstructorReturn(this,(OpeningHoursContainer.__proto__||Object.getPrototypeOf(OpeningHoursContainer)).apply(this,arguments));}_createClass(OpeningHoursContainer,[{key:'render',value:function render(){var _props=this.props,data=_props.data,day=_props.day,onUpdate=_props.onUpdate,otherProps=_objectWithoutProperties(_props,['data','day','onUpdate']);var timeranges=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(data,'openingHoursByDay.'+day+'.openingHours',[]);var note=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(data,'openingHoursByDay.'+day+'.note','');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OpeningHours__["a" /* default */],Object.assign({timeranges:timeranges,note:note,onTimerangesChange:function onTimerangesChange(newTimeranges){onUpdate(data,{openingHoursByDay:_defineProperty({},day,{openingHours:{$set:newTimeranges}})});},onNoteChange:function onNoteChange(newNote){onUpdate(data,{openingHoursByDay:_defineProperty({},day,{note:{$set:newNote}})},true,false);}},otherProps));}}]);return OpeningHoursContainer;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OpeningHoursContainer);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimeRanges__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__ = __webpack_require__(1);
function OpeningHours(_ref){var onNoteChange=_ref.onNoteChange,onTimerangesChange=_ref.onTimerangesChange,timeranges=_ref.timeranges,note=_ref.note;return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].sectionDividerLabeled,{label:'Text'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',{className:'OpeningHours__Note'},!Object(__WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__["c" /* isPremium */])()?__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',{className:'OpeningHours__NotePremium'},__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].tooltip,{value:'Upgrade App to describe regular events that happen during your business hours. These will appear in your business hours table.'},__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].symbol,{name:'premiumLarge',style:{cursor:'pointer'},onClick:__WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__["d" /* openBillingPage */]}))):null,__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_3__TextInput__["a" /* default */],{value:note,title:'Note',placeholder:'e.g. Happy Hour from 6pm',infoText:Object(__WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__["c" /* isPremium */])()?'Add a note to describe regular events that happen during your business hours. These will appear in your business hours table.':null,maxLength:50,invalidMessage:'Limit reached',validator:function validator(val){return(val||'').length<50;},onChange:onNoteChange,disabled:!Object(__WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__["c" /* isPremium */])()})),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_2__TimeRanges__["a" /* default */],{onChange:onTimerangesChange,timeranges:timeranges}));}/* harmony default export */ __webpack_exports__["a"] = (OpeningHours);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown__ = __webpack_require__(149);
var options=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.times(24).reduce(function(memo,val,i){var hour=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.padStart(i,2,'0');memo.push(hour+':00');memo.push(hour+':15');memo.push(hour+':30');memo.push(hour+':45');if(hour==='23'){memo.push('24:00');}return memo;},[]).map(function(time){return{label:time,value:time};});function TimeDropdown(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Dropdown__["a" /* default */],Object.assign({},props,{options:options}));}/* harmony default export */ __webpack_exports__["a"] = (TimeDropdown);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_UI__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dropdown=function(_React$Component){_inherits(Dropdown,_React$Component);function Dropdown(props){_classCallCheck(this,Dropdown);var _this=_possibleConstructorReturn(this,(Dropdown.__proto__||Object.getPrototypeOf(Dropdown)).call(this,props));_this.updateValue=_this.updateValue.bind(_this);_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(Dropdown,[{key:'componentDidMount',value:function componentDidMount(){this.updateValue();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.updateValue();}},{key:'updateValue',value:function updateValue(){var value=this.props.value;var _el$getValueLink=this.el.getValueLink('value'),requestChange=_el$getValueLink.requestChange;requestChange(value);}},{key:'handleChange',value:function handleChange(newValue){// only propagate if the value changed
if(this.props.value!==newValue&&this.props.onChange){this.props.onChange(newValue);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,value=_props.value,defaultValue=_props.defaultValue,otherProps=_objectWithoutProperties(_props,['value','defaultValue']);return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].dropDownSelect,Object.assign({ref:function ref(el){return _this2.el=el;}},otherProps));}}]);return Dropdown;}(__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].Component);/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_TZDate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpecialOpeningHours__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SpecialOpeningHoursContainer=function(_React$Component){_inherits(SpecialOpeningHoursContainer,_React$Component);function SpecialOpeningHoursContainer(props){_classCallCheck(this,SpecialOpeningHoursContainer);var _this=_possibleConstructorReturn(this,(SpecialOpeningHoursContainer.__proto__||Object.getPrototypeOf(SpecialOpeningHoursContainer)).call(this,props));_this.updateProp=_this.updateProp.bind(_this);_this.updateStartAndEnd=_this.updateStartAndEnd.bind(_this);_this.getSpecialIdx=_this.getSpecialIdx.bind(_this);_this.getSpecial=_this.getSpecial.bind(_this);return _this;}_createClass(SpecialOpeningHoursContainer,[{key:'updateStartAndEnd',value:function updateStartAndEnd(start,end){var _props=this.props,data=_props.data,onUpdate=_props.onUpdate;var specialIdx=this.getSpecialIdx();var startDate=__WEBPACK_IMPORTED_MODULE_2__services_TZDate__["a" /* default */].createFromDateAndTimeString(start);var endDate=__WEBPACK_IMPORTED_MODULE_2__services_TZDate__["a" /* default */].createFromDateAndTimeString(end);if(endDate.isBefore(startDate)){var _ref=[end,start];start=_ref[0];end=_ref[1];}onUpdate(data,{specialOpeningHours:_defineProperty({},specialIdx,{start:{$set:start},end:{$set:end}})});}},{key:'updateProp',value:function updateProp(prop,val,save,triggerSettingsUpdate){var _props2=this.props,data=_props2.data,onUpdate=_props2.onUpdate;var specialIdx=this.getSpecialIdx();onUpdate(data,{specialOpeningHours:_defineProperty({},specialIdx,_defineProperty({},prop,{$set:val}))},save,triggerSettingsUpdate);}},{key:'getSpecialIdx',value:function getSpecialIdx(){var _props3=this.props,data=_props3.data,id=_props3.id;return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(data.specialOpeningHours,function(special){return special.id===id;});}},{key:'getSpecial',value:function getSpecial(){var data=this.props.data;var specialIdx=this.getSpecialIdx();return data.specialOpeningHours[specialIdx];}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,data=_props4.data,id=_props4.id,otherProps=_objectWithoutProperties(_props4,['data','id']);var special=this.getSpecial();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SpecialOpeningHours__["a" /* default */],Object.assign({timeranges:special.openingHours,note:special.note,start:special.start,end:special.end,onTimerangesChange:function onTimerangesChange(newTimeranges){_this2.updateProp('openingHours',newTimeranges);},onTitleChange:function onTitleChange(newTitle){_this2.updateProp('title',newTitle);},onNoteChange:function onNoteChange(newNote){_this2.updateProp('note',newNote,true,false);},onStartChange:function onStartChange(newStart){_this2.updateStartAndEnd(newStart,special.end);},onEndChange:function onEndChange(newEnd){_this2.updateStartAndEnd(special.start,newEnd);}},otherProps));}}]);return SpecialOpeningHoursContainer;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SpecialOpeningHoursContainer);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimeRanges__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_components_WixDatePicker__ = __webpack_require__(153);
function SpecialOpeningHours(_ref){var onStartChange=_ref.onStartChange,onEndChange=_ref.onEndChange,onNoteChange=_ref.onNoteChange,onTimerangesChange=_ref.onTimerangesChange,timeranges=_ref.timeranges,title=_ref.title,start=_ref.start,end=_ref.end,note=_ref.note;return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].sectionDividerLabeled,{label:'Text'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_3__TextInput__["a" /* default */],{value:note,title:'Note',placeholder:'e.g., We are on vacation',infoText:'Define a special event which happens once in between a specific date range with optional time slots. Shows up in the business hours table.',maxLength:50,invalidMessage:'Limit reached',validator:function validator(val){return(val||'').length<50;},onChange:onNoteChange}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].sectionDividerLabeled,{label:'Date'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_4__commons_components_WixDatePicker__["a" /* default */],{label:'Start Date',selected:start,onChange:onStartChange}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_4__commons_components_WixDatePicker__["a" /* default */],{label:'End Date',selected:end,onChange:onEndChange}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_2__TimeRanges__["a" /* default */],{onChange:onTimerangesChange,timeranges:timeranges}));}/* harmony default export */ __webpack_exports__["a"] = (SpecialOpeningHours);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DATE_FORMAT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WixDatePicker_css__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WixDatePicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WixDatePicker_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DATE_FORMAT='YYYY-MM-DD';var WixDatePicker=function(_React$Component){_inherits(WixDatePicker,_React$Component);function WixDatePicker(props){_classCallCheck(this,WixDatePicker);var _this=_possibleConstructorReturn(this,(WixDatePicker.__proto__||Object.getPrototypeOf(WixDatePicker)).call(this,props));_this.open=_this.open.bind(_this);return _this;}_createClass(WixDatePicker,[{key:'open',value:function open(ev){var calendarEl=this.container.querySelector('.WixDatePicker__Calendar');if(!(calendarEl&&calendarEl.contains(ev.target))){this.el.setOpen(true);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,selected=_props.selected,_onChange=_props.onChange,label=_props.label,otherProps=_objectWithoutProperties(_props,['selected','onChange','label']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'DatePicker_PseudoSelect'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown select',tabindex:'0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dd'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'selected-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'selected'},selected)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'expand arrow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{className:'symbol-arrowDown',width:'12',height:'12',viewBox:'135.1 -517.4 1024 1024'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M137.3-195c0 17.4 7.4 34.7 19.8 47.1l441.4 409.1c27.3 24.8 71.9 24.8 99.2 0l438.9-429c27.3-24.8 27.3-66.9 0-91.7-27.3-24.8-71.9-24.8-99.2 0L648.1 122.3 256.3-242.2c-27.3-24.8-71.9-24.8-99.2 0-12.4 14.9-19.8 29.8-19.8 47.2z',className:'c1'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'DatePickerWrapper',ref:function ref(el){_this2.container=el;},onClick:this.open},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datepicker__["a" /* default */],Object.assign({},otherProps,{ref:function ref(el){_this2.el=el;},selected:__WEBPACK_IMPORTED_MODULE_0_moment___default()(selected,DATE_FORMAT),onChange:function onChange(newVal){if(_onChange){_onChange(newVal.format(DATE_FORMAT));}},dateFormat:DATE_FORMAT,className:'WixDatePicker',calendarClassName:'WixDatePicker__Calendar'}))));}}]);return WixDatePicker;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (WixDatePicker);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CalendarContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_popper__ = __webpack_require__(160);







var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var YearDropdownOptions = function (_React$Component) {
  inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    classCallCheck(this, YearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: selectedYear === year ? "react-datepicker__year-option --selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          },
          selectedYear === year ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__year-option--selected" },
            "\u2713"
          ) : "",
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  YearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__year-dropdown": true,
      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return YearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var dayOfWeekCodes = {
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
  7: "sun"
};

// These functions are not exported so
// that we avoid magic strings like 'days'
function set$1(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get$1(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

// ** Date Constructors **

function newDate(point) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(point);
}

function newDateWithOffset(utcOffset) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, dateFormat, locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isMoment(date);
}

function isDate(date) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set$1(date, "month", month);
}

function setYear(date, year) {
  return set$1(date, "year", year);
}



// ** Date Getters **

function getSecond(date) {
  return get$1(date, "second");
}

function getMinute(date) {
  return get$1(date, "minute");
}

function getHour(date) {
  return get$1(date, "hour");
}

// Returns day of week
function getDay(date) {
  return get$1(date, "day");
}

function getWeek(date) {
  return get$1(date, "week");
}

function getMonth(date) {
  return get$1(date, "month");
}

function getYear(date) {
  return get$1(date, "year");
}

// Returns day of month
function getDate(date) {
  return get$1(date, "date");
}



function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, "day");
}

function getStartOfWeek(date) {
  return getStartOf(date, "week");
}
function getStartOfMonth(date) {
  return getStartOf(date, "month");
}

function getStartOfDate(date) {
  return getStartOf(date, "date");
}

// *** End of ***





// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, "minutes");
}

function addHours(date, amount) {
  return add(date, amount, "hours");
}

function addDays(date, amount) {
  return add(date, amount, "days");
}

function addWeeks(date, amount) {
  return add(date, amount, "weeks");
}

function addMonths(date, amount) {
  return add(date, amount, "months");
}

function addYears(date, amount) {
  return add(date, amount, "years");
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, "days");
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, "weeks");
}

function subtractMonths(date, amount) {
  return subtract(date, amount, "months");
}

function subtractYears(date, amount) {
  return subtract(date, amount, "years");
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}



function isSameYear(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "year");
  } else {
    return !date1 && !date2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "month");
  } else {
    return !date1 && !date2;
  }
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, "day");
  } else {
    return !moment1 && !moment2;
  }
}



function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf("day").subtract(1, "seconds");
  var after = endDate.clone().startOf("day").add(1, "seconds");
  return day.clone().startOf("day").isBetween(before, after);
}

// *** Diffing ***



// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale());
}







function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.localeData(locale);
}

function getFormattedWeekdayInLocale(locale, date, formatFunc) {
  return formatFunc(locale.weekdays(date));
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

function getMonthShortInLocale(locale, date) {
  return locale.monthsShort(date);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref5) {
  var minTime = _ref5.minTime,
      maxTime = _ref5.maxTime;

  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }

  var base = __WEBPACK_IMPORTED_MODULE_4_moment___default()().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref6.minDate,
      includeDates = _ref6.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref7.maxDate,
      includeDates = _ref7.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref8) {
  var minDate = _ref8.minDate,
      includeDates = _ref8.includeDates;

  if (includeDates && minDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref9) {
  var maxDate = _ref9.maxDate,
      includeDates = _ref9.includeDates;

  if (includeDates && maxDate) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, "day");
    }));
  } else if (includeDates) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.max(includeDates);
  } else {
    return maxDate;
  }
}

function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";

  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isMoment(obj)) {
      var key = obj.format("MM.DD.YYYY");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfMoments = obj[keys[0]];
      if (typeof className === "string" && arrOfMoments.constructor === Array) {
        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
          var _key = arrOfMoments[k].format("MM.DD.YYYY");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }

  return dateClasses;
}

function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);

    if (injectedTime.isBetween(currentTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }

  return times;
}

var WrappedYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(YearDropdownOptions);

var YearDropdown = function (_React$Component) {
  inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__year-read-view--selected-year" },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    }, _this.handleYearChange = function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    }, _this.onSelect = function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    }, _this.setOpen = function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  YearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return YearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearDropdown.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var MonthDropdownOptions = function (_React$Component) {
  inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          },
          _this.props.month === i ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-option--selected" },
            "\u2713"
          ) : "",
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdownOptions.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__month-dropdown" },
      this.renderOptions()
    );
  };

  return MonthDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdownOptions.propTypes = {
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  monthNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired).isRequired
};

var WrappedMonthDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthDropdownOptions);

var MonthDropdown = function (_React$Component) {
  inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-read-view--selected-month" },
          monthNames[_this.props.month]
        )
      );
    }, _this.renderDropdown = function (monthNames) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        ref: "options",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdown.prototype.render = function render() {
    var _this2 = this;

    var localeData = getLocaleDataForLocale(this.props.locale);
    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
      return getMonthShortInLocale(localeData, newDate({ M: M }));
    } : function (M) {
      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
    });

    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode(monthNames);
        break;
      case "select":
        renderedDropdown = this.renderSelectMode(monthNames);
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function generateMonthYears(minDate, maxDate) {
  var list = [];

  var currDate = getStartOfMonth(cloneDate(minDate));
  var lastDate = getStartOfMonth(cloneDate(maxDate));

  while (!isAfter(currDate, lastDate)) {
    list.push(cloneDate(currDate));

    addMonths(currDate, 1);
  }

  return list;
}

var MonthYearDropdownOptions = function (_React$Component) {
  inherits(MonthYearDropdownOptions, _React$Component);

  function MonthYearDropdownOptions(props) {
    classCallCheck(this, MonthYearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = monthYear.valueOf();

        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          },
          isSameMonthYear ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "react-datepicker__month-year-option--selected" },
            "\u2713"
          ) : "",
          formatDate(monthYear, _this.props.dateFormat)
        );
      });
    };

    _this.onChange = function (monthYear) {
      return _this.props.onChange(monthYear);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  MonthYearDropdownOptions.prototype.render = function render() {
    var dropdownClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      "react-datepicker__month-year-dropdown": true,
      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return MonthYearDropdownOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdownOptions.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var WrappedMonthYearDropdownOptions = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(MonthYearDropdownOptions);

var MonthYearDropdown = function (_React$Component) {
  inherits(MonthYearDropdown, _React$Component);

  function MonthYearDropdown() {
    var _temp, _this, _ret;

    classCallCheck(this, MonthYearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));

      var options = [];

      while (!isAfter(currDate, lastDate)) {
        var timepoint = currDate.valueOf();
        options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: timepoint, value: timepoint },
          formatDate(currDate, _this.props.dateFormat)
        ));

        addMonths(currDate, 1);
      }

      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "react-datepicker__month-year-read-view--selected-month-year" },
          yearMonth
        )
      );
    }, _this.renderDropdown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: localizeDate(_this.props.minDate, _this.props.locale),
        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (monthYearPoint) {
      _this.toggleDropdown();

      var changedDate = newDate(parseInt(monthYearPoint));

      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }

      _this.props.onChange(changedDate);
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthYearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthYearDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthYearDropdown.propTypes = {
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Day = function (_React$Component) {
  inherits(Day, _React$Component);

  function Day() {
    var _temp, _this, _ret;

    classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return isSameDay(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return isDayDisabled(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = day.format("MM.DD.YYYY");
      return highlightDates.get(dayStr);
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return isDayInRange(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return isDayInRange(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isOutsideMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      },
      getDate(this.props.day)
    );
  };

  return Day;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Day.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var WeekNumber = function (_React$Component) {
  inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _temp, _this, _ret;

    classCallCheck(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  WeekNumber.prototype.render = function render() {
    var weekNumberClasses = {
      "react-datepicker__week-number": true,
      "react-datepicker__week-number--clickable": !!this.props.onClick
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      },
      this.props.weekNumber
    );
  };

  return WeekNumber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WeekNumber.propTypes = {
  weekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Week = function (_React$Component) {
  inherits(Week, _React$Component);

  function Week() {
    var _temp, _this, _ret;

    classCallCheck(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Day, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset
        });
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Week.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "react-datepicker__week" },
      this.renderDays()
    );
  };

  return Week;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Week.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var Month = function (_React$Component) {
  inherits(Month, _React$Component);

  function Month() {
    var _temp, _this, _ret;

    classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Week, {
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset
        }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Month.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox"
      },
      this.renderWeeks()
    );
  };

  return Month;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Month.propTypes = {
  day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onDayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDayMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectingDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var Time = function (_React$Component) {
  inherits(Time, _React$Component);

  function Time() {
    var _temp, _this, _ret;

    classCallCheck(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ["react-datepicker__time-list-item"];

      if (currH === getHour(time) && currM === getMinute(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }

      return classes.join(" ");
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "hh:mm A";
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : newDate();
      var currH = getHour(activeTime);
      var currM = getMinute(activeTime);
      var base = getStartOfDay(newDate());
      var multiplier = 1440 / intervals;
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(cloneDate(base), i * intervals);
        times.push(currentTime);

        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      return times.map(function (time, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM)
          },
          formatDate(time, format)
        );
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Time.prototype.componentDidMount = function componentDidMount() {
    // code to ensure selected time will always be in focus within time window when it first appears
    var multiplier = 60 / this.props.intervals;
    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
    this.list.scrollTop = 30 * (multiplier * currH);
  };

  Time.prototype.render = function render() {
    var _this2 = this;

    var height = null;
    if (this.props.monthRef) {
      height = this.props.monthRef.clientHeight - 39;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__header react-datepicker__header--time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker-time__header" },
          this.props.timeCaption
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__time" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__time-box" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            {
              className: "react-datepicker__time-list",
              ref: function ref(list) {
                _this2.list = list;
              },
              style: height ? { height: height } : {}
            },
            this.renderTimes.bind(this)()
          )
        )
      )
    );
  };

  createClass(Time, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
  return Time;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Time.propTypes = {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  intervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  monthRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

function CalendarContainer(_ref) {
  var className = _ref.className,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "react-datepicker__triangle" }),
    children
  );
}

CalendarContainer.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var Calendar = function (_React$Component) {
  inherits(Calendar, _React$Component);
  createClass(Calendar, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time"
      };
    }
  }]);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = now(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return localizeDate(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: addMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: subtractMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleYearChange = function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
      }
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
    };

    _this.handleMonthYearChange = function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: setYear(cloneDate(_this.state.date), year)
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: setMonth(cloneDate(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.changeMonthYear = function (monthYear) {
      _this.setState({
        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = getStartOfWeek(cloneDate(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name" },
          _this.props.weekLabel || "#"
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        var localeData = getLocaleData(day);
        var weekDayName = _this.formatWeekday(localeData, day);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: offset, className: "react-datepicker__day-name" },
          weekDayName
        );
      }));
    };

    _this.formatWeekday = function (localeData, day) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
    };

    _this.renderPreviousMonthButton = function () {
      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        className: classes.join(" "),
        onClick: clickHandler
      });
    };

    _this.renderNextMonthButton = function () {
      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }

      var clickHandler = _this.increaseMonth;

      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        className: classes.join(" "),
        onClick: clickHandler
      });
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ["react-datepicker__current-month"];

      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes.join(" ") },
        formatDate(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    };

    _this.renderMonthYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        },
        _this.props.todayButton
      );
    };

    _this.renderMonths = function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }

      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = addMonths(cloneDate(_this.state.date), i);
        var monthKey = "month-" + i;
        monthList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "react-datepicker__header" },
            _this.renderCurrentMonth(monthDate),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
                onFocus: _this.handleDropdownFocus
              },
              _this.renderMonthDropdown(i !== 0),
              _this.renderMonthYearDropdown(i !== 0),
              _this.renderYearDropdown(i !== 0)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "react-datepicker__day-names" },
              _this.header(monthDate)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset
          })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes
        });
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: _this.monthContainer
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // monthContainer height is needed in time component
    // to determine the height for the ul in the time component
    // setState here so height is given after final component
    // layout is rendered
    if (this.props.showTimeSelect) {
      this.assignMonthContainer = function () {
        _this2.setState({ monthContainer: _this2.monthContainer });
      }();
    }
  };

  Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.preSelection && !isSameDay(nextProps.preSelection, this.props.preSelection)) {
      this.setState({
        date: this.localizeDate(nextProps.preSelection)
      });
    } else if (nextProps.openToDate && !isSameDay(nextProps.openToDate, this.props.openToDate)) {
      this.setState({
        date: this.localizeDate(nextProps.openToDate)
      });
    }
  };

  Calendar.prototype.render = function render() {
    var Container = this.props.container || CalendarContainer;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Container,
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      },
      this.renderPreviousMonthButton(),
      this.renderNextMonthButton(),
      this.renderMonths(),
      this.renderTodayButton(),
      this.renderTimeSection(),
      this.props.children
    );
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Calendar.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]),
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDropdownFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onTimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  preSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var popperPlacementPositions = ["auto", "auto-left", "auto-right", "bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];

var PopperComponent = function (_React$Component) {
  inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    classCallCheck(this, PopperComponent);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PopperComponent.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        targetComponent = _props.targetComponent;


    var popper = void 0;

    if (!hidePopper) {
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("react-datepicker-popper", className);
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["b" /* Popper */],
        {
          className: classes,
          modifiers: popperModifiers,
          placement: popperPlacement
        },
        popperComponent
      );
    }

    if (this.props.popperContainer) {
      popper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.popperContainer, {}, popper);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_popper__["a" /* Manager */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_popper__["c" /* Target */],
        { className: "react-datepicker-wrapper" },
        targetComponent
      ),
      popper
    );
  };

  createClass(PopperComponent, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: "viewport"
          }
        },
        popperPlacement: "bottom-start"
      };
    }
  }]);
  return PopperComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperComponent.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hidePopper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  popperComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <datepicker/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  targetComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = Object(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__["a" /* default */])(Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }

  return date1 !== date2;
}

/**
 * General datepicker component.
 */

var DatePicker = function (_React$Component) {
  inherits(DatePicker, _React$Component);
  createClass(DatePicker, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        allowSameDay: false,
        dateFormat: "L",
        dateFormatCalendar: "MMMM YYYY",
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside$$1() {},
        onMonthChange: function onMonthChange() {},

        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},

        monthsShown: 1,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30,
        timeCaption: "Time"
      };
    }
  }]);

  function DatePicker(props) {
    classCallCheck(this, DatePicker);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus();
      }
    };

    _this.setOpen = function (open) {
      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection
      });
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus) {
          _this.setOpen(true);
        }
      }
      _this.setState({ focused: true });
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open && !_this.props.withPortal) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
      _this.setState({ focused: false });
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function () {
      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }

      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({ inputValue: event.target.value });
      var date = parseDate(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
        return;
      }

      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            var selected = _this.props.selected;
            if (keepInput) selected = newDate(changedDate);
            changedDate = setTime(newDate(changedDate), {
              hour: getHour(selected),
              minute: getMinute(selected),
              second: getSecond(selected)
            });
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = setTime(cloneDate(selected), {
        hour: getHour(time),
        minute: getMinute(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
      _this.setOpen(false);
      _this.setState({ inputValue: null });
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled) {
        _this.setOpen(true);
      }
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey !== "Enter" && eventKey !== "Escape" && eventKey !== "Tab") {
          _this.onInputClick();
        }
        return;
      }
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        if (isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === "Escape") {
        event.preventDefault();
        _this.setOpen(false);
      } else if (eventKey === "Tab") {
        _this.setOpen(false);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case "ArrowLeft":
            event.preventDefault();
            newSelection = subtractDays(copy, 1);
            break;
          case "ArrowRight":
            event.preventDefault();
            newSelection = addDays(copy, 1);
            break;
          case "ArrowUp":
            event.preventDefault();
            newSelection = subtractWeeks(copy, 1);
            break;
          case "ArrowDown":
            event.preventDefault();
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            event.preventDefault();
            newSelection = subtractMonths(copy, 1);
            break;
          case "PageDown":
            event.preventDefault();
            newSelection = addMonths(copy, 1);
            break;
          case "Home":
            event.preventDefault();
            newSelection = subtractYears(copy, 1);
            break;
          case "End":
            event.preventDefault();
            newSelection = addYears(copy, 1);
            break;
        }
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.clear = function () {
      _this.onClearClick();
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && (!_this.state.open || _this.props.disabled)) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber
        },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var _classnames, _React$cloneElement;

      var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));

      var customInput = _this.props.customInput || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text" });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
        _this.input = input;
      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          onClick: _this.onClearClick,
          title: _this.props.clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.inline && hasPreSelectionChanged(this.props.selected, nextProps.selected)) {
      this.setPreSelection(nextProps.selected);
    }
    if (this.props.highlightDates !== nextProps.highlightDates) {
      this.setState({
        highlightDates: getHightLightDaysMap(nextProps.highlightDates)
      });
    }
    if (!this.state.focused) this.setState({ inputValue: null });
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearPreventFocusTimeout();
  };

  DatePicker.prototype.render = function render() {
    var calendar = this.renderCalendar();

    if (this.props.inline && !this.props.withPortal) {
      return calendar;
    }

    if (this.props.withPortal) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        !this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__input-container" },
          this.renderDateInput(),
          this.renderClearButton()
        ) : null,
        this.state.open || this.props.inline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "react-datepicker__portal" },
          calendar
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopperComponent, {
      className: this.props.popperClassName,
      hidePopper: !this.state.open || this.props.disabled,
      popperModifiers: this.props.popperModifiers,
      targetComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "react-datepicker__input-container" },
        this.renderDateInput(),
        this.renderClearButton()
      ),
      popperContainer: this.props.popperContainer,
      popperComponent: calendar,
      popperPlacement: this.props.popperPlacement
    });
  };

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  adjustDateOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowSameDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  calendarClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  calendarContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  customInputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  dateFormatCalendar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dayClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledKeyboardNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropdownMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["scroll", "select"]).isRequired,
  endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  filterDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  fixedHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeDates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  includeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  injectTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isClearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  monthsShown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onWeekSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeRaw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMonthChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onYearChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  openToDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  peekNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholderText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popperContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  popperClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, // <PopperComponent/> props
  popperModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // <PopperComponent/> props
  popperPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(popperPlacementPositions), // <PopperComponent/> props
  preventOpenOnFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollableMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectsEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectsStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMonthYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showYearDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceShowMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDisabledMonthNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  startOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  timeCaption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  todayButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  useWeekdaysShort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formatWeekDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  utcOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weekLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  withPortal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  yearDropdownItemNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  shouldCloseOnSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTimeSelectOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeIntervals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  excludeTimes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  useShortMonthInDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clearButtonTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(156);
var invariant = __webpack_require__(157);
var ReactPropTypesSecret = __webpack_require__(158);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(165);
/* unused harmony reexport Arrow */





/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.3
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && parent.nodeName === 'HTML') {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* unused harmony default export */ var _unused_webpack_default_export = (Arrow);

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InlineMenu_jsx__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DrilldownMenuList_css__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DrilldownMenuList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DrilldownMenuList_css__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function DrilldownMenuList(_ref){var _ref$items=_ref.items,items=_ref$items===undefined?[]:_ref$items;var itemsHTML=items.map(function(_ref2){var label=_ref2.label,subLabel=_ref2.subLabel,menuItems=_ref2.menuItems,otherProps=_objectWithoutProperties(_ref2,['label','subLabel','menuItems']);var menuHTML=void 0;var subLabelHTML=void 0;if(menuItems&&menuItems.length){menuHTML=__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__InlineMenu_jsx__["a" /* default */],{items:menuItems});}if(subLabel){subLabelHTML=__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('span',{className:'DrilldownMenuList__Item__SubLabel'},subLabel);}return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('li',Object.assign({className:'DrilldownMenuList__Item'},otherProps),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('span',{className:'DrilldownMenuList__Item__Label'},label,subLabelHTML),menuHTML);});return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('ul',{className:'DrilldownMenuList'},itemsHTML);}/* harmony default export */ __webpack_exports__["a"] = (DrilldownMenuList);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utils__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InlineMenu_css__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InlineMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InlineMenu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InlineMenu=function(_React$Component){_inherits(InlineMenu,_React$Component);function InlineMenu(props){_classCallCheck(this,InlineMenu);var _this=_possibleConstructorReturn(this,(InlineMenu.__proto__||Object.getPrototypeOf(InlineMenu)).call(this,props));_this.toggleOpen=_this.toggleOpen.bind(_this);_this.setContainer=_this.setContainer.bind(_this);_this.handle=_this.handle.bind(_this);_this.openMenu=_this.openMenu.bind(_this);// close menu after 500ms (if this.openMenu() wasn't
// called in that time)
_this.debouncedCloseMenu=Object(__WEBPACK_IMPORTED_MODULE_1__services_utils__["a" /* debounce */])(_this.debouncedCloseMenu.bind(_this),150);_this.state={isOpen:false};return _this;}_createClass(InlineMenu,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('click',this.handle,true);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.handle,true);this.debouncedCloseMenu.abort();}},{key:'handle',value:function handle(ev){if(this.container.contains&&!this.container.contains(ev.target)){this.toggleOpen(false);}}},{key:'setContainer',value:function setContainer(ref){this.container=ref;}},{key:'toggleOpen',value:function toggleOpen(){var open=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;this.setState(function(_ref){var isOpen=_ref.isOpen;return{isOpen:open!==null?open:!isOpen};});}},{key:'openMenu',value:function openMenu(){this.debouncedCloseMenu.abort();this.toggleOpen(true);}},{key:'debouncedCloseMenu',value:function debouncedCloseMenu(){this.toggleOpen(false);}},{key:'render',value:function render(){var items=this.props.items;var isOpen=this.state.isOpen;var menuHTML=void 0;if(isOpen){var itemsHTML=items.map(function(_ref2){var label=_ref2.label,iconSRC=_ref2.iconSRC,otherProps=_objectWithoutProperties(_ref2,['label','iconSRC']);var iconHTML=void 0;if(iconSRC){iconHTML=__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('img',{className:'InlineMenu__MenuItemIcon',alt:'',src:iconSRC});}return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('li',Object.assign({className:'InlineMenu__MenuItem'},otherProps),iconHTML,label);});menuHTML=__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',{className:'InlineMenu__Menu',onMouseEnter:this.openMenu,onMouseLeave:this.debouncedCloseMenu,onClick:function onClick(ev){ev.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('ul',null,itemsHTML));}return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',{className:'InlineMenu',ref:this.setContainer},__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',{className:'InlineMenu__TriggerButton',onMouseEnter:this.openMenu,onMouseLeave:this.debouncedCloseMenu,onClick:function onClick(ev){ev.stopPropagation();}},'\u2026'),menuHTML);}}]);return InlineMenu;}(__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].Component);/* harmony default export */ __webpack_exports__["a"] = (InlineMenu);

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_React__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_UI__ = __webpack_require__(2);
function withBackButton(WrappedComponent){return function(props){return __WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(__WEBPACK_IMPORTED_MODULE_1__services_UI__["a" /* default */].button,{label:'Back',className:'btn-back',onClick:props.gotoPrevComponent}),__WEBPACK_IMPORTED_MODULE_0__services_React__["a" /* default */].createElement(WrappedComponent,props));};}/* harmony default export */ __webpack_exports__["a"] = (withBackButton);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_badges_index__ = __webpack_require__(9);
function BadgesTab(_ref){var onUpdate=_ref.onUpdate,data=_ref.data,styles=_ref.styles,fetchStyles=_ref.fetchStyles;var selectedBadge=Object(__WEBPACK_IMPORTED_MODULE_4__commons_badges_index__["c" /* getNormalizedBadgeId */])(data.selectedBadge);var badgesHTML=__WEBPACK_IMPORTED_MODULE_4__commons_badges_index__["b" /* badgesList */].map(function(_ref2){var BadgeComponent=_ref2.BadgeComponent,id=_ref2.id,premium=_ref2.premium;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:function onClick(){if(!premium||Object(__WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__["c" /* isPremium */])()){onUpdate(data,{selectedBadge:{$set:id}});}},onMouseEnter:function onMouseEnter(){onUpdate(data,{hoverBadge:{$set:id}},false);},onMouseLeave:function onMouseLeave(){onUpdate(data,{$unset:['hoverBadge']},false);},className:__WEBPACK_IMPORTED_MODULE_0_classnames___default()('BadgesOverview__Badge',{'BadgesOverview__Badge--selected':selectedBadge===id,'BadgesOverview__Badge--disablePointer':premium&&!Object(__WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__["c" /* isPremium */])()})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'BadgesOverview__BadgeInnerWrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BadgeComponent,{data:data,styles:styles}),premium&&!Object(__WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__["c" /* isPremium */])()&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'BadgesOverview__PremiumBadge'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].tooltip,{value:'Upgrade to use this sign design.'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].symbol,{name:'premiumLarge',style:{cursor:'pointer'},onClick:__WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__["d" /* openBillingPage */]})))));});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Choose a Sign'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'BadgesOverview'},badgesHTML),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{height:'200px'}}));}/* harmony default export */ __webpack_exports__["a"] = (BadgesTab);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_components_createNavigationContainer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_components_TextInput__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_services_styles__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_badges__ = __webpack_require__(9);
function BadgeSettings(_ref){var onUpdate=_ref.onUpdate,data=_ref.data;var selectedBadge=Object(__WEBPACK_IMPORTED_MODULE_6__commons_badges__["c" /* getNormalizedBadgeId */])(data.selectedBadge);var badgeColors=__WEBPACK_IMPORTED_MODULE_6__commons_badges__["a" /* badgesById */][selectedBadge].colors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Sign Colors'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].toggleSwitch,{label:'Use sign default colors',defaultValue:data.badgeDefaultColors,onChange:function onChange(isOn){onUpdate(data,{badgeDefaultColors:{$set:isOn}});}}),!data.badgeDefaultColors&&badgeColors>=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),!data.badgeDefaultColors&&badgeColors>=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].colorPickerInput,{title:'First Color',disabled:true,startWithColor:'color-8','wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].badgeFirstColor}),!data.badgeDefaultColors&&badgeColors>=2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),!data.badgeDefaultColors&&badgeColors>=2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].colorPickerInput,{title:'Second Color',startWithColor:'color-1','wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].badgeSecondColor}),!data.badgeDefaultColors&&badgeColors>=3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),!data.badgeDefaultColors&&badgeColors>=3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].colorPickerInput,{title:'Third Color',startWithColor:'color-6','wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].badgeThirdColor}));}function ModalPremiumTeaser(_ref2){var onUpgradeClick=_ref2.onUpgradeClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Table Settings'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PremiumTeaserContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PremiumTeaserUpgradeSymbol'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].symbol,{name:'premiumLarge',onClick:onUpgradeClick})),'Please upgrade to premium in order to have the business hour table settings available.'));}function ModalSettings(_ref3){var onUpdate=_ref3.onUpdate,data=_ref3.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Table Colors + Fonts'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CenterButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].button,{className:'btn-confirm-primary Actions__PreviewButton',label:'Preview Table',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__["f" /* openSettingsModal */])('Business Hours | Table Preview');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].colorPickerInput,{title:'Background Color','wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalBackgroundColor,startWithColor:'color-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].tooltip,{value:'In order to see this style in the preview, you need to add at least one note in the hours settings.'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].colorPickerInput,{title:'Note Background Color','wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalNoteBackgroundColor,startWithColor:'color-6'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].fontAndColorPicker,{title:'Headline',fontMinSize:12,fontMaxSize:22,startWithColor:'color-5',startWithTheme:'font_5','wix-param-font':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalHeadlineFont,'wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalHeadlineColor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].fontAndColorPicker,{title:'Weekdays',fontMinSize:12,fontMaxSize:14,startWithColor:'color-5',startWithTheme:'font_8',startWithStyle:{bold:true},'wix-param-font':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalWeekdaysFont,'wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalWeekdaysColor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].fontAndColorPicker,{title:'Time Slots',fontMinSize:12,fontMaxSize:14,startWithColor:'color-5',startWithTheme:'font_8','wix-param-font':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalTimeSlotsFont,'wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalTimeSlotsColor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commons_services_UI__["a" /* default */].fontAndColorPicker,{title:'Notes',fontMinSize:12,fontMaxSize:14,startWithColor:'color-5',startWithTheme:'font_8','wix-param-font':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalNotesFont,'wix-param':__WEBPACK_IMPORTED_MODULE_5__commons_services_styles__["b" /* params */].modalNotesColor,infoText:'In order to see this style in the preview, you need to add at least one note in the hours settings.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commons_components_TextInput__["a" /* default */],{value:data.tableHeadline||'',title:'Custom Table Headline',placeholder:'e.g. My business hours',infoText:Object(__WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__["c" /* isPremium */])()?'Use this headline, instead of the default one.':null,maxLength:30,invalidMessage:'Limit reached',validator:function validator(val){return(val||'').length<30;},onChange:function onChange(newTableHeadline){onUpdate(data,{tableHeadline:{$set:newTableHeadline}});},disabled:!Object(__WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__["c" /* isPremium */])()}));}function DesignTab(_ref4){var onUpgradeClick=_ref4.onUpgradeClick,data=_ref4.data,onUpdate=_ref4.onUpdate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BadgeSettings,{data:data,onUpdate:onUpdate}),Object(__WEBPACK_IMPORTED_MODULE_4__commons_services_Wix__["c" /* isPremium */])()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalSettings,{data:data,onUpdate:onUpdate}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalPremiumTeaser,{onUpgradeClick:onUpgradeClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'200px'}}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__commons_components_createNavigationContainer__["a" /* default */])(DesignTab));

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_email_like__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_email_like___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_email_like__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_services_request__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FORM_STATES={DEFAULT:'DEFAULT',SENDING:'SENDING',SUCCESS:'SUCCESS',ERROR:'ERROR'};var SupportTab=function(_React$Component){_inherits(SupportTab,_React$Component);function SupportTab(props){_classCallCheck(this,SupportTab);var _this=_possibleConstructorReturn(this,(SupportTab.__proto__||Object.getPrototypeOf(SupportTab)).call(this,props));_this.rateUs=_this.rateUs.bind(_this);_this.setEmail=_this.setEmail.bind(_this);_this.setMessage=_this.setMessage.bind(_this);_this.validateMessage=_this.validateMessage.bind(_this);_this.send=_this.send.bind(_this);_this.isFormValid=_this.isFormValid.bind(_this);_this.state={formState:FORM_STATES.DEFAULT,error:null,email:'',message:''};return _this;}_createClass(SupportTab,[{key:'rateUs',value:function rateUs(){__WEBPACK_IMPORTED_MODULE_3__commons_services_Wix__["a" /* default */].Settings.openReviewInfo();}},{key:'setEmail',value:function setEmail(email){this.setState({email:email});}},{key:'setMessage',value:function setMessage(message){this.setState({message:message});}},{key:'send',value:function send(){var _this2=this;var _state=this.state,email=_state.email,message=_state.message;this.setState(function(){return{formState:FORM_STATES.SENDING};});__WEBPACK_IMPORTED_MODULE_4__commons_services_request__["a" /* default */].post('/api/contact/send',{email:email,message:message}).then(function(response){var body=response.data;if(body.error){_this2.setState(function(){return{formState:FORM_STATES.ERROR,error:body.error};});}else{_this2.setState(function(){return{formState:FORM_STATES.SUCCESS};});}}).catch(function(){_this2.setState(function(){return{formState:FORM_STATES.ERROR,error:'unknown error'};});});}},{key:'validateEmail',value:function validateEmail(email){return __WEBPACK_IMPORTED_MODULE_0_is_email_like___default()(email);}},{key:'validateMessage',value:function validateMessage(message){return message.length>5;}},{key:'isFormValid',value:function isFormValid(){return this.messageRef&&this.messageRef.isValueValid()&&this.emailRef&&this.emailRef.isValueValid();}},{key:'render',value:function render(){var _this3=this;var _state2=this.state,formState=_state2.formState,error=_state2.error;var form=void 0;if(formState===FORM_STATES.SUCCESS){form=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'SupportTab__SuccessParagraph'},'Thanks for your message. Our support team will get in contact with you soon.');}else if(formState===FORM_STATES.ERROR){form=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'SupportTab__ErrorParagraph'},'Error: ',error);}else{form=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].textInput,{title:'What\'s your email?',ref:function ref(emailRef){return _this3.emailRef=emailRef;},placeholder:'Email',validator:this.validateEmail,invalidMessage:'Invalid email address!',validateOnBlurOnly:true,onBlur:function onBlur(){_this3.forceUpdate();},onChange:this.setEmail}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].textInput,{title:'What do you want to tell us?',ref:function ref(messageRef){return _this3.messageRef=messageRef;},placeholder:'Write us your message (new feature idea / other issues)',isMultiLine:true,invalidMessage:'Message must be at least 5 characters long',validator:this.validateMessage,validateOnBlurOnly:true,onKeyDown:function onKeyDown(){_this3.forceUpdate();},onChange:this.setMessage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-short'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-wrapper-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].button,{label:'Send',disabled:!this.isFormValid()||formState===FORM_STATES.SENDING,onClick:this.send})));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SupportTab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Developer info'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'SupportTab__DeveloperInfo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].symbol,{name:'email'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'mailto:support@sope.io'},'support@sope.io')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].symbol,{name:'globe'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'https://sope.io/',target:'_blank',rel:'noopener noreferrer'},'Developer Website',' '),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Review the App'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'SupportTab__ReviewParagraph'},'Enjoying Open Sign? Leave us a review in the App Market.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-wrapper-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].button,{className:'btn-confirm-primary',label:'Rate Us',onClick:this.rateUs})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_services_UI__["a" /* default */].sectionDividerLabeled,{label:'Send us a message'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'divider-long'}),form,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{height:'200px'}}));}}]);return SupportTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SupportTab);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var emailRegex = __webpack_require__(177);

module.exports = function (str) {
	return emailRegex({exact: true}).test(str);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (opts) {
	opts = opts || {};
	var re = '[^\\.\\s@][^\\s@]*(?!\\.)@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)*';
	return opts.exact ? new RegExp('^' + re + '$') : new RegExp(re, 'g');
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_services_request__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_translations__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_components_OpeningHoursTable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_components_createStylesContainer__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_css__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Modal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_React$Component){_inherits(Modal,_React$Component);function Modal(props){_classCallCheck(this,Modal);var _this=_possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this,props));_this.state={data:null};return _this;}_createClass(Modal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var type=__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Utils.getViewMode()==='site'?'public':'draft';__WEBPACK_IMPORTED_MODULE_3__commons_services_request__["a" /* default */].get('/api/settings/'+type).then(function(_ref){var data=_ref.data;_this2.setState(function(){return{data:data};});});}},{key:'render',value:function render(){var styles=this.props.styles;var data=this.state.data;if(!data){return null;}var openingHoursByDay=data.openingHoursByDay,specialOpeningHours=data.specialOpeningHours,tableHeadline=data.tableHeadline;var lang=styles.language.value;var translation=Object(__WEBPACK_IMPORTED_MODULE_4__commons_translations__["a" /* default */])(lang);var deviceType=__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Utils.getDeviceType();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('Modal','Modal--'+deviceType)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commons_components_OpeningHoursTable__["a" /* default */],{headline:tableHeadline,openingHoursByDay:openingHoursByDay,specialOpeningHours:specialOpeningHours,styles:styles,translation:translation}));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__commons_components_createStylesContainer__["a" /* default */])(Modal));

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_TZDate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_dateHelpers__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_openingHours__ = __webpack_require__(13);
function OpeningHoursTableColumn(_ref){var day=_ref.day,dayLabel=_ref.dayLabel,openingHours=_ref.openingHours,noteId=_ref.noteId,styles=_ref.styles,translation=_ref.translation;var openingHoursHTML=void 0;if(openingHours.length){openingHoursHTML=openingHours.map(function(_ref2){var from=_ref2.from,to=_ref2.to;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable__FromTo'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4__services_dateHelpers__["b" /* formatTime */])(from,styles.timeFormat.value)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,' \u2013 '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4__services_dateHelpers__["b" /* formatTime */])(to,styles.timeFormat.value)));});}else{openingHoursHTML=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable__FromTo'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,translation.closed_standalone));}// TODO: do we need to factor in the timezone here?
var currentDay=new __WEBPACK_IMPORTED_MODULE_3__services_TZDate__["a" /* default */]().getDayString().toLowerCase();var isToday=currentDay===day;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('modal-highlight-border OpeningHoursTable__Column',{'OpeningHoursTable__Column--active':isToday,'OpeningHoursTable__Column--highlight':noteId})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable__Day'},dayLabel,' ',noteId&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,noteId)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable__OpeningHours'},openingHoursHTML));}function TableFooter(_ref3){var notes=_ref3.notes;var renderedNotes=notes.map(function(note,i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable__Note'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable__NoteId modal-highlight-background'},i+1),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable__NoteTitle'},note));});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable__Footer'},renderedNotes);}function OpeningHoursTable(_ref4){var headline=_ref4.headline,openingHoursByDay=_ref4.openingHoursByDay,specialOpeningHours=_ref4.specialOpeningHours,styles=_ref4.styles,translation=_ref4.translation;var firstDayOfWeek=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(styles,'firstDayOfWeek.value','monday');var normalized=Object(__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["g" /* normalizeTableOpeningHours */])(firstDayOfWeek,openingHoursByDay,specialOpeningHours);var notes=normalized.reduce(function(memo,_ref5){var note=_ref5.note;if(note&&memo.indexOf(note)===-1){memo.push(note);}return memo;},[]);// Render each weekday
var columns=Object(__WEBPACK_IMPORTED_MODULE_5__services_openingHours__["g" /* normalizeTableOpeningHours */])(firstDayOfWeek,openingHoursByDay,specialOpeningHours).map(function(_ref6){var note=_ref6.note,day=_ref6.day,openingHours=_ref6.openingHours;// Use ID to reference note in footer
var noteId=note&&notes.indexOf(note)+1;var dayLabel=translation[day];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(OpeningHoursTableColumn,{noteId:noteId,key:day,day:day,dayLabel:dayLabel,openingHours:openingHours,styles:styles,translation:translation});});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTable'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTableHeadline'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,headline?headline:translation.businessHours)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'OpeningHoursTableWrapper'},columns),notes.length?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TableFooter,{notes:notes}):null);}/* harmony default export */ __webpack_exports__["a"] = (OpeningHoursTable);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_services_request__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_components_createStylesContainer__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_components_SelectErrorMessage__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_badges_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_services_errorCodes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Widget_css__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Widget_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Widget_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createWidgetContainer(WrappedComponent){return function(_React$Component){_inherits(_class,_React$Component);function _class(props){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props));_this.onSettingsUpdate=_this.onSettingsUpdate.bind(_this);_this.onClick=_this.onClick.bind(_this);_this.onEditModeChange=_this.onEditModeChange.bind(_this);_this.onSitePublished=_this.onSitePublished.bind(_this);_this.state={data:null,viewMode:__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Utils.getViewMode(),errorCode:null};return _this;}_createClass(_class,[{key:'onEditModeChange',value:function onEditModeChange(){this.setState(function(){return{viewMode:__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Utils.getViewMode()};});}},{key:'onSettingsUpdate',value:function onSettingsUpdate(data){this.setState(function(){return{data:data};});}},{key:'onSitePublished',value:function onSitePublished(){__WEBPACK_IMPORTED_MODULE_3__commons_services_request__["a" /* default */].post('/api/settings/publish');}},{key:'onClick',value:function onClick(ev){var modalEnabled=this.props.styles.modalEnabled;var svgEl=this.widgetEl.querySelector('svg');if(!modalEnabled||!Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["c" /* isPremium */])()||!svgEl||svgEl.contains&&!svgEl.contains(ev.target)||svgEl===ev.target){return;}Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["e" /* openModal */])();}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Events.SETTINGS_UPDATED,this.onSettingsUpdate);__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Events.EDIT_MODE_CHANGE,this.onEditModeChange);__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Events.SITE_PUBLISHED,this.onSitePublished);var type=this.state.viewMode==='site'?'public':'draft';__WEBPACK_IMPORTED_MODULE_3__commons_services_request__["a" /* default */].get('/api/settings/'+type).then(function(_ref){var data=_ref.data;_this2.setState(function(){return{data:data};});},function(err){_this2.setState(function(){return{errorCode:err.response.status===403?__WEBPACK_IMPORTED_MODULE_7__commons_services_errorCodes__["a" /* AUTH_ERROR */]:__WEBPACK_IMPORTED_MODULE_7__commons_services_errorCodes__["b" /* UNEXPECTED_ERROR */]};});});}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Events.SETTINGS_UPDATED,this.onSettingsUpdate);__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Events.EDIT_MODE_CHANGE,this.onEditModeChange);__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["a" /* default */].Events.SITE_PUBLISHED,this.onSitePublished);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,errorCode=_state.errorCode,hide=_state.hide;if(hide){return null;}if(errorCode){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commons_components_SelectErrorMessage__["a" /* default */],{code:errorCode});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Widget',ref:function ref(el){return _this3.widgetEl=el;},onClick:this.onClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent,Object.assign({},this.state,this.props)));}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);}function Widget(_ref2){var data=_ref2.data,styles=_ref2.styles;if(!data||!data.selectedBadge||!styles){return null;}var selectedBadge=Object(__WEBPACK_IMPORTED_MODULE_6__commons_badges_index__["c" /* getNormalizedBadgeId */])(data.selectedBadge);var _badgesById=__WEBPACK_IMPORTED_MODULE_6__commons_badges_index__["a" /* badgesById */][data.hoverBadge||selectedBadge],BadgeComponent=_badgesById.BadgeComponent,animated=_badgesById.animated,supportsNoSubline=_badgesById.supportsNoSubline,otherBadgeSettings=_objectWithoutProperties(_badgesById,['BadgeComponent','animated','supportsNoSubline']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BadgeComponent,Object.assign({},otherBadgeSettings,{className:__WEBPACK_IMPORTED_MODULE_0_classnames___default()({'Badge--clickable':Object(__WEBPACK_IMPORTED_MODULE_2__commons_services_Wix__["c" /* isPremium */])()&&styles.modalEnabled,'Badge--overwriteColors':!data.badgeDefaultColors,'Badge--animated':animated&&styles.animateEnabled}),disableSubline:supportsNoSubline&&styles.noSublineEnabled,enableChromeRenderingHack:true,data:data,styles:styles})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__commons_components_createStylesContainer__["a" /* default */])(createWidgetContainer(Widget)));

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c2647bbf.js